const menuData_en = [
  {
    "name": "Korean Zucchini Clam Vongole Pasta",
    "url": "https://youtu.be/u-r7_tJddww",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2024-04-05",
    "ingredients": [
      "Clams",
      "Korean zucchini",
      "Garlic",
      "Spaghetti",
      "Salt",
      "Peperoncino",
      "Parsley",
      "Butter",
      "Olive oil",
      "White wine"
    ],
    "steps": [
      "Boil water in a pot, add salt, and cook spaghetti.",
      "Heat olive oil in a pan and sauté minced garlic and peperoncino over low heat.",
      "Add clams and sauté, then pour in white wine, cover, and cook until they open. Remove opened clams.",
      "Add cooked spaghetti, pasta water, olive oil, and sliced Korean zucchini to the pan.",
      "Add parsley, the cooked clams, and butter, then sauté to combine all ingredients well.",
      "Serve the finished vongole pasta on a plate and drizzle with olive oil."
    ]
  },
  {
    "name": "Classic Carbonara",
    "url": "https://youtu.be/ZQK9mxZG6w0",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2024-04-22",
    "ingredients": [
      "Guanciale",
      "Pecorino Romano cheese",
      "Onion",
      "Egg yolks",
      "Black pepper",
      "Chicken stock",
      "Olive oil",
      "Spaghetti",
      "Salt"
    ],
    "steps": [
      "In a pot, bring 1 liter of water and 7g of salt to a boil, then cook the spaghetti for 7 minutes.",
      "In another pan, add olive oil and the sliced guanciale, frying until golden brown and crispy, rendering out its fat.",
      "Remove the cooked guanciale from the pan. In the same pan (with the rendered fat), add some pasta water and olive oil. Turn the heat to low, then add chicken stock and black pepper and mix.",
      "In the pan with the sauce base, add the cooked spaghetti and grated Pecorino Romano cheese. With the heat off, stir gently with a spatula.",
      "Add the egg yolks and stir quickly to create a thick, creamy sauce.",
      "Add the crispy guanciale to the pasta and mix. Finally, drizzle with a little olive oil."
    ]
  },
  {
    "name": "Aglio Olio Pasta",
    "url": "https://youtu.be/XXu79nKWCqs",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2024-05-03",
    "ingredients": [
      "Pasta",
      "Garlic",
      "Peperoncino",
      "Parsley",
      "Pecorino Cheese",
      "Chicken Stock",
      "Salt",
      "Black Pepper",
      "Olive Oil"
    ],
    "steps": [
      "Boil water with salt in a pot and cook pasta for 6 minutes.",
      "Slice the garlic and crush the peperoncino.",
      "Heat a generous amount of olive oil in a pan over very low heat and sauté the garlic until fragrant.",
      "Add peperoncino and slowly sauté until the garlic is golden brown without burning.",
      "Add chicken stock and pasta water to the pan and slightly increase the heat.",
      "Add the cooked pasta to the pan, drizzle with a little olive oil, and toss, stirring continuously, until the pasta absorbs the sauce.",
      "Reduce heat, grate in Pecorino cheese, and mix well to prevent clumping.",
      "Add chopped parsley, mix thoroughly, and transfer to a plate.",
      "Finish with a drizzle of olive oil and a sprinkle of parsley."
    ]
  },
  {
    "name": "Arrabbiata Pasta",
    "url": "https://youtu.be/LTAouuafb5s",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2024-05-16",
    "ingredients": [
      "Spaghetti",
      "Tomato Sauce",
      "Bacon",
      "Nduja",
      "Stracciatella",
      "Parsley",
      "Minced Garlic",
      "Peperoncino",
      "Salt",
      "Black Pepper",
      "Olive Oil",
      "White Wine",
      "Chicken Stock"
    ],
    "steps": [
      "Bring salted water to a boil in a pot and cook spaghetti for 7 minutes and 30 seconds.",
      "Heat olive oil in a pan and cook bacon until its fat renders.",
      "Add nduja to the pan with the bacon fat and sauté without burning.",
      "Add minced garlic and peperoncino, and sauté until fragrant.",
      "Pour in white wine to deglaze the pan and cook off the alcohol.",
      "Add pasta water and chicken stock, mixing well to create the sauce base.",
      "Add the cooked spaghetti and gently mix to coat the pasta with the sauce.",
      "Stir in olive oil and black pepper for flavor, and season to taste.",
      "Add tomato sauce and simmer over medium-low heat until the sauce thickens.",
      "Serve the pasta on plates, sprinkle with parsley, and top with stracciatella cheese.",
      "Drizzle with a little olive oil to finish."
    ]
  },
  {
    "name": "Cheese Tomato Spaghetti",
    "url": "https://youtu.be/Ti0YvlkrDOY",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2024-05-17",
    "ingredients": [
      "Spaghetti",
      "Tomato sauce",
      "Cheese",
      "Parsley",
      "Olive oil"
    ],
    "steps": [
      "Generously sprinkle parsley over the finished spaghetti.",
      "Lightly drizzle olive oil over the parsley.",
      "Mix the spaghetti and cheese well."
    ]
  },
  {
    "name": "Macaroni Cream Cheese Pasta",
    "url": "https://youtu.be/IZzt46FnzIk",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2024-06-05",
    "ingredients": [
      "Rigatoni",
      "Bacon",
      "Prosciutto",
      "Minced garlic",
      "Black pepper",
      "Salt",
      "Cheddar cheese",
      "Milk",
      "Reggiano cheese",
      "Chicken stock",
      "Butter",
      "Olive oil"
    ],
    "steps": [
      "Boil water and cook the rigatoni for the time indicated on the package (9 minutes).",
      "Heat olive oil in a pan, add bacon and minced garlic, and stir-fry until enough bacon fat is rendered.",
      "Add chicken stock and milk to the stir-fried bacon and garlic, then bring to a boil.",
      "Add two slices of cheddar cheese and sprinkle with black pepper, then boil until the sauce begins to thicken.",
      "Add the cooked rigatoni to the sauce and mix well.",
      "Drizzle with a little good olive oil and grate in Reggiano cheese."
    ]
  },
  {
    "name": "Shrimp Tomato Pasta",
    "url": "https://youtu.be/jfFQauNAdDs",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2024-06-12",
    "ingredients": [
      "Shrimp",
      "Bacon",
      "Cherry Tomatoes",
      "Garlic",
      "Parmesan Cheese",
      "Parsley",
      "Olive Oil",
      "White Wine",
      "Chicken Broth",
      "Whole Peeled Tomatoes",
      "Linguine"
    ],
    "steps": [
      "Cook linguine in boiling water.",
      "Heat olive oil in a pan, sauté bacon, then add shrimp and cook until done. Remove the shrimp and set aside.",
      "In the same pan, add minced garlic and halved cherry tomatoes, then sauté.",
      "Deglaze the pan with a splash of white wine, then add 4oz chicken broth and simmer with the tomatoes.",
      "Add crushed whole tomatoes and the cooked linguine, then toss with the sauce.",
      "Stir in grated Parmesan cheese and sprinkle with parsley. Add the reserved shrimp back into the pan, drizzle with olive oil, and mix well."
    ]
  },
  {
    "name": "Slab Bacon Rosé Assassin's Pasta",
    "url": "https://youtu.be/eHpI-mFpG3I",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2024-07-10",
    "ingredients": [
      "slab bacon",
      "garlic",
      "salt",
      "pepper",
      "chicken stock",
      "oyster sauce",
      "peperoncino",
      "tomato paste",
      "whole tomatoes",
      "heavy cream",
      "spaghetti",
      "olive oil",
      "butter",
      "basil",
      "parsley"
    ],
    "steps": [
      "Bring the pasta and tomato sauce to a boil in a pan.",
      "Add slab bacon pieces to the rosé pasta and continue to cook.",
      "Stir the Assassin's Pasta with a spatula until cooked through.",
      "Sprinkle with herbs such as parsley or basil to taste."
    ]
  },
  {
    "name": "Assassin's Pasta",
    "url": "https://youtu.be/H22HacLBGno",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2024-07-29",
    "ingredients": [
      "Spaghetti",
      "Whole tomatoes",
      "Peperoncino",
      "Minced garlic",
      "Tomato paste",
      "Oyster sauce",
      "Black pepper",
      "Salt",
      "Chicken stock",
      "Olive oil"
    ],
    "steps": [
      "Mix tomato paste with water to create tomato water.",
      "Heat olive oil in a pan and sauté minced garlic.",
      "Crumble peperoncino by hand and add to the pan.",
      "When the garlic begins to brown, remove the pan from heat to allow it to infuse slowly.",
      "Add whole tomatoes and mix with the garlic-infused oil.",
      "Add raw spaghetti noodles directly into the sauce and stir.",
      "Gradually add tomato water, stirring and simmering until reduced.",
      "When approximately half of the tomato water has been added, grind in fresh pepper.",
      "Add oyster sauce.",
      "Add salt.",
      "Continue to gradually add the remaining tomato water, stirring and simmering until the pasta is cooked and the sauce has thickened."
    ]
  },
  {
    "name": "Spaghetti all' Assassina",
    "url": "https://youtu.be/BaI6IRsSjuo",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2024-07-31",
    "ingredients": [
      "Spaghetti",
      "Garlic",
      "Chili",
      "Tomato sauce",
      "Parsley",
      "Olive oil"
    ],
    "steps": [
      "Heat olive oil in a pan and sauté garlic and chili.",
      "Add tomato sauce and spaghetti to the pan, and cook, tossing with the sauce.",
      "Cook until the spaghetti absorbs the sauce and achieves an al dente texture.",
      "Serve the finished spaghetti on a plate and garnish with parsley."
    ]
  },
  {
    "name": "Slab Bacon Rosé Pasta",
    "url": "https://youtu.be/VbGHIK6KYo0",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2024-08-05",
    "ingredients": [
      "Bacon",
      "Penne Pasta",
      "Whole Tomatoes",
      "Heavy Cream",
      "Minced Garlic",
      "Pepperoncino",
      "Parsley",
      "Parmesan Cheese",
      "Butter",
      "Chicken Stock",
      "Oyster Sauce",
      "Olive Oil",
      "Salt",
      "Black Pepper"
    ],
    "steps": [
      "Drizzle olive oil in a pan.",
      "Add the slab bacon and cook until crispy, then set aside the cooked bacon.",
      "In the remaining bacon fat, add minced garlic and sauté until fragrant.",
      "Add whole tomatoes, heavy cream, chicken stock, and oyster sauce, then mix.",
      "Add pasta water and regular water, then simmer the sauce over low heat to reduce.",
      "Add the cooked penne pasta to the sauce and mix.",
      "Season with black pepper to taste.",
      "Add butter and olive oil and mix well.",
      "Serve the pasta in a bowl, then top with the reserved bacon, Parmesan cheese, and parsley."
    ]
  },
  {
    "name": "Slab Bacon Rosé Pasta",
    "url": "https://youtu.be/Bx2BSYVoqRo",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2024-08-06",
    "ingredients": [
      "Penne pasta",
      "Slab bacon",
      "Minced garlic",
      "Whole peeled tomatoes",
      "Heavy cream",
      "Peperoncino",
      "Chicken stock",
      "Oyster sauce",
      "Black pepper",
      "Parmigiano Reggiano cheese",
      "Parsley",
      "Butter"
    ],
    "steps": [
      "Slice the bacon lengthwise and pan-fry until golden brown in a pan with olive oil.",
      "Chop onion and garlic, then add them to the pan with the golden-brown bacon and sauté together.",
      "Boil water with salt in a pot and cook the penne.",
      "Add tomato paste to the sautéed ingredients and stir-fry, then add a little pasta water.",
      "Add black pepper and butter and mix, then add the cooked penne, heavy cream, and Parmesan cheese and mix well.",
      "Add parsley and peperoncino and mix one more time to finish."
    ]
  },
  {
    "name": "Mentaiko Perilla Oil Pasta",
    "url": "https://youtu.be/C38UPoquzr4",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2024-08-12",
    "ingredients": [
      "Spaghetti",
      "Mentaiko",
      "Perilla leaves",
      "Garlic chives",
      "Minced garlic",
      "Pepperoncino",
      "Chicken stock",
      "Lime",
      "Mayonnaise",
      "Salt",
      "Black pepper",
      "Olive oil",
      "Butter"
    ],
    "steps": [
      "Pour olive oil into a pan.",
      "Sauté minced garlic in the pan over low heat.",
      "Add pepperoncino to the pan.",
      "Add butter to the pan.",
      "Add mayonnaise to the pan.",
      "Add water and spaghetti to the pan.",
      "Once it starts boiling, reduce to medium heat and cook for 6 minutes.",
      "While the pasta cooks, prepare the perilla leaves and mentaiko.",
      "Season with black pepper to taste.",
      "Taste the pasta; if umami is lacking, add chicken stock.",
      "Add the remaining butter, prepared perilla leaves, and mentaiko.",
      "Drizzle in olive oil, adjusting for desired consistency."
    ]
  },
  {
    "name": "Tteokbokki (Premium & Simple Version)",
    "url": "https://youtu.be/7suCKACarkY",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2024-08-26",
    "ingredients": [
      "Wheat tteok",
      "Rice tteok",
      "Manila clam",
      "Boiled egg",
      "Quail egg",
      "Fish cake",
      "Cabbage",
      "Green onion",
      "Garlic",
      "Gochujang",
      "Soy sauce",
      "Grain syrup",
      "Sugar",
      "Corn syrup",
      "Cheongyang chili powder",
      "Curry powder",
      "Black pepper",
      "Cooking oil"
    ],
    "steps": [
      "Drizzle a suitable amount of oil in a pan and lightly grill the rice tteok.",
      "Remove the grilled rice tteok and add 500ml of water.",
      "Add the de-gritted clams immediately.",
      "Once the clams start to open, add 5 tablespoons of gochujang.",
      "Add 2 tablespoons of grain syrup.",
      "Add 2 tablespoons of soy sauce."
    ]
  },
  {
    "name": "White Ragu Pasta",
    "url": "https://youtu.be/I32E2YkEomQ",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2024-09-03",
    "ingredients": [
      "Pork",
      "Beef",
      "Celery",
      "Onion",
      "Button mushrooms",
      "King oyster mushrooms",
      "Oyster mushrooms",
      "Garlic",
      "Mafaldine pasta",
      "Parmigiano Reggiano cheese",
      "Oyster sauce",
      "Chicken stock",
      "Heavy cream",
      "White wine",
      "Salt",
      "Black pepper",
      "Butter",
      "Oil",
      "Bay leaf"
    ],
    "steps": [
      "Heat oil in a pan and sear the pork until crispy and well browned.",
      "Add minced celery and minced onion to the pan and sauté.",
      "Add beef to the pan and sauté together.",
      "Add 4.5g of salt.",
      "Pour 20-25ml of cooking white wine into the pan.",
      "Add a bay leaf and 600ml of water.",
      "Add one tablespoon of oyster sauce.",
      "Add one generous tablespoon of chicken stock.",
      "Finely chop the prepared mushrooms.",
      "Grate a portion of the Parmigiano Reggiano cheese into the pan and add the remaining rind whole.",
      "Cook the mafaldine pasta according to package directions.",
      "In a separate pan, heat oil and sauté the mushrooms.",
      "Add 1/2 teaspoon of minced garlic to the mushrooms and sauté.",
      "Add the prepared ragu sauce to the mushroom mixture.",
      "Add 120ml heavy cream, 120ml pasta water, and the cooked mafaldine pasta.",
      "Season with freshly ground black pepper to taste.",
      "Check the doneness of the mafaldine pasta and finish the dish."
    ]
  },
  {
    "name": "Spicy Rosé Risotto",
    "url": "https://youtu.be/gtVZBZ1DbkA",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2024-09-09",
    "ingredients": [
      "Arborio rice",
      "Mussels",
      "Shrimp",
      "Bacon",
      "Onion",
      "Mushrooms",
      "Garlic",
      "Egg yolk",
      "Cream",
      "Butter",
      "Parmesan cheese",
      "Chili oil",
      "Peperoncino",
      "Salt",
      "Black pepper",
      "Bay leaf",
      "Chicken stock",
      "Oyster sauce",
      "Parsley",
      "White wine",
      "Olive oil"
    ],
    "steps": [
      "Wash the rice.",
      "Dice the onion and mushrooms to a similar size.",
      "Heat olive oil in a pan, add bacon, and render the fat.",
      "Add minced garlic and diced onion.",
      "Add chili oil.",
      "Add peperoncino.",
      "Add the diced mushrooms.",
      "Sauté until the onion is translucent and the mushrooms have softened.",
      "Lightly cook the shrimp on one side of the pan.",
      "Remove the shrimp, then add the washed rice.",
      "Season with salt.",
      "Add white wine.",
      "Add water and chicken stock.",
      "Add oyster sauce and simmer over medium-high heat, gradually adding water as it evaporates.",
      "Add cream.",
      "Add bay leaf.",
      "After adding the cream, stir gently over medium heat.",
      "Simmer until the rice is slightly al dente.",
      "Stir in butter and Parmesan cheese, allowing them to melt with residual heat.",
      "Add black pepper.",
      "Adjust the consistency.",
      "Add mussels and the partially cooked shrimp, and cook until done.",
      "Top with an egg yolk for final plating."
    ]
  },
  {
    "name": "Yellowtail Ceviche",
    "url": "https://youtu.be/f_brr1OcJBI",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2024-09-27",
    "ingredients": [
      "Yellowtail",
      "Korean melon",
      "Dill",
      "Bronze fennel",
      "Maldon salt",
      "Gungchae Jangajji",
      "Cilantro",
      "Lime",
      "Fish sauce",
      "Lemon juice",
      "Garlic",
      "Wasabi mayonnaise",
      "Fried shallots",
      "Olive oil",
      "Thyme"
    ],
    "steps": [
      "Dice the yellowtail into small pieces.",
      "Halve the Korean melon, scoop out the seeds and pulp, then squeeze the pulp to extract the juice.",
      "Lightly char the seedless melon skin with a torch to infuse flavor, then cool it in ice water.",
      "Spread out the diced yellowtail and charred melon skin in a container and smoke them with a smoke gun.",
      "In a bowl, combine the smoked diced yellowtail, Gungchae Jangajji, wasabi mayonnaise, cilantro stems and roots, and a green chili dressing made with lime juice, lemon juice, fish sauce, and garlic.",
      "Add olive oil smoked with dried and charred thyme, fried shallots, chopped cilantro, and smoked Maldon salt, then mix well.",
      "Place a circular mold on a plate, fill it with the mixed ceviche, and press down with a coffee tamper to shape it.",
      "Top the ceviche with smoked, juice-marinated diced Korean melon and sliced Korean melon.",
      "Garnish with lime zest and finish with dill and bronze fennel."
    ]
  },
  {
    "name": "Shrimp Tempura",
    "url": "https://youtu.be/IWlUH-Ht1TM",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2024-10-04",
    "ingredients": [
      "Whiteleg Shrimp",
      "Black Tiger Shrimp",
      "Red Shrimp",
      "Carabineros Shrimp",
      "Pine Mushroom",
      "Salt",
      "Egg",
      "Flour",
      "Cooking oil"
    ],
    "steps": [
      "Prepare the tempura batter: Whisk egg into ice water until foamy, similar to a meringue.",
      "Mix the foamy egg mixture with the heavier, settled egg mixture in a suitable ratio to form the batter, and keep it chilled over ice water.",
      "Prepare the shrimp: Remove heads and peel shells (leaving the last tail segment), then remove veins. Make several diagonal incisions on the belly side to straighten the shrimp. Pinch the water sac in the shrimp tail to prevent oil from splattering during frying. Completely dry the shrimp heads with a paper towel.",
      "Lightly dust the pine mushrooms and prepared shrimp (bodies and heads) with flour using a sieve.",
      "Heat cooking oil to 170-180°C. To check the temperature, drop a little batter into the oil; if it floats up immediately, the temperature is correct.",
      "Dip the floured ingredients into the cold tempura batter.",
      "Fry shrimp bodies for about 1-2 minutes, shrimp heads for about 40 seconds, and pine mushrooms for about 5-6 minutes until golden and crispy. Continuously remove any batter bits (tenkatsu) from the oil during frying to keep the oil clean.",
      "Drain excess oil from all fried ingredients.",
      "Arrange the tempura on a plate. Sprinkle fine salt on the fried pine mushrooms according to taste and serve immediately."
    ]
  },
  {
    "name": "Creamy Shrimp",
    "url": "https://youtu.be/yEboonAtIu4",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2024-10-11",
    "ingredients": [
      "Shrimp",
      "Lettuce",
      "Mayonnaise",
      "Condensed milk",
      "Honey",
      "Lemon",
      "Starch",
      "Cooking oil",
      "Parsley"
    ],
    "steps": [
      "Heat cooking oil before preparing shrimp and lettuce.",
      "Tear lettuce into bite-sized pieces.",
      "Combine starch and water.",
      "Devein shrimp and trim tail tips.",
      "Put mayonnaise in a bowl.",
      "Add condensed milk, honey, and lemon juice; mix well.",
      "Pour off any separated water from the starch slurry.",
      "Coat the prepared shrimp with the starch slurry and deep-fry.",
      "After the initial frying, double-fry the shrimp again before plating to crisp and remove moisture."
    ]
  },
  {
    "name": "Lettuce Preparation and Storage",
    "url": "https://youtu.be/dLRsnGQOQhQ",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2024-10-14",
    "ingredients": [
      "Lettuce"
    ],
    "steps": [
      "Press the core of the lettuce with your hand to loosen it.",
      "Remove the loosened core.",
      "Tear the desired amount of lettuce leaves into large pieces by hand.",
      "To store the remaining lettuce, line a container with paper towels, then place the lettuce upside down so the stem-end faces up."
    ]
  },
  {
    "name": "Dried Pollock Skin Seokbakji & Dried Pollock Green Onion Kimchi",
    "url": "https://youtu.be/38xf8TAtXX8",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2024-10-18",
    "ingredients": [
      "Radish",
      "Dried pollock skin",
      "Green onions",
      "Shredded dried pollock",
      "Pork jowl",
      "Pear",
      "Onion",
      "Salted fermented shrimp",
      "Blue crab extract",
      "Chili powder",
      "Minced garlic",
      "Ginger",
      "Salt",
      "Sugar",
      "Whole black peppercorns",
      "MSG",
      "Sesame seeds"
    ],
    "steps": [
      "Prepare Suyuk (Boiled Pork Slices): Pour water into a pot, add pork jowl, green onions, coarse salt, whole black peppercorns, and onion, then boil.",
      "For the Dried Pollock Skin Seokbakji, peel only the rough parts of the radish skin, cut it into thick pieces, and salt it with coarse salt and white sugar.",
      "Soak the dried pollock skin in water, remove excess water, and clean by removing any bones or gill bones.",
      "In a blender, combine pear, onion, salted fermented shrimp, blue crab extract, minced garlic, and ginger, then blend finely to make the kimchi seasoning base.",
      "Add chili powder to the blended seasoning base and let it sit for a while for the color to develop.",
      "Discard the water from the salted radish. First, add chili powder to the radish and prepared dried pollock skin and mix until well coated and red."
    ]
  },
  {
    "name": "Pasta alla Pescatora",
    "url": "https://youtu.be/Rkctb-PhF24",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2024-10-21",
    "ingredients": [
      "Pasta",
      "Shrimp",
      "Squid",
      "Clams",
      "Mussels",
      "Cherry tomatoes",
      "Garlic",
      "Basil",
      "Parsley",
      "Tomato paste",
      "Chopped tomatoes",
      "Bisque sauce",
      "Salt",
      "Olive oil",
      "Clam broth",
      "Parmesan cheese"
    ],
    "steps": [
      "Boil water in a pot and cook pasta for 4 minutes and 30 seconds.",
      "Heat olive oil in a pan, add cherry tomatoes, and sauté while crushing them.",
      "Add whole shrimp and minced garlic, sauté, then add squid, peeled shrimp, clams, and mussels, cook briefly, and remove only the seafood.",
      "In the same pan, add clam broth, bisque sauce, and chopped tomatoes, and bring to a boil to create the sauce.",
      "Add the cooked pasta to the sauce, season with salt and mix well, then add the reserved seafood, basil, and parsley and mix.",
      "Plate the finished pasta, then sprinkle with Parmesan cheese and parsley to finish."
    ]
  },
  {
    "name": "Easy Shrimp Pancakes",
    "url": "https://youtu.be/qD1qYZXNc6c",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2024-10-28",
    "ingredients": [
      "Shrimp",
      "Cheongyang Chili",
      "Egg White",
      "Oyster Sauce",
      "Tuna Sauce",
      "Pepper",
      "Starch",
      "Cooking Oil",
      "Buldak Sauce",
      "Soy Sauce"
    ],
    "steps": [
      "Peel and clean the shrimp.",
      "Finely chop the Cheongyang chili.",
      "Mince the shrimp.",
      "Add chopped Cheongyang chili, minced shrimp, starch, egg white, oyster sauce, tuna sauce, and pepper.",
      "Mix well in one direction to make a batter.",
      "Put the batter into a piping bag.",
      "Heat oil in a pan and pan-fry the batter over low heat."
    ]
  },
  {
    "name": "Beef Steak",
    "url": "https://youtu.be/BUQPamuhwcw",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2024-11-04",
    "ingredients": [
      "Sirloin",
      "Asparagus",
      "Garlic",
      "Butter",
      "Salt",
      "Pepper",
      "Canola oil",
      "Olive oil",
      "Vinegar"
    ],
    "steps": [
      "Prepare the sirloin.",
      "Bring the sirloin to room temperature.",
      "Trim excess fat and pat the sirloin dry.",
      "Season the sirloin generously with salt.",
      "Heat oil in a hot pan and add the sirloin.",
      "Sear the sirloin, turning frequently to cook evenly.",
      "Lift the sirloin off the pan for a brief, initial rest.",
      "Add whole garlic cloves to the pan and cook over medium heat.",
      "Once the garlic is cooked, add butter and return the steak to the pan for further searing.",
      "Continue to sear until the exterior is crispy.",
      "Rest the steak for 5 minutes.",
      "In a separate pan, cook asparagus in olive oil.",
      "Add butter to the asparagus and cook until tender-crisp.",
      "Finish by seasoning the asparagus with salt and pepper to taste."
    ]
  },
  {
    "name": "Spicy Shrimp Pancakes",
    "url": "https://youtu.be/1_PRT0gdEVc",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2024-11-07",
    "ingredients": [
      "Shrimp",
      "Cheongyang chili pepper",
      "Egg",
      "Oyster sauce",
      "Tuna sauce",
      "Black pepper",
      "Starch",
      "Cooking oil"
    ],
    "steps": [
      "Peel and clean the shrimp.",
      "Finely chop the Cheongyang chili pepper.",
      "Mince the shrimp.",
      "Combine the minced Cheongyang chili pepper, minced shrimp, starch, egg, oyster sauce, tuna sauce, and black pepper.",
      "Mix well in one direction.",
      "Transfer the batter to a piping bag.",
      "Heat a pan with ample oil over low heat and cook the batter until golden brown."
    ]
  },
  {
    "name": "Korean Grilled Beef Platter",
    "url": "https://youtu.be/VQH2p5vEMGg",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2024-11-11",
    "ingredients": [
      "Ribeye Cap",
      "Flat Iron Steak",
      "Boneless Short Rib",
      "Shrimp",
      "Minced garlic",
      "Marinade",
      "Salt",
      "Wasabi",
      "Rice"
    ],
    "steps": [
      "Prepare the charcoal grill.",
      "Place the ribeye cap on the hot charcoal. Once one side is cooked enough to prevent sticking, flip it.",
      "When the color of the meat's sides begins to change, cut the ribeye into bite-sized pieces.",
      "To preserve the juices, do not overcook the cut ribeye; enjoy it medium-rare.",
      "Place shrimp on the hot charcoal. When they start to cook, stand them vertically and cook thoroughly until done.",
      "Place boneless short ribs on the charcoal. Cook evenly by continuously flipping, being careful not to overcook to preserve the juices.",
      "Place the flat iron steak, marinated with minced garlic, on the hot charcoal. Cook carefully, ensuring the marinade does not burn.",
      "Serve the well-cooked meats over rice with salt or wasabi."
    ]
  },
  {
    "name": "Sirloin and Scallion Jjapaguri",
    "url": "https://youtu.be/eZy_egur2Jk",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2024-11-25",
    "ingredients": [
      "Sirloin",
      "Scallions",
      "Chapagetti ramen",
      "Neoguri ramen",
      "Salt",
      "Neoguri soup base",
      "Chapagetti soup base",
      "Seasoning oil",
      "Olive oil",
      "Kelp (from Neoguri)",
      "Truffle oil"
    ],
    "steps": [
      "Pour water into a pot and bring to a boil.",
      "Season sirloin steak with salt.",
      "Heat a pan, add olive oil, and sear sirloin steak until golden brown on all sides.",
      "Rest the cooked sirloin steak briefly.",
      "Prepare Chapagetti and Neoguri noodles, their respective dried vegetable flakes, Chapagetti soup base, and half a pack of Neoguri soup base separately.",
      "Add Chapagetti noodles, Neoguri noodles, and Neoguri kelp to boiling water and cook for 2 minutes.",
      "In another pan, add olive oil and seasoning oil, then stir-fry the chopped scallions.",
      "Once scallions are cooked, add Chapagetti dried vegetable flakes, Neoguri dried vegetable flakes, and the remaining half pack of Neoguri soup base, and stir-fry together.",
      "Add a ladleful of noodle cooking water and Chapagetti soup base to the stir-fry mixture, mixing well to create a paste-like sauce.",
      "Drain the cooked noodles (after 2 minutes) and add them to the sauce pan with another ladleful of cooking water; stir-fry well until the noodles are glossy.",
      "Remove the Neoguri kelp while stir-frying.",
      "Slice the rested sirloin steak into bite-sized pieces and place them on top of the stir-fried noodles.",
      "(Optional) Drizzle with a little truffle oil.",
      "Enjoy your completed Sirloin and Scallion Jjapaguri."
    ]
  },
  {
    "name": "Sirloin and Scallion Chapaguri",
    "url": "https://youtu.be/WymD7rNJq78",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2024-11-29",
    "ingredients": [
      "Sirloin steak",
      "Scallions",
      "Chapagetti (instant black bean noodles)",
      "Neoguri (spicy seafood instant noodles)",
      "Olive oil"
    ],
    "steps": [
      "Sear the sirloin steak in a pan with olive oil, then remove and set aside.",
      "In the same pan, add the sliced scallions and stir-fry.",
      "Prepare water for boiling the noodles. In the pan where the scallions were stir-fried, add the Chapagetti seasoning packet and Neoguri seasoning packet, then pour in water to create a stir-fried Jjajang sauce.",
      "Add the cooked noodles to the Jjajang sauce pan and stir-fry well with the sauce.",
      "Place the stir-fried Chapaguri noodles in a bowl, then top with the sliced sirloin steak."
    ]
  },
  {
    "name": "Soft-Cooked Egg Jin Ramen",
    "url": "https://youtu.be/fNbCxxlGfXc",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2024-12-03",
    "ingredients": [
      "Jin Ramen",
      "Egg"
    ],
    "steps": [
      "Add water to a pot and bring to a boil.",
      "Add the ramen soup base and dried vegetable flakes to the boiling water.",
      "Add the ramen noodles to the soup and boil for 3 minutes.",
      "Crack an egg into a bowl and whisk it.",
      "Transfer the cooked noodles to the bowl with the whisked egg and mix, allowing the residual heat to cook the egg.",
      "Carefully pour the soup from the pot into the bowl with the noodles, along the edges.",
      "Lightly mix the noodles and soup once."
    ]
  },
  {
    "name": "Egg-Coated Jin Ramen",
    "url": "https://youtu.be/tyGZAxtExgo",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2024-12-03",
    "ingredients": [
      "Jin Ramen",
      "Egg",
      "Green Onion Kimchi"
    ],
    "steps": [
      "Boil water, add Jin Ramen noodles and soup base, and cook.",
      "Beat an egg in a bowl.",
      "Transfer the cooked ramen noodles to the bowl with the beaten egg.",
      "Pour the ramen broth over the noodles to coat them with the egg.",
      "Top with well-fermented green onion kimchi and enjoy."
    ]
  },
  {
    "name": "Pressed Mackerel Sushi",
    "url": "https://youtu.be/0OL210IRRx4",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2024-12-09",
    "ingredients": [
      "Mackerel",
      "Vinegar",
      "Sugar",
      "Salt",
      "Wasabi",
      "Sudachi",
      "Yuzu",
      "Ginger",
      "Shiso leaves",
      "Sesame seeds"
    ],
    "steps": [
      "Scale the mackerel from tail to head, remove the guts, and wash thoroughly.",
      "Place the mackerel on a cutting board, remove the head, then fillet into two halves by cutting along the backbone.",
      "Remove the thin membrane and pin bones from the mackerel fillets, and trim off the reddish bloodline (chiai).",
      "Generously spread salt on a perforated tray. Place the mackerel fillets skin-side up, then completely cover them with more salt and cure for 2 hours. (Tilt the tray during curing to drain water.)",
      "Rinse the cured mackerel thoroughly with plain water to remove salt, then pat dry completely with paper towels.",
      "Cook rice with less water than usual to make it firmer. Transfer to a large bowl and let it cool slightly.",
      "Prepare sushi vinegar (6 parts vinegar : 3 parts sugar : 1 part salt). Add it to the cooled rice, mix by cutting with a spatula, then fan to cool.",
      "Mix roasted sesame seeds into the sushi rice. Thinly slice and julienne only the yellow peel of the yuzu. Finely chop the shiso leaves and ginger.",
      "On the flesh side of the mackerel fillet, spread a thin layer of chopped shiso and yuzu on one half, and chopped ginger and wasabi on the other half.",
      "Place an appropriate amount of rice lengthwise on the mackerel fillet. Wrap tightly with a paper towel or plastic wrap, forming a firm rectangular log.",
      "Slice the finished pressed mackerel sushi into even pieces. Lightly torch (aburi) the skin side to render some of the oil.",
      "Arrange the pressed mackerel sushi on a plate and enjoy. (For a richer flavor, drizzle the rendered mackerel oil from torching over the rice.)"
    ]
  },
  {
    "name": "Mackerel Bo-sushi",
    "url": "https://youtu.be/NZX23zm6iRs",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2024-12-11",
    "ingredients": [
      "Mackerel",
      "Shiso",
      "Yuzu",
      "Rice"
    ],
    "steps": [
      "Place finely chopped shiso and yuzu on the prepared mackerel fillet.",
      "Place rice and the filling ingredients inside the mackerel fillet, then roll tightly to form the bo-sushi.",
      "Lightly sear the surface of the finished mackerel bo-sushi with a torch.",
      "Drizzle the oil rendered from the torched mackerel onto the bo-sushi."
    ]
  },
  {
    "name": "Snow Crab Shabu-Shabu",
    "url": "https://youtu.be/CksX-xCg83c",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2024-12-16",
    "ingredients": [
      "Snow Crab",
      "Kelp",
      "Ponzu Sauce",
      "Sudachi"
    ],
    "steps": [
      "Add kelp to water and gently heat to 70-80°C.",
      "Once the kelp softens enough to be easily pressed with a fingernail, remove it from the water.",
      "Bring the broth to a boil above 90°C to coagulate the kelp's mucilage (impurities), then skim off the foam.",
      "Separate the snow crab legs from the body. Cut the body in half, remove inedible parts, and clean the innards.",
      "Cut off the shells and remove tendons from the separated crab legs, extracting only the meat. Soak the meat in ice water until it blooms like a flower.",
      "Add the remaining crab body parts and leg shells to the broth to enhance its flavor.",
      "Dip the prepared snow crab leg meat into the boiling broth for 2-3 seconds until it blooms like a flower.",
      "Serve the blanched crab meat with ponzu sauce or a squeeze of sudachi juice."
    ]
  },
  {
    "name": "Tomato Meatballs",
    "url": "https://youtu.be/uUHBUwiliGI",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2024-12-23",
    "ingredients": [
      "Beef",
      "Pork",
      "Onion",
      "Bread",
      "Garlic",
      "Parsley",
      "Parmesan Cheese",
      "Salt",
      "Pepper",
      "Tomato Sauce",
      "Dried Herbs",
      "Mozzarella Cheese",
      "Basil",
      "Milk",
      "Olive Oil"
    ],
    "steps": [
      "Trim the crusts from the bread and cut into pieces.",
      "Soak the bread in milk.",
      "Combine beef, pork, minced garlic, parsley, Parmesan cheese, salt, and pepper in a large bowl.",
      "Squeeze out excess milk from the soaked bread and add it to the meat mixture.",
      "Knead the mixture thoroughly, adjusting consistency with milk if needed, until well combined and pliable.",
      "Form the mixture into large, round meatballs.",
      "Heat olive oil in a pan. Chop the onion.",
      "Add the chopped onion and garlic to the pan and sauté until softened.",
      "Add water to the tomato sauce and bring to a boil.",
      "Stir in pepper, salt, parsley, and dried herbs, then continue to boil.",
      "Brown the meatballs over medium heat, taking care not to burn them.",
      "Add the browned meatballs to the tomato sauce and simmer together.",
      "Simmer gently over medium-low heat for about 15 minutes.",
      "Sprinkle mozzarella cheese on top and let it melt.",
      "Garnish with basil and Parmesan cheese."
    ]
  },
  {
    "name": "Rice Cake and Dumpling Soup",
    "url": "https://youtu.be/DQ-aJ91znkY",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-01-06",
    "ingredients": [
      "Brisket",
      "Sliced rice cakes",
      "Large dumplings",
      "Kelp",
      "Seasoned seaweed flakes",
      "Store-bought ox bone soup base",
      "Egg",
      "Minced garlic",
      "Soy sauce",
      "Sesame oil",
      "Sesame seeds"
    ],
    "steps": [
      "Add kelp to cold water and slowly heat to 80°C to make a broth.",
      "Prepare brisket by slicing it thinly along the grain.",
      "Once the kelp broth reaches 80°C, remove the kelp.",
      "Add the brisket to the broth and cook until done, skimming off any foam.",
      "Soak the rice cakes in cold water and prepare the dumplings.",
      "Remove the cooked brisket, let it cool, then shred it by hand.",
      "Mix the shredded brisket with soy sauce, sesame oil, and sesame seeds to prepare the garnish.",
      "Pour the ox bone soup base into the broth to create a milky white soup.",
      "Add the soaked rice cakes and large dumplings to the broth and bring to a boil.",
      "Add minced garlic to season the soup.",
      "Turn off the heat, add beaten egg, and stir gently to cook until fluffy.",
      "Ladle the finished soup into bowls and top with the brisket garnish and seasoned seaweed flakes."
    ]
  },
  {
    "name": "Cumin Poached Egg Ramen",
    "url": "https://youtu.be/9l4kklDVsb0",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-01-13",
    "ingredients": [
      "Shin Ramyun Air-Dried Noodles",
      "Egg",
      "Cheongyang Chili Pepper",
      "Powdered Soup Base",
      "Flakes",
      "Vegetable Seasoning Oil",
      "Lamb Skewer Seasoning (Cumin Seasoning)"
    ],
    "steps": [
      "Thickly slice the Cheongyang chili pepper.",
      "Pour water into a pot and place it on the stove.",
      "Once the water starts boiling, add the ramen powdered soup base, vegetable seasoning oil, and flakes.",
      "Add the Shin Ramyun air-dried noodles and the sliced Cheongyang chili pepper, then boil.",
      "Add the lamb skewer seasoning (cumin).",
      "After boiling the noodles for 2 minutes and 30 seconds, temporarily remove from heat and crack an egg into the center of the noodles."
    ]
  },
  {
    "name": "Cumin Egg Shin Ramyun",
    "url": "https://youtu.be/c57a67SckGQ",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-01-14",
    "ingredients": [
      "Shin Ramyun",
      "Egg",
      "Cheongyang Chili Pepper",
      "Lamb Skewer Seasoning"
    ],
    "steps": [
      "Slice the Cheongyang chili pepper to a moderate thickness.",
      "Add about 500ml of water to a pot and bring it to a boil.",
      "Once the water boils, add the Shin Ramyun noodles, soup base, and vegetable flakes, and continue boiling.",
      "Add the sliced Cheongyang chili pepper and one level teaspoon of lamb skewer seasoning.",
      "Crack an egg and gently place it into the center of the ramen.",
      "Boil on medium-low heat, gently stirring the noodles with chopsticks to prevent the egg from sticking to the bottom.",
      "Once the egg whites float and the noodles are fully cooked, turn off the heat and transfer the ramen to a bowl."
    ]
  },
  {
    "name": "Cumin Egg Shin Ramyun",
    "url": "https://youtu.be/zxoNUH7udNA",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-01-15",
    "ingredients": [
      "Shin Ramyun",
      "Egg",
      "Cheongyang pepper",
      "Cumin seasoning"
    ],
    "steps": [
      "Add Shin Ramyun soup base to boiling water.",
      "Slice Cheongyang pepper.",
      "Add noodles to the pot and cook.",
      "Add sliced Cheongyang pepper to the boiling noodles.",
      "Crack an egg into the ramen and cook until soft-boiled.",
      "Transfer cooked ramen to a bowl.",
      "Gently break the yolk and enjoy with the noodles."
    ]
  },
  {
    "name": "Cabbage Steak",
    "url": "https://youtu.be/MnC46BncM18",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-01-20",
    "ingredients": [
      "Napa cabbage",
      "Kelp",
      "Parmesan cheese",
      "Garlic",
      "Peperoncino",
      "Salt",
      "Pepper",
      "Paprika",
      "Herbs",
      "Butter",
      "Cooking oil",
      "Olive oil"
    ],
    "steps": [
      "Melt water and butter slowly over the lowest heat.",
      "Cut the napa cabbage into quarters.",
      "Cut and add kelp to the melted butter.",
      "Season the cabbage with salt and slowly cook it cut-side down in a pan with cooking oil over low heat.",
      "Add water to rehydrate the kelp.",
      "Once the cut sides of the cabbage start to cook, add peperoncino and garlic.",
      "Pour the prepared kelp butter mixture little by little over the cabbage as it cooks.",
      "Adjust the pan's position to prevent the garlic and peperoncino from burning.",
      "Season with pepper before removing the cabbage from the pan.",
      "Generously sprinkle Parmesan cheese.",
      "Garnish with paprika for color.",
      "Finish with herbs and olive oil."
    ]
  },
  {
    "name": "Kim Ho-yoon's Baby Napa Cabbage Steak",
    "url": "https://youtu.be/BCOTgmCdF_g",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-01-21",
    "ingredients": [
      "Baby Napa Cabbage",
      "Garlic",
      "Peperoncino",
      "Herbs",
      "Parmigiano-Reggiano Cheese",
      "Butter",
      "Paprika Powder",
      "Salt",
      "Pepper",
      "Dried Kelp",
      "Olive Oil"
    ],
    "steps": [
      "Add water and butter to a pan and melt slowly over very low heat.",
      "Cut the cabbage into quarters.",
      "Cut the dried kelp and add it to the melted butter.",
      "Season the cabbage with salt, then sear the cut sides slowly over low heat with oil.",
      "Add water to the kelp until it rehydrates.",
      "Once the cut sides of the cabbage start to brown and cook, add peperoncino and garlic.",
      "Gradually pour the kelp butter over the cabbage as it cooks.",
      "Adjust the pan position to prevent the garlic and chili from burning.",
      "Season with pepper before removing the cabbage from the pan.",
      "Sprinkle generously with Parmigiano-Reggiano cheese.",
      "Garnish with paprika powder for color.",
      "Finish with herbs and olive oil."
    ]
  },
  {
    "name": "Shin Ramyun with Egg and Cheese",
    "url": "https://youtu.be/XyNXtW550kc",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-01-28",
    "ingredients": [
      "Shin Ramyun",
      "Egg",
      "Cheese",
      "Scallions"
    ],
    "steps": [
      "Boil water.",
      "Add Shin Ramyun noodles and soup base, then cook.",
      "When the ramen is almost done, crack in an egg and do not stir.",
      "Transfer the ramen to a bowl.",
      "Place cheese on top of the ramen.",
      "Ladle hot broth over the cheese to melt it.",
      "Garnish with scallions."
    ]
  },
  {
    "name": "Tomato Chicken Steak",
    "url": "https://youtu.be/VoKDkaUiavg",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-02-03",
    "ingredients": [
      "Chicken Thighs",
      "Red Onion",
      "Black Olives",
      "Minced Garlic",
      "Potato Chips",
      "Arrabbiata Tomato Sauce",
      "Chili Oil",
      "Gochujang",
      "Parmesan Cheese",
      "Salt",
      "Black Pepper",
      "Parsley",
      "Butter",
      "Olive Oil"
    ],
    "steps": [
      "Slice the red onion into rounds and soak in ice water.",
      "Prepare the chicken thighs and season with salt and pepper.",
      "Drizzle olive oil into a pan.",
      "Cook the chicken skin-side down, pressing firmly to keep them flat.",
      "Adjust heat and cook until the chicken skin is crispy.",
      "Add minced garlic and chili oil to the chicken fat in the pan.",
      "Add the Arrabbiata sauce.",
      "Add sliced black olives.",
      "Add Gochujang.",
      "Return the chicken steak to the tomato sauce and let it simmer briefly.",
      "Drain the red onion and plate it."
    ]
  },
  {
    "name": "Tomato Chicken Steak",
    "url": "https://youtu.be/5xXPxBkujsA",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-02-04",
    "ingredients": [
      "Chicken Thigh",
      "Red Onion",
      "Black Olives",
      "Potato Chips",
      "Arrabbiata Tomato Sauce",
      "Gochujang",
      "Garlic",
      "Salt",
      "Black Pepper",
      "Chili Oil",
      "Butter",
      "Olive Oil"
    ],
    "steps": [
      "Slice the red onion into rings and soak in ice water.",
      "Trim the chicken thighs and season with salt and black pepper.",
      "Drizzle olive oil in a pan.",
      "Cook the chicken skin-side down, pressing firmly to prevent shrinkage.",
      "Adjust heat and cook until the skin is crispy.",
      "Add 2/3 teaspoon of garlic and 1 teaspoon of chili oil to the chicken fat in the pan.",
      "Add 200g of Arrabbiata sauce.",
      "Add 10 sliced black olives.",
      "Add 1 teaspoon of gochujang.",
      "Add the chicken steak to the tomato sauce and let it simmer briefly.",
      "Drain the red onion from the ice water and plate."
    ]
  },
  {
    "name": "Creamy Oyster and Spinach Risoni Pasta",
    "url": "https://youtu.be/-kWArpJDyGs",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-02-10",
    "ingredients": [
      "Oyster",
      "Spinach",
      "Risoni pasta",
      "Garlic",
      "Peperoncino",
      "Dill",
      "Pecorino cheese",
      "Oyster sauce",
      "Chicken stock",
      "Salt",
      "Black pepper",
      "Olive oil",
      "Heavy cream",
      "White wine",
      "Breadcrumbs"
    ],
    "steps": [
      "Add olive oil and garlic to a pan over medium heat.",
      "Crumble and add the peperoncino.",
      "Add the oysters before the garlic turns golden brown.",
      "Remove the oysters before too much moisture is released.",
      "Add white wine.",
      "Add the risoni pasta.",
      "Add water to the pan, ensuring the pasta is coated with the oil.",
      "Boil vigorously for 4 minutes.",
      "Add black pepper and oyster sauce.",
      "After 4 minutes, add the heavy cream.",
      "Stir well for 2 minutes after adding the heavy cream.",
      "Add the spinach.",
      "Reduce the heat and add Pecorino cheese.",
      "Add water and the previously removed oysters.",
      "Add Pecorino cheese.",
      "Plate the dish, topping with breadcrumbs and herbs."
    ]
  },
  {
    "name": "One-Pan Oyster & Cream Pasta",
    "url": "https://youtu.be/-uchgW2LB3E",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-02-11",
    "ingredients": [
      "Oysters",
      "Spinach",
      "Orzo pasta",
      "Garlic",
      "Heavy cream",
      "Chicken stock",
      "Pecorino cheese",
      "Oyster sauce",
      "White wine",
      "Peperoncino",
      "Black pepper",
      "Breadcrumbs",
      "Olive oil",
      "Herbs"
    ],
    "steps": [
      "Heat olive oil and minced garlic over medium heat.",
      "Crush and add peperoncino.",
      "Add oysters before the garlic turns golden.",
      "Remove oysters from the pan before they release too much liquid and set aside.",
      "Add white wine to the pan.",
      "Add Orzo pasta.",
      "Add water to the pan.",
      "Bring to a boil and cook for 4 minutes.",
      "Add black pepper and oyster sauce.",
      "After 4 minutes, add heavy cream.",
      "Set a timer for 2 minutes after adding the cream and stir well.",
      "Add spinach.",
      "Reduce heat and add Pecorino cheese.",
      "Add water, then return the reserved oysters to the pan over medium-high heat.",
      "Add Pecorino cheese.",
      "Plate and garnish with breadcrumbs and herbs."
    ]
  },
  {
    "name": "Sundubu Gratin",
    "url": "https://youtu.be/sXnZVHew-U8",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-02-17",
    "ingredients": [
      "Soft tofu",
      "Cabbage",
      "Oyster mushrooms",
      "Shrimp",
      "Broccoli",
      "Bacon",
      "Egg",
      "Tomato sauce",
      "Salt",
      "Pepper",
      "Chili oil",
      "Minced garlic",
      "Mozzarella cheese",
      "Reggiano cheese",
      "Parsley",
      "Olive oil"
    ],
    "steps": [
      "Sauté bacon in chili oil.",
      "Add prepared cabbage and salt over medium heat.",
      "Once the cabbage wilts, add prepared oyster mushrooms and minced garlic.",
      "Add a splash of water to the pan to deglaze and enhance flavors.",
      "Add soft tofu and shrimp, then slightly increase the heat.",
      "Cover generously with tomato sauce.",
      "Season with salt and pepper.",
      "Add prepared broccoli and an egg, then break the egg yolk.",
      "Top with mozzarella cheese and Reggiano cheese, cover, and bake in a preheated oven at 200°C for 5 minutes.",
      "Finish by sprinkling with Reggiano cheese, parsley, and olive oil."
    ]
  },
  {
    "name": "Scarlett Johansson Pasta",
    "url": "https://youtu.be/cmgitd9Ui6A",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-02-24",
    "ingredients": [
      "Spaghetti",
      "Garlic",
      "Parsley",
      "Lemon",
      "Parmigiano-Reggiano cheese",
      "Chicken stock",
      "Peperoncino",
      "Salt",
      "Pepper",
      "Butter",
      "Olive oil"
    ],
    "steps": [
      "Prepare and finely chop the parsley.",
      "Slice the garlic.",
      "Add salt to water and bring to a boil.",
      "Once boiling, add spaghetti noodles and cook.",
      "Heat olive oil and sauté the garlic.",
      "Add crushed parsley stems and peperoncino.",
      "Add pasta water.",
      "Add the cooked pasta, pasta water, chicken stock, and pepper.",
      "Adjust heat to medium to medium-high and add the prepared parsley.",
      "Add Parmigiano-Reggiano cheese and butter, then reduce heat to medium.",
      "Add more pasta water.",
      "Add remaining parsley and lemon zest.",
      "Finish with Parmigiano-Reggiano cheese, parsley, and olive oil."
    ]
  },
  {
    "name": "Scarlett Johansson Pasta",
    "url": "https://youtu.be/CZRYhkQV1mc",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-02-25",
    "ingredients": [
      "Spaghetti",
      "Parmigiano Reggiano cheese",
      "Garlic",
      "Lemon",
      "Parsley",
      "Pepperoncini",
      "Chicken stock",
      "Salt",
      "Black pepper",
      "Butter",
      "Olive oil"
    ],
    "steps": [
      "Clean and finely chop fresh parsley.",
      "Slice the garlic.",
      "Bring 1L water to a boil with salt.",
      "Once boiling, add spaghetti and cook for 4 to 4.5 minutes.",
      "Heat olive oil and sauté the garlic.",
      "Crush 2-3 pepperoncini and add them along with parsley stems.",
      "Add 4oz of pasta water.",
      "Combine the cooked pasta, 4oz pasta water, 1/2 tbsp chicken stock, and black pepper.",
      "Adjust heat to medium-medium high and add some of the chopped parsley.",
      "Add Parmigiano Reggiano cheese and butter, then reduce heat to medium.",
      "Add 2oz more pasta water as needed.",
      "Add the remaining parsley and about 1/3 of the lemon zest.",
      "Finish with Parmigiano Reggiano cheese, parsley, and a drizzle of olive oil."
    ]
  },
  {
    "name": "Oyster Jjamppong",
    "url": "https://youtu.be/Bwr6H9GK_2w",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-03-03",
    "ingredients": [
      "Oyster",
      "Garlic chives",
      "Shiitake mushrooms",
      "Cheongyang pepper",
      "Napa cabbage",
      "Onion",
      "Carrot",
      "Green onion",
      "Garlic",
      "Ginger",
      "Aromatic vegetables",
      "Sugar",
      "MSG",
      "Salt",
      "Chicken stock",
      "Cooking rice wine",
      "Oyster sauce",
      "Soy sauce",
      "Chinese noodles",
      "Sesame oil",
      "Cooking oil"
    ],
    "steps": []
  },
  {
    "name": "Mapo Tofu with Fish Roe and Milt",
    "url": "https://youtu.be/muKUuq5GdLM",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-03-10",
    "ingredients": [
      "Tofu",
      "Fish Milt",
      "Fish Roe",
      "Minced Pork",
      "Scallions",
      "Garlic",
      "Ginger",
      "Doubanjiang",
      "Chili Oil",
      "MSG",
      "Cooking Sake",
      "Soy Sauce",
      "Oyster Sauce",
      "Dark Soy Sauce",
      "Sichuan Peppercorns",
      "Salt",
      "Sugar",
      "Sesame Oil",
      "Cooking Oil",
      "Potato Starch"
    ],
    "steps": [
      "Cut tofu into bite-sized pieces, pat dry with paper towels, then coat lightly with potato starch.",
      "Add cooking oil to a cold pan, then place the starch-coated tofu and pan-fry until golden brown.",
      "In the pan, add minced pork and stir-fry until the moisture evaporates, then add chili oil, scallions, garlic, and ginger, and continue to stir-fry until fragrant.",
      "Add cooking sake, soy sauce, doubanjiang, MSG, sugar, oyster sauce, chicken stock, and water (400ml), bring to a boil, then add dark soy sauce to adjust the color.",
      "Once it starts boiling, add Sichuan peppercorns, then gradually pour in a slurry of starch and water while continuously stirring with a spatula to thicken the sauce.",
      "Add the fried tofu, blanched fish milt, and fish roe, gently stir to coat with the sauce without breaking them, then drizzle with a little sesame oil and chili oil to finish."
    ]
  },
  {
    "name": "Four-Color Sirutteok",
    "url": "https://youtu.be/mXOjd2fXtJQ",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-03-17",
    "ingredients": [
      "Red beans",
      "Sweet pumpkin",
      "Spinach",
      "Lettuce",
      "Gardenia powder",
      "Glutinous rice flour",
      "Non-glutinous rice flour",
      "Sugar",
      "Salt"
    ],
    "steps": [
      "Wash the red beans, soak them in water, boil for 3 minutes, and discard the first water.",
      "Add new water (3 times the amount of red beans) and boil for 30-40 minutes until the red beans are soft.",
      "Cut off the root ends of the spinach and blend it with 100ml of water in a blender.",
      "Cut the sweet pumpkin in half, remove the seeds, and microwave for 3 minutes.",
      "Thinly slice the microwaved sweet pumpkin and microwave again for 1 minute 30 seconds.",
      "Put the blended spinach into a cheesecloth, squeeze out the juice, and set aside."
    ]
  },
  {
    "name": "Sage Butter Pasta",
    "url": "https://youtu.be/2RpQtkFBK_k",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-03-24",
    "ingredients": [
      "Eggs",
      "Sage",
      "Minced garlic",
      "Parsley",
      "Parmigiano Reggiano cheese",
      "Chicken broth",
      "Salt",
      "Pepper",
      "Butter",
      "Olive oil",
      "Truffle oil",
      "All-purpose flour",
      "Semolina flour"
    ],
    "steps": [
      "Mix 200g all-purpose flour with 2 eggs to form a dough, then let it rest for 20 minutes.",
      "Divide the rested dough into rectangular portions.",
      "Using a pasta machine, roll the dough thin.",
      "Dust the rolled dough with semolina flour, then cut it into noodles using the pasta machine.",
      "Prepare 4oz of chicken broth.",
      "Heat 30ml of olive oil in a pan.",
      "Sauté 1 tablespoon of minced garlic over low heat until golden.",
      "Melt 130g of butter in the pan.",
      "Add 14g of salt to boiling water and cook the pasta for 1 minute.",
      "Add the cooked pasta to the sautéed garlic and butter sauce, then add 2g of salt and mix.",
      "Add 30g of Parmigiano Reggiano cheese and 5 sage leaves, then mix.",
      "Plate the pasta, make a well in the center, and top with an egg yolk.",
      "Garnish with Parmigiano Reggiano cheese and pepper around the yolk, drizzle with truffle oil, and serve."
    ]
  },
  {
    "name": "Grilled Pork Belly",
    "url": "https://youtu.be/_KhpWDSrarg",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-03-31",
    "ingredients": [
      "Pork belly"
    ],
    "steps": [
      "Select thick, well-marbled pork belly.",
      "Separate the pork belly into head-side, lower belly, and back-side sections, trimming along the rib bones.",
      "Cut diagonally along the muscle grain and separate any tough, lean tail-end parts.",
      "Separate and trim the front muscle (lower abdominal muscle).",
      "Slice the prepared pork belly to a suitable grilling thickness (e.g., 2cm or 4cm).",
      "Place pork belly in a pan and grill until golden brown, searing the surface with a torch if desired.",
      "Slice the well-grilled pork belly into bite-sized pieces and serve."
    ]
  },
  {
    "name": "Mushroom Steak Truffle Cream Pasta",
    "url": "https://youtu.be/DYArgYxwtlQ",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-04-01",
    "ingredients": [
      "Oyster Mushrooms",
      "King Oyster Mushrooms",
      "Shallot",
      "Garlic",
      "Fusilli Lunghi Pasta",
      "White Truffle Porcini Puree",
      "Parmigiano-Reggiano Cheese",
      "White Wine",
      "Chicken Broth",
      "Heavy Cream",
      "Butter",
      "Olive Oil",
      "Truffle Oil",
      "Black Pepper",
      "Salt"
    ],
    "steps": [
      "Peel and slice half a shallot.",
      "Mince the garlic.",
      "Trim the ends of oyster mushrooms and tear into bite-sized pieces.",
      "Trim the stems of king oyster mushrooms and cut into cubes.",
      "Bring water to a boil, add salt, and cook fusilli lunghi pasta for at least 9 minutes.",
      "Heat olive oil in a pan over high heat, sear oyster mushrooms until browned, then season with a pinch of salt.",
      "Transfer the seared oyster mushrooms to a plate.",
      "Add more olive oil to the same pan, then sauté garlic, shallots, and king oyster mushrooms until fragrant and slightly colored.",
      "Season the sautéed mushrooms and shallots with a pinch of salt.",
      "Once the garlic is cooked, add white wine and reduce.",
      "Add pasta water and chicken broth.",
      "Add the cooked fusilli lunghi and white truffle porcini puree.",
      "Drizzle with olive oil, and once the pasta starts to simmer, sprinkle with pepper.",
      "Add heavy cream and simmer for 1-2 minutes until the cream thickens.",
      "Stir in a knob of butter.",
      "Transfer the pasta to a plate and top with the seared oyster mushrooms.",
      "Grate Parmigiano-Reggiano cheese over the top, then drizzle with truffle oil.",
      "Finish with a sprinkle of pepper."
    ]
  },
  {
    "name": "Perfectly Grilled Pork Belly",
    "url": "https://youtu.be/0TYMkWKhARY",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-04-04",
    "ingredients": [
      "Pork Belly",
      "Hind Pork Belly",
      "Pork Neck Meat",
      "Pork Fat",
      "Salt",
      "Butter"
    ],
    "steps": [
      "Render pork fat in a pan.",
      "Place 1cm thick pork belly in the pan, overlapping to melt the fat.",
      "Baste the meat with the rendered fat, pressing the external fat sections to melt the fat.",
      "Once the fat is sufficiently cooked and rendered, cut into bite-sized pieces and sprinkle with powdered salt.",
      "For 2cm thick pork belly, grill the subcutaneous fat side first over low heat, then stand it on its side with tongs to cook evenly.",
      "Remove excess fat from the pan.",
      "For 4cm thick pork belly, stand it upright and torch the skin until the fat bursts and cracks.",
      "Remove the skin and briefly grill the lean meat side just to color the surface.",
      "Cook the hind pork belly and pork neck meat thoroughly in the pan.",
      "Finish by grilling thinly sliced pork neck meat in a buttered pan."
    ]
  },
  {
    "name": "Mala Yeollamyeon",
    "url": "https://youtu.be/VZXK-QYazFA",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-04-07",
    "ingredients": [
      "Yeollamyeon ramen",
      "Perilla leaves",
      "Mala sauce",
      "Perilla seed powder",
      "Egg",
      "Sichuan peppercorn oil",
      "Black pepper"
    ],
    "steps": [
      "Pour 600ml water into a pot and bring to a boil.",
      "Before the water boils, add the Yeollamyeon soup base.",
      "Remove stems from 10 perilla leaves and julienne.",
      "Once the water boils, add 15g Mala sauce.",
      "Add the Yeollamyeon noodles and cook.",
      "After 2 minutes 30 seconds, add 3T perilla seed powder, julienned perilla leaves, and an egg, then stir gently to poach the egg.",
      "Transfer the ramen to a bowl, then garnish with remaining julienned perilla leaves and 1T perilla seed powder.",
      "Finish by drizzling 2 drops of Sichuan peppercorn oil and a pinch of black pepper."
    ]
  },
  {
    "name": "Spinach Pesto Pasta",
    "url": "https://youtu.be/MEK1-AVTs9w",
    "uploader": "미뇨끼",
    "upload_date": "2024-04-07",
    "ingredients": [
      "Spinach",
      "Garlic",
      "Macadamia nuts",
      "Ricotta cheese",
      "Mafaldine pasta",
      "Parmesan cheese",
      "Salt",
      "Olive oil"
    ],
    "steps": [
      "Add macadamia nuts, spinach, olive oil, salt, and cream cheese to a blender and process.",
      "Blend until the ingredients form a smooth green sauce.",
      "Cook Mafaldine pasta in boiling water.",
      "Drain the cooked pasta, transfer to a bowl, and add the green sauce and Parmesan cheese.",
      "Toss the pasta to ensure all ingredients are well combined.",
      "Serve the pasta on a plate and drizzle with olive oil to finish."
    ]
  },
  {
    "name": "Thick-Cut Grilled Pork Belly",
    "url": "https://youtu.be/EIx6_92AhxE",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-04-09",
    "ingredients": [
      "Pork belly"
    ],
    "steps": [
      "Place the thick-cut pork belly in a pan and begin grilling.",
      "Press down on the fatty parts of the pork belly in the pan to render out the fat.",
      "Use a torch to char the skin side of the pork belly for a smoky flavor.",
      "Stand the cooked pork belly upright and use a knife to cut off the skin.",
      "Slice the skin-removed pork belly into bite-sized pieces to complete."
    ]
  },
  {
    "name": "Crispy Butter Baby Potatoes",
    "url": "https://youtu.be/7_DF6S7aGhQ",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-04-12",
    "ingredients": [
      "Baby Potatoes",
      "Onion",
      "Pickles",
      "Lemon",
      "Bacon",
      "Mayonnaise",
      "Whole Grain Mustard",
      "Salt",
      "Sugar",
      "Butter",
      "Parsley",
      "Olive Oil"
    ],
    "steps": [
      "Add 10g of salt to 1L of water and boil 1kg of baby potatoes for 20 minutes.",
      "Drain the boiled potatoes and mash them.",
      "Mix chopped onion, pickles, lemon juice, sugar, salt, mayonnaise, and whole grain mustard to make a sauce.",
      "Heat olive oil in a pan and fry the bacon.",
      "Add the mashed potatoes and 50g of butter to the frying bacon and fry until golden brown.",
      "Once the potatoes turn brown, add two more pieces of butter and continue frying."
    ]
  },
  {
    "name": "Crispy Bacon Potatoes",
    "url": "https://youtu.be/ho24Ag9J5g4",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-04-12",
    "ingredients": [
      "Small potatoes",
      "Bacon",
      "Onion",
      "Jalapeño",
      "Pickle",
      "Lemon",
      "Sugar",
      "Salt",
      "Mayonnaise",
      "Whole grain mustard",
      "Parsley",
      "Pepper",
      "Butter",
      "Olive oil"
    ],
    "steps": [
      "Wash the small potatoes thoroughly.",
      "Pour water into a pot, add salt to achieve approximately 1% salinity, and boil the small potatoes for 15-20 minutes until slightly undercooked with a slight resistance when poked.",
      "Drain the boiled small potatoes and mash them using the bottom of a cup.",
      "In a bowl, combine minced onion, minced jalapeño, minced pickle, lemon juice, sugar, salt, mayonnaise, and whole grain mustard, then mix well to make a dipping sauce.",
      "Lightly coat a non-stick pan with olive oil, add minced bacon, and cook over medium heat until golden brown and enough fat has rendered.",
      "Add the mashed potatoes to the pan with butter and sauté over medium-high heat until the potatoes are crispy from the butter and bacon fat."
    ]
  },
  {
    "name": "Okra and Shirasu Pasta",
    "url": "https://youtu.be/onfMAbLEEKQ",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-04-14",
    "ingredients": [
      "Pasta",
      "Okra",
      "Shirasu",
      "Anchovy",
      "Chives",
      "Garlic",
      "Capers",
      "Salt",
      "Olive oil",
      "Chicken stock",
      "Parsley",
      "Lemon"
    ],
    "steps": [
      "Trim both ends of the okra and slice diagonally.",
      "Sprinkle salt on the okra, rub, and rinse.",
      "Heat 30ml of olive oil in a pan.",
      "Over low heat, add 2/3 tsp of garlic and sauté until fragrant.",
      "Add 1/2 tsp capers, 1 finely chopped anchovy, and 5 pieces of okra, and sauté briefly.",
      "Add 500ml of water and bring to a boil over high heat.",
      "Add 100g of pasta.",
      "Add 1/2 tbsp of chicken stock and cook.",
      "While the pasta is cooking, finely chop the white parts of the chives.",
      "First, add the prepared white parts of the chives.",
      "Add additional olive oil, tossing the pan until the sauce emulsifies.",
      "Plate the pasta, top with 30-50g of shirasu, and garnish with the green parts of the chives.",
      "Finish with a sprinkle of grated lemon zest."
    ]
  },
  {
    "name": "Spaghetti with Saffron",
    "url": "https://youtu.be/CuQCMa-QyX0",
    "uploader": "미뇨끼",
    "upload_date": "2023-03-25",
    "ingredients": [
      "Spaghetti",
      "Bacon",
      "Saffron",
      "Parmesan cheese",
      "Olive oil"
    ],
    "steps": [
      "Blend saffron, Parmesan cheese, and water to create the saffron mix.",
      "Heat olive oil in a pan and sauté the bacon.",
      "Add cooked spaghetti and pasta water to the sautéed bacon and mix well.",
      "Stir in the saffron mix and toss until well combined with the pasta.",
      "Plate the finished saffron spaghetti."
    ]
  },
  {
    "name": "Kiwi Pizza",
    "url": "https://youtu.be/Hat2YdpcakI",
    "uploader": "미뇨끼",
    "upload_date": "2023-03-31",
    "ingredients": [
      "Kiwi",
      "Mozzarella cheese",
      "Canned tomatoes",
      "Yeast",
      "Salt",
      "Dried oregano",
      "Semolina flour"
    ],
    "steps": [
      "Dissolve yeast in water, add salt and semolina flour to make dough, knead thoroughly, then cover with a cloth and let it rise.",
      "Divide the risen dough into portions and shape each into a ball.",
      "Combine canned tomatoes and dried oregano in a pot, then mash to create pizza sauce.",
      "Peel and slice the kiwi.",
      "Roll out the dough on a floured surface to form a pizza crust, then spread tomato sauce.",
      "Top the crust with mozzarella cheese and sliced kiwi.",
      "Bake the pizza in a preheated oven until golden brown.",
      "Cut the finished kiwi pizza into serving-sized pieces."
    ]
  },
  {
    "name": "Pasta e Fagioli",
    "url": "https://youtu.be/e3DgSxDaUZM",
    "uploader": "미뇨끼",
    "upload_date": "2023-04-04",
    "ingredients": [
      "Bacon",
      "Carrots",
      "Cabbage",
      "Onion",
      "Canned tomatoes",
      "Canned white beans",
      "Pasta",
      "Chili pepper",
      "Parsley",
      "Olive oil"
    ],
    "steps": [
      "Chop bacon, parsley, and chili pepper.",
      "Heat olive oil in a pot and sauté diced bacon.",
      "Add chopped carrots, cabbage, and onion and sauté together.",
      "Add canned tomatoes, mash, and sauté.",
      "Add canned white beans and bring to a boil.",
      "Add pasta and cook until tender.",
      "Serve in bowls and sprinkle with chopped parsley."
    ]
  },
  {
    "name": "Ratatouille",
    "url": "https://youtu.be/yHJcndLqEgg",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-04-18",
    "ingredients": [
      "Zucchini",
      "Eggplant",
      "Tomatoes",
      "Bell Peppers",
      "Onion",
      "Garlic",
      "Tomato Paste",
      "Tomato Sauce",
      "Salt",
      "Black Pepper",
      "Parmesan Cheese",
      "Vinegar",
      "Olive Oil",
      "Thyme",
      "Rosemary",
      "Parsley",
      "Chives"
    ],
    "steps": [
      "Dice the onion and bell peppers to an appropriate size.",
      "Heat olive oil in a pan, add the onion and bell peppers, and sauté with salt.",
      "Add garlic and tomato paste, and sauté.",
      "Add tomato sauce and black pepper, and simmer.",
      "Transfer the sautéed vegetables, simmered tomato sauce, and rosemary leaves to a blender. Blend until smooth, seasoning with salt and black pepper, to make the sauce.",
      "Slice the zucchini, eggplant, and tomatoes thinly with a slicer, then season lightly with salt.",
      "Spread a generous layer of the prepared tomato sauce on an oven-safe dish.",
      "Arrange the sliced zucchini, eggplant, and tomatoes in overlapping circles on top of the sauce.",
      "Cover with parchment paper and bake in a preheated oven at 150°C for 20 minutes.",
      "Drizzle olive oil over the baked vegetables, then sprinkle with thyme and grated Parmesan cheese.",
      "To make the vinaigrette, combine equal parts of the main tomato sauce and olive oil, then add vinegar.",
      "Place the ratatouille on a serving plate and drizzle with the vinaigrette.",
      "Garnish with chives and thyme."
    ]
  },
  {
    "name": "Wine-Steamed Razor Clams",
    "url": "https://youtu.be/uVD4zmiQl0A",
    "uploader": "미뇨끼",
    "upload_date": "2023-04-15",
    "ingredients": [
      "Razor clams",
      "Garlic",
      "Green onions",
      "Chili pepper",
      "Parsley",
      "Black pepper",
      "White wine",
      "Olive oil",
      "Bread"
    ],
    "steps": [
      "Rinse and purge the razor clams.",
      "Slice the garlic and green onions, and finely chop the parsley.",
      "Heat olive oil in a pot, then sauté the sliced garlic and green onions.",
      "Add the razor clams, water, white wine, and black pepper, then bring to a boil.",
      "Add the chopped chili pepper and chopped parsley, and simmer until the razor clams open.",
      "Toast the bread.",
      "Plate the cooked razor clams, pour the remaining sauce over them, and serve with the toasted bread."
    ]
  },
  {
    "name": "Salsiccia and Friarielli Pizza",
    "url": "https://youtu.be/T7JTElKSSuI",
    "uploader": "미뇨끼",
    "upload_date": "2023-05-05",
    "ingredients": [
      "Salsiccia",
      "Friarielli",
      "Yellow tomatoes",
      "Fior di Latte Campano",
      "Grana Padano cheese",
      "Pizza dough",
      "Olive oil"
    ],
    "steps": [
      "Place salsiccia, yellow tomatoes, and Fior di Latte Campano on a flattened pizza dough.",
      "Evenly spread friarielli and Grana Padano on the pizza dough.",
      "Place the pizza with all ingredients into a pizza oven and bake until golden brown.",
      "Lightly drizzle olive oil over the baked pizza to finish."
    ]
  },
  {
    "name": "Polpette al Sugo",
    "url": "https://youtu.be/Q6aG1Mjv9PA",
    "uploader": "미뇨끼",
    "upload_date": "2023-05-14",
    "ingredients": [
      "Ground beef",
      "Parsley",
      "Ricotta cheese",
      "Raisins",
      "Pine nuts",
      "Rigatoni",
      "Tomato sauce",
      "Parmesan cheese",
      "Salt",
      "Olive oil"
    ],
    "steps": [
      "Combine ground beef with chopped parsley, ricotta cheese, Parmesan cheese, raisins, and pine nuts. Mix well and form into meatballs.",
      "Heat olive oil in a pan and brown the meatballs.",
      "Prepare tomato sauce in a separate pan.",
      "Boil salted water in a pot and cook the rigatoni.",
      "Combine the cooked rigatoni and browned meatballs with the tomato sauce.",
      "Serve in a dish and garnish with grated Parmesan cheese."
    ]
  },
  {
    "name": "Sugar Snap Scallop Pasta",
    "url": "https://youtu.be/XZtAy41vqSc",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-04-21",
    "ingredients": [
      "Scallops",
      "Spaghettini",
      "Sugar snap peas",
      "Cherry tomatoes",
      "Shiso leaves",
      "Garlic",
      "Peperoncino",
      "Shio kombu",
      "Oyster sauce",
      "Black pepper",
      "Salt",
      "Parmigiano Reggiano cheese",
      "Lemon",
      "Parsley",
      "Olive oil"
    ],
    "steps": [
      "Remove the tough adductor muscle from the scallops.",
      "Score the scallops and season with salt.",
      "Heat olive oil in a pan.",
      "Add the prepared scallops to the pan and cook for about 2 minutes per side until browned.",
      "Remove scallops, then add water to the pan to make scallop broth.",
      "Mince the small shiso leaves.",
      "Remove stems from cherry tomatoes and cut them in half.",
      "Snap off the ends and string the sugar snap peas.",
      "In a pan over low heat, add olive oil, minced garlic, and peperoncino, and sauté until the garlic turns golden.",
      "Add minced shio kombu and sauté together.",
      "Add water and bring to a boil over high heat.",
      "Add spaghettini to the pan and cook for 4 minutes 30 seconds.",
      "Add oyster sauce, black pepper, scallop broth, cooked scallops, sugar snap peas, cherry tomatoes, and additional water.",
      "Grate in some Parmigiano Reggiano cheese and lemon zest.",
      "Add minced shiso leaves and salt.",
      "Toss the ingredients in the pan to combine thoroughly.",
      "Plate the finished pasta and finish with a light grating of Parmigiano Reggiano cheese and lemon zest."
    ]
  },
  {
    "name": "Pasta in Bianco",
    "url": "https://youtu.be/2UGhKQfJ6Ug",
    "uploader": "미뇨끼",
    "upload_date": "2023-06-04",
    "ingredients": [
      "Pasta",
      "Parmigiano Reggiano",
      "Salt",
      "Butter"
    ],
    "steps": [
      "Boil water in a pot and add salt.",
      "Add conchiglie pasta and cook until al dente.",
      "Transfer the cooked pasta to a pan, turn off the heat, add butter, and mix.",
      "Add a generous amount of Parmigiano Reggiano cheese and mix well until creamy.",
      "Serve the finished pasta in a bowl, and finish by sprinkling more Parmigiano Reggiano cheese."
    ]
  },
  {
    "name": "Beet and Gorgonzola Risotto",
    "url": "https://youtu.be/8Q3iVkDTNTI",
    "uploader": "미뇨끼",
    "upload_date": "2023-06-11",
    "ingredients": [
      "Onion",
      "Red beet",
      "Rice",
      "Gorgonzola cheese",
      "Cream",
      "Parmesan cheese",
      "Salt",
      "Pepper",
      "Vegetable broth",
      "Butter",
      "White wine",
      "Olive oil",
      "Oil"
    ],
    "steps": [
      "Finely chop the onion and cook it in olive oil.",
      "Toast the rice in a separate pan.",
      "Add the rice to the onion, and once the rice absorbs the oil, add white wine.",
      "Slowly add vegetable broth and simmer the rice over low heat.",
      "Blend the beet, oil, salt, and pepper in a blender.",
      "Melt Gorgonzola cheese with cream.",
      "Stir butter, Parmesan cheese, and the beet puree into the risotto.",
      "Ladle the risotto onto plates and top with the cream sauce."
    ]
  },
  {
    "name": "Sugar Snap Pea Scallop Pasta",
    "url": "https://youtu.be/o5dVRl4Sf6I",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-04-24",
    "ingredients": [
      "Scallop",
      "Sugar Snap Pea",
      "Spaghettini",
      "Cherry Tomato",
      "Shiso Leaf",
      "Parsley",
      "Lemon",
      "Minced Garlic",
      "Peperoncino",
      "Shio Kombu",
      "Oyster Sauce",
      "Salt",
      "Black Pepper",
      "Olive Oil",
      "Parmigiano Reggiano Cheese"
    ],
    "steps": [
      "Prepare sugar snap peas by removing their fibrous strings. Prepare scallops by removing their side muscles and scoring them.",
      "Heat olive oil in a pan, sear scallops until golden brown on both sides, then set aside.",
      "Pour water into the pan where the scallops were seared to create scallop pan juices.",
      "In the same pan, heat olive oil, then sauté minced garlic, peperoncino, and shio kombu.",
      "Add water, spaghettini, oyster sauce, and black pepper to the pan, and cook until the pasta is done.",
      "When the spaghettini is almost cooked, add the seared scallops, sugar snap peas, and cherry tomatoes, and sauté together."
    ]
  },
  {
    "name": "Rigatoni Carbonara",
    "url": "https://youtu.be/faQq8Ee1TeA",
    "uploader": "미뇨끼",
    "upload_date": "2023-06-19",
    "ingredients": [
      "Guanciale",
      "Rigatoni",
      "Pecorino cheese",
      "Eggs",
      "Pepper",
      "Rendered guanciale fat"
    ],
    "steps": [
      "Cook guanciale until crispy, then strain and collect the rendered fat.",
      "Bring water to a boil in a pot.",
      "In a bowl, mix eggs, cheese, rendered fat, and hot water over the hot steam of the pot.",
      "Cook the rigatoni.",
      "Toast pepper and add the al dente pasta.",
      "Add the pasta to the bowl and mix well."
    ]
  },
  {
    "name": "Tom Yum Shrimp Noodle Soup",
    "url": "https://youtu.be/uCLvkoSTblM",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-04-25",
    "ingredients": [
      "Cilantro",
      "Lime",
      "Tom Yum paste",
      "Powdered soup base",
      "Flakes",
      "Milk"
    ],
    "steps": [
      "Add 550ml of water to a pot, then add the flakes and powdered soup base and bring to a boil.",
      "Once the water boils, add the noodles and 30g of Tom Yum paste, and cook.",
      "Add 100ml of milk. (For first-timers, it is recommended to use 50ml of milk and 600ml of water.)",
      "Roughly chop and add cilantro stems.",
      "Taste and add more milk according to personal preference.",
      "Finally, while there is residual heat, squeeze half a lime into the pot.",
      "Pour into a bowl and garnish with cilantro leaves."
    ]
  },
  {
    "name": "Fried Burrata Cheese",
    "url": "https://youtu.be/gnznwT6MRVU",
    "uploader": "미뇨끼",
    "upload_date": "2023-06-28",
    "ingredients": [
      "Burrata cheese",
      "Basil",
      "Tomato sauce",
      "Parmesan cheese",
      "Flour",
      "Egg",
      "Breadcrumbs",
      "Cooking oil"
    ],
    "steps": [
      "Coat the burrata cheese in flour.",
      "Dip the floured burrata cheese in egg wash.",
      "Coat the egg-washed burrata cheese in breadcrumbs.",
      "Fry the breaded burrata cheese in hot cooking oil until golden brown.",
      "Spread tomato sauce on a plate, then place the fried burrata cheese on top of basil leaves.",
      "Finally, grate and sprinkle Parmesan cheese."
    ]
  },
  {
    "name": "Risotto",
    "url": "https://youtu.be/GW5seRHdz3Q",
    "uploader": "미뇨끼",
    "upload_date": "2023-07-04",
    "ingredients": [
      "Rice",
      "Onion",
      "Artichoke",
      "Vegetable broth",
      "White wine",
      "Butter",
      "Parmesan cheese",
      "Salt",
      "Pepper",
      "Olive oil"
    ],
    "steps": [
      "Finely chop the onion and cook it in olive oil.",
      "In a separate pan, toast the rice for 3/4 minute.",
      "Add 2 chopped artichokes to the onion and season with salt and pepper.",
      "Add the rice, and once it has absorbed the oil, add the white wine.",
      "Gradually add the vegetable broth and simmer the rice over low heat.",
      "Stir in the butter and Parmesan cheese.",
      "Thinly slice and fry the remaining artichokes, then season with salt.",
      "Ladle the risotto onto plates and top with the fried artichokes."
    ]
  },
  {
    "name": "Easy Shrimp Pancakes V2",
    "url": "https://youtu.be/UY3i6D6ZhvY",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-04-29",
    "ingredients": [
      "Shrimp",
      "Dried shrimp",
      "Water parsley",
      "Onion",
      "Cheongyang chili",
      "Red chili",
      "Oyster sauce",
      "Tuna fish sauce",
      "Salt",
      "Black pepper",
      "Egg white",
      "Starch powder",
      "Frying mix",
      "Sesame oil",
      "Cooking oil"
    ],
    "steps": [
      "Thinly slice the onion.",
      "Mince the Cheongyang chili.",
      "Diagonally slice the red chili, removing the seeds.",
      "Mince the shrimp to your desired consistency.",
      "In a bowl, combine the minced shrimp, oyster sauce, tuna fish sauce, minced Cheongyang chili, and egg white; mix well.",
      "Add starch powder to the mixture for crispiness and mix thoroughly.",
      "Grease an oven-safe dish with sesame oil.",
      "Spread the shrimp mixture evenly on the dish.",
      "Bake in a preheated toaster oven at 250°C for 20 minutes.",
      "While the shrimp pancake bakes, trim the water parsley stems, chop into 4cm pieces, and place in a mixing bowl.",
      "To the water parsley, add starch powder, frying mix, water, and salt; mix to create a batter.",
      "Take the shrimp pancake out of the oven, top with the sliced red chili, brush with sesame oil, and continue baking for the remaining time.",
      "Heat cooking oil in a pan over high heat, then stir the water parsley batter once and pour it into the pan.",
      "Place minced shrimp and dried shrimp on top of the water parsley pancake, reduce heat to medium, and gently press the surface.",
      "When smoke rises from inside the pancake, reduce heat to low, flip the pancake, and gently press it down.",
      "Drizzle a little cooking oil around the flipped pancake for extra crispiness.",
      "Transfer the finished pancakes to a serving dish."
    ]
  },
  {
    "name": "Lemon Cream Pasta",
    "url": "https://youtu.be/k2Nsdq2S4xM",
    "uploader": "미뇨끼",
    "upload_date": "2023-07-16",
    "ingredients": [
      "Pasta",
      "Lemon",
      "Garlic",
      "Cream",
      "Basil",
      "Parmesan cheese",
      "Black pepper",
      "Olive oil",
      "Butter"
    ],
    "steps": [
      "Sauté minced garlic in olive oil.",
      "Add cream.",
      "Add lemon and basil, mix well.",
      "Add pasta and pasta water to the sauce.",
      "Add Parmesan cheese and butter.",
      "Garnish with Parmesan cheese, black pepper, lemon zest, and basil."
    ]
  },
  {
    "name": "Fried Mozzarella Toast",
    "url": "https://youtu.be/oUHockctSxc",
    "uploader": "미뇨끼",
    "upload_date": "2023-07-27",
    "ingredients": [
      "Mozzarella Cheese",
      "Bread",
      "Eggs",
      "Basil",
      "Salt",
      "Flour",
      "Breadcrumbs",
      "Milk"
    ],
    "steps": [
      "Thinly slice mozzarella cheese and pat dry with paper towels.",
      "Trim the crusts off the bread slices.",
      "Prepare three separate bowls: one with flour, one with breadcrumbs, and one with eggs whisked with a little milk and salt.",
      "Dredge the mozzarella slices in flour, then dip them in the egg mixture.",
      "Dip the bread slices in the egg mixture.",
      "Place the mozzarella and basil inside the bread slices.",
      "Coat the filled bread in breadcrumbs.",
      "Deep-fry until golden brown."
    ]
  },
  {
    "name": "Minari Shrimp Pancake",
    "url": "https://youtu.be/pBqQceTnm44",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-04-30",
    "ingredients": [
      "Minari",
      "Shrimp",
      "Onion",
      "Small shrimp",
      "Salt",
      "Starch flour",
      "Frying mix",
      "Oil"
    ],
    "steps": [
      "Dice the shrimp, and slice the minari stalks and onion.",
      "In a mixing bowl, add the sliced minari and onion, starch flour, frying mix, water, and salt, then mix well to form a batter.",
      "Heat oil in a pan, place the batter, then top with the diced shrimp and small shrimp, pressing lightly.",
      "Flip the pancake, drizzle more oil, press down again, and cook until golden brown.",
      "Serve the finished Minari Shrimp Pancake on a plate."
    ]
  },
  {
    "name": "Eggplant Meatballs",
    "url": "https://youtu.be/zsAlk28cBl8",
    "uploader": "미뇨끼",
    "upload_date": "2023-08-16",
    "ingredients": [
      "Eggplant",
      "Garlic",
      "Parsley",
      "Basil",
      "Salt",
      "Pepper",
      "Tomato sauce",
      "Breadcrumbs",
      "Parmesan cheese",
      "Egg",
      "Belcube cheese",
      "Mozzarella",
      "Olive oil"
    ],
    "steps": [
      "Slice eggplant thinly, then dice finely.",
      "Sauté diced eggplant in olive oil until softened.",
      "Place sautéed eggplant in a bowl, add breadcrumbs, Parmesan cheese, and chopped herbs, then mix well to form a dough.",
      "Shape the dough into balls, insert a Belcube cheese cube in the center, and reshape into a ball.",
      "Carefully coat the eggplant balls with breadcrumbs.",
      "Deep-fry the breaded eggplant balls until golden brown and crispy.",
      "Spread tomato sauce on a plate and arrange the fried eggplant meatballs on top.",
      "Grate Parmesan cheese over the fried eggplant meatballs and garnish with basil leaves."
    ]
  },
  {
    "name": "Crispy Oven-Baked Shrimp Cakes",
    "url": "https://youtu.be/1j4UPhWVTb0",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-05-02",
    "ingredients": [
      "Shrimp",
      "Onion",
      "Cheongyang chili",
      "Red chili",
      "Oyster sauce",
      "Tuna sauce",
      "Egg white",
      "Starch",
      "Sesame oil"
    ],
    "steps": [
      "Mince the shrimp, onion, and Cheongyang chili, then diagonally slice the red chili.",
      "In a mixing bowl, combine the minced shrimp, oyster sauce, tuna sauce, minced Cheongyang chili, egg white, and starch, then mix well to form a batter.",
      "Grease a toaster oven pan with sesame oil and spread the shrimp batter evenly.",
      "Place the pan in a toaster oven preheated to 250 degrees and bake for 20 minutes.",
      "Midway through baking, top with red chili, brush with sesame oil, and continue baking for the remaining time.",
      "Cut the finished shrimp cakes into bite-sized pieces."
    ]
  },
  {
    "name": "Classic Carbonara V2",
    "url": "https://youtu.be/Z2bSjg79TEg",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-05-02",
    "ingredients": [
      "Fusilli Lunghi",
      "Guanciale",
      "Eggs",
      "Pecorino Romano Cheese",
      "Chicken Stock",
      "Salt",
      "Pepper",
      "Olive Oil"
    ],
    "steps": [
      "Separate and prepare 2 egg yolks.",
      "Add 8g salt to 1 liter of boiling water, then add 120g Fusilli Lunghi and cook for 10-13 minutes.",
      "Drizzle olive oil in a pan, then sauté 25g guanciale over low heat until crispy like bacon bits. Remove the larger crispy pieces and set aside.",
      "When steam starts to rise from the pan where guanciale was cooked, add 4oz pasta water and 4oz plain water, then season generously with pepper.",
      "Add half a spoon of chicken stock.",
      "Transfer the cooked Fusilli Lunghi to the pan and add 2oz pasta water and 2oz plain water.",
      "Adjust seasoning with water to taste, and simmer until the sauce thickens and coats the pasta.",
      "Remove the pan from heat. Mix a small amount of the pan liquid into the separated egg yolks to temper them.",
      "Add the tempered egg yolks and 15g grated Pecorino Romano cheese to the pan. Quickly stir to emulsify (mantecare) and adjust consistency.",
      "Transfer the pasta to a plate and garnish with the reserved crispy guanciale pieces.",
      "Sprinkle with an additional 15g Pecorino Romano cheese, a pinch of pepper, and a drizzle of olive oil to finish."
    ]
  },
  {
    "name": "Eggplant Tomato Pasta",
    "url": "https://youtu.be/SJ-3wSYnTik",
    "uploader": "미뇨끼",
    "upload_date": "2023-09-01",
    "ingredients": [
      "Eggplant",
      "Carrot",
      "Celery",
      "Onion",
      "Pasta",
      "Tomato Puree",
      "Basil",
      "Salt",
      "Olive Oil",
      "Ricotta Salata",
      "Pecorino",
      "Parmesan"
    ],
    "steps": [
      "Finely dice carrots, celery, and onions, then sauté them in olive oil.",
      "Add tomato puree to a pot, then fill the empty puree can with water and add it to the pot.",
      "Simmer the sauce slowly until it thickens, then add salt and basil.",
      "Cut eggplant into bite-sized pieces and fry them.",
      "Add the fried eggplant to the tomato sauce.",
      "Cook your desired pasta.",
      "Add the cooked pasta and some pasta water to the sauce, tossing to combine.",
      "Garnish generously with Pecorino or Parmesan cheese."
    ]
  },
  {
    "name": "Eggplant Parmigiana",
    "url": "https://youtu.be/XKtzu-qbBfc",
    "uploader": "미뇨끼",
    "upload_date": "2023-09-24",
    "ingredients": [
      "Eggplant",
      "Minced meat",
      "Carrot",
      "Celery",
      "Onion",
      "Mozzarella",
      "Tomato puree",
      "Red wine",
      "Parmesan cheese",
      "Salt",
      "Pepper",
      "Eggs",
      "Flour",
      "Olive oil"
    ],
    "steps": [
      "Finely chop carrots, celery, and onion, then sauté in olive oil.",
      "Add minced meat.",
      "Pour in red wine and simmer until the wine evaporates.",
      "Add tomato puree and water.",
      "Simmer until the sauce thickens, then season with salt and pepper.",
      "Slice eggplant into 0.5 cm thick pieces.",
      "Dredge eggplant in flour and beaten eggs, then fry.",
      "Slice mozzarella.",
      "Assemble in layers: ragu, eggplant, mozzarella, and Parmesan cheese.",
      "Bake in a 200°C oven for 30 minutes."
    ]
  },
  {
    "name": "Authentic Carbonara",
    "url": "https://youtu.be/q1kfZDur6_Q",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-05-03",
    "ingredients": [
      "Fusilli pasta",
      "Guanciale",
      "Eggs",
      "Pecorino cheese",
      "Black pepper",
      "Salt",
      "Chicken stock",
      "Olive oil"
    ],
    "steps": [
      "Separate egg yolks and whites.",
      "Add salt to boiling water and cook the fusilli pasta.",
      "Heat olive oil in a pan and crisp up the guanciale.",
      "Remove the crisped guanciale. In the same pan, add pasta water, water, black pepper, and chicken stock, then bring to a boil.",
      "Add the cooked pasta to the pan and mix well, adding more pasta water as needed.",
      "Temper the egg yolks with some hot liquid from the pan, then pour over the pasta and mantecare (emulsify) to adjust the consistency.",
      "Add Pecorino cheese and mix.",
      "Serve the pasta in bowls, topping with the crisped guanciale and an extra sprinkle of Pecorino cheese."
    ]
  },
  {
    "name": "Pesto",
    "url": "https://youtu.be/yXQaQ4NoXu0",
    "uploader": "미뇨끼",
    "upload_date": "2023-09-30",
    "ingredients": [
      "Basil",
      "Garlic",
      "Pine nuts",
      "Pecorino cheese",
      "Parmesan cheese",
      "Salt",
      "Olive oil"
    ],
    "steps": [
      "Pick basil leaves by hand and soak them in cold water.",
      "Crush garlic, salt, and pine nuts using a mortar and pestle.",
      "Add basil leaves and olive oil, then grind vigorously.",
      "Add Pecorino cheese and Parmesan cheese, and grind until creamy.",
      "Spread the finished pesto on bread and enjoy."
    ]
  },
  {
    "name": "Gambas al Ajillo",
    "url": "https://youtu.be/IgtlIEaNwEs",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-05-05",
    "ingredients": [
      "Shrimp",
      "Baguette",
      "Garlic",
      "Garlic Chives",
      "Peperoncino",
      "Salt",
      "Chicken Stock",
      "Olive Oil"
    ],
    "steps": [
      "Slice baguette diagonally, drizzle with olive oil, then bake in a 130°C oven for 3 minutes.",
      "Cut off shrimp heads, peel the shells, remove veins with a toothpick, and season with salt.",
      "Slice garlic 3mm thick, and crush peperoncino by hand.",
      "Pour a generous amount of olive oil into a pan, add sliced garlic and crushed peperoncino, and sauté over medium-low heat, making sure the garlic doesn't burn.",
      "Add the prepared shrimp to the pan and cook over medium heat, flipping only once or twice to avoid overcooking.",
      "Add chicken stock to the pan (approximately 1/2 tablespoon per shrimp) and mix well with the ingredients.",
      "Transfer the finished Gambas al Ajillo to a serving dish and sprinkle with finely chopped garlic chives to finish."
    ]
  },
  {
    "name": "Lasagna",
    "url": "https://youtu.be/7rLYL4bsWsI",
    "uploader": "미뇨끼",
    "upload_date": "2023-10-05",
    "ingredients": [
      "Lasagna noodles",
      "Mozzarella",
      "Basil",
      "Pine nuts",
      "Garlic",
      "Salt",
      "Pepper",
      "Nutmeg",
      "Milk",
      "Butter",
      "Flour",
      "Eggs",
      "Olive oil"
    ],
    "steps": [
      "Blend pine nuts and garlic in a blender.",
      "Add basil.",
      "Add olive oil and mix until the pesto is smooth.",
      "Season with salt.",
      "Melt butter in a pot and add flour.",
      "Slowly add eggs and milk, whisking well until creamy.",
      "Season with salt, pepper, and nutmeg.",
      "Boil the lasagna noodles.",
      "Layer the ingredients in the order of lasagna noodles, pesto, béchamel, and mozzarella.",
      "Bake in a 200°C oven for 30 minutes."
    ]
  },
  {
    "name": "Basil Pesto Pasta",
    "url": "https://youtu.be/fDxTjh1Wpbo",
    "uploader": "미뇨끼",
    "upload_date": "2023-11-23",
    "ingredients": [
      "Pasta",
      "Basil",
      "Garlic",
      "Pine nuts",
      "Parmigiano Reggiano",
      "Pecorino Romano",
      "Olive oil",
      "Salt"
    ],
    "steps": [
      "Wash and drain the basil.",
      "Process pine nuts, garlic, and salt.",
      "Add basil and process.",
      "Add olive oil and process until creamy.",
      "Add Parmigiano and Pecorino and process.",
      "Toss pesto with cooked pasta.",
      "Garnish with grated Parmigiano."
    ]
  },
  {
    "name": "Trofie al Pesto",
    "url": "https://youtu.be/sDKigNkztxs",
    "uploader": "미뇨끼",
    "upload_date": "2023-11-30",
    "ingredients": [
      "Potatoes",
      "Trofie",
      "Green beans",
      "Basil pesto",
      "Parmesan cheese",
      "Salt"
    ],
    "steps": [
      "Peel and dice the potatoes.",
      "Trim the ends of the green beans and cut them in half.",
      "Add salt to boiling water.",
      "Add trofie and cook for 18 minutes.",
      "After 3 minutes, add the potatoes (they will cook for 15 minutes).",
      "After 11 minutes, add the green beans (they will cook for 7 minutes).",
      "Drain all the water and transfer the trofie, potatoes, and green beans to a bowl.",
      "Add basil pesto and mix, then finish with Parmesan cheese."
    ]
  },
  {
    "name": "Authentic Gambas al Ajillo",
    "url": "https://youtu.be/x46_9lrbGck",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-05-07",
    "ingredients": [
      "Shrimp",
      "Baguette",
      "Garlic",
      "Peperoncino",
      "Garlic Chives",
      "Salt",
      "Chicken Stock",
      "Olive Oil"
    ],
    "steps": [
      "Slice the baguette diagonally.",
      "Peel the shrimp, make an incision along the back, and remove the veins.",
      "Lightly brush the baguette with olive oil and bake in a 130°C oven for 3 minutes.",
      "Combine water and chicken stock in a pot to make broth.",
      "Slice the garlic and crush 2 peperoncini, then add them to a pan.",
      "Add olive oil to the pan and sauté the garlic and peperoncini.",
      "Sprinkle a little salt on the shrimp, then add them to the pan and cook.",
      "Remove the cooked garlic and flip the shrimp once.",
      "Add 4 tablespoons of the prepared broth to the pan.",
      "Transfer the cooked shrimp and sauce to a serving dish. Add the reserved garlic and pour in the pan liquids.",
      "Garnish with julienned garlic chives and whole peperoncini to finish."
    ]
  },
  {
    "name": "Paella",
    "url": "https://youtu.be/SVVNzIsXtYc",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-05-13",
    "ingredients": [
      "Shrimp",
      "Squid",
      "Cuttlefish",
      "Clams",
      "Tomato",
      "Whole peeled tomatoes",
      "Onion",
      "Lemon",
      "Garlic",
      "Salt",
      "Turmeric powder",
      "Pimentón",
      "Chicken stock",
      "Egg",
      "Cooking oil",
      "Olive oil",
      "Rice"
    ],
    "steps": [
      "Combine lemon juice, minced garlic, salt, and egg in a blender and blend.",
      "Gradually add cold cooking oil to the blender while blending to make alioli.",
      "Bring chicken stock and water to a boil for the broth.",
      "Clean the shrimp, and cut the cuttlefish (or squid) into rice-grain-sized pieces.",
      "Chop the whole peeled tomatoes, onion, and garlic.",
      "Cook the clams in the chicken broth until they open, then remove.",
      "Heat olive oil in a pan, lightly sear the cleaned shrimp, then remove.",
      "In the same pan, sauté the chopped onion and garlic, then add pimentón, turmeric, and whole peeled tomatoes.",
      "Sauté over low heat to evaporate moisture, then add rice and sauté until coated.",
      "Add the prepared cuttlefish.",
      "Gradually add chicken broth and simmer.",
      "Do not stir the rice with a spatula; instead, shake the pan to cook it.",
      "Turn off the heat, cover with foil and a damp cloth to steam, then plate with the shrimp and clams.",
      "Finally, place the pan back on the heat to create a crispy rice crust (socarrat) on the edges."
    ]
  },
  {
    "name": "Tteokbokki alla Sorrentina",
    "url": "https://youtu.be/JIQnDWXJ2LY",
    "uploader": "미뇨끼",
    "upload_date": "2023-12-07",
    "ingredients": [
      "Rice cakes",
      "Onion",
      "Carrot",
      "Celery",
      "Fresh Mozzarella",
      "Basil",
      "Tomato Puree",
      "Gochujang",
      "Salt",
      "Sugar",
      "Parmesan Cheese",
      "Olive Oil"
    ],
    "steps": [
      "Sauté onion, carrot, and celery in olive oil.",
      "Cover and sauté until softened.",
      "Add Gochujang and sauté until red oil appears.",
      "Add tomato puree and pour in water using half the tomato puree jar.",
      "Cover and simmer for 1 hour 30 minutes.",
      "Add salt and sugar.",
      "Cut rice cakes into bite-sized pieces.",
      "Add half of the prepared tomato sauce and mix.",
      "Add half of the fresh mozzarella and mix.",
      "Top with remaining fresh mozzarella, Parmesan cheese, and basil.",
      "Bake in a 180°C oven for 20 minutes.",
      "Mix well, then serve."
    ]
  },
  {
    "name": "Peperoncino Pesto Pasta",
    "url": "https://youtu.be/Md9xY8Wt1fI",
    "uploader": "미뇨끼",
    "upload_date": "2023-12-10",
    "ingredients": [
      "Orecchiette",
      "Cherry Tomatoes",
      "Basil",
      "Burrata",
      "Milk",
      "CookRoot Chili Pesto",
      "Salt",
      "Pepper",
      "Olive Oil"
    ],
    "steps": [
      "Halve cherry tomatoes and sprinkle with salt and olive oil.",
      "Blend burrata, milk, olive oil, and salt in a blender for over 1 minute.",
      "Cook orecchiette in salted water.",
      "Mix cherry tomatoes, pesto, and orecchiette, then transfer to a plate.",
      "Top with burrata cream and chopped basil, then finish with olive oil and pepper."
    ]
  },
  {
    "name": "Christmas Charcuterie Tree",
    "url": "https://youtu.be/uL6uwRCZ6x0",
    "uploader": "미뇨끼",
    "upload_date": "2023-12-17",
    "ingredients": [
      "Daikon Radish",
      "Cherry Tomatoes",
      "Mozzarella Cheese",
      "Green Olives",
      "Black Olives",
      "Green Grapes",
      "Salami",
      "Mini Salami",
      "Cheese",
      "Rosemary",
      "Parmesan Cheese",
      "Toothpicks"
    ],
    "steps": [
      "Trim both ends of the daikon radish, peel it, and shape it into a cone.",
      "Insert toothpicks densely into the cone-shaped radish.",
      "Skewer cherry tomatoes and mozzarella cheese onto the toothpicks to decorate the bottom of the tree.",
      "Fill the tree by skewering green olives, black olives, green grapes, mini salami, and square cheese onto the toothpicks.",
      "Fold salami slices, skewer them onto toothpicks, and decorate with rosemary sprigs.",
      "Sprinkle Parmesan cheese powder over the entire tree to represent snow.",
      "Cut cheese into a star shape and place it on top of the tree to finish."
    ]
  },
  {
    "name": "Salmon Steak Bento",
    "url": "https://youtu.be/2ilp4E4cDpQ",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-05-19",
    "ingredients": [
      "Salmon",
      "Kumquats",
      "Cherry tomatoes",
      "Cheongyang chili pepper",
      "Cooked rice",
      "Tuna",
      "Mayonnaise",
      "Salt",
      "Allulose",
      "Soy sauce",
      "Spicy perilla seasoning",
      "Black pepper",
      "Sesame oil",
      "Sesame seeds",
      "Cooking oil"
    ],
    "steps": [
      "Heat the pre-cooked rice in the microwave, then spread it out and let it cool.",
      "Drain the oil from canned tuna, mince Cheongyang chili peppers, and mix with mayonnaise to make tuna mayo.",
      "Mix allulose and soy sauce to make a soy sauce.",
      "To the cooled rice, add sesame oil, salt, and sesame seeds, then mix well.",
      "Form the rice into square shapes, hollow out the center, and fill with tuna mayo to make rice balls.",
      "Scrape the salmon skin with a knife to remove scales. Season the salmon with salt on both the skin and flesh sides.",
      "Remove stems from cherry tomatoes. Prepare kumquats by cutting off the end opposite the stem and removing the seeds.",
      "Heat cooking oil in a pan. Place the salmon skin-side down over low heat, press lightly and cook, then flip and cook the other side until done.",
      "Remove the salmon from the pan. In the same pan, add a little soy sauce and lightly grill the cherry tomatoes and kumquats until just before they burst.",
      "Lightly brush the prepared soy sauce over the rice balls and grill until golden brown.",
      "Sprinkle spicy perilla seasoning over the grilled rice balls.",
      "Arrange the salmon steak, grilled cherry tomatoes and kumquats, and rice balls with perilla seasoning in a bento box to complete."
    ]
  },
  {
    "name": "Shrimp Rosé",
    "url": "https://youtu.be/lnIGp_nuPPs",
    "uploader": "미뇨끼",
    "upload_date": "2023-12-19",
    "ingredients": [
      "Shrimp",
      "Tomato",
      "Garlic",
      "Parsley",
      "Cream",
      "White wine",
      "Salt",
      "Pepper",
      "Yuzu zest",
      "Lemon zest",
      "Olive oil"
    ],
    "steps": [
      "Chop garlic and parsley.",
      "Score the top of the tomato, blanch in boiling water for 30 seconds, then peel.",
      "Finely chop the tomato.",
      "Add enough olive oil to coat the bottom of a pan.",
      "Sauté garlic gently for 1-2 minutes.",
      "Add chopped tomato and cook until the moisture evaporates and the sauce thickens.",
      "Add shrimp and white wine.",
      "Stir in cream.",
      "Finish with parsley and yuzu zest."
    ]
  },
  {
    "name": "Perfectly Seared Spicy Pork Stir-fry",
    "url": "https://youtu.be/AkX6uA4BaDs",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-06-03",
    "ingredients": [
      "Pork shoulder",
      "Onion",
      "Green onion",
      "Perilla leaves",
      "Sugar",
      "Oligosaccharide",
      "Mirin",
      "Soy sauce",
      "Gochugaru",
      "Gochujang",
      "Minced garlic",
      "Oyster sauce",
      "Black pepper",
      "Curry powder",
      "Sesame oil",
      "Sesame seeds"
    ],
    "steps": [
      "Prepare pork shoulder by draining any excess blood.",
      "Combine sugar, oligosaccharide, mirin, soy sauce, gochugaru, gochujang, minced garlic, oyster sauce, black pepper, and curry powder to make the sauce.",
      "First, stir-fry the pork over low heat.",
      "While the pork cooks, slice the onion somewhat thickly.",
      "Cut the green onion lengthwise, then dice it.",
      "If the pork sticks to the pan, add a splash of mirin.",
      "Add the prepared onion and half of the green onion.",
      "Once the onion softens slightly, add the sauce.",
      "Increase to high heat to evaporate moisture, then reduce to medium heat and cook until crispy.",
      "While the pork finishes cooking, slice the perilla leaves for garnish.",
      "When the sauce starts to stick to the bottom, add the perilla leaves and the remaining green onion.",
      "Once the green onion is cooked and tender, turn off the heat and transfer to a plate.",
      "Top with sliced perilla leaves and drizzle with a little sesame oil."
    ]
  },
  {
    "name": "Panettone with Mascarpone Cream",
    "url": "https://youtu.be/P7eyB2nZ3OY",
    "uploader": "미뇨끼",
    "upload_date": "2023-12-21",
    "ingredients": [
      "Panettone",
      "Mascarpone",
      "Eggs",
      "Blueberries",
      "Sugar",
      "Cognac",
      "Cinnamon",
      "Powdered sugar"
    ],
    "steps": [
      "Separate egg whites and yolks.",
      "Whip egg whites into a soft meringue.",
      "Whip egg yolks with sugar until light and ivory colored.",
      "Add mascarpone and whip until well combined.",
      "Gently fold in the meringue with a spatula.",
      "Cut panettone into wedges and toast in the oven.",
      "Top panettone with cream, cinnamon, blueberries, and powdered sugar to finish."
    ]
  },
  {
    "name": "Tagliatelle with Pine Mushrooms",
    "url": "https://youtu.be/D3RSOYm1sQM",
    "uploader": "미뇨끼",
    "upload_date": "2024-04-03",
    "ingredients": [
      "Pine mushrooms",
      "Tagliatelle",
      "Garlic",
      "Parsley",
      "Salt",
      "Black pepper",
      "Parmesan cheese",
      "Butter",
      "Olive oil",
      "White wine"
    ],
    "steps": [
      "Remove the root from the pine mushrooms, separate the cap and stem, then slice thinly.",
      "Chop the parsley and grate the Parmesan cheese.",
      "Heat olive oil in a pan, sauté minced garlic, then add all the sliced mushrooms and season with salt and pepper.",
      "When the mushrooms are golden brown, add a little white wine and water, cover, and steam for 10 minutes.",
      "Cook the tagliatelle in boiling salted water.",
      "Add the cooked tagliatelle to the mushroom sauce pan, then add pasta water, butter, chopped parsley, and Parmesan cheese, stirring evenly over low heat.",
      "Serve the pasta in a dish and top generously with mushroom sauce."
    ]
  },
  {
    "name": "Zampone",
    "url": "https://youtu.be/4nH-4WHlOQY",
    "uploader": "미뇨끼",
    "upload_date": "2023-12-31",
    "ingredients": [
      "Pork hock (front leg)",
      "Minced pork",
      "Pork skin",
      "Garlic",
      "Lentils",
      "Onion",
      "Carrot",
      "Celery",
      "Salt",
      "Sugar",
      "Pepper",
      "Nutmeg",
      "Red wine",
      "Cinnamon"
    ],
    "steps": [
      "Separate the bone from the pork hock, then mince the meat and skin from the foot portion.",
      "In a bowl, combine minced pork, minced garlic, salt, red wine, and the minced pork hock meat and skin to create the filling.",
      "Stuff the prepared filling into the pork hock skin and tie it tightly with kitchen string.",
      "Wrap the zampone in a cloth, place it in water, and simmer.",
      "In a pot, heat cooking oil, sauté carrots, celery, and onion until softened, then add tomato paste and continue to sauté briefly.",
      "Add lentils and water to the sautéed vegetables and simmer until a lentil stew is formed."
    ]
  },
  {
    "name": "Matsutake Mushroom Soup",
    "url": "https://youtu.be/SACPMPTR-0s",
    "uploader": "미뇨끼",
    "upload_date": "2024-04-28",
    "ingredients": [
      "Matsutake mushrooms",
      "potatoes",
      "leek",
      "bread",
      "olive oil",
      "mushroom broth",
      "vegetable broth",
      "heavy cream",
      "butter",
      "salt",
      "oregano",
      "parsley"
    ],
    "steps": [
      "Chop potatoes and leek.",
      "Slice matsutake mushrooms.",
      "In a pot, heat olive oil and sauté the leek. Add chopped potatoes and sliced matsutake mushrooms and continue to sauté.",
      "Pour in mushroom broth and vegetable broth, then simmer for about 40 minutes.",
      "Remove crusts from the bread and cut into cubes. Toss with olive oil, salt, and oregano, then bake in the oven until crispy to make croutons.",
      "Let the cooked mushroom mixture cool slightly, then transfer to a blender and blend until completely smooth.",
      "Return the blended soup to the pot, stir in heavy cream and butter until well combined.",
      "Serve the soup in bowls, drizzle with a little olive oil, and garnish with baked croutons and chopped parsley."
    ]
  },
  {
    "name": "Salmon Pasta",
    "url": "https://youtu.be/oi-IqwQVeaE",
    "uploader": "미뇨끼",
    "upload_date": "2024-01-09",
    "ingredients": [
      "Smoked Salmon",
      "Farfalle Pasta",
      "Onion",
      "Parsley",
      "Cream",
      "Pepper",
      "Salt",
      "Olive Oil"
    ],
    "steps": [
      "Chop the onion and parsley, and season and cut the smoked salmon into bite-sized pieces.",
      "Cook the farfalle pasta in boiling salted water.",
      "Heat olive oil in a pan, sauté the chopped onion, then add pasta water and stir to form a sauce.",
      "Add the smoked salmon and cook until it flakes, then add cream and pepper and simmer until thickened.",
      "Add the cooked farfalle pasta to the sauce and toss. Add more cream if needed to adjust consistency.",
      "Garnish with chopped parsley and serve."
    ]
  },
  {
    "name": "Tagliatelle alla Boscaiola",
    "url": "https://youtu.be/DQiyHOlXzBg",
    "uploader": "미뇨끼",
    "upload_date": "2024-05-05",
    "ingredients": [
      "Mushrooms",
      "Guanciale",
      "Leek",
      "Parsley",
      "Tagliatelle",
      "Tomato paste",
      "Salt",
      "Cream",
      "Olive oil",
      "White wine"
    ],
    "steps": [
      "Slice mushrooms, leek, and parsley, and dice pancetta.",
      "Heat olive oil in a pan, add the diced pancetta, and cook until golden brown to render its fat.",
      "Add leek and mushrooms to the pan and sauté.",
      "Pour in white wine and continue to cook.",
      "Add tomato paste, cover, and simmer until the mushrooms are tender.",
      "Add heavy cream to complete the rosé sauce.",
      "Cook tagliatelle in boiling water.",
      "Add the cooked tagliatelle to the sauce and mix well.",
      "Garnish with chopped parsley to finish."
    ]
  },
  {
    "name": "Risotto",
    "url": "https://youtu.be/5YybGQKiEnk",
    "uploader": "미뇨끼",
    "upload_date": "2024-05-17",
    "ingredients": [
      "Asparagus",
      "Leek",
      "Rice",
      "Parmesan Cheese",
      "Butter",
      "Salt",
      "Pepper",
      "Olive Oil",
      "White Wine",
      "Broth"
    ],
    "steps": [
      "Cut off the woody ends of the asparagus, separate the tips from the stalks, and finely chop the stalks.",
      "Finely chop the leek.",
      "Grate the Parmesan cheese.",
      "In a pan with olive oil, sear the asparagus tips and set aside.",
      "In a pot, heat olive oil and sauté the chopped leek.",
      "Add the finely chopped asparagus stalks and rice, sauté together, then season with salt.",
      "Pour in the white wine and cook until fully absorbed by the rice.",
      "Gradually add the broth, stirring constantly, and cook the risotto until the rice is tender with an al dente bite.",
      "Stir in the grated Parmesan cheese, butter, and pepper.",
      "Serve the risotto on a plate, top with the seared asparagus tips, and drizzle with olive oil."
    ]
  },
  {
    "name": "Orecchiette with Broccoli Rabe",
    "url": "https://youtu.be/afGBrHfMlEY",
    "uploader": "미뇨끼",
    "upload_date": "2024-05-22",
    "ingredients": [
      "Broccoli Rabe",
      "Orecchiette",
      "Green chili",
      "Garlic",
      "Salt",
      "Parmesan cheese",
      "Olive oil"
    ],
    "steps": [
      "Cut broccoli rabe into bite-sized pieces, and slice the green chili and garlic.",
      "Heat a generous amount of olive oil in a pan, and sauté the sliced garlic and green chili.",
      "Add the chopped broccoli rabe and stir-fry until slightly crisp, then season with salt.",
      "Cook the orecchiette until al dente.",
      "Add the cooked orecchiette to the stir-fried broccoli rabe and stir-fry until well combined and slightly dry, without pasta water.",
      "Plate and sprinkle with Parmesan cheese."
    ]
  },
  {
    "name": "Spaghetti All' Assassina",
    "url": "https://youtu.be/RwKcHHLjf0I",
    "uploader": "미뇨끼",
    "upload_date": "2024-05-29",
    "ingredients": [
      "Spaghetti",
      "Minced garlic",
      "Peperoncino",
      "Salt",
      "Sugar",
      "Tomato paste",
      "Tomato puree",
      "Olive oil"
    ],
    "steps": [
      "Sauté olive oil, peperoncino, and minced garlic.",
      "Add tomato puree and pasta, then sear thoroughly.",
      "Once browned, gradually pour in tomato water.",
      "Stir occasionally to prevent burning until the pasta is cooked through.",
      "Finish with olive oil."
    ]
  },
  {
    "name": "Oven-Baked Square Pastry",
    "url": "https://youtu.be/NFeeS2PhI-4",
    "uploader": "미뇨끼",
    "upload_date": "2024-06-02",
    "ingredients": [
      "Onion",
      "Square pastry dough",
      "Balsamic glaze",
      "Rosemary",
      "Salt",
      "Parmesan cheese",
      "Olive oil"
    ],
    "steps": [
      "Thaw frozen pastry for about 30 minutes.",
      "Slice the onion thinly.",
      "Drizzle olive oil and balsamic glaze on a baking tray lined with baking paper.",
      "Place the sliced onion and rosemary on top.",
      "Cover the onion with the pastry and press lightly.",
      "Grate Parmesan cheese over the pastry.",
      "Bake in a preheated 180°C oven for about 15 minutes."
    ]
  },
  {
    "name": "Balsamic Risotto",
    "url": "https://youtu.be/tSLrHbUdGZ4",
    "uploader": "미뇨끼",
    "upload_date": "2024-06-07",
    "ingredients": [
      "Arborio rice",
      "Carnaroli rice",
      "Onion",
      "Balsamic vinegar",
      "Salt",
      "Parmesan cheese",
      "White wine",
      "Butter",
      "Olive oil",
      "Vegetable broth"
    ],
    "steps": [
      "Finely chop the onion.",
      "Heat olive oil in a pan and sauté the onion.",
      "Add the risotto rice and sauté together.",
      "Pour in white wine and reduce.",
      "Gradually add warm broth, one ladleful at a time, and cook over low heat until the rice is al dente.",
      "Turn off the heat, add butter and Parmesan cheese, and mix well.",
      "Serve the risotto on a plate and drizzle with balsamic vinegar."
    ]
  },
  {
    "name": "Shrimp and Korean Zucchini Pasta",
    "url": "https://youtu.be/H7fkh9LSc58",
    "uploader": "미뇨끼",
    "upload_date": "2024-06-09",
    "ingredients": [
      "shrimp",
      "Korean zucchini",
      "onion",
      "minced garlic",
      "lemon juice",
      "lemon zest",
      "salt",
      "pepper",
      "butter",
      "short pasta",
      "olive oil"
    ],
    "steps": [
      "Sauté shrimp in butter and drizzle with lemon juice.",
      "Sauté onion in olive oil.",
      "Add Korean zucchini and a splash of water, then sauté until tender.",
      "Add cooked pasta and reserved pasta water, then toss to combine.",
      "Combine the pasta, shrimp, a drizzle of olive oil, and lemon zest to finish."
    ]
  },
  {
    "name": "Aglio Olio e Peperoncino",
    "url": "https://youtu.be/extP0h_j2yc",
    "uploader": "미뇨끼",
    "upload_date": "2024-01-14",
    "ingredients": [
      "Spaghetti",
      "Garlic",
      "Peperoncino",
      "Parsley",
      "Salt",
      "Olive oil"
    ],
    "steps": [
      "Thinly slice garlic and chop peperoncino.",
      "Heat a generous amount of olive oil in a pan, then add the sliced garlic and peperoncino and sauté.",
      "Boil spaghetti al dente in salted water.",
      "Transfer the cooked spaghetti to the pan, gradually add pasta water, and stir continuously to make it creamy.",
      "Sprinkle with plenty of parsley, mix well, and plate."
    ]
  },
  {
    "name": "Korean Seaweed Soup",
    "url": "https://youtu.be/Gijn8Jm7RxY",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-05-27",
    "ingredients": [
      "Beef",
      "Dried Seaweed",
      "Onion",
      "Tuna Sauce",
      "Korean Rice Wine",
      "Soy Sauce",
      "Minced Garlic",
      "Salt",
      "Sesame Oil"
    ],
    "steps": [
      "Soak dried seaweed in a mixing bowl with salt and water.",
      "Place beef in cold water to firm up its fat.",
      "Score the onion without slicing it.",
      "Add beef to water and bring to a boil.",
      "Once boiling, remove any impurities from the beef.",
      "Add Korean rice wine to the beef to eliminate gamey odor.",
      "Rinse the soaked seaweed thoroughly in cold water.",
      "Add tuna sauce to the beef broth.",
      "In a pot, sauté the seaweed, using only its own moisture.",
      "Sauté until nearly dry, then add water.",
      "Add water and the scored onion, then bring to a boil.",
      "Add soy sauce to the boiling seaweed.",
      "Add salt.",
      "When the onion is nearly cooked, add the beef and broth to the seaweed pot.",
      "Remove the cooked onion.",
      "Add minced garlic.",
      "Drizzle with sesame oil."
    ]
  },
  {
    "name": "Spicy Marinated Crab",
    "url": "https://youtu.be/ph8uBTh_Ntw",
    "uploader": "미뇨끼",
    "upload_date": "2024-01-25",
    "ingredients": [
      "Blue Crab",
      "Onion",
      "Cheongyang Chili",
      "Red Chili",
      "Minced Garlic",
      "Soy Sauce",
      "Gochugaru",
      "Fish Sauce",
      "Sugar",
      "Soju",
      "Sesame Seeds",
      "Rice"
    ],
    "steps": [
      "Clean blue crabs thoroughly, scrubbing off impurities. Separate the top shell and cut the crab into bite-sized pieces.",
      "Pour soju over the prepared blue crabs and let marinate briefly.",
      "In a large bowl, combine soy sauce, gochugaru, fish sauce, minced garlic, and sugar to make the seasoning sauce.",
      "Add the marinated blue crabs to the seasoning sauce and mix well to coat evenly.",
      "Slice the onion, Cheongyang chili, and red chili, then add them to the marinated crab and mix again.",
      "Plate the finished spicy marinated crab and sprinkle with sesame seeds.",
      "Cook rice by combining rice and water in a pot."
    ]
  },
  {
    "name": "Pork Loin with Tuna-Caper Sauce",
    "url": "https://youtu.be/Y9bvF4IawWo",
    "uploader": "미뇨끼",
    "upload_date": "2024-06-12",
    "ingredients": [
      "Pork loin",
      "Canned tuna",
      "Anchovies",
      "Onion",
      "Carrot",
      "Bay leaf",
      "Capers",
      "Eggs",
      "Mayonnaise",
      "Lemon juice",
      "Garlic",
      "Pink peppercorns",
      "White wine",
      "Olive oil",
      "Salt",
      "Pepper"
    ],
    "steps": [
      "Trim fat from pork loin and tie with kitchen twine.",
      "Add garlic, onion, carrot, bay leaf, black peppercorns, and white wine to boiling water, then add the tied pork loin.",
      "Turn off the heat, cover, and let stand for 30 minutes.",
      "Remove pork, let cool slightly, then slice thinly and arrange on a plate.",
      "In a measuring cup, combine canned tuna, capers, boiled eggs, lemon juice, and olive oil.",
      "Use an immersion blender to finely blend all ingredients to make a sauce.",
      "Pour the sauce generously over the sliced pork, then garnish with pink peppercorns, caper berries, and a drizzle of olive oil."
    ]
  },
  {
    "name": "Soy-Marinated Raw Crabs",
    "url": "https://youtu.be/e8sfhVjc8g8",
    "uploader": "미뇨끼",
    "upload_date": "2024-01-28",
    "ingredients": [
      "Blue Crab",
      "Onion",
      "Ginger",
      "Fresh Ginseng",
      "Jujubes",
      "Cheongyang Chili Peppers",
      "Red Chili Peppers",
      "Dried Chili Peppers",
      "Anchovies",
      "Kelp",
      "Shiitake Mushrooms",
      "Soy Sauce",
      "Vinegar",
      "Corn Syrup",
      "Cooking Wine",
      "Sesame Seeds"
    ],
    "steps": [
      "Clean the blue crabs thoroughly.",
      "In a pot, add water, onion, ginger, fresh ginseng, jujubes, dried chili peppers, anchovies, kelp, and shiitake mushrooms, then boil to make a broth.",
      "Add soy sauce, cooking wine, vinegar, and corn syrup to the prepared broth to create the soy sauce marinade.",
      "Place the cleaned blue crabs in an airtight container and pour the soy sauce marinade over them, then let marinate for 3 days.",
      "Serve the well-aged soy-marinated crabs in a dish, garnished with Cheongyang chili peppers, red chili peppers, and sesame seeds."
    ]
  },
  {
    "name": "Squid Summer Salad",
    "url": "https://youtu.be/opju1YkIuzo",
    "uploader": "미뇨끼",
    "upload_date": "2024-06-16",
    "ingredients": [
      "Squid",
      "Potatoes",
      "Cherry tomatoes",
      "Garlic",
      "White Balsamic Vinegar",
      "Parsley",
      "Salt",
      "Pepper",
      "Olive oil",
      "Croutons"
    ],
    "steps": [
      "Clean and cut the squid into bite-sized pieces.",
      "Briefly blanch the squid in boiling salted water.",
      "Combine cooked potatoes, cherry tomatoes, and blanched squid in a bowl.",
      "Whisk together parsley, salt, pepper, white balsamic vinegar, and olive oil to make the dressing.",
      "Pour the dressing over the salad ingredients and mix thoroughly.",
      "Add croutons and mix again. Serve."
    ]
  },
  {
    "name": "Linguine with Crab",
    "url": "https://youtu.be/UBU8BsyI0_8",
    "uploader": "미뇨끼",
    "upload_date": "2024-01-31",
    "ingredients": [
      "Blue Crab",
      "Cherry Tomatoes",
      "Linguine",
      "Garlic",
      "White Wine",
      "Parsley",
      "Lemon Zest",
      "Olive Oil",
      "Salt"
    ],
    "steps": [
      "Heat olive oil in a hot pan and sauté minced garlic.",
      "Add cherry tomatoes and prepared blue crab, then pour in white wine.",
      "Extract crab meat from the blue crab bodies using a rolling pin.",
      "Pour in water, cover, and simmer briefly to create the sauce.",
      "Cook linguine in boiling salted water.",
      "Add the crab meat to the sauce, then add the cooked linguine and mix until creamy.",
      "Stir in chopped parsley and lemon zest, and drizzle with a little more olive oil.",
      "Plate the linguine, top with crab meat sauce, and garnish with crab shells."
    ]
  },
  {
    "name": "Spicy Pork Stir-fry",
    "url": "https://youtu.be/ovRTZMgQZB8",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-06-04",
    "ingredients": [
      "Pork",
      "Onion",
      "Green onion",
      "Perilla leaves",
      "Sugar",
      "Syrup",
      "Mirin",
      "Soy sauce",
      "Korean chili powder",
      "Korean chili paste",
      "Garlic",
      "Oyster sauce",
      "Black pepper",
      "Curry powder",
      "Sesame seeds",
      "Sesame oil"
    ],
    "steps": [
      "Prepare pork shoulder by draining any excess blood.",
      "Combine sugar, syrup, mirin, soy sauce, Korean chili powder, Korean chili paste, garlic, oyster sauce, black pepper, and curry powder to make the sauce.",
      "First, stir-fry the pork over low heat.",
      "While the pork cooks, slice the onion thickly.",
      "Cut the green onion into thick pieces.",
      "If the pork sticks to the pan, add a splash of mirin.",
      "Add the sliced onion and half of the green onion.",
      "Once the onion has slightly softened, add the sauce.",
      "Cook over high heat to reduce moisture, then reduce to medium heat and cook until well-browned and the sauce has thickened.",
      "While the pork cooks, slice the perilla leaves.",
      "When the sauce starts to stick to the bottom of the pan, add the sliced perilla leaves and the remaining green onion.",
      "Once the green onion is cooked through, turn off the heat and transfer to a serving dish.",
      "Top with the sliced perilla leaves and drizzle with a little sesame oil."
    ]
  },
  {
    "name": "Aglio e Olio",
    "url": "https://youtu.be/U8G10aA9lTs",
    "uploader": "미뇨끼",
    "upload_date": "2024-02-07",
    "ingredients": [
      "Spaghetti",
      "Garlic",
      "Parsley",
      "Olive oil",
      "Salt",
      "Peperoncino"
    ],
    "steps": [
      "Boil water in a pot, add salt, and cook the spaghetti.",
      "Heat a generous amount of olive oil in a frying pan, then add sliced garlic and peperoncino and sauté.",
      "Add the cooked spaghetti to the pan and toss to coat well with the garlic and olive oil mixture.",
      "Add chopped parsley, mix once more, then plate and serve."
    ]
  },
  {
    "name": "Couscous",
    "url": "https://youtu.be/nhrP5ARj7a8",
    "uploader": "미뇨끼",
    "upload_date": "2024-06-21",
    "ingredients": [
      "Couscous",
      "Carrots",
      "Onion",
      "Bell pepper",
      "Zucchini",
      "Chickpeas",
      "Apple mint",
      "Salt",
      "Pepper",
      "White balsamic vinegar",
      "Olive oil"
    ],
    "steps": [
      "Add salt and olive oil to couscous.",
      "Pour hot water over it.",
      "Cover and let sit for 20 minutes.",
      "Sauté vegetables in olive oil.",
      "Add salt and pepper.",
      "Fluff cooked couscous with a fork.",
      "Turn off the heat, add couscous and mix.",
      "Garnish with apple mint."
    ]
  },
  {
    "name": "Pork Bulbaek",
    "url": "https://youtu.be/F9T-S4dVgag",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-06-10",
    "ingredients": [
      "Pork shoulder/leg",
      "Shishito peppers",
      "Soy sauce",
      "Oyster sauce",
      "Minced garlic",
      "Mirin",
      "Corn syrup",
      "Salt",
      "Sugar",
      "Sesame oil",
      "Tuna extract",
      "Black pepper",
      "Sesame seeds",
      "Cooking oil"
    ],
    "steps": [
      "Soak pork to remove blood.",
      "Wash and destem shishito peppers.",
      "Combine sugar, corn syrup, mirin, soy sauce, minced garlic, oyster sauce, tuna extract, and black pepper to make the sauce.",
      "Pat dry the pork. If a gamey smell persists, marinate lightly with sugar, mirin, and pepper.",
      "Heat cooking oil in a pan.",
      "Over high heat, lightly grill shishito peppers seasoned with salt, then remove from pan.",
      "Reduce heat to medium-high and cook the pork.",
      "Stir constantly to prevent sticking.",
      "Once moisture appears, increase heat to high to evaporate it.",
      "Add more cooking oil. Once moisture is gone, add 2/3 of the sauce and cook over high heat.",
      "When pork starts to brown, reduce heat and add the remaining sauce.",
      "Increase heat to high again and grill until crispy.",
      "Before the sauce burns, add the shishito peppers and stir-fry briefly.",
      "Serve in a dish, sprinkle with sesame seeds, and drizzle with sesame oil."
    ]
  },
  {
    "name": "Rice Paper Cannelloni",
    "url": "https://youtu.be/tmu6kyibH6U",
    "uploader": "미뇨끼",
    "upload_date": "2024-02-11",
    "ingredients": [
      "Spinach",
      "Ricotta cheese",
      "Egg",
      "Garlic",
      "Rice paper",
      "Tomato sauce",
      "Parmesan cheese",
      "Salt",
      "Pepper",
      "Nutmeg",
      "Olive oil",
      "Basil"
    ],
    "steps": [
      "Blanch spinach lightly and squeeze out excess water.",
      "In a bowl, combine blanched spinach with ricotta cheese, egg, minced garlic, olive oil, Parmesan cheese, salt, pepper, and nutmeg to make the filling.",
      "Briefly dip rice paper in water, add the filling, and roll it up.",
      "Brush the rolled rice paper with olive oil and air fry at 200°C for 15 minutes.",
      "Spread tomato sauce on a plate, top with the cooked cannelloni, and garnish with basil and Parmesan cheese."
    ]
  },
  {
    "name": "Meatballs",
    "url": "https://youtu.be/Lp5LlSkQ8GA",
    "uploader": "미뇨끼",
    "upload_date": "2024-06-23",
    "ingredients": [
      "Ground beef",
      "Tomato puree",
      "Carrot",
      "Onion",
      "Celery",
      "Salt",
      "Pepper",
      "Milk",
      "Bread",
      "Pine nuts",
      "Raisins",
      "Parmesan cheese",
      "Basil"
    ],
    "steps": [
      "Trim bread crusts, dice, soak in milk for 5 minutes, then squeeze out liquid.",
      "Combine ground beef, squeezed bread, pine nuts, raisins, and Parmesan cheese; knead vigorously and form into small balls.",
      "Brown meatballs on all sides in generous olive oil.",
      "Sauté minced carrot, onion, and celery in olive oil in a pot.",
      "Add tomato puree, cover, and simmer for 1 hour over low heat to make sauce.",
      "Add browned meatballs to the sauce, heat through, serve on a plate, and sprinkle with Parmesan cheese."
    ]
  },
  {
    "name": "Frittata",
    "url": "https://youtu.be/8YQunR0XwhI",
    "uploader": "미뇨끼",
    "upload_date": "2024-06-30",
    "ingredients": [
      "Eggs",
      "Green onions",
      "Zucchini",
      "Salt",
      "Pepper",
      "Olive oil"
    ],
    "steps": [
      "Slice the green onions and zucchini.",
      "Whisk the eggs and season with salt and pepper.",
      "Heat a generous amount of olive oil in a pan, add the sliced green onions and zucchini, season with salt, and sauté until tender.",
      "Once the vegetables are tender, pour the whisked eggs evenly into the pan, do not stir, cover, and cook slowly.",
      "When one side is cooked, use the lid to help flip the frittata and cook the other side.",
      "Serve the finished frittata on a plate."
    ]
  },
  {
    "name": "Creamy Dried Pollock with Potatoes",
    "url": "https://youtu.be/fkw925XqmmI",
    "uploader": "미뇨끼",
    "upload_date": "2024-02-14",
    "ingredients": [
      "Dried pollock",
      "Potato",
      "Minced garlic",
      "Olives",
      "Pine nuts",
      "Lemon zest",
      "Parsley",
      "Salt",
      "Olive oil"
    ],
    "steps": [
      "Boil dried pollock, potatoes, and salt in boiling water.",
      "Sauté olive oil, parsley, minced garlic, and salt. Then mash the potatoes.",
      "Add dried pollock and salt, then sauté.",
      "Dry out the moisture sufficiently.",
      "Close the lid and shake vigorously to make it creamy.",
      "Add lemon zest and plate with olives, parsley, and pine nuts."
    ]
  },
  {
    "name": "Italian Fried Stuffed Peppers",
    "url": "https://youtu.be/zEGbzu10xok",
    "uploader": "미뇨끼",
    "upload_date": "2024-07-10",
    "ingredients": [
      "Mild green chili peppers",
      "Italian meatballs",
      "Salt",
      "Batter mix",
      "Beer"
    ],
    "steps": [
      "Cut the chili peppers in half and remove the seeds with a teaspoon.",
      "Stuff each chili pepper half with a frozen Italian meatball.",
      "Mix the batter mix and canned beer in a 1:1 ratio to make a simple batter.",
      "Completely coat the stuffed chili peppers with the batter.",
      "Pour cooking oil into a pan and heat to about 170°C.",
      "Fry the battered chili peppers until golden brown. If there isn't enough oil, spoon oil over them while frying.",
      "Serve the fried chili peppers piled high on a flat plate."
    ]
  },
  {
    "name": "Lemon Butter Spaghetti",
    "url": "https://youtu.be/7crVSLa6tYg",
    "uploader": "미뇨끼",
    "upload_date": "2024-07-14",
    "ingredients": [
      "Spaghetti",
      "Lemon",
      "Lemon peel",
      "Lemon zest",
      "Salt",
      "Butter",
      "Parmesan cheese",
      "Olive oil"
    ],
    "steps": [
      "Combine water, lemon, and lemon peel.",
      "Simmer on low heat for 30 minutes.",
      "Boil pasta for 5 minutes and transfer to a pan.",
      "Add 2 ladles of the lemon-infused water and finish cooking the pasta in the pan.",
      "If the liquid is insufficient, add more lemon-infused water.",
      "Turn off the heat and let the pan cool slightly.",
      "Add butter and gradually stir in Parmesan cheese.",
      "Plate the dish and garnish with lemon zest."
    ]
  },
  {
    "name": "Pork Bulgogi",
    "url": "https://youtu.be/i_e6k-cflfM",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-06-11",
    "ingredients": [
      "Pork hind leg",
      "Shishito peppers",
      "Sugar",
      "Corn syrup",
      "Mirin",
      "Soy sauce",
      "Minced garlic",
      "Oyster sauce",
      "Tuna sauce",
      "Black pepper",
      "Salt",
      "Sesame seeds",
      "Sesame oil",
      "Cooking oil"
    ],
    "steps": [
      "Drain blood from pork hind leg.",
      "Wash and destem shishito peppers.",
      "Prepare the sauce by combining sugar, corn syrup, mirin, soy sauce, minced garlic, oyster sauce, tuna sauce, and black pepper.",
      "Pat dry the pork. If there's a gamey smell, rub with a small amount of sugar, mirin, and black pepper to remove it.",
      "Heat cooking oil in a pan.",
      "Season shishito peppers with salt, quickly sear on high heat, then remove from pan.",
      "Reduce heat to medium-high and grill the pork hind leg.",
      "Cook the pork, ensuring it doesn't stick to the pan.",
      "When moisture appears, increase heat to high to evaporate it completely.",
      "Add more cooking oil. Once moisture has evaporated, add 2/3 of the sauce and cook on high heat.",
      "When the meat browns, reduce heat and add the remaining sauce.",
      "Increase heat to high again and continue to grill until crispy.",
      "Before the sauce burns, add the shishito peppers and stir-fry briefly.",
      "Transfer to a plate, sprinkle with sesame seeds, and drizzle with sesame oil."
    ]
  },
  {
    "name": "Candied Yuzu",
    "url": "https://youtu.be/9ZJ2uExBLTM",
    "uploader": "미뇨끼",
    "upload_date": "2024-02-21",
    "ingredients": [
      "Ricotta",
      "Yuzu peel",
      "Yuzu zest",
      "Sugar",
      "Powdered sugar",
      "Salt",
      "Milk"
    ],
    "steps": [
      "Mix ricotta, powdered sugar, and milk.",
      "Strain through a sieve or whip in a food processor.",
      "Grate in yuzu zest.",
      "Soak yuzu in salt water for 30 minutes.",
      "Boil yuzu for 10 minutes, then drain, repeat 3 times.",
      "Simmer yuzu peel, sugar, and water until syrupy.",
      "Dry in an oven at 60°C for 2 hours or at room temperature for over 12 hours."
    ]
  },
  {
    "name": "Spam Fried Rice",
    "url": "https://youtu.be/NhXF1IU2ZHk",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-06-17",
    "ingredients": [
      "Spam",
      "Onion",
      "Carrot",
      "Green onion",
      "Egg",
      "Cooked rice",
      "Chicken stock",
      "Black pepper",
      "Cooking oil",
      "Sesame seeds"
    ],
    "steps": [
      "Chop the onion, carrot, and green onion into bite-sized pieces.",
      "Slice the Spam.",
      "Heat cooking oil in a pan and stir-fry the Spam and carrot.",
      "Cook over medium heat until moisture evaporates.",
      "Microwave the cooked rice for about 1 minute.",
      "Once the Spam and carrot are cooked, add the onion and stir-fry.",
      "In a mixing bowl, combine the egg, chicken stock, cooking oil, and the microwaved rice, mixing well.",
      "Cook the vegetables and Spam over medium heat until moisture evaporates, then reduce to low heat.",
      "Allow the rice grains to absorb the egg mixture.",
      "Heat cooking oil in a separate pan and pour in the egg-rice mixture.",
      "Cook over medium heat until moisture evaporates.",
      "Once the moisture is gone, switch to high heat and add the stir-fried vegetables and Spam to the rice.",
      "Finally, add the chopped green onion and briefly stir-fry to remove a little moisture.",
      "Serve in a bowl and sprinkle with black pepper and sesame seeds."
    ]
  },
  {
    "name": "Pasta with Ricotta Tomato Sauce",
    "url": "https://youtu.be/BMGnQCAb9Zc",
    "uploader": "미뇨끼",
    "upload_date": "2024-02-23",
    "ingredients": [
      "Celery",
      "Carrot",
      "Onion",
      "Garlic",
      "Basil",
      "Tomato puree",
      "Ricotta",
      "Pasta",
      "Salt",
      "Pepper",
      "Olive oil"
    ],
    "steps": [
      "Sauté onion, carrot, and celery in olive oil. Add tomato puree, then pour in water and bring to a boil.",
      "Add salt and basil. Simmer partially covered for 1.5 hours to make the tomato sauce.",
      "Cook pasta in boiling salted water.",
      "In a pan, combine the tomato sauce and cooked pasta. Add ricotta and pasta water, mix well, and turn off the heat.",
      "Serve pasta, topping with ricotta, tomato sauce, and basil leaves. Drizzle with olive oil and sprinkle with pepper to finish."
    ]
  },
  {
    "name": "Fried Rice",
    "url": "https://youtu.be/XJHpTAkR6sk",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-06-18",
    "ingredients": [
      "Spam",
      "Carrot",
      "Onion",
      "Egg",
      "Green Onion",
      "Chicken Stock",
      "Pepper",
      "Cooking Oil",
      "Rice",
      "Sesame Seeds"
    ],
    "steps": [
      "Cut the onion, carrot, and green onion into bite-sized pieces.",
      "Slice the Spam.",
      "Heat cooking oil in a pan, then stir-fry the Spam and carrot first.",
      "Stir-fry over medium heat to remove moisture.",
      "Microwave the cooked rice for about 1 minute.",
      "Once the Spam and carrot are cooked, add the onion and stir-fry.",
      "In a mixing bowl, combine the egg, chicken stock, cooking oil, and warm rice, then mix well.",
      "After cooking out moisture from the vegetables over medium heat, continue to cook them over low heat.",
      "Wait until the rice grains absorb the egg mixture.",
      "Heat cooking oil in another pan and pour in the mixed egg-rice.",
      "Cook over medium heat to remove moisture.",
      "Once moisture is gone, switch to high heat and add the stir-fried vegetables and Spam.",
      "Finally, add the chopped green onion and cook briefly to evaporate a bit more moisture.",
      "Transfer to a bowl and sprinkle with a little pepper."
    ]
  },
  {
    "name": "Cobb Salad & Open-Faced Sandwiches",
    "url": "https://youtu.be/Z6ZO4kTY4w0",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-06-24",
    "ingredients": [
      "Salmon",
      "Sliced Jambon",
      "Salad greens",
      "Arugula",
      "Lettuce",
      "Corn kernels",
      "Black olives",
      "Feta cheese",
      "Red onion",
      "Tomato",
      "Cherry tomatoes",
      "Cucumber",
      "Avocado",
      "Eggs",
      "Sourdough bread",
      "Garlic",
      "Greek yogurt",
      "Mayonnaise",
      "Whole grain mustard",
      "Sriracha sauce",
      "Salt",
      "Black pepper",
      "Parsley",
      "Crushed red pepper flakes",
      "Lemon",
      "Olive oil"
    ],
    "steps": [
      "Score the avocado in a cross pattern and cut into quarters.",
      "Cut avocado, lettuce, cucumber, black olives, cherry tomatoes, and salmon into bite-sized pieces.",
      "Wet the knife blade and cut the hard-boiled eggs in half.",
      "Make the dressing by mixing Greek yogurt, minced garlic, olive oil, salt, pepper, and squeezed lemon juice.",
      "Arrange ingredients in a bowl, starting with larger pieces, then top with feta cheese and hard-boiled eggs.",
      "Sprinkle with a little coarse salt.",
      "Drizzle with a little olive oil.",
      "Halve the avocado and peel it.",
      "Slice the avocado using the tip of the knife.",
      "Slice the sourdough bread 2cm thick.",
      "Brush one side of the sourdough with olive oil and grill in a pan over medium-low heat.",
      "Thinly slice red onion, tomato, and jambon.",
      "Make Sriracha aioli sauce by mixing mayonnaise, Sriracha, whole grain mustard, and parsley.",
      "When water boils, turn off the heat and add a little salt.",
      "Place an egg on a strainer and immerse in hot water for 2 minutes to make a poached egg.",
      "Spread the sauce on one side of the well-grilled sourdough, then top with arugula, red onion, tomato, jambon, and avocado.",
      "Lightly sprinkle coarse salt on top.",
      "Place the poached egg on top and sprinkle with parsley, pepper, crushed red pepper flakes, and drizzle with olive oil."
    ]
  },
  {
    "name": "Burrata",
    "url": "https://youtu.be/DS-zmxNdlpw",
    "uploader": "미뇨끼",
    "upload_date": "2024-02-25",
    "ingredients": [
      "Buffalo milk curds",
      "Cow milk curds",
      "Heavy cream",
      "Olive oil",
      "Pepper"
    ],
    "steps": [
      "Place buffalo milk curds and cow milk curds in a bowl.",
      "Pour hot water and stir with a wooden spoon, kneading until the cheese becomes stretchy.",
      "Stretch the prepared mozzarella thinly and long, then tear into strings.",
      "Pour heavy cream over the torn mozzarella, mix, and let it age for a day.",
      "Flatten a piece of mozzarella into a round, flat shape.",
      "Fill the flattened mozzarella with the aged creamed mozzarella.",
      "Gather the edges like a flower and tie a knot to complete the burrata.",
      "Drizzle olive oil and sprinkle pepper over the finished burrata before serving."
    ]
  },
  {
    "name": "Pasta with Anmyeondo Mussels and Potatoes",
    "url": "https://youtu.be/hQlk_jKRdGA",
    "uploader": "미뇨끼",
    "upload_date": "2024-02-28",
    "ingredients": [
      "Mussels",
      "Potatoes",
      "Mezzi Maniche pasta",
      "Onion",
      "Garlic",
      "Tomato paste",
      "Olive oil",
      "Scallions",
      "Parsley"
    ],
    "steps": [
      "Heat olive oil in a frying pan. Add garlic and scallions, then add mussels. Cover and cook until mussels open.",
      "Remove the cooked mussels. Strain the remaining broth and set aside.",
      "Dice the potatoes and onion.",
      "In the same frying pan, heat olive oil. Sauté the diced onion and garlic, then add tomato paste, diced potatoes, strained mussel broth, and water. Simmer until the sauce thickens slightly.",
      "Cook the Mezzi Maniche pasta halfway. Transfer it to the sauce pan, add pasta water, and simmer like a risotto until the sauce reduces and coats the pasta.",
      "Add the cooked mussel meat and simmer until creamy.",
      "Serve the finished pasta in a bowl. Top with mussel meat and chopped parsley, then drizzle with olive oil to finish."
    ]
  },
  {
    "name": "Vongole Pasta",
    "url": "https://youtu.be/ZevJuQ04DFU",
    "uploader": "미뇨끼",
    "upload_date": "2024-03-03",
    "ingredients": [
      "Clams",
      "Linguine",
      "Garlic",
      "Parsley",
      "White wine",
      "Salt",
      "Olive oil"
    ],
    "steps": [
      "Chop the parsley.",
      "Bring water to a boil in a pot and cook the pasta.",
      "Heat olive oil in a pan, sauté garlic and rosemary, then add clams and white wine. Cover and cook until the clams open.",
      "Remove some cooked clams from their shells. Add the cooked pasta and shelled clams to the remaining clam broth in the pan and mix to thicken the sauce.",
      "Plate the finished pasta and garnish with the remaining clam shells and chopped parsley."
    ]
  },
  {
    "name": "Spicy Stir-fried Squid",
    "url": "https://youtu.be/ZhNcFZzgzjo",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-06-27",
    "ingredients": [
      "Squid",
      "Green onions",
      "Cabbage",
      "Onion",
      "Perilla leaves",
      "Cheongyang chili pepper",
      "Red chili pepper",
      "Tuna extract",
      "Sugar",
      "Mirin",
      "Corn syrup",
      "Soy sauce",
      "Gochujang",
      "Doenjang",
      "Garlic",
      "Oyster sauce",
      "Gochugaru",
      "Black pepper",
      "Chili oil",
      "Cooking oil",
      "Sesame oil",
      "Sesame seeds"
    ],
    "steps": [
      "Cut red chili pepper, Cheongyang chili pepper, green onions, and cabbage into bite-sized pieces.",
      "Combine sugar, mirin, minced garlic, gochujang, doenjang, soy sauce, oyster sauce, cooking oil, and pepper to make the seasoning sauce.",
      "Heat a pan over high heat, add a generous amount of oil, then add squid and Cheongyang chili pepper and stir-fry quickly over high heat until moisture starts to come out.",
      "Place a strainer over a mixing bowl and pour the stir-fried squid and chili broth into it.",
      "Heat chili oil in a pan over high heat and stir-fry the cabbage.",
      "Once the cabbage has softened slightly, add the onion and gochugaru.",
      "Continue to stir-fry over high heat; once the moisture evaporates, add the seasoning sauce.",
      "Taste and add more soy sauce if needed.",
      "Add green onions, red chili pepper, squid, and the broth.",
      "Add corn syrup and sesame oil.",
      "Tear the perilla leaves into small pieces and add them.",
      "Finally, sprinkle with sesame seeds."
    ]
  },
  {
    "name": "Octopus Salad",
    "url": "https://youtu.be/5XGJ_tOyUt8",
    "uploader": "미뇨끼",
    "upload_date": "2024-03-06",
    "ingredients": [
      "Octopus",
      "Potato",
      "Lemon",
      "Red Chili",
      "Pine Nuts",
      "Parsley",
      "Lemon Zest",
      "Bay Leaf",
      "Salt",
      "Olive Oil"
    ],
    "steps": [
      "Boil water with lemon peel, bay leaf, and salt, then cook the octopus.",
      "Peel and dice the potatoes, then boil them.",
      "Finely chop the red chili and parsley.",
      "Mix lemon juice, olive oil, chopped parsley, and salt to make the dressing.",
      "Slice the cooked octopus into bite-sized pieces.",
      "Combine the cooked potatoes, chopped red chili, pine nuts, dressing, and sliced octopus in a bowl and mix.",
      "Serve on a plate."
    ]
  },
  {
    "name": "Stracciatella",
    "url": "https://youtu.be/MoJAQnM4yc0",
    "uploader": "미뇨끼",
    "upload_date": "2024-03-10",
    "ingredients": [
      "Mozzarella",
      "Cream",
      "Yuzu marmalade",
      "Granola",
      "Parsley",
      "Black pepper",
      "Olive oil",
      "Bread"
    ],
    "steps": [
      "Tear warm mozzarella into strands.",
      "Submerge the torn mozzarella in fresh cream.",
      "Place the submerged mozzarella into a serving bowl.",
      "Top the stracciatella with yuzu marmalade, granola, black pepper, and drizzle with olive oil.",
      "Garnish with parsley.",
      "Serve and enjoy with bread."
    ]
  },
  {
    "name": "Matcha Tiramisu",
    "url": "https://youtu.be/fivkdmgfeKo",
    "uploader": "미뇨끼",
    "upload_date": "2024-03-13",
    "ingredients": [
      "Eggs",
      "Heavy cream",
      "Mascarpone cheese",
      "Ladyfingers",
      "Matcha powder",
      "Sugar",
      "Vanilla extract"
    ],
    "steps": [
      "Whisk egg yolks and sugar until well combined and pale.",
      "Place the mixture from step 1 over a pot of simmering water (double boiler) and whisk until thickened.",
      "Add vanilla extract and mascarpone cheese to the mixture from step 2 and whisk until smooth.",
      "Add matcha powder to the mixture from step 3. Stir with a spatula once, then whisk until fully incorporated.",
      "Whip heavy cream separately until stiff peaks form.",
      "Gently fold the whipped cream from step 5 into the matcha mascarpone mixture from step 4."
    ]
  },
  {
    "name": "Dumpling Skin Ravioli",
    "url": "https://youtu.be/TDzfBvQm7No",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-07-01",
    "ingredients": [
      "Bacon",
      "Shrimp",
      "Shrimp Heads",
      "Squid",
      "Carrot",
      "Celery",
      "Button Mushrooms",
      "Onion",
      "Tomato",
      "Shiitake Mushrooms",
      "Dumpling Skins",
      "Bay Leaf",
      "Oyster Sauce",
      "Parmigiano Reggiano Cheese",
      "Garlic",
      "Salt",
      "Heavy Cream",
      "Cayenne Pepper",
      "Chicken Stock",
      "Tomato Paste",
      "Paprika Powder",
      "Peperoncino",
      "Black Pepper",
      "White Wine",
      "Chili Oil",
      "Butter",
      "Olive Oil",
      "Parsley"
    ],
    "steps": [
      "Combine butter and heavy cream in a pot and bring to a boil.",
      "Stir well with a spatula to prevent separation.",
      "Reduce until it reaches a potato puree consistency, then cool and firm up.",
      "Chop celery, onion, tomato, mushrooms, and carrot. Separate parsley leaves from stems.",
      "Finely chop parsley leaves.",
      "Heat olive oil in a pot.",
      "Sauté onion, carrot, and celery over high heat until browned, then set aside.",
      "Add more olive oil to the pot and sauté shrimp heads over medium heat.",
      "Stir in tomato paste.",
      "Add the reserved sautéed vegetables and continue to sauté.",
      "Add water, bay leaf, black pepper, tomato, parsley stems, and peperoncino. Simmer for 30-40 minutes until reduced.",
      "Roughly chop shrimp and squid.",
      "In a mixing bowl, combine chopped shrimp and squid with white wine, garlic, black pepper, cayenne pepper, paprika powder, salt, and parsley. Mix well and briefly refrigerate.",
      "Bring salted water to a boil for cooking dumplings.",
      "Slightly widen dumpling skins with a round cutter, moisten edges with water, place filling, and cover with another dumpling skin.",
      "Create an air hole and press down with the round cutter to seal.",
      "Heat chili oil in a pan, then sauté garlic, bacon, peperoncino, and mushrooms.",
      "Once mushrooms and bacon are cooked, add heavy cream and three ladles of the prepared broth.",
      "Cook dumplings in boiling water for about 3 minutes.",
      "Add cooked dumplings and cheese to the sauce and reduce.",
      "Drizzle with olive oil and sprinkle with Parmigiano Reggiano cheese."
    ]
  },
  {
    "name": "Monte Carlo Pasta",
    "url": "https://youtu.be/XKu19xhFbZE",
    "uploader": "미뇨끼",
    "upload_date": "2024-03-15",
    "ingredients": [
      "Ground beef",
      "Carrot",
      "Rigatoni",
      "Celery",
      "Onion",
      "Treccie",
      "Red wine",
      "Basil pesto",
      "Heavy cream",
      "Tomato puree",
      "Salt",
      "Olive oil"
    ],
    "steps": [
      "Heat olive oil in a pot, then sauté minced onion, carrot, and celery.",
      "Add ground beef and brown it, then add red wine and tomato puree, and simmer to make a ragu.",
      "Cook pasta in boiling salted water.",
      "In a pan, combine the ragu, cream, cooked pasta, and some pasta water, and mix well.",
      "Serve the pasta in a bowl and top with cream and basil pesto."
    ]
  },
  {
    "name": "Gnocchi",
    "url": "https://youtu.be/LbNQDjKbfw0",
    "uploader": "미뇨끼",
    "upload_date": "2024-03-18",
    "ingredients": [
      "Potatoes",
      "Eggs",
      "Flour",
      "Butter",
      "Pepper",
      "Salt",
      "Parmesan cheese"
    ],
    "steps": [
      "Boil potatoes in water for 40 minutes.",
      "Peel the potatoes and mash them with a ricer.",
      "Add eggs and flour and mix.",
      "If the dough is sticky, knead it while gradually sprinkling flour.",
      "Divide the finished dough into several portions.",
      "Roll the dough into long, rope-like strands and cut into thumb-sized pieces.",
      "Dust a gnocchi board with flour and roll each piece to create ridges.",
      "Add salt to boiling water and cook the gnocchi for 1-2 minutes until they float to the surface."
    ]
  },
  {
    "name": "Chestnut Risotto",
    "url": "https://youtu.be/1NYIYVq1_c0",
    "uploader": "미뇨끼",
    "upload_date": "2024-03-20",
    "ingredients": [
      "Chestnuts",
      "Onion",
      "Rice",
      "Salt",
      "Parmesan cheese",
      "Olive oil",
      "White wine",
      "Vegetable broth",
      "Butter",
      "Parsley"
    ],
    "steps": [
      "Air fry chestnuts at 180°C for 25 minutes, then peel.",
      "Add a little water to the chestnuts and blend until smooth.",
      "Sauté onion in olive oil, then add rice and sauté.",
      "Add white wine and simmer briefly, then add 2-3 ladles of vegetable broth.",
      "Cook slowly over low heat until the rice is tender, adding one ladle of broth at a time if the broth runs low or the rice is still hard.",
      "Once the rice is cooked, stir in butter and Parmesan cheese vigorously.",
      "Season with salt.",
      "Garnish with reserved chestnuts, parsley, and a drizzle of olive oil, then serve."
    ]
  },
  {
    "name": "Doritos Mac and Cheese",
    "url": "https://youtu.be/ZsX-RPwfQp8",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-07-04",
    "ingredients": [
      "Cappelletti",
      "Shishito peppers",
      "Jalapeño",
      "Corn",
      "Heavy cream",
      "Cheddar slices",
      "Mozzarella cheese",
      "Pecorino cheese",
      "Salt",
      "Minced garlic",
      "Chicken stock",
      "Black pepper",
      "Red pepper flakes",
      "Cooking oil",
      "Olive oil",
      "Butter",
      "Doritos"
    ],
    "steps": [
      "Bring salted water to a boil for cooking pasta.",
      "Cut shishito peppers to the size of corn kernels.",
      "Finely chop jalapeños.",
      "Add Cappelletti to the boiling water and cook for 6 minutes and 30 seconds.",
      "Heat cooking oil in a pan, add minced garlic, and sauté.",
      "Before the garlic turns brown, add pasta water and heavy cream.",
      "Add cheddar slices before the sauce boils.",
      "Add the cooked Cappelletti to the sauce.",
      "While the sauce is boiling, sauté corn and jalapeños in another pan.",
      "Once the sauce starts boiling, add mozzarella cheese and simmer over medium heat for about 2 minutes and 30 seconds.",
      "When the corn and jalapeños are cooked, add the chopped shishito peppers.",
      "When the sauce boils, add black pepper, chicken stock, and Pecorino cheese.",
      "Once the sauce thickens, turn off the heat and add olive oil and butter.",
      "Scoop out a portion for the classic version. To the remaining sauce, add the sautéed corn, jalapeños, and shishito peppers to create the Korean-style version.",
      "Adjust consistency by adding a little more pasta water and olive oil if needed.",
      "For the classic version, garnish with Pecorino cheese and black pepper. For the Korean-style version, sprinkle with red pepper flakes."
    ]
  },
  {
    "name": "Gorgonzola Gnocchi",
    "url": "https://youtu.be/7nd4MmkerpE",
    "uploader": "미뇨끼",
    "upload_date": "2024-03-24",
    "ingredients": [
      "Gnocchi",
      "Walnuts",
      "Gorgonzola cheese",
      "Milk",
      "Salt",
      "Pepper"
    ],
    "steps": [
      "Cook the gnocchi in boiling water until they float to the surface.",
      "In a pan, add milk and Gorgonzola cheese, stir, and simmer until the cheese melts.",
      "Finely crush the walnuts.",
      "Add the cooked gnocchi to the cheese sauce and mix well.",
      "Serve the finished gnocchi in a bowl, sprinkle with crushed walnuts and pepper."
    ]
  },
  {
    "name": "Mugwort Spätzle",
    "url": "https://youtu.be/HrluOJx4_ME",
    "uploader": "미뇨끼",
    "upload_date": "2024-03-27",
    "ingredients": [
      "Mugwort",
      "Guanciale",
      "Flour",
      "Egg",
      "Cream",
      "Salt"
    ],
    "steps": [
      "Blanch mugwort in boiling water, squeeze out water, and finely grind.",
      "In a bowl, mix flour, egg, ground mugwort, and water to make Spätzle dough.",
      "Add salt to boiling water, then press the dough through a grater with large holes to form Spätzle.",
      "When the Spätzle floats to the surface, remove and drain.",
      "Dice guanciale and pan-fry until crispy.",
      "Add fresh cream and cooked Spätzle to the fried guanciale, and mix well.",
      "Serve the finished Spätzle in a bowl."
    ]
  },
  {
    "name": "Cherry Blossom Tiramisu",
    "url": "https://youtu.be/NzR4iU-pFE0",
    "uploader": "미뇨끼",
    "upload_date": "2024-03-31",
    "ingredients": [
      "Mascarpone",
      "Eggs",
      "Whipping cream",
      "Ladyfingers",
      "Cherry blossom cordial",
      "Sugar",
      "Strawberry powder"
    ],
    "steps": [
      "Mix sugar and egg yolks.",
      "Add mascarpone and mix well.",
      "Whip whipping cream.",
      "Gently fold the whipped cream into the egg-mascarpone mixture.",
      "Pour cherry blossom cordial into a dish.",
      "Dip ladyfingers into the cherry blossom cordial.",
      "Spread a thin layer of mascarpone cream in a square dish, then place the soaked ladyfingers on top.",
      "Pour the remaining mascarpone cream generously and smooth the surface.",
      "Sprinkle strawberry powder evenly.",
      "Chill thoroughly in the refrigerator.",
      "Scoop the chilled tiramisu onto a plate, sprinkle with additional strawberry powder, and serve."
    ]
  },
  {
    "name": "Mac and Cheese",
    "url": "https://youtu.be/kJh5AgAtGrY",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-07-05",
    "ingredients": [
      "Cappelletti pasta",
      "Doritos",
      "Heavy cream",
      "Mozzarella cheese",
      "Corn",
      "Garlic",
      "Jalapeno",
      "Sliced cheddar cheese",
      "Shishito peppers",
      "Pecorino cheese",
      "Chicken stock",
      "Peperoncino",
      "Black pepper",
      "Salt",
      "Olive oil",
      "Butter",
      "Cooking oil"
    ],
    "steps": [
      "Bring salted water to a boil for pasta.",
      "Dice shishito peppers to the size of corn kernels.",
      "Finely chop jalapenos.",
      "Add cappelletti pasta to boiling water and cook.",
      "Heat cooking oil in a pan, add garlic, and sauté.",
      "Before garlic turns brown, add pasta water and heavy cream.",
      "Before it boils, add sliced cheddar cheese.",
      "Add cooked cappelletti pasta to the sauce.",
      "While the sauce is simmering, sauté corn and jalapenos in a separate pan.",
      "Once the sauce starts to boil, add mozzarella cheese and simmer over medium heat.",
      "When corn and jalapenos are cooked, add the diced shishito peppers.",
      "Once the sauce is boiling, add black pepper, chicken stock, and Pecorino cheese.",
      "When the sauce thickens, turn off the heat and add olive oil and butter.",
      "Scoop out a portion for the classic version, then add the sautéed ingredients to the remaining sauce to create the Korean-style version.",
      "Stir in a little more pasta water and olive oil.",
      "For the classic version, sprinkle with Pecorino cheese and black pepper; for the Korean-style version, sprinkle with peperoncino."
    ]
  },
  {
    "name": "Spicy Pork Gochujang Stew",
    "url": "https://youtu.be/4G904gzlq6k",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-07-08",
    "ingredients": [
      "Pork shoulder",
      "Potato",
      "Green onion",
      "Zucchini",
      "Onion",
      "Cheongyang chili",
      "Oyster mushroom",
      "Enoki mushroom",
      "Shiitake mushroom",
      "Soy sauce",
      "Gochujang",
      "Chili powder",
      "Minced garlic",
      "Mirin",
      "Salted shrimp paste",
      "Sugar",
      "Tuna sauce",
      "Chili oil",
      "Cooking oil",
      "Sesame oil"
    ],
    "steps": [
      "Cut onion, zucchini, shiitake mushrooms, green onion, potato, oyster mushrooms, and enoki mushrooms into bite-sized pieces.",
      "Remove blood from pork shoulder and cut into desired size.",
      "Add 1T chili oil and 2T sesame oil to a pot and heat it.",
      "Add pork shoulder and stir-fry.",
      "Add 1T chili powder; if oil is insufficient, add 1T cooking oil.",
      "Once the meat is stir-fried, first add 500ml water.",
      "Add 2T gochujang and 2T sugar.",
      "First add potato and boil.",
      "Add shiitake mushroom stems to make broth.",
      "Add 0.5T minced garlic.",
      "Add shiitake mushrooms.",
      "Add 1T mirin and onion.",
      "Add 1t salted shrimp paste.",
      "Turn heat to high and add another 500ml water.",
      "Remove shiitake mushroom stems, then add oyster mushrooms, zucchini, and Cheongyang chili.",
      "Add 3T soy sauce and 1T tuna sauce.",
      "Add enoki mushrooms 2-3 minutes before finishing."
    ]
  },
  {
    "name": "Fabri Kitchen Course Menu",
    "url": "https://youtu.be/PWqpRxQ0MlQ",
    "uploader": "미뇨끼",
    "upload_date": "2024-04-12",
    "ingredients": [
      "Octopus",
      "Pork tenderloin",
      "Assorted seafood",
      "Shrimp",
      "Prosciutto",
      "Potato",
      "Carrot",
      "Lemon zest",
      "Rosemary",
      "Butter",
      "Bread",
      "Black olives",
      "Peas",
      "Spaghetti",
      "Rice",
      "Orecchiette pasta",
      "Zucchini",
      "Cherry tomatoes",
      "Capers",
      "Thyme",
      "Tomato",
      "Pesto",
      "Fennel",
      "Provolone cheese",
      "Mayonnaise",
      "Balsamic vinegar",
      "Cream",
      "Sauce",
      "Caramel sauce",
      "Parmesan cheese",
      "Pepper",
      "Olive oil",
      "Cookie crumbles",
      "Parsley",
      "White wine"
    ],
    "steps": [
      "Serve 'Panzanella di Polpo' salad, made with bread, tomatoes, and octopus, firmly bound with mayonnaise and balsamic vinegar.",
      "Serve 'Patate e Provolone', a traditional Neapolitan soup pasta with melted potatoes and Provolone cheese.",
      "Serve 'Risotto alla Pescatora', a quintessential Italian seafood risotto adjusted to suit Korean tastes.",
      "Serve 'PPP Pasta (Piselli Panna Prosciutto)', where the savory flavor of cream and bacon harmonizes with the sweetness of peas.",
      "Serve 'Pasta Limone e Gamberi', a butter pasta infused with a delicate lemon aroma.",
      "Serve 'Polpetti alla Luciana', traditional Neapolitan braised octopus, enjoyed with fresh pesto bruschetta.",
      "Serve 'Maiale alle Erbe', the tenderest pork tenderloin dish, with roasted vegetables.",
      "Serve 'Panna Cotta', a creamy pudding known as 'Mignoki Soul Dessert', with caramel sauce and cookie crumbles."
    ]
  },
  {
    "name": "Italian Brunch",
    "url": "https://youtu.be/18nlTRR1Izg",
    "uploader": "미뇨끼",
    "upload_date": "2024-04-21",
    "ingredients": [
      "Fregola pasta",
      "Tuna",
      "Bell pepper",
      "Mozzarella cheese",
      "Bacon",
      "Arancini",
      "Eggplant",
      "Bruschetta bread",
      "Prosciutto",
      "Cheese",
      "Grapes",
      "Cashews",
      "Cherry tomatoes",
      "Arugula",
      "Garlic",
      "Leek",
      "Shrimp",
      "Mussels",
      "Squid",
      "Penne pasta",
      "Chicken breast",
      "Beef sirloin steak",
      "Lamb chops",
      "Potatoes",
      "Mushrooms",
      "Ladyfingers",
      "Lemon",
      "Cherries",
      "Saffron",
      "Tomato sauce",
      "Bitter caramel sauce",
      "Limoncello",
      "Chocolate",
      "Mascarpone cheese",
      "Olive oil",
      "Pistachios",
      "Parsley",
      "Croutons",
      "Coffee",
      "Sugar"
    ],
    "steps": [
      "Drink Italian sparkling wine, Prosecco.",
      "Enjoy a massive antipasto board featuring fregola pasta, fresh tuna carpaccio, crisp bell peppers, mozzarella and bacon arancini, pistachios, and eggplant bruschetta.",
      "Taste a hearty soup with leeks and bacon, and Sugu di Pesce, a seafood tomato pasta.",
      "Savor a main meat platter consisting of chicken breast, beef sirloin steak, lamb chops, and mashed potatoes with bitter caramel sauce.",
      "Enjoy Limoncello tiramisu (topped with pistachios) and chocolate cherry tiramisu for dessert, and drink espresso."
    ]
  },
  {
    "name": "Spicy Squid and Watercress Salad",
    "url": "https://youtu.be/AQcdLe8dP6E",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-07-15",
    "ingredients": [
      "Squid",
      "Onion",
      "Watercress",
      "Green onion",
      "Cheongyang chili",
      "Pear",
      "Gochujang",
      "Chogochujang",
      "Sugar",
      "Sesame oil",
      "Gochugaru",
      "Vinegar",
      "Makgeolli",
      "Garlic",
      "Sesame seeds",
      "Yuja makgeolli"
    ],
    "steps": [
      "Blanch the squid in rapidly boiling water for about 30 seconds, then cool it in ice water.",
      "Mix sugar, gochugaru, vinegar, sesame oil, minced garlic, sesame seeds, chogochujang, gochujang, and makgeolli to make the sauce.",
      "Add onion, watercress, green onion, and Cheongyang chili to the prepared sauce.",
      "Peel and julienne the pear, then add.",
      "Add green onions.",
      "Add the cooled squid and gently toss.",
      "Serve on a plate and sprinkle with sesame seeds to finish."
    ]
  },
  {
    "name": "Luciana-style Webfoot Octopus Polpetti",
    "url": "https://youtu.be/3DcSUtx2q5Y",
    "uploader": "미뇨끼",
    "upload_date": "2024-04-24",
    "ingredients": [
      "Webfoot octopus",
      "Webfoot octopus roe",
      "Olives",
      "Capers",
      "Chili pepper",
      "Parsley",
      "Tomato puree",
      "Olive oil",
      "White wine",
      "Bread"
    ],
    "steps": [
      "Heat olive oil in a pot and sauté minced chili pepper.",
      "Add prepared webfoot octopus and roe, pour in white wine, and cook.",
      "Add tomato puree, olives, and capers, mix well, then cover and simmer slowly over low heat until the sauce thickens.",
      "Garnish the finished dish with chopped parsley and serve warm with bread."
    ]
  },
  {
    "name": "McToast",
    "url": "https://youtu.be/Peo-oZw4e0Y",
    "uploader": "미뇨끼",
    "upload_date": "2024-05-12",
    "ingredients": [
      "ham",
      "cheese",
      "yeast",
      "milk",
      "flour",
      "egg",
      "butter",
      "sesame seeds"
    ],
    "steps": [
      "Mix yeast and milk, then add flour and egg and knead the dough.",
      "Add butter to the dough, knead, then let it rise.",
      "Divide the risen dough, fill with cheese and ham, and shape into rounds.",
      "Brush the buns with egg wash, sprinkle with sesame seeds, and bake in the oven.",
      "Slice the baked buns in half, then layer with ham and cheese.",
      "Grill the buns in a buttered pan until golden brown on both sides."
    ]
  },
  {
    "name": "Ginseng Chicken Soup",
    "url": "https://youtu.be/gPKFWzn3WaQ",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-07-18",
    "ingredients": [
      "Young chicken",
      "Mung beans",
      "Sweet rice",
      "Ginseng",
      "Nurungji (scorched rice)",
      "Fresh chestnuts",
      "Garlic",
      "Ginkgo nuts",
      "Jujubes",
      "Green onions",
      "Shiitake mushrooms",
      "Salt",
      "Pepper",
      "Samgyetang broth pack"
    ],
    "steps": [
      "Soak the sweet rice and mung beans for about an hour.",
      "First, place water on the stove. Rinse the raw chicken thoroughly under running water, scraping the inside.",
      "Remove the tail and cut off the neck of the chicken.",
      "Briefly parboil the chicken in boiling water.",
      "Discard the parboiling water and add 4L of fresh water to the pot.",
      "Add the broth pack while the water is still cold.",
      "Prepare the garlic by removing the stems.",
      "Remove the stem from one shiitake mushroom and finely chop the cap.",
      "Drain the mung beans and sweet rice, then stuff them into the chicken's cavity.",
      "Stuff 1 fresh chestnut, the chopped shiitake mushroom, 1 jujube, 3 ginkgo nuts, and 2 cloves of garlic inside the chicken.",
      "Make a slit in the fatty part of one chicken leg and tuck the other leg through it to close the cavity.",
      "Place the chicken into the broth and bring it to a boil.",
      "Cut off only the head of the ginseng and add 4 roots to the pot.",
      "Add the shiitake mushroom stem (from earlier) and two jujubes to the pot.",
      "Cover the pot with a lid.",
      "After about 40 minutes, open the lid and add 0.5 tablespoons of salt.",
      "Add green onions and 6 cloves of garlic.",
      "Sprinkle with a little pepper.",
      "Add 100g of nurungji (scorched rice).",
      "Cover with a lid and boil for another 15 minutes."
    ]
  },
  {
    "name": "Basil Cheese Potato Pancake",
    "url": "https://youtu.be/yqb4NTkWWFo",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-07-22",
    "ingredients": [
      "Potatoes",
      "Mozzarella cheese",
      "Parmesan cheese",
      "Grana Padano cheese",
      "Basil rub and peperoncino",
      "Maldon salt",
      "Honey",
      "Egg",
      "Korean pancake mix",
      "Oil spray"
    ],
    "steps": [
      "Wash and peel the potatoes.",
      "Julienne the potatoes.",
      "Add a little basil rub and peperoncino to the julienned potatoes.",
      "Add Korean pancake mix and Grana Padano cheese.",
      "Add 1 egg and mix thoroughly.",
      "Spray a pan with oil spray and cook over medium heat.",
      "Sprinkle with mozzarella cheese and continue cooking.",
      "Sprinkle with Parmesan cheese.",
      "Sprinkle additional basil rub on top.",
      "Flip several times over low heat."
    ]
  },
  {
    "name": "Seafood Spaghetti",
    "url": "https://youtu.be/h97P-inNaXE",
    "uploader": "미뇨끼",
    "upload_date": "2024-06-05",
    "ingredients": [
      "Carrot",
      "Green onion",
      "Zucchini",
      "Garlic",
      "Onion",
      "Tomato",
      "Spaghetti",
      "Webfoot octopus",
      "Mussels",
      "Red pepper powder",
      "Gochujang",
      "Soy sauce"
    ],
    "steps": [
      "Chop carrot, green onion, and zucchini.",
      "Chop garlic and onion.",
      "Place chopped garlic, onion, green onion, zucchini, carrot, tomato, spaghetti noodles, red pepper powder, gochujang, and soy sauce into a pan.",
      "Wearing gloves, mix all ingredients thoroughly by hand.",
      "Pour in water and bring to a boil.",
      "Once boiling, add webfoot octopus and mussels, and continue to simmer.",
      "Cook until the spaghetti noodles are tender and the sauce has reduced."
    ]
  },
  {
    "name": "Seasoned Beef Pancakes and Fresh Cucumber & Chive Salad",
    "url": "https://youtu.be/qfP5iAd7BHk",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-07-25",
    "ingredients": [
      "Cucumber",
      "Chives",
      "Top Round Beef",
      "Green Onions",
      "Pear",
      "Fish Sauce",
      "Rice Syrup",
      "Minced Garlic",
      "Chili Powder",
      "Soy Sauce",
      "Sugar",
      "Sesame Oil",
      "Black Pepper",
      "Salt",
      "Sesame Seeds",
      "Frying Mix",
      "Egg",
      "Cooking Oil"
    ],
    "steps": [
      "Dissolve coarse salt in warm water and soak the cucumbers.",
      "While cucumbers are brining, prepare the seasoning for the beef.",
      "Grate pear into a mixing bowl.",
      "Add sugar, sesame oil, soy sauce, minced garlic, black pepper, and green onions to the grated pear, then mix well.",
      "Pat beef dry to remove excess blood.",
      "Once beef is drained, coat it with the prepared seasoning and layer three slices of beef.",
      "For the cucumber salad dressing, combine chili powder, rice syrup, and fish sauce.",
      "Add sesame seeds and minced garlic to the salad dressing and mix.",
      "Squeeze out water from the brined cucumbers and mix them first with the prepared salad dressing.",
      "Add chives and a generous amount of sesame seeds to the cucumber salad and mix well.",
      "Heat a generous amount of oil in a pan, and lightly coat the seasoned beef with frying mix.",
      "Dip the beef in egg wash and cook until done.",
      "When the oil bubbles around the beef, flip to cook the other side."
    ]
  },
  {
    "name": "Pizza Fritta",
    "url": "https://youtu.be/yKeSp44_c1g",
    "uploader": "미뇨끼",
    "upload_date": "2024-06-19",
    "ingredients": [
      "Pizza dough",
      "Ricotta cheese",
      "Mozzarella cheese",
      "Salami",
      "Olive oil"
    ],
    "steps": [
      "Roll out the pizza dough.",
      "Spread ricotta cheese on one half of the pizza dough.",
      "Top with mozzarella cheese and salami over the ricotta.",
      "Fold the other half of the dough over to form a half-moon shape and seal the edges.",
      "Pour a generous amount of olive oil into a pan and heat.",
      "Fry the filled pizza until golden brown and crispy.",
      "Remove the fried pizza and drain excess oil.",
      "Cut in half and serve warm."
    ]
  },
  {
    "name": "Aglio e Olio",
    "url": "https://youtu.be/MGJhxx2fSeE",
    "uploader": "미뇨끼",
    "upload_date": "2024-07-05",
    "ingredients": [
      "Spaghetti",
      "Garlic",
      "Peperoncino",
      "Parsley",
      "Salt",
      "Olive oil",
      "Breadcrumbs"
    ],
    "steps": [
      "Slice garlic and prepare peperoncino and parsley.",
      "Sauté breadcrumbs in olive oil until crispy.",
      "Add salt to boiling water and cook spaghetti until softer than al dente.",
      "Pour olive oil into a pan and sauté sliced garlic and peperoncino until fragrant.",
      "Add the cooked spaghetti to the hot oil, toss until slightly dry, then add the sautéed breadcrumbs and parsley and mix well.",
      "Serve the finished Aglio e Olio on a plate and enjoy."
    ]
  },
  {
    "name": "Florentine Italian Cuisine",
    "url": "https://youtu.be/5NqHgnPoi0c",
    "uploader": "미뇨끼",
    "upload_date": "2024-07-07",
    "ingredients": [
      "Offal",
      "Meat",
      "Tortellini",
      "Agnolotti",
      "T-bone steak",
      "Mushrooms",
      "Tomatoes",
      "Red wine",
      "Rosé cream",
      "Cheese",
      "Salt",
      "Pepper",
      "Parmesan cheese",
      "Parsley",
      "Mustard",
      "Broth",
      "Focaccia",
      "Mashed potatoes",
      "Lemon",
      "Rosemary",
      "Olive oil"
    ],
    "steps": [
      "Cook offal in tomato sauce to make a stew, then sprinkle with Parmesan cheese and parsley and serve with focaccia.",
      "Slow cook beef with red wine and pepper to make Peposo stew, serve with mashed potatoes, drizzled with olive oil and sprinkled with parsley.",
      "Cook cheese-filled tortellini in broth, then serve sprinkled with Parmesan cheese.",
      "Toss meat-filled agnolotti in rosé cream sauce, then sprinkle with pepper and Parmesan cheese.",
      "Season a large T-bone steak with salt and pepper, cook rare, slice, and serve with grilled lemon, rosemary, and mustard.",
      "Grill mushrooms and serve as a contorni side dish."
    ]
  },
  {
    "name": "Melon & Prosciutto Salad",
    "url": "https://youtu.be/fsOE-UdOcGs",
    "uploader": "미뇨끼",
    "upload_date": "2024-07-16",
    "ingredients": [
      "Prosciutto",
      "Melon",
      "Cherry Tomatoes",
      "Arugula",
      "Feta Cheese",
      "Honey",
      "Balsamic Vinegar",
      "Salt",
      "Pepper",
      "Olive Oil"
    ],
    "steps": [
      "Cut the melon in half and remove the seeds.",
      "Slice some melon and arrange it on a plate, top with prosciutto, and drizzle with honey.",
      "Dice the remaining melon and place it in a bowl.",
      "Add cherry tomatoes and arugula to the bowl with the melon.",
      "Add olive oil, salt, and pepper, then mix well.",
      "Serve the salad on a plate, then sprinkle with feta cheese and drizzle with balsamic vinegar."
    ]
  },
  {
    "name": "Lobster Avocado Cannelloni",
    "url": "https://youtu.be/-woXEG89Fj0",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-05-12",
    "ingredients": [
      "Lobster",
      "Pancetta",
      "Avocado",
      "Carrot",
      "Chives",
      "Onion",
      "Shallot",
      "Leek",
      "Celery",
      "Basil",
      "Oregano",
      "Thyme",
      "Dill",
      "Pineapple",
      "Kale",
      "Cucumber",
      "Lime",
      "Dijon mustard",
      "Tabasco",
      "White wine vinegar",
      "Salt",
      "Pepper",
      "Honey",
      "Caviar",
      "Mascarpone cheese",
      "Extra virgin olive oil",
      "Heavy cream",
      "Coconut milk",
      "White wine"
    ],
    "steps": [
      "Dice carrots, onions, leeks, and celery, then add them to salted boiling water with white wine and simmer.",
      "Once the water boils again, add lobster claws, tail, and legs in order to cook, then add extra virgin olive oil and thyme for aroma.",
      "Remove the meat from the cooked lobster claws, knuckles, tail, and legs, and chop it into small pieces.",
      "Combine minced shallots, finely chopped basil, oregano, chives, mascarpone cheese, lime juice, salt, pepper, heavy cream, and lime zest to make the filling.",
      "Gently mix the lobster meat and avocado cubes into the filling.",
      "Thinly slice avocado and overlap the slices on a sheet of plastic wrap. Spread the filling on top, then roll it up tightly like gimbap and store briefly in the freezer.",
      "Mix white wine vinegar, extra virgin olive oil, and Dijon mustard to make a dressing.",
      "Slice the avocado cannelloni from the freezer, arrange them on a plate, and garnish with lobster claw and tail meat. Drizzle with the dressing, and sprinkle with caviar and fresh dill to finish."
    ]
  },
  {
    "name": "Steak Sandwich",
    "url": "https://youtu.be/3EfILoTjmX8",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-11-21",
    "ingredients": [
      "Beef Sirloin",
      "Onion",
      "Arugula",
      "Whole Grain Mustard",
      "Salt",
      "Pepper",
      "Baguette",
      "Cooked Rice",
      "Olive Oil",
      "Butter"
    ],
    "steps": [
      "Bake the baguette in the oven until crispy, then let it rest on a cooling rack.",
      "Cut the baked baguette in half and hollow out the inside.",
      "Spread a thin layer of cooked rice in a pan and cook over low heat until golden and crispy, then cut in half.",
      "Season the beef sirloin with salt and white pepper.",
      "Heat olive oil in a pan, cook the steak to rare, then slice it finely.",
      "In a hot pan, melt olive oil and butter, then sauté the julienned onion with salt and white pepper until soft and translucent, without browning.",
      "Spread butter and whole grain mustard inside the baguette, then layer with sautéed onion, sliced steak, and arugula. Cut in half to complete the baguette steak sandwich.",
      "Spread butter and whole grain mustard on one piece of crispy rice, then layer with sautéed onion, sliced steak, and arugula. Cover with the other piece of crispy rice to complete the crispy rice steak sandwich."
    ]
  },
  {
    "name": "Sautéed King Oyster Mushrooms",
    "url": "https://youtu.be/749N_sGO_3g",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-05-23",
    "ingredients": [
      "King oyster mushrooms",
      "Garlic",
      "Parsley",
      "Salt",
      "Pepper",
      "Butter",
      "Cheese",
      "Olive oil"
    ],
    "steps": [
      "First, remove the tough ends from the king oyster mushrooms.",
      "Heat a pan with olive oil.",
      "Season both sides of the king oyster mushrooms with salt and pepper.",
      "Place the whole mushrooms in the preheated pan and press them down.",
      "Score the mushrooms, then flip and cook until cooked through.",
      "Add butter and melt.",
      "Add minced garlic.",
      "Turn off the heat, then sprinkle with chopped parsley and extra virgin olive oil.",
      "Grate and sprinkle cheese."
    ]
  },
  {
    "name": "Oysters with Three Sauces",
    "url": "https://youtu.be/hjNn1ezgUdA",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-07-08",
    "ingredients": [
      "Oysters",
      "Green tomatoes",
      "Lime juice",
      "Red wine vinegar",
      "Lemon juice",
      "White pepper",
      "Vodka",
      "Shallots",
      "Celery salt",
      "Tabasco",
      "Tomatoes",
      "Tomato juice",
      "Parsley",
      "Jalapeño",
      "Red onion",
      "Green Tabasco"
    ],
    "steps": [
      "Scrub oysters with a brush to remove any debris from the shells.",
      "Carefully insert a knife into the thickest part of the oyster's side.",
      "Once the knife is fully in, push it to create a gap in the oyster.",
      "Do not discard the oyster liquid; strain and collect it.",
      "Break off the top oyster shell to open the oyster.",
      "Detach the oyster muscle with a knife, then flip the oyster and arrange it nicely.",
      "Cut off the root end of the shallot, make an incision, then push to easily peel the skin.",
      "Finely mince the shallots.",
      "Pour red wine vinegar over the minced shallots until they are submerged.",
      "Remove immediately once it starts to boil and let it cool.",
      "Core the tomatoes, remove seeds, and finely chop them (peeling is optional).",
      "Cover the finely chopped tomatoes and red onion with tomato juice.",
      "Season with celery salt and white pepper.",
      "Add Tabasco to taste.",
      "Julienne the green tomatoes.",
      "Deseed fresh jalapeños and julienne them to the same size as the green tomatoes.",
      "Roughly chop flat parsley leaves and finely mince the stems.",
      "Mix the finely chopped green tomatoes, jalapeños, and parsley, then add lemon juice and lime juice.",
      "Season with celery salt.",
      "Add an appropriate amount of Green Tabasco to taste.",
      "Add a splash of vodka."
    ]
  },
  {
    "name": "Citrus Grilled Mackerel",
    "url": "https://youtu.be/4A_bpApw-uY",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-09-26",
    "ingredients": [
      "Mackerel",
      "Shallot",
      "Dill",
      "Basil",
      "Orange",
      "Lemon",
      "Lime",
      "Tangerine",
      "Grapefruit",
      "Salt",
      "White pepper",
      "Pink peppercorns",
      "Olive oil",
      "Extra virgin olive oil",
      "Butter"
    ],
    "steps": [
      "Pat the mackerel dry with a paper towel.",
      "Score along the mackerel's backbone, remove the head, and fillet both sides.",
      "Remove any remaining bones from the mackerel fillets and trim off the fins and any parts with small bones.",
      "Wrap the prepared mackerel fillets in a paper towel, skin-side down, and refrigerate.",
      "Slice off the top and bottom of the citrus fruits (orange, lemon, lime, tangerine, grapefruit) and carefully peel the skin, minimizing fruit loss.",
      "Segment the peeled citrus fruits along the membranes and cut them into bite-sized pieces.",
      "Finely chop the shallot. Remove the white pith from the lime peel and finely chop it.",
      "Separate dill leaves from stems; finely chop the dill stems and basil.",
      "Combine the citrus segments, shallot, dill, and basil with extra virgin olive oil, salt, white pepper, and crushed pink peppercorns to make a citrus salad.",
      "Season the mackerel with salt and white pepper.",
      "Heat pure olive oil in a preheated pan. Place the mackerel skin-side down and press the center with your hand for 10 seconds to prevent the skin from curling.",
      "When the mackerel is about two-thirds cooked, add butter to the pan and baste the top of the fish with the melted butter.",
      "Flip the mackerel and cook for another 30 seconds, then pour the remaining butter over it to enhance the flavor.",
      "Plate the grilled mackerel with the citrus salad and drizzle with extra virgin olive oil."
    ]
  },
  {
    "name": "Chicken Breast Steak",
    "url": "https://youtu.be/1N7MpsfyQdY",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-05-22",
    "ingredients": [
      "Chicken breast",
      "Spinach",
      "Soy milk",
      "Minced garlic",
      "Salt",
      "White pepper",
      "Thyme",
      "Basil",
      "Olive oil",
      "Butter",
      "White wine"
    ],
    "steps": [
      "Season chicken breast evenly with salt and white pepper on both sides.",
      "Heat olive oil in a hot pan, and sear the chicken breast on one side over medium heat until golden brown.",
      "Once the top of the chicken breast is cooked, add butter, thyme, and basil, then baste the chicken with the melted butter to infuse flavor.",
      "Flip the chicken breast and cook the other side until golden brown, then remove and let it rest.",
      "Pour white wine into the pan where the chicken was cooked and reduce to make a sauce.",
      "In a separate pot, add olive oil, then butter, salt, and white pepper.",
      "Before the butter melts and changes color, add washed spinach leaves and sauté.",
      "Add minced garlic, turn off the heat, mix well, then remove the spinach temporarily.",
      "In the pot where the spinach was removed, add soy milk and reduce until thickened.",
      "Return the spinach to the reduced soy milk sauce and mix to complete the soy milk spinach.",
      "Place the soy milk spinach on a plate, then top with the rested chicken breast.",
      "Drizzle the reduced sauce over the chicken breast to finish."
    ]
  },
  {
    "name": "Mackerel Salad",
    "url": "https://youtu.be/Lyx4whidkjM",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-05-25",
    "ingredients": [
      "Mackerel",
      "Romaine lettuce",
      "Radicchio",
      "Arugula",
      "Red onion",
      "Breakfast radish",
      "Avocado",
      "Cherry tomatoes",
      "Olives",
      "Cheese",
      "Oats",
      "White wine vinegar",
      "Olive oil",
      "Dijon mustard",
      "Salt",
      "Black pepper",
      "Herbs"
    ],
    "steps": [
      "Combine white wine vinegar, extra virgin olive oil, pure olive oil, and Dijon mustard in a dressing bottle and shake to mix.",
      "Fill a bowl with water and add 1/3 capful of white wine vinegar.",
      "Tear romaine, radicchio (red parts only), and arugula by hand, place in the bowl, and wash.",
      "Slice red onion and breakfast radish into rings and soak in cold water.",
      "Score the avocado around the pit, twist to separate halves, remove the pit, peel, and slice.",
      "Season mackerel fillets with salt and pepper, score the skin, and cut into bite-sized pieces.",
      "Drain washed vegetables and arrange them on a plate with olives, oats, cherry tomatoes, cheese, red onion, and breakfast radish to set up the salad.",
      "Heat olive oil in a preheated pan, place mackerel fillets skin-side down, press down on the center, and cook over medium heat until the top flesh turns white.",
      "Once the top flesh is fully cooked, flip only once, quickly sear, remove, and drain excess oil on a paper towel.",
      "Drizzle any remaining oil from the pan over the cooked mackerel.",
      "Generously drizzle dressing over the prepared salad.",
      "Place the grilled mackerel on the dressed salad and garnish with herbs to finish."
    ]
  },
  {
    "name": "Salmon Steak",
    "url": "https://youtu.be/E6K9R6-3LgY",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-05-28",
    "ingredients": [
      "Salmon",
      "Carrots",
      "Basil",
      "Salt",
      "Pepper",
      "Olive oil",
      "Orange juice",
      "Butter",
      "Minced garlic",
      "Parsley",
      "Rice paper"
    ],
    "steps": [
      "**Prepare Carrot Orange Butter Garnish:**",
      "Wash and thinly slice carrots.",
      "Heat olive oil in a pan, add sliced carrots, and season with salt and pepper.",
      "Sauté carrots, then add butter, orange juice, and minced garlic, cooking until al dente.",
      "Finally, add chopped parsley, mix lightly, and transfer to a plate to cool.",
      "**Cook Skin-On Salmon Steak:**",
      "Season skin-on salmon evenly with salt and pepper, and make shallow incisions on the skin side.",
      "Heat a generous amount of olive oil in a pan, then place salmon skin-side down.",
      "Hold the salmon steady with tongs and fry the skin side until well crisped.",
      "Add butter, baste the salmon to finish cooking, and check doneness with a blunt needle.",
      "Remove cooked salmon from the pan, place it on a wire rack, and serve with the prepared carrot garnish.",
      "Drizzle with extra virgin olive oil to finish.",
      "**Cook Skinless Salmon Steak (Rice Paper):**",
      "Cut skinless salmon into appropriate pieces and season with salt and pepper.",
      "Place basil leaves and salmon on rice paper softened in hot water, then roll tightly.",
      "Heat olive oil in a pan, then pan-fry the rice paper-wrapped salmon until golden brown.",
      "Slice into serving pieces and serve with the prepared carrot garnish."
    ]
  },
  {
    "name": "Grilled Skirt Steak and Vegetables with Tomato Salsa Sauce",
    "url": "https://youtu.be/eow5m2CzLrM",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-05-30",
    "ingredients": [
      "Skirt Steak",
      "Tomato",
      "Onion",
      "Bell Pepper",
      "Jalapeño",
      "Zucchini",
      "Eggplant",
      "Minced Garlic",
      "Parsley",
      "Gochugaru",
      "Lemon Juice",
      "Tabasco",
      "Fish Sauce",
      "Salt",
      "Black Pepper"
    ],
    "steps": [
      "Wash and roughly chop the tomatoes, then place them in a bowl.",
      "Finely chop the onion and add it to the tomato bowl.",
      "Chop the jalapeño and add it to the tomato bowl.",
      "Finely chop the parsley and add it to the tomato bowl.",
      "Chop the bell pepper and add it to the tomato bowl.",
      "Add gochugaru, minced garlic, lemon juice, salt, black pepper, Tabasco, and fish sauce, then mix well to complete the tomato salsa sauce."
    ]
  },
  {
    "name": "Chicken Stock",
    "url": "https://youtu.be/9-JSo_8nziY",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-06-01",
    "ingredients": [
      "Chicken bones",
      "Onion",
      "Scallion",
      "Garlic",
      "Parsley",
      "Whole black peppercorns",
      "Thyme",
      "Cloves"
    ],
    "steps": [
      "Remove excess fat and skin from chicken bones.",
      "Chop large chicken bones into smaller pieces.",
      "Place chicken bones in a pot, add enough water to cover them, and bring to a boil over high heat.",
      "Roughly chop the onion and scallion, and prepare whole garlic cloves and black peppercorns.",
      "Prepare parsley stems.",
      "Wait for the stock to boil and for the foam to solidify.",
      "Reduce heat and skim off the foam and fat with a ladle.",
      "Add the prepared onion, scallion, whole garlic, black peppercorns, parsley stems, thyme, and cloves.",
      "Add enough water to cover the vegetables, and simmer over low heat for about two hours.",
      "Strain the finished stock to separate the bones and vegetables.",
      "Freeze the stock for future use."
    ]
  },
  {
    "name": "Army Stew",
    "url": "https://youtu.be/C8lIMYhvZs0",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-06-02",
    "ingredients": [
      "Ham",
      "Sausage",
      "Rice cakes",
      "Bean sprouts",
      "Green onions",
      "Enoki mushrooms",
      "Crown daisy",
      "Kimchi",
      "Cheese",
      "Baked beans",
      "Instant noodles",
      "Rice noodles",
      "Sauce",
      "Broth"
    ],
    "steps": [
      "Pour broth into the meal kit container and place on the burner.",
      "Add sausage, rice cakes, ham, cheese, bean sprouts, and green onions; bring to a boil.",
      "Add the sauce and boil.",
      "Add instant noodles and boil.",
      "Add kimchi, extra cheese, baked beans, enoki mushrooms, and crown daisy; bring to a boil (Leo-style Budae Jjigae).",
      "Once Leo-style Budae Jjigae boils, taste the noodles and broth.",
      "Pour broth and sauce into a new container and place on the burner.",
      "Add ham, sausage, rice cakes, cheese, bean sprouts, and green onions; bring to a boil.",
      "Add soaked rice noodles and cook until done (Rice Noodle Budae Jjigae).",
      "Transfer the noodles and broth from the Rice Noodle Budae Jjigae to a bowl and taste."
    ]
  },
  {
    "name": "Rice Pudding",
    "url": "https://youtu.be/Cw-c25Ss8yc",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-06-03",
    "ingredients": [
      "Rice",
      "Oats",
      "Milk",
      "Butter",
      "Mozzarella cheese",
      "Cardamom seeds",
      "Cinnamon",
      "Vanilla pod",
      "Sugar",
      "Salt",
      "Eggs",
      "Ice cream",
      "Agave syrup",
      "Mint"
    ],
    "steps": [
      "Pour milk into a pan and bring to a boil.",
      "Add cardamom seeds, cinnamon powder, scrape the seeds from the vanilla pod, and add both the seeds and the pod to boil.",
      "Add sugar and salt to season.",
      "Add butter.",
      "Add the soaked rice and cooked oats, and simmer, stirring, until the rice is about one-third cooked.",
      "**[Gratin Style]** Spoon a portion of the cooked pudding into a small dish, mix in a little egg yolk and mozzarella cheese, then bake in an air fryer at 180-200℃ for 10 minutes until the surface is golden brown.",
      "**[Risotto Style]** When the pudding reaches a thick, lava-like consistency, add mozzarella cheese and turn off the heat.",
      "Quickly stir in the remaining egg yolk to prevent clumping, then plate the pudding.",
      "Drizzle with agave syrup and garnish with ice cream and mint to finish."
    ]
  },
  {
    "name": "Spanish Salad",
    "url": "https://youtu.be/eDtYUPA6ngA",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-06-05",
    "ingredients": [
      "Cooked octopus",
      "Shrimp",
      "Baby potatoes",
      "Red onion",
      "Garlic",
      "Cherry tomatoes",
      "Scallions",
      "Chorizo sausage",
      "Cilantro leaves",
      "Cilantro stems",
      "Salt",
      "Black pepper",
      "Ground thyme",
      "Paprika",
      "Classic vinaigrette dressing",
      "Olive oil"
    ],
    "steps": [
      "Place baby potatoes in water with salt, extra virgin olive oil, whole garlic cloves, cilantro stems, and ground thyme. Boil until cooked.",
      "Peel and devein shrimp.",
      "Cut cooked octopus into bite-sized pieces. If it has an odor, rub with salt and vinegar, then rinse with water.",
      "Drain and cool the cooked potatoes. Sauté with chopped scallions, chorizo sausage, and paprika to make crushed potatoes (do not mash flat).",
      "Dice red onion, slice cherry tomatoes and garlic, and finely chop cilantro leaves.",
      "Heat extra virgin olive oil and pure olive oil in a pan.",
      "Add prepared shrimp, season with salt and pepper, and sear. Then add octopus, being careful not to overcook.",
      "Add garlic and red onion and cook lightly, ensuring their pungent flavor is not lost.",
      "Add cherry tomatoes and paprika, and cook briefly.",
      "Stir in extra virgin olive oil and remove from heat.",
      "Plate the Spanish salad, top with crushed potatoes, and sprinkle with paprika and cilantro leaves.",
      "Drizzle generously with classic vinaigrette dressing to finish."
    ]
  },
  {
    "name": "Shrimp Stock",
    "url": "https://youtu.be/67xGV6x1ysM",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-06-06",
    "ingredients": [
      "shrimp heads",
      "shrimp shells",
      "carrots",
      "onions",
      "scallions",
      "garlic",
      "cherry tomatoes",
      "white wine",
      "olive oil"
    ],
    "steps": [
      "Chop shrimp heads and shells into small pieces with scissors.",
      "Heat olive oil in a pan, add the chopped shrimp heads and shells, and sauté.",
      "Chop carrots and onions, add them with the shrimp, and sauté.",
      "Chop the green tops of scallions, crush three cloves of garlic, and sauté them together.",
      "If you have tomato paste, add it; otherwise, crush cherry tomatoes and add them, then sauté.",
      "Once the shrimp heads are browned, add white wine and deglaze the bottom of the pan while sautéing.",
      "Once the alcohol has evaporated, pour in enough water to cover the shrimp and simmer for about 1 hour.",
      "Strain the cooked stock through a sieve to remove solids, pressing the solids firmly to extract all the liquid."
    ]
  },
  {
    "name": "English Breakfast",
    "url": "https://youtu.be/HJOXv-kBSYk",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-06-11",
    "ingredients": [
      "Broccoli",
      "Onion",
      "Button mushrooms",
      "Tomato",
      "Broccoli stems",
      "Garlic",
      "Parsley",
      "Egg",
      "Sausage",
      "Bacon",
      "Butter",
      "Fresh cream",
      "Parmesan cheese",
      "Dinner roll",
      "Baked beans",
      "Chicken broth",
      "Salt",
      "Pepper",
      "Olive oil",
      "Vinegar"
    ],
    "steps": [
      "Prepare only the broccoli florets and julienne the onion.",
      "Season the julienned onion with salt and pepper, then sauté over low heat with butter until translucent.",
      "Add the prepared broccoli and sauté together until it turns a deep green.",
      "Pour just enough chicken broth over the sautéed broccoli and onion to cover, then bring to a boil.",
      "Transfer the boiled ingredients to a blender and blend to your desired consistency.",
      "Heat the blended soup, then add fresh cream to finish. Garnish with Parmesan cheese and parsley."
    ]
  },
  {
    "name": "Wine-Steamed Clams",
    "url": "https://youtu.be/T3OSfL9BpRI",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-06-17",
    "ingredients": [
      "Clams",
      "Red onion",
      "Tomato",
      "Parsley",
      "Basil",
      "Butter",
      "White wine",
      "Olive oil",
      "Classic vinaigrette dressing"
    ],
    "steps": [
      "Rinse purged clams thoroughly in cold water 3-4 times until no more debris comes out, then drain.",
      "Trim the red onion, peel, and finely chop.",
      "Finely chop parsley and basil leaves.",
      "Heat a generous amount of olive oil in a pan.",
      "Add chopped red onion to the pan and sauté until translucent.",
      "Before the onion is fully cooked, add the clams and turn the heat to high.",
      "Once the pan is hot, pour dry white wine (about half the volume of the clams) into the pan and cover with a lid.",
      "When most of the clams have opened their shells, add chopped parsley and basil, then shake the pan to mix well.",
      "Add butter and shake the pan to melt the butter and distribute it evenly.",
      "Add chopped tomato and turn off the heat.",
      "Drizzle with extra virgin olive oil and classic vinaigrette dressing."
    ]
  },
  {
    "name": "Chicken Breast Steak",
    "url": "https://youtu.be/07l1FiyENFg",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-06-20",
    "ingredients": [
      "Chicken breast",
      "Rice paper",
      "Basil",
      "Salt",
      "Black pepper",
      "Olive oil"
    ],
    "steps": [
      "Pat dry the chicken breast with a paper towel.",
      "Fillet the chicken breast to make it as long as possible.",
      "Score the thinner parts and fold to match the thickness.",
      "If there are thick sections, trim the meat and attach it to thinner areas to achieve uniform thickness.",
      "Season evenly with salt and black pepper.",
      "Place your preferred herb (basil) on the chicken breast.",
      "Soak the rice paper, then roll the chicken breast tightly, stretching as you go.",
      "Preheat a pan with olive oil.",
      "Cook all four sides of the chicken breast for 4-5 minutes over medium-low heat until golden brown.",
      "Slice the golden brown chicken breast into bite-sized pieces."
    ]
  },
  {
    "name": "Tteokgalbi Potato Pancake",
    "url": "https://youtu.be/s8GxYE1k_qA",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-06-24",
    "ingredients": [
      "Potato",
      "Frozen Tteokgalbi",
      "Minced garlic",
      "Cheongyang chili pepper",
      "Thyme",
      "Soy sauce",
      "Salt",
      "Vinegar",
      "Black pepper",
      "Olive oil"
    ],
    "steps": [
      "Wash the potatoes thoroughly, then peel them.",
      "Use a rotary grater (or spiralizer/julienne peeler) to julienne the potatoes into long, noodle-like strips.",
      "Soak the julienned potatoes in water to remove starch, then drain and remove as much moisture as possible using paper towels.",
      "Add salt, black pepper, herbs (thyme), minced garlic, and olive oil to the julienned potatoes and mix well.",
      "Thaw the frozen tteokgalbi, then break or cut it into bite-sized pieces.",
      "Heat olive oil in a pan, spread half of the potato mixture thinly and widely, and cook until golden brown on one side, then remove from the pan."
    ]
  },
  {
    "name": "Shrimp Ravioli",
    "url": "https://youtu.be/y7u4hMlGNSI",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-07-01",
    "ingredients": [
      "Shrimp",
      "Wonton Wrappers",
      "Tomatoes",
      "Spinach",
      "Salt",
      "White Pepper",
      "Dill",
      "Basil",
      "Minced Garlic",
      "Heavy Cream",
      "Classic Vinaigrette",
      "Shrimp Stock",
      "Olive Oil",
      "Egg Yolk"
    ],
    "steps": [
      "Cut fresh shrimp into bite-sized pieces.",
      "Blanch tomatoes with a torch to remove the skin, then cut the flesh into appropriate-sized pieces.",
      "Tear dill by hand and add to the ravioli filling.",
      "Chop basil smaller than the shrimp and add to the ravioli filling.",
      "Add appropriate amounts of minced garlic, salt, and white pepper to the ravioli filling and mix well.",
      "Add heavy cream to the ravioli filling, mix well, then form into small mounds.",
      "In a pot, bring water, salt, and olive oil to a boil to prepare water for cooking ravioli.",
      "Brush one side of a wonton wrapper evenly with egg yolk, place the filling on it, then cover with another wrapper and press firmly to seal and shape.",
      "Trim the edges of the ravioli with scissors for a neater shape.",
      "Once the water boils, create a gentle swirl, add the ravioli, and cook for 2 minutes 30 seconds to 3 minutes.",
      "Once cooked, remove the ravioli and place on an olive oil-moistened paper towel to prevent drying.",
      "Lightly blanch spinach leaves in the ravioli cooking water, then squeeze out excess water.",
      "Thaw frozen shrimp stock, pour into a pot, and reduce.",
      "Add heavy cream to the reduced shrimp stock, continue to reduce, then season with salt and white pepper.",
      "Once the sauce boils, add the ravioli, blanched spinach, diced tomatoes, and drizzle with classic vinaigrette to finish."
    ]
  },
  {
    "name": "Shallot Vinaigrette",
    "url": "https://youtu.be/rOrXR46BKNI",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-07-11",
    "ingredients": [
      "Shallots",
      "Red Wine Vinegar"
    ],
    "steps": [
      "Trim the root end of the shallots, then peel.",
      "Cut the shallots in half, then finely mince.",
      "Place the minced shallots in a pot and add enough red wine vinegar to just cover them.",
      "Place the pot over heat and bring to a gentle simmer, then turn off the heat.",
      "Allow to cool to room temperature."
    ]
  },
  {
    "name": "Mexican Salsa",
    "url": "https://youtu.be/fBPV9WEf6VM",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-07-13",
    "ingredients": [
      "Tomatillos",
      "Jalapeño",
      "Lime juice",
      "Green Tabasco sauce",
      "Salt",
      "Pepper",
      "Parsley",
      "Vodka"
    ],
    "steps": [
      "Remove stems from tomatillos, cut in half, and remove seeds.",
      "Finely dice the tomatillos.",
      "Cut jalapeño in half and remove seeds.",
      "Finely dice the jalapeño.",
      "Combine diced tomatillos and jalapeño in a bowl, then add lime juice, salt, and pepper.",
      "Coarsely chop parsley leaves and stems, then add them.",
      "Add Green Tabasco sauce and vodka.",
      "Mix all ingredients well to complete."
    ]
  },
  {
    "name": "Spicy Whelk and Noodle Salad",
    "url": "https://youtu.be/rECjd6HGd-w",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-07-15",
    "ingredients": [
      "Canned whelk",
      "Capellini noodles",
      "Dried pollock strips",
      "Jalapeño",
      "Cucumber",
      "Cabbage",
      "Onion",
      "Scallions",
      "Carrot",
      "Tomato gochujang",
      "Red pepper powder",
      "Sugar",
      "Salt",
      "Fish sauce",
      "White wine vinegar",
      "Canned whelk brine",
      "Garlic",
      "Sesame oil",
      "Classic vinaigrette",
      "Olive oil",
      "Parsley",
      "Sesame seeds"
    ],
    "steps": [
      "Soak dried pollock strips in canned whelk brine.",
      "Prepare and julienne scallions, cucumber, onion, cabbage, carrot, and jalapeño.",
      "Add salt and olive oil to boiling water, then cook capellini for 5-6 minutes.",
      "Rinse cooked capellini in cold water, then toss with olive oil.",
      "Squeeze out excess water from the soaked pollock strips.",
      "Combine tomato gochujang, red pepper powder, sugar, fish sauce, minced garlic, and wine vinegar to make the sauce, adjusting seasoning to taste.",
      "Add the prepared vegetables and dried pollock strips to the finished sauce and mix well.",
      "Add a little canned whelk brine, sesame seeds, and sesame oil, then mix.",
      "Add the whelk and mix.",
      "Place the mixed whelk on a serving plate and garnish with jalapeño and parsley.",
      "Arrange the cooked capellini like pasta on the plate and drizzle with classic vinaigrette."
    ]
  },
  {
    "name": "Bloody Mary Sauce",
    "url": "https://youtu.be/o-KraT3ZjzI",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-07-18",
    "ingredients": [
      "Tomato",
      "Tomato juice",
      "Red onion",
      "Garlic",
      "Red wine vinegar",
      "Celery salt",
      "Worcestershire sauce",
      "Tabasco",
      "Pepper",
      "Olive oil"
    ],
    "steps": [
      "Deseed and finely dice tomatoes.",
      "Finely dice red onion.",
      "Combine diced tomatoes and red onion in a bowl.",
      "Pour in tomato juice to cover.",
      "Add celery salt.",
      "Add Worcestershire sauce.",
      "Add Tabasco sauce.",
      "Season with white pepper.",
      "Marinate for 1-2 hours for enhanced flavor."
    ]
  },
  {
    "name": "Bloody Mary",
    "url": "https://youtu.be/kBn7tHA51jk",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-07-20",
    "ingredients": [
      "Celery",
      "Lime juice",
      "Celery salt",
      "Worcestershire sauce",
      "Tabasco sauce",
      "Tomato juice",
      "Vodka",
      "Ice"
    ],
    "steps": [
      "Add ice to a glass.",
      "Add vodka to your liking.",
      "Add Worcestershire sauce.",
      "Add Tabasco sauce.",
      "Add lime juice.",
      "Add celery salt.",
      "Add tomato juice.",
      "Trim a celery stick.",
      "Place the celery stick in the cocktail."
    ]
  },
  {
    "name": "Watermelon Cold Noodles",
    "url": "https://youtu.be/vi6fD0GzZuY",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-07-22",
    "ingredients": [
      "Apple Watermelon",
      "Somyeon (thin wheat noodles)",
      "Yeolmu Kimchi (young radish kimchi)",
      "Cucumber",
      "Carrot",
      "Scallions",
      "Egg",
      "Yeolmu Kimchi Broth",
      "Perilla Oil",
      "Salt",
      "Vinegar",
      "Black Sesame Seeds"
    ],
    "steps": [
      "Place the egg in cold water, bring to a boil, and cook for 6 minutes 35-45 seconds (for a runny yolk) or 7 minutes (for a jelly-like yolk). Immediately cool in cold water and cut in half.",
      "Cut the bottom of the apple watermelon flat so it can stand, then cut off the top and scoop out the flesh.",
      "Blend the scooped watermelon flesh until smooth, then strain through a sieve to remove seeds. Cover with plastic wrap and refrigerate.",
      "Cook somyeon noodles in boiling water, then rinse thoroughly several times in cold water.",
      "Julienne the cucumber and carrot into bite-sized pieces, then mix with yeolmu kimchi and perilla oil for a savory flavor.",
      "Mix the yeolmu kimchi broth and the chilled watermelon liquid in a 1:1 ratio, then season with vinegar and salt to taste."
    ]
  },
  {
    "name": "Watermelon Bruschetta",
    "url": "https://youtu.be/Di5aA6KKAFI",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-07-25",
    "ingredients": [
      "watermelon",
      "bread",
      "frisee lettuce",
      "radish",
      "ricotta cheese",
      "arugula",
      "mint",
      "salt",
      "pepper",
      "balsamic vinegar",
      "classic vinaigrette",
      "olive oil"
    ],
    "steps": [
      "Slice watermelon 1-1.3cm thick and cut into desired shapes.",
      "Pat the watermelon dry with a paper towel.",
      "Slice baguette or ciabatta to desired thickness and toast in a dry pan.",
      "Prepare desired salad greens such as frisee, radish, arugula, and mint.",
      "Season the watermelon with salt and pepper.",
      "Place the watermelon on a heated pan and grill until lightly browned on both sides.",
      "Brush balsamic vinegar onto the grilled watermelon.",
      "Drizzle olive oil over the toasted bread.",
      "Cut the grilled watermelon into small pieces and place them on the bread.",
      "Top the watermelon with ricotta cheese.",
      "Arrange the prepared salad greens and radish on top.",
      "Drizzle with classic vinaigrette to finish."
    ]
  },
  {
    "name": "Classic Vinaigrette",
    "url": "https://youtu.be/rJ-1V_cW-rE",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-07-27",
    "ingredients": [
      "Dijon mustard",
      "White wine vinegar",
      "Pure olive oil",
      "Extra virgin olive oil"
    ],
    "steps": [
      "Add white wine vinegar to a graduated jar.",
      "Add pure olive oil.",
      "Top off with extra virgin olive oil.",
      "Add one teaspoon of Dijon mustard.",
      "Close the jar and shake well to combine."
    ]
  },
  {
    "name": "Spanish-Style Tomato Mulhoe",
    "url": "https://youtu.be/8vycgMbSA6o",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-07-29",
    "ingredients": [
      "Halibut sashimi",
      "Tomato",
      "Red onion",
      "Bell pepper",
      "Carrot",
      "Cucumber",
      "Arugula",
      "Shallot",
      "Garlic",
      "Basil",
      "Herbs",
      "Tomato juice",
      "Balsamic vinegar",
      "Tabasco sauce",
      "Lemon juice",
      "Classic Vinaigrette",
      "Salt",
      "Pepper",
      "Olive oil"
    ],
    "steps": [
      "Slice the red onion into pieces suitable for blending in a mixer.",
      "Cut ripe tomatoes into large chunks and place them in a bowl with the red onion.",
      "Halve the red bell pepper, remove the seeds and white pith, then cut into appropriate sizes and add to the bowl.",
      "Season the ingredients in the bowl with salt and white pepper.",
      "Add balsamic vinegar and olive oil.",
      "Pour in minced garlic and enough tomato juice to barely cover the ingredients."
    ]
  },
  {
    "name": "French Dressing",
    "url": "https://youtu.be/7wJO3ddp0mg",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-08-01",
    "ingredients": [
      "Red Onion",
      "Dijon Mustard",
      "Red Wine Vinegar",
      "Salt",
      "Pepper",
      "Olive Oil"
    ],
    "steps": [
      "Prepare a blender.",
      "Peel the red onion and remove the core.",
      "Roughly chop the red onion for blending.",
      "Add the chopped red onion to the blender.",
      "Add Dijon mustard.",
      "Add red wine vinegar.",
      "Sprinkle in pepper.",
      "Sprinkle in salt.",
      "Add olive oil.",
      "Blend all ingredients in the blender.",
      "Adjust the taste by adding more red wine vinegar or olive oil to your liking.",
      "Pour the finished dressing into a sauce bottle.",
      "Store in the refrigerator and serve with salads, fish dishes, meat dishes, etc."
    ]
  },
  {
    "name": "Cold Seaweed Soup",
    "url": "https://youtu.be/rhYltFWJgno",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-08-03",
    "ingredients": [
      "Cucumber",
      "Carrot",
      "Onion",
      "Breakfast Radish",
      "Dried Laver",
      "Soy Sauce",
      "Chili Powder",
      "Sesame Seeds",
      "Plum Syrup",
      "Vinegar",
      "Seafood Broth",
      "Ice"
    ],
    "steps": [
      "Grill dried laver in a pan until it turns slightly bluish and becomes crispy.",
      "Julienne the carrot.",
      "Julienne the cucumber.",
      "Slice the breakfast radish into rings.",
      "In a bowl, combine the julienned vegetables (carrot, cucumber, onion, breakfast radish) with sesame seeds, soy sauce, chili powder, plum syrup, and vinegar.",
      "Crush the grilled laver in a plastic bag until crispy, then add it to the bowl with the vegetables.",
      "Pour the chilled seafood broth and ice into the bowl.",
      "Mix all ingredients well."
    ]
  },
  {
    "name": "Nicoise Salad",
    "url": "https://youtu.be/o_kW7npDQBo",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-08-05",
    "ingredients": [
      "Tuna Loin",
      "Green Beans",
      "Radicchio",
      "Potatoes",
      "Cherry Tomatoes",
      "Olives",
      "Dill",
      "Eggs",
      "Red Onion",
      "Dijon Mustard",
      "Salt",
      "Pepper",
      "White Wine Vinegar",
      "Red Wine Vinegar",
      "Olive Oil",
      "Extra Virgin Olive Oil"
    ],
    "steps": [
      "Thaw frozen tuna in lukewarm salted water, then gently rinse the surface.",
      "Pat dry the rinsed tuna with paper towels, then wrap in paper towels and let it fully thaw at room temperature.",
      "Slice the red onion into rings, separating portions for the dressing and for the salad.",
      "In a blender, combine the red onion designated for the dressing and white wine vinegar, then blend first.",
      "Add Dijon mustard, olive oil, salt, and pepper to the partially blended dressing, then blend again to make French dressing.",
      "Soak the red onion rings for the salad in white wine vinegar water.",
      "Tear the radicchio into bite-sized pieces.",
      "Boil clean potatoes in salted water. Then, cook the green beans in the same potato-boiling water.",
      "Rinse the cooked green beans in cold water, drain, and halve them for easy eating.",
      "Arrange salad greens (radicchio, salad red onion, etc.), boiled potatoes, green beans, cherry tomatoes, olives, eggs, and dill on a plate.",
      "Season the thawed tuna loin with salt and pepper.",
      "Drizzle olive oil on a preheated grill and quickly sear the tuna on all sides.",
      "Place the seared tuna on top of the salad, drizzle with French dressing, and finish by lightly drizzling extra virgin olive oil over the tuna."
    ]
  },
  {
    "name": "Anchovy Dill Butter",
    "url": "https://youtu.be/TVW9sAqKSCU",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-08-08",
    "ingredients": [
      "Butter",
      "Anchovy puree",
      "Cherry tomatoes",
      "Dill",
      "Rosemary",
      "Thyme",
      "Baguette",
      "Olive oil"
    ],
    "steps": [
      "Dice butter and microwave briefly to soften.",
      "Stir the softened butter well with a spatula until smooth.",
      "Add anchovy puree and process finely with a food processor.",
      "Finely chop dill, add, and mix again.",
      "Transfer the finished butter to a bowl and tap the bottom to remove air pockets.",
      "Slice the baguette.",
      "Drizzle olive oil over the sliced baguette and top with chopped rosemary or thyme.",
      "Bake in an air fryer until crispy.",
      "Spread anchovy dill butter on the toasted baguette and top with sliced cherry tomatoes."
    ]
  },
  {
    "name": "Sea Squirt Bibimbap",
    "url": "https://youtu.be/Bp8BfeplbRA",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-08-12",
    "ingredients": [
      "Sea Squirt",
      "Garlic Chives",
      "Green Chili",
      "Gamtae Seaweed",
      "Cooked Rice",
      "Minced Garlic",
      "Anchovy Fish Sauce",
      "Salt",
      "Sesame Oil",
      "Toasted Sesame Seeds",
      "Seasoned Seaweed Flakes"
    ],
    "steps": [
      "Trim the mouth and anus parts of the sea squirt.",
      "Cut the sea squirt in half and trim the bottom part.",
      "Separate the flesh from the shell and remove the entrails.",
      "Cut the cleaned sea squirt flesh into bite-sized pieces.",
      "Add salt to the cut sea squirt, gently massage, then rinse under running water and drain.",
      "Generously chop the garlic chives and finely slice the green chili.",
      "In the cleaned sea squirt, add minced garlic, crushed sesame seeds, sesame oil, sliced green chili, and salt, then mix well.",
      "Place warm cooked rice in a bowl and let it cool slightly.",
      "Add seasoned seaweed flakes, sesame oil, and generously chopped garlic chives to the rice, then lightly mix.",
      "Gently place the seasoned sea squirt on top of the mixed rice.",
      "Taste it, and if the sea squirt flavor feels too mild, reduce the amount of rice.",
      "Additionally, add gamtae seaweed, sesame oil, and more green chili, then mix well.",
      "If it's bland, add a little anchovy fish sauce to season and mix well.",
      "Wrap in gamtae seaweed and enjoy."
    ]
  },
  {
    "name": "Zabaglione with Mixed Berries and Mango",
    "url": "https://youtu.be/ynhvynMpXcY",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-08-15",
    "ingredients": [
      "mango",
      "raspberry",
      "cherry",
      "blueberry",
      "egg",
      "sugar",
      "lime zest",
      "mint leaves",
      "vanilla bean",
      "white wine"
    ],
    "steps": [
      "Cut the mango into three sections, slicing close to the pit.",
      "Separate the skin from the flesh and cut the mango flesh into bite-sized pieces.",
      "Prepare raspberries, checking for quality.",
      "Pit the cherries, using chopsticks or a cherry pitter.",
      "Combine the cut mango, raspberries, pitted cherries, and blueberries in a bowl.",
      "Grate lime zest directly into the bowl with the fruit.",
      "Add two pinches of sugar to the fruit, cover with plastic wrap, and gently warm in a double boiler for about 3 minutes to meld the flavors and aromas of the fruit.",
      "Separate egg yolks from whites, placing only the yolks in a bowl.",
      "Split the vanilla bean pod, scrape out the seeds, and add them to the egg yolks.",
      "Add 2 and a half tablespoons of sugar to the egg yolks and whisk until the sugar dissolves.",
      "Add a splash of white wine for flavor and mix well.",
      "Place the egg yolk mixture over a double boiler with simmering water and whisk rapidly and continuously until it thickens to a custard-like consistency.",
      "Stir finely chopped mint leaves into the warmed fruit mixture.",
      "Divide the fruit mixture among serving glasses.",
      "Pour the finished Zabaglione cream over the fruit in the glasses.",
      "Caramelize the top of the Zabaglione cream using a kitchen torch, then garnish with fresh mint leaves, lime zest, and a few raspberries."
    ]
  },
  {
    "name": "Wasabi Pesto Grilled Squid",
    "url": "https://youtu.be/S-cIo0MEpZg",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-08-19",
    "ingredients": [
      "Whole squid",
      "Wasabi",
      "Tomato",
      "Minced garlic",
      "Thyme",
      "Pine nuts",
      "Salt",
      "Pepper",
      "Parmesan cheese",
      "Butter",
      "Olive oil"
    ],
    "steps": [
      "Remove small roots from wasabi, then separate the stems and leaves.",
      "Cut wasabi root and leaves for the pesto.",
      "In a blender, combine wasabi root, leaves, pine nuts, olive oil, salt, and white pepper, then blend until smooth.",
      "Stir in minced garlic and Parmesan cheese to complete the wasabi pesto.",
      "Clean the squid by removing the entrails and cartilage, score the body, and cut the tentacles so they spread.",
      "Cut tomatoes lengthwise.",
      "Heat olive oil in a pan, add the squid, season with salt, and grill.",
      "When the squid is about halfway cooked, add butter, wasabi pesto, and thyme, and continue to cook.",
      "Turn off the heat, add the tomatoes, then transfer the squid to a plate.",
      "Grate fresh wasabi over the plated squid and sprinkle with Parmesan cheese to finish."
    ]
  },
  {
    "name": "Hanger Steak",
    "url": "https://youtu.be/DZawkH5fhVQ",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-08-22",
    "ingredients": [
      "Hanger Steak",
      "Parsley",
      "Basil",
      "Garlic",
      "Cilantro",
      "Red Chili Pepper",
      "Green Chili Pepper",
      "Salt",
      "Black Pepper",
      "Extra Virgin Olive Oil",
      "Pure Olive Oil",
      "White Wine Vinegar",
      "Pink Peppercorns"
    ],
    "steps": [
      "Remove fat from the hanger steak.",
      "Butterfly the thick hanger steak and trim thinly.",
      "Blend parsley, basil, cilantro, garlic, red chili pepper, and green chili pepper in a mixer.",
      "Add salt, black pepper, extra virgin olive oil, pure olive oil, and white wine vinegar to the blended ingredients to make the chimichurri sauce.",
      "Season the prepared hanger steak with salt and black pepper.",
      "Lightly coat the seasoned hanger steak evenly with olive oil.",
      "Quickly sear only the surface of the hanger steak in a hot pan over high heat.",
      "Place the seared hanger steak on a plate and garnish with basil leaves and pink peppercorns.",
      "Serve the hanger steak with the chimichurri sauce."
    ]
  },
  {
    "name": "Abalone Innard Risotto",
    "url": "https://youtu.be/o62DQDv_xfI",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-08-26",
    "ingredients": [
      "Abalone",
      "Barley",
      "Tomato",
      "Shallot",
      "Onion",
      "Heavy cream",
      "Parmesan cheese",
      "Parsley",
      "Basil",
      "Dill",
      "Thyme",
      "White wine",
      "Olive oil",
      "Salt",
      "Pepper",
      "Butter"
    ],
    "steps": [
      "Clean the abalone thoroughly with a brush, then blanch in boiling water for 10 seconds to separate the meat from the shell.",
      "Remove the teeth and esophagus from the abalone meat, and grind the innards separately.",
      "Score the abalone meat with an X-shaped cut.",
      "Mince the shallots and wash the barley.",
      "Heat olive oil and butter in a pan, then add thyme.",
      "Season the abalone meat with salt and pepper, then gently cook over low heat until just cooked through.",
      "In another pan, add olive oil, then sauté the minced shallots and washed barley.",
      "Season the barley with salt and pepper, pour in white wine, and cook until the alcohol evaporates.",
      "Once the wine has evaporated, add water and simmer until the barley is cooked.",
      "When the barley is cooked, add heavy cream and minced tomato (seeded part), then season with salt and pepper.",
      "Add the ground abalone innards, minced basil, parsley, and dill, then adjust the consistency.",
      "Plate the finished risotto and top with the cooked abalone.",
      "Garnish with tomato flesh and basil leaves, then finish by grating Parmesan cheese over it."
    ]
  },
  {
    "name": "Striploin Steak and Potato Gratin",
    "url": "https://youtu.be/UUcuPz1qdQY",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-08-29",
    "ingredients": [
      "Striploin Steak",
      "Potatoes",
      "Milk",
      "Thyme",
      "Garlic cloves",
      "Minced garlic",
      "Salt",
      "Pepper",
      "Nutmeg",
      "Orange juice",
      "White wine",
      "Butter",
      "Olive oil"
    ],
    "steps": [
      "Wash and thinly slice potatoes (skin on).",
      "Sprinkle salt on potato slices and squeeze out excess water.",
      "Layer the seasoned potatoes in an oven-safe dish.",
      "Bring milk to a boil with salt, white pepper, nutmeg, and minced garlic.",
      "Pour the hot milk mixture over the potatoes until barely submerged, then bake in a 195°C air fryer for 20 minutes.",
      "Season the striploin steak generously with salt and white pepper.",
      "Heat olive oil in a preheated pan, then sear the striploin steak until golden brown on both sides.",
      "Once the steak is partially cooked, add garlic cloves, butter, and thyme, then baste the steak with the melted butter.",
      "Remove the cooked steak from the pan and let it rest for 3-4 minutes.",
      "Discard excess oil from the pan, then deglaze with white wine, scraping up the browned bits from the bottom to make a sauce.",
      "Add the resting juices from the steak and orange juice to the sauce.",
      "Season the sauce with salt and white pepper, and once it begins to thicken, stir in butter and remaining thyme.",
      "Return the cooked steak to the sauce, glaze it, then slice and serve with the gratin."
    ]
  },
  {
    "name": "Scallion Pancake",
    "url": "https://youtu.be/mfY8TkS53MI",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-09-05",
    "ingredients": [
      "Scallions",
      "Red chili",
      "Green chili",
      "Soy sauce",
      "Chili powder",
      "Vinegar",
      "Salt",
      "Pepper",
      "Starch",
      "Olive oil"
    ],
    "steps": [
      "Finely slice red and green chilies.",
      "Combine sliced chilies with chili powder, soy sauce, vinegar, and water to make a dipping sauce.",
      "Cut scallions to fit the length of your frying pan.",
      "In a bowl, combine starch, salt, and pepper, then gradually add water to form a batter.",
      "Evenly coat the scallions with the batter.",
      "Heat olive oil in a preheated pan, then evenly arrange the batter-coated scallions.",
      "Flip once and cook until golden brown.",
      "Cut the cooked scallion pancake in half, place on a plate, and serve with the dipping sauce."
    ]
  },
  {
    "name": "Sirloin Yukjeon",
    "url": "https://youtu.be/6Y0RxfF2LXE",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-09-09",
    "ingredients": [
      "Sirloin",
      "Green Onions",
      "Soy Sauce",
      "Gochugaru",
      "Classic Vinaigrette",
      "Salt",
      "Vinegar",
      "Pepper",
      "Eggs",
      "Sesame Seeds",
      "All-Purpose Flour",
      "Korean Pancake Mix"
    ],
    "steps": [
      "Tightly wrap the sirloin block in plastic wrap to shape it, then refrigerate.",
      "Slice the shaped sirloin thickly (0.7-1 cm).",
      "Season both sides of the sliced meat with salt and white pepper.",
      "Heat olive oil in a pan over high heat and quickly sear only the surface of the meat until lightly browned.",
      "Remove the seared meat. Separate egg whites and lightly beat only the yolks.",
      "Brush one side of the pre-seared meat with egg yolk.",
      "Wipe the pan clean to remove excess oil. Place the meat in the pan, egg-yolk-coated side down, over low heat.",
      "Brush the top side of the meat in the pan with egg yolk. Once the bottom yolk is cooked, flip and cook the other side.",
      "Thinly julienne green onions.",
      "In a bowl, combine the julienned green onions with gochugaru, black sesame seeds, classic vinaigrette, and soy sauce; mix well.",
      "Arrange the cooked yukjeon on a plate and place the green onion salad next to it.",
      "Drizzle classic vinaigrette sauce over the yukjeon."
    ]
  },
  {
    "name": "Pork Neck Steak",
    "url": "https://youtu.be/CVyniN--dDE",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-09-12",
    "ingredients": [
      "Pork neck",
      "Cabbage",
      "Onion",
      "Carrot",
      "Celery",
      "Pancetta",
      "Garlic",
      "Thyme",
      "Chives",
      "Salt",
      "Pepper",
      "Heavy cream",
      "Butter",
      "Olive oil"
    ],
    "steps": [
      "Slice the pork neck about 2.5cm thick, then season with salt and white pepper.",
      "Cut the cabbage into long strips, and dice the onion, carrot, celery, and pancetta.",
      "Fry the pancetta in a pan until crisp and render out the fat. Add the onion, carrot, celery, and cabbage, season with salt and white pepper, and cook until half-done. Set aside.",
      "Heat olive oil in a pan, then place the seasoned pork neck and sear evenly on both sides.",
      "Add thyme sprigs and crushed whole garlic cloves, and continue cooking to infuse with herb flavor.",
      "When the meat is almost done, add butter and baste the pork neck with the melted butter.",
      "Once the pork neck is fully cooked, remove from the pan and let it rest.",
      "In the same pan used for vegetables, add heavy cream and reduce.",
      "Add the half-cooked vegetables to the cream, sauté together, then turn off the heat, add finely chopped chives, and mix.",
      "Arrange Kofmann's Cabbage on a plate first, then slice the rested pork neck and place it on top."
    ]
  },
  {
    "name": "Peanut Pancakes",
    "url": "https://youtu.be/sQ_oR8uikP4",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-09-16",
    "ingredients": [
      "raw peanuts",
      "scallions",
      "salt",
      "pepper",
      "flour",
      "cooking oil"
    ],
    "steps": [
      "Season raw peanuts with salt.",
      "Season with pepper.",
      "Add flour and mix to coat the peanuts.",
      "Gradually add water and mix until the batter has a risotto-like consistency.",
      "Finely chop scallions and mix into the batter.",
      "Heat cooking oil in a pan.",
      "Scoop spoonfuls of batter and cook until golden brown."
    ]
  },
  {
    "name": "French Rack Steak and Herbed Lamb Chops",
    "url": "https://youtu.be/L9vTdyl8CWI",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-09-19",
    "ingredients": [
      "Lamb",
      "Salt",
      "White pepper",
      "Dijon mustard",
      "Chives",
      "Rosemary",
      "Garlic",
      "Butter",
      "Pure olive oil",
      "Extra virgin olive oil"
    ],
    "steps": [
      "Separate the French rack into bone and lean meat.",
      "Cut the separated bone portion into edible pieces to form lamb chops.",
      "Mix Dijon mustard and pure olive oil to make a sauce.",
      "Season the lamb chops with salt and white pepper, then place them in a tray with plenty of olive oil, coating evenly.",
      "Quickly grill the lamb chops on a hot plate, then brush both sides with the prepared mustard sauce.",
      "Finish by tossing finely chopped chives onto one side of the grilled lamb chops.",
      "Season the separated lean meat block (cannon) with salt and white pepper.",
      "Preheat a pan with pure olive oil, then add the lamb and sear all sides until golden brown.",
      "When the meat is almost cooked, add rosemary, whole garlic cloves, and butter, then melt the butter and baste it over the meat.",
      "Remove the cooked meat immediately and let it rest for about 5 minutes.",
      "Finely chop chives and mix with extra virgin olive oil to make a sauce.",
      "Slice the rested meat into serving pieces, arrange on a plate, and drizzle with the chive sauce to finish."
    ]
  },
  {
    "name": "Grilled Eel Rice Bowl",
    "url": "https://youtu.be/O-UqC-xif_U",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-09-30",
    "ingredients": [
      "Eel",
      "Rice",
      "Cheongyang chili",
      "Salt",
      "Sugar",
      "Green onion",
      "Scallion",
      "Garlic",
      "Ginger",
      "Sake",
      "Mirin",
      "Soy sauce"
    ],
    "steps": [
      "Season the eel with salt and grill lightly.",
      "Cut the grilled eel in half.",
      "Combine soy sauce, mirin, sake, and sugar to make a sauce.",
      "Add whole garlic, ginger, and green onion to the sauce and bring to a boil.",
      "Dip the lightly grilled eel into the sauce.",
      "Remove the eel from the sauce and grill it again.",
      "Repeat the process of coating with sauce and grilling 2-3 times.",
      "Cut the cooked eel into bite-sized pieces.",
      "Place rice in a bowl and drizzle with sauce.",
      "Arrange the cut eel over the rice.",
      "Finely chop scallions and sprinkle over the eel.",
      "Top with julienned ginger and drizzle a little more sauce to finish."
    ]
  },
  {
    "name": "Pan-Fried Skate Cutlet",
    "url": "https://youtu.be/haX9oH9ojEE",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-10-03",
    "ingredients": [
      "Skate",
      "Cheongyang Chili Pepper",
      "Soy Sauce",
      "Mirin",
      "Salt",
      "Wine Vinegar",
      "Pepper",
      "Sesame Seeds",
      "Olive Oil",
      "Uncooked Rice",
      "Parsley"
    ],
    "steps": [
      "Toast uncooked rice over medium heat until golden brown and fragrant, then let it cool.",
      "Carefully pat the skate dry with paper towels.",
      "Using scissors, trim off the thin fin parts of the skate.",
      "Lightly sprinkle salt on both sides of the skate and let it sit for about 10 minutes to draw out moisture.",
      "Crush about two-thirds of the cooled toasted rice using a bowl or mortar and pestle.",
      "Evenly press the crushed toasted rice onto both sides of the seasoned skate.",
      "Sprinkle pepper on one side of the skate coated with toasted rice.",
      "Heat a generous amount of olive oil in a hot pan and pan-fry the skate over low heat until golden.",
      "Flip the skate to prevent burning, cook until golden, and sprinkle pepper on the other side.",
      "Finely mince the Cheongyang chili pepper and parsley stems.",
      "In a bowl, combine the minced chili pepper and parsley with wine vinegar, soy sauce, and mirin to make a sauce.",
      "Plate the pan-fried skate cutlet and serve with the sauce, fresh parsley leaves, and a lemon wedge."
    ]
  },
  {
    "name": "Tomato Hangover Ramen",
    "url": "https://youtu.be/lIAye5iO7FY",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-10-07",
    "ingredients": [
      "Tomato",
      "Ramen noodles",
      "Bacon",
      "Onion",
      "Scallions",
      "Oyster mushrooms",
      "Clams",
      "Salt",
      "Pepper",
      "Minced garlic",
      "Olive oil",
      "White wine",
      "Ramen seasoning packet"
    ],
    "steps": [
      "Score the tomato, cook to remove the skin, then mince.",
      "Heat olive oil in a preheated pan, stir-fry bacon, then add minced onion and cook until translucent.",
      "Add salt, pepper, and minced garlic; stir-fry. Once onions are fully cooked, add white wine.",
      "Add the minced tomato and bring to a boil.",
      "Add ramen noodles and the ramen seasoning packet, then boil.",
      "Add oyster mushrooms and clams, then boil.",
      "Add scallions and boil until the noodles are cooked."
    ]
  },
  {
    "name": "Cream Chicken Stew",
    "url": "https://youtu.be/FjArRPBN7iQ",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-10-14",
    "ingredients": [
      "Chicken",
      "Button Mushrooms",
      "Parsley",
      "Minced Garlic",
      "Pink Peppercorns",
      "Olive Oil",
      "Milk",
      "Heavy Cream",
      "Salt",
      "Pepper",
      "Olive Oil"
    ],
    "steps": [
      "Season chicken cut into bite-sized pieces with salt and pepper.",
      "Heat olive oil in a pan and brown the chicken, starting with the skin side.",
      "Add halved button mushrooms to the browned chicken and sauté together.",
      "Season the mushrooms with additional salt and pepper.",
      "Add 1 tablespoon of minced garlic and stir-fry to combine well.",
      "Pour in milk, scraping the seasonings stuck to the edges of the pan, and simmer until the milk reduces."
    ]
  },
  {
    "name": "Beef Stir-Fry",
    "url": "https://youtu.be/T_KJ177xOa4",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-10-17",
    "ingredients": [
      "Beef Strips",
      "Broccoli",
      "Bell Pepper",
      "Green Beans",
      "Onion",
      "Ginger",
      "Garlic",
      "Basil",
      "Salt",
      "White Pepper",
      "Sugar",
      "Soy Sauce",
      "Oyster Sauce",
      "Wine Vinegar",
      "Olive Oil",
      "Potato Starch"
    ],
    "steps": [
      "Season the beef with salt and white pepper.",
      "Heat olive oil in a pan.",
      "Add beef to the pan in a single layer and sear until browned, then remove and set aside.",
      "Cut broccoli, bell pepper, green beans, and onion into similar-sized pieces as the beef.",
      "Stir-fry vegetables (excluding onion) in the remaining oil from the beef.",
      "When vegetables are partially cooked, add onion, re-season with salt and white pepper, add more olive oil, stir-fry, then remove from the pan and set aside.",
      "In the same pan, combine soy sauce, minced garlic, sugar, grated ginger, and wine vinegar to make the sauce.",
      "Add the beef and vegetables back into the sauce, stir-fry, then add a potato starch slurry to thicken the sauce.",
      "Stir in chopped basil to finish the stir-fry."
    ]
  },
  {
    "name": "Frozen Margherita Pizza Taste Test",
    "url": "https://youtu.be/ndRgubN58qk",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-10-10",
    "ingredients": [
      "Pizza dough",
      "Tomato",
      "Mozzarella cheese",
      "Shredded cheese",
      "Basil"
    ],
    "steps": [
      "Prepare five different frozen Margherita pizza products.",
      "Cook the <Gourmet> pizza in an air fryer at 150°C for 6 minutes.",
      "Since the cheese was not fully melted, cook for an additional 6 minutes at 150°C, then 4 more minutes at 200°C.",
      "Slice the cooked <Gourmet> pizza and taste.",
      "Cook the <Yorihada> pizza in an air fryer at 200°C for about 4 minutes.",
      "Slice the cooked <Yorihada> pizza and taste.",
      "Cook the <No Brand> pizza in a microwave for about 3-4 minutes.",
      "Slice the cooked <No Brand> pizza and taste.",
      "Cook the <Volare> pizza in an air fryer at 200°C for about 10 minutes.",
      "Slice the cooked <Volare> pizza and taste.",
      "Cook the <Woozooin> pizza in an air fryer at 180°C for about 7-8 minutes.",
      "Slice the cooked <Woozooin> pizza and taste."
    ]
  },
  {
    "name": "Hanwoo Beef Platter",
    "url": "https://youtu.be/vT2pFcNjNRA",
    "uploader": "강레오 걍레오",
    "upload_date": "2025-12-16",
    "ingredients": [
      "Beef",
      "Rice",
      "Eggs",
      "Salt",
      "Black Pepper",
      "Soy Sauce",
      "Mirin",
      "Cheongju",
      "Yuzu Cheong",
      "Shio Sauce",
      "Honey",
      "Olive Oil",
      "Green Onions",
      "Ginger",
      "Garlic",
      "Onion",
      "Parsley",
      "Sesame Seeds"
    ],
    "steps": [
      "Season Hanwoo sirloin steak with salt, pepper, and olive oil.",
      "Heat olive oil in a hot pan and sear all sides of the Hanwoo sirloin steak over high heat.",
      "Remove the cooked steak and let it rest.",
      "In a pan, combine soy sauce, mirin, cheongju, yuzu cheong, whole green onions, ginger, garlic, and parsley, then simmer to create the Donburi sauce.",
      "Add honey and sliced onion to the Donburi sauce and simmer.",
      "Whisk eggs, make a thin omelet, and julienne finely.",
      "Place Hanwoo skirt steak in a bowl, add minced green onions and sliced garlic.",
      "Add shio sauce, pepper, and honey, then mix well to marinate.",
      "Sprinkle sesame seeds over the marinated skirt steak and set aside.",
      "Pour Donburi sauce over rice and top with julienned egg omelet.",
      "Slice the rested Hanwoo sirloin steak and place it over the rice.",
      "Drizzle more Donburi sauce over the sliced Hanwoo and garnish with chopped green onions to complete the Donburi.",
      "Grill the marinated skirt steak over charcoal until golden brown.",
      "Sprinkle chopped green onions and sesame seeds over the grilled skirt steak to complete the marinated Hanwoo grill."
    ]
  },
  {
    "name": "Truffle Abalone Katsu Sando",
    "url": "https://youtu.be/UMOhLf7gSw4",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-09-10",
    "ingredients": [
      "Abalone",
      "Abalone viscera",
      "Kelp",
      "Truffle",
      "Bread",
      "Mayonnaise",
      "Cream",
      "Honey",
      "Truffle salt",
      "Truffle oil",
      "Yakju (Korean clear rice wine)",
      "Reggiano cheese",
      "Tare sauce",
      "Sesame seeds",
      "Betamix",
      "Butter"
    ],
    "steps": [
      "Soak kelp in yakju.",
      "Add butter to the soaked kelp, wrap the abalone, place in a vacuum pack, and sous vide at 80°C for 2 hours.",
      "Mix abalone viscera, tare sauce, the yakju used for soaking kelp, sesame seeds, and cream, then reduce once.",
      "Add Reggiano cheese, cream, and the yakju used for soaking kelp to the reduced sauce to complete the 'Geu-woo' (abalone gut) sauce.",
      "Mix mayonnaise, truffle, Reggiano cheese, truffle salt, and truffle oil to make the mayo sauce.",
      "Mix Betamix and water to make a batter."
    ]
  },
  {
    "name": "Grilled Thick-Cut Pork Collar",
    "url": "https://youtu.be/KrG2Hwzb-kQ",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-09-12",
    "ingredients": [
      "Pork Collar",
      "King Oyster Mushrooms",
      "Potatoes",
      "Cherry Tomatoes",
      "Basil",
      "Butter",
      "Salt",
      "Pepper",
      "Olive Oil",
      "Parmesan Cheese",
      "Ssamjang"
    ],
    "steps": [
      "Wrap king oyster mushrooms in aluminum foil.",
      "Wash potatoes, coat with butter, sprinkle with salt, then wrap in aluminum foil.",
      "Place the foil-wrapped mushrooms and potatoes next to the charcoal grill to cook.",
      "Place a griddle on the charcoal grill and heat thoroughly.",
      "Spread olive oil on the heated griddle.",
      "Lightly score the thick-cut pork collar.",
      "Rub olive oil on the scored pork collar and season with salt and pepper.",
      "Place the pork collar on the griddle, turning frequently, minimizing direct flame contact, and grill.",
      "Once the exterior is golden brown, cut the pork collar into bite-sized pieces.",
      "Return the cut pork pieces to the griddle and grill, turning frequently, until cooked to medium doneness.",
      "Transfer the cooked pork collar to a plate and let it rest.",
      "Place cherry tomatoes on the griddle where the pork was cooked, season with salt and pepper, and grill until their skins burst.",
      "Lightly grill basil leaves on the griddle.",
      "Remove the foil-wrapped potatoes, cut in half, generously spread butter, grate a generous amount of Parmesan cheese on top, and sprinkle with pepper.",
      "Arrange all ingredients on a plate and enjoy."
    ]
  },
  {
    "name": "Tuna Soft Tofu Kimchi Stew",
    "url": "https://youtu.be/9DQaqKptu04",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-09-16",
    "ingredients": [
      "Tuna",
      "Soft Tofu",
      "Red Chili Pepper",
      "Cheongyang Chili Pepper",
      "Green Onion",
      "Onion",
      "Shiitake Mushrooms",
      "Kimchi",
      "Samyang Instant Noodles",
      "Minced Garlic",
      "Soy Sauce",
      "Chili Powder",
      "Dashida",
      "Sugar",
      "Salt",
      "Tuna Extract",
      "Oil from Canned Tuna",
      "Kimchi Juice"
    ],
    "steps": [
      "Pour the oil from the canned tuna into a pot.",
      "Slice green onion and onion, then stir-fry them in the tuna oil.",
      "When the onion softens, add kimchi and stir-fry.",
      "Add sugar and chili powder, then continue to stir-fry.",
      "While the kimchi is cooking, slice shiitake mushrooms and Cheongyang chili peppers.",
      "Add kimchi juice and simmer.",
      "Add 250ml water and bring to a boil.",
      "Add the sliced shiitake mushrooms and Cheongyang chili peppers.",
      "Add soy sauce, tuna extract, and minced garlic.",
      "Add 100ml more water.",
      "Add Dashida.",
      "Add soft tofu and place the tuna meat on one side.",
      "Slice red chili pepper and use as a garnish."
    ]
  },
  {
    "name": "Spicy Soft Tofu Tuna Kimchi Ramen",
    "url": "https://youtu.be/QyFgAiSr1uY",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-09-19",
    "ingredients": [
      "Green onions",
      "Cheongyang chili",
      "Kimchi",
      "Soft tofu",
      "Canned tuna",
      "Egg",
      "Ramen noodles",
      "Minced garlic",
      "Tuna sauce",
      "Sesame oil",
      "Chili oil"
    ],
    "steps": [
      "Cut green onions and Cheongyang chili.",
      "Add chili oil to a pot and stir-fry green onions.",
      "Add minced garlic.",
      "Add a little tuna oil (from the can).",
      "Add kimchi and stir-fry before the garlic and green onions burn.",
      "Add the ramen seasoning packet and a little sesame oil.",
      "Add water.",
      "Add ramen noodles and Cheongyang chili, then bring to a boil.",
      "Add soft tofu and cut it with scissors.",
      "Separate the egg yolk and white.",
      "Add tuna sauce.",
      "Add tuna and the egg white.",
      "Once cooked, gently place the egg yolk on top, among the tuna."
    ]
  },
  {
    "name": "Sea Urchin Seaweed Soup",
    "url": "https://youtu.be/skcV-srd_Uk",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-09-30",
    "ingredients": [
      "Seaweed",
      "Sea urchin roe",
      "Soy sauce",
      "Clam seasoning powder",
      "Sesame oil"
    ],
    "steps": [
      "Rinse and separate the sea urchin with seawater or salt water.",
      "Wash the seaweed thoroughly.",
      "Place the seaweed in a pot and sauté.",
      "Sauté the seaweed, gradually adding rice water.",
      "Add 500ml of rice water.",
      "Add 1 tablespoon of soup soy sauce.",
      "Add the sea urchin roe.",
      "Add 1/3 teaspoon of clam seasoning powder."
    ]
  },
  {
    "name": "Shin Ramyun Toowoomba Pasta",
    "url": "https://youtu.be/cpjmNCDfWVM",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-10-03",
    "ingredients": [
      "Shin Ramyun",
      "Red onion",
      "Cheongyang chili",
      "Sea urchin roe",
      "Milk",
      "Garlic",
      "Red pepper powder",
      "Parsley",
      "Black pepper",
      "Olive oil"
    ],
    "steps": [
      "Slice the red onion into medium-thick pieces.",
      "Heat olive oil in a pan and sauté the red onion.",
      "Add minced garlic and continue to sauté.",
      "Add red pepper powder.",
      "Pour in water.",
      "While it boils, slice the Cheongyang chili into bite-sized pieces.",
      "Add the noodles and Cheongyang chili.",
      "Gradually add milk and bring to a simmer.",
      "Add olive oil and stir to emulsify the sauce.",
      "Transfer to a bowl and top with sea urchin roe.",
      "Sprinkle with parsley, black pepper, and a drizzle of olive oil."
    ]
  },
  {
    "name": "Chicken Broth Soba",
    "url": "https://youtu.be/D0fqjxLpNBA",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2026-01-30",
    "ingredients": [
      "chicken thigh",
      "chicken bones",
      "chicken feet",
      "leek",
      "chamnamul",
      "bonito flakes",
      "kelp",
      "soy sauce",
      "sake",
      "buckwheat flour",
      "sansho pepper"
    ],
    "steps": [
      "Boil chicken bones and chicken feet in water, then add kelp, bonito flakes, and sake to create a rich broth.",
      "Mix buckwheat flour and warm water to make a dough. Fold and knead the dough into a rectangular, tile-like shape.",
      "Roll out the dough thinly with a rolling pin and cut into long noodle-like strips.",
      "Boil the cut noodles in hot water for 30-40 seconds, then rinse in cold water.",
      "Mix soy sauce into the chicken broth to make soba tsuyu.",
      "Pan-fry chicken thighs until the skin is crispy, and cook leeks alongside.",
      "Cut the pan-fried chicken thighs and leeks into bite-sized pieces and place them in a serving bowl.",
      "Pour hot tsuyu over the chicken thighs and leeks in the bowl, avoiding the crispy chicken skin.",
      "Place the cooked soba noodles in the bowl. Top with chamnamul stems and leaves, then sprinkle with sansho pepper to finish."
    ]
  },
  {
    "name": "Earthy Hot Soba",
    "url": "https://youtu.be/snSJaFp7nl0",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2026-02-03",
    "ingredients": [
      "Beltfish",
      "Abalone",
      "Mussels",
      "Maitake mushroom",
      "Lion's Mane mushroom",
      "Kelp",
      "Burdock root",
      "Dried Jerusalem artichoke",
      "Soba noodles",
      "Butter",
      "Salt",
      "Oil"
    ],
    "steps": [
      "Add water, mussels, and kelp to a pot and boil to make broth.",
      "Remove the mussels and kelp, then strain the broth.",
      "Add burdock root, dried Jerusalem artichoke, and some maitake mushrooms to the broth, boil for 30-40 minutes, and skim off any foam.",
      "Season the broth with sea salt.",
      "Fillet the beltfish, score it, season with sea salt, then grill in an oiled pan.",
      "Remove the shell, innards, and tooth from the abalone, then pre-cook until tender."
    ]
  },
  {
    "name": "Bouillabaisse",
    "url": "https://youtu.be/l34tnZ2UCLE",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2026-02-06",
    "ingredients": [
      "Fish",
      "Lobster",
      "Mussels",
      "Clams",
      "Scallops",
      "Fennel",
      "Onion",
      "Leek",
      "Shallots",
      "Garlic",
      "Tomatoes",
      "Potatoes",
      "Saffron",
      "Parsley",
      "Bay leaves",
      "Thyme",
      "Peppercorns",
      "Chili powder",
      "Salt",
      "Pepper",
      "Tomato paste",
      "Olive oil",
      "White wine",
      "Pernod"
    ],
    "steps": [
      "Remove the ends and core of the fennel, then slice.",
      "Slice the onion, white part of the leek, and shallots.",
      "In a pot with olive oil, add the sliced fennel and sauté until moisture evaporates.",
      "Add the leek, onion, and shallots, and continue to sauté until moisture evaporates.",
      "Add garlic, saffron, tomato paste, and chopped tomatoes, then sauté until the ingredients soften into a paste-like consistency.",
      "Add white wine and cook off the alcohol, then pour in water and add bay leaves, thyme, and peppercorns. Simmer the bouillabaisse base for about 10 minutes to concentrate.",
      "Cook clams and mussels separately with a little white wine in a covered pot until they open. Remove them and set aside their broth.",
      "Cook the lobster and potatoes separately in salted water.",
      "Sear the prepared fish fillets in a pan with olive oil, starting with the skin side until golden brown.",
      "Layer the potatoes, lobster, clams, mussels, seared fish, and sautéed fennel in a deep pot.",
      "Pour in the bouillabaisse base broth and the clam/mussel broth, and simmer for about 10 minutes to allow all ingredients to meld.",
      "Sprinkle with a little Pernod liqueur and chili powder, top generously with parsley, cover, and cook for a short time until done."
    ]
  },
  {
    "name": "French Onion Soup",
    "url": "https://youtu.be/kD_5LQe1F3Y",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2026-02-10",
    "ingredients": [
      "Onion",
      "Beef stock",
      "Bay leaf",
      "Thyme",
      "Emmental cheese",
      "Gruyère cheese",
      "Baguette",
      "Butter",
      "Sherry wine",
      "Sherry vinegar",
      "Salt",
      "Pepper",
      "Olive oil",
      "Apple brandy",
      "White wine"
    ],
    "steps": [
      "Thinly slice the onions along the grain.",
      "Heat olive oil in a wide pan, spread 1/3 of the onions, and sauté over medium heat until softened.",
      "Season the softened onions with salt and continue to sauté, stirring occasionally.",
      "Reduce heat to low, add a knob of butter when the onions turn golden brown, and continue to sauté.",
      "Add the remaining onions in 1/3 increments and repeat the process to caramelize all the onions.",
      "Add apple brandy to the caramelized onions and cook off the alcohol.",
      "Add white wine and cook off the alcohol.",
      "Add sherry wine, scraping the bottom of the pan to deglaze, and cook off the alcohol.",
      "Make a bouquet garni by tying bay leaves, thyme, and whole peppercorns in cheesecloth.",
      "Add beef stock and the bouquet garni to the caramelized onions, bring to a boil, then reduce heat and simmer for 30 minutes.",
      "Finally, stir in sherry vinegar to enhance the flavor.",
      "Slice the baguette, season with olive oil, salt, and pepper, and bake in the oven.",
      "Ladle a good amount of onion solids into soup bowls and fill with broth.",
      "Top with toasted baguette slices, a generous amount of sliced Emmental cheese and grated Gruyère cheese, then bake in the oven until the cheese is melted and golden brown.",
      "Finish the completed onion soup with a sprinkle of pepper."
    ]
  },
  {
    "name": "Pork Neck Galbijjim",
    "url": "https://youtu.be/XPcKkSAyo8o",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2026-02-13",
    "ingredients": [
      "Pork ribs",
      "Pork neck or shoulder",
      "Korean radish",
      "King oyster mushrooms",
      "Shiitake mushrooms",
      "Cheongyang chili pepper",
      "Kabocha squash",
      "Onion",
      "Minced garlic",
      "Ginger",
      "Star anise",
      "Bay leaf",
      "Soy sauce",
      "Sugar",
      "Corn syrup",
      "Tuna extract",
      "Mirin",
      "Vinegar",
      "Sake",
      "Black pepper",
      "Sesame oil",
      "Sesame seeds",
      "Cooking oil"
    ],
    "steps": [
      "Score the washed pork, heat cooking oil in a pan, and sear until golden brown.",
      "In the same pan, add radish and sear until golden brown in the pork fat.",
      "Transfer the pork and radish to a pot. In the same pan, add sugar, corn syrup, and soy sauce, and boil to create a caramelized sauce.",
      "Pour the sauce into the pot. Add water to the same pan, boil the remaining seasoning, then combine with the pot.",
      "In the pot, add mirin, tuna extract, minced garlic, ginger, bay leaves, and star anise.",
      "When the pot comes to a rolling boil, skim off the foam and sprinkle with black pepper."
    ]
  },
  {
    "name": "French Onion Soup",
    "url": "https://youtu.be/XtWFLNTUnfU",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2026-02-15",
    "ingredients": [
      "Onion",
      "Baguette",
      "Emmental Cheese",
      "Gruyère Cheese",
      "Beef Stock",
      "Salt",
      "Pepper",
      "Bay Leaf",
      "Thyme",
      "Butter"
    ],
    "steps": [
      "Add olive oil to a wide pan.",
      "Spread thinly sliced onions in a single layer in the pan.",
      "Cook the onions slowly until they caramelize and the moisture evaporates."
    ]
  },
  {
    "name": "Royal Court Cold Vegetable Salad",
    "url": "https://youtu.be/HagrngJo4WI",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2026-02-17",
    "ingredients": [
      "Cucumber",
      "Eggplant",
      "Shiitake mushrooms",
      "Bellflower root",
      "Mung bean sprouts",
      "Beef",
      "Sugar",
      "Plum extract",
      "Soy sauce",
      "Minced garlic",
      "Vinegar",
      "Lemon juice",
      "Black pepper",
      "Sesame oil",
      "Salt",
      "Crushed pine nuts",
      "Rice wine",
      "Canola oil"
    ],
    "steps": [
      "Julienne cucumber and eggplant, then salt them.",
      "Thinly slice shiitake mushrooms.",
      "Season bellflower root and mung bean sprouts with salt and let them sit.",
      "Marinate beef with soy sauce, sugar, sesame oil, black pepper, and rice wine, then stir-fry.",
      "Briefly blanch mung bean sprouts in boiling water, drain, and cool.",
      "Combine sugar, plum extract, soy sauce, minced garlic, vinegar, lemon juice, sesame oil, and black pepper to make the dressing.",
      "Heat oil in a pan, then stir-fry bellflower root, shiitake mushrooms, and eggplant over high heat.",
      "Add cucumber to the stir-fried vegetables, stir-fry quickly over high heat, then spread out to cool.",
      "Add blanched mung bean sprouts and salted, squeezed bellflower root to the cooled stir-fried vegetables.",
      "Add the stir-fried beef, pour the dressing over all ingredients, and mix well.",
      "Plate the cold salad and sprinkle with crushed pine nuts to serve."
    ]
  },
  {
    "name": "Mom's 4 Kinds of Mini Kimbap",
    "url": "https://youtu.be/QD3l8qdYuQQ",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2026-02-20",
    "ingredients": [
      "Bulgogi",
      "White Pollack Roe",
      "Fish Cake",
      "Dried Gourd Strips",
      "Pickled Radish",
      "Pickled Ginger",
      "Egg",
      "Rice",
      "Seaweed",
      "Soy Sauce",
      "Mirin",
      "Sugar",
      "Salt",
      "Sesame Oil",
      "Cream Cheese",
      "Flour"
    ],
    "steps": [
      "Make an egg crepe, slice it into long strips, and season with mirin.",
      "Season fish cake with soy sauce, mirin, and sugar, then stir-fry.",
      "Drain excess blood from bulgogi beef, season it, and stir-fry until all the liquid has evaporated.",
      "Mix white pollack roe and cream cheese.",
      "Prepare pickled radish, dried gourd strips, and pickled ginger.",
      "Cook rice with less water than usual to make it firm."
    ]
  },
  {
    "name": "Chef Ho-un Style Grilled Spanish Mackerel",
    "url": "https://youtu.be/g4NglftDshE",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2026-02-24",
    "ingredients": [
      "Spanish Mackerel",
      "Rice",
      "Salt",
      "Black Pepper",
      "Soy Sauce",
      "Mirin",
      "Lemon Juice",
      "Sesame Oil",
      "Sesame Seeds",
      "Wasabi",
      "Scallions",
      "Lemon Zest",
      "Olive Oil"
    ],
    "steps": [
      "Remove bones from the Spanish mackerel fillet and score the skin side.",
      "Cut the prepared Spanish mackerel fillet into appropriate-sized pieces and season thoroughly with salt.",
      "Remove moisture from the seasoned Spanish mackerel fillet with a paper towel.",
      "Generously add olive oil to a non-stick pan and heat over low heat.",
      "Place the Spanish mackerel fillet in the pan, skin side down, and cook slowly while gently pressing to prevent it from curling.",
      "Baste with oil occasionally and cook until the skin is golden brown."
    ]
  },
  {
    "name": "Anchovy Garlic Spaghetti",
    "url": "https://youtu.be/dFUIXZ872Eo",
    "uploader": "미뇨끼",
    "upload_date": "2024-07-24",
    "ingredients": [
      "Spaghetti",
      "Anchovies",
      "Garlic",
      "Parsley",
      "Lemon zest",
      "Butter",
      "Salt"
    ],
    "steps": [
      "Boil spaghetti.",
      "Melt butter in a pan.",
      "Add finely minced garlic.",
      "Cut anchovies into the pan and add pasta water.",
      "Mash the anchovies with a rubber spatula.",
      "Add al dente spaghetti to the sauce.",
      "Add more pasta water and toss until slightly saucy to make the sauce creamy.",
      "Turn off the heat, add parsley, and mix.",
      "Plate the pasta.",
      "Grate and sprinkle lemon zest."
    ]
  },
  {
    "name": "Zucchini Crepes",
    "url": "https://youtu.be/0Rw9U6YGMPE",
    "uploader": "미뇨끼",
    "upload_date": "2024-07-28",
    "ingredients": [
      "Zucchini",
      "Smoked Salmon",
      "Shallots",
      "Dill",
      "Cream Cheese",
      "Salt",
      "Eggs",
      "Flour"
    ],
    "steps": [
      "Slice zucchini and place in a measuring cup.",
      "Add eggs, salt, flour, and water.",
      "Blend until a runny batter forms.",
      "Pour a thin layer of batter onto a preheated flat pan.",
      "Cook crepes on both sides without butter or oil.",
      "Spread cream cheese on cooked crepes.",
      "Top with smoked salmon and sliced shallots.",
      "Add dill.",
      "Fold crepes in half and roll up."
    ]
  },
  {
    "name": "Basil Pesto Pasta",
    "url": "https://youtu.be/URLjRaHqnLA",
    "uploader": "미뇨끼",
    "upload_date": "2024-08-07",
    "ingredients": [
      "Basil",
      "Pine nuts",
      "Garlic",
      "Spaghetti",
      "Olive oil",
      "Parmesan cheese",
      "Salt"
    ],
    "steps": [
      "Blend pine nuts, garlic, and salt in a blender.",
      "Add basil, olive oil, and Parmesan cheese, then blend again.",
      "Scrape down ingredients from the blender walls with a spatula and blend again.",
      "Transfer the finished basil pesto to a glass jar.",
      "Freeze the basil pesto in the glass jar for storage.",
      "When ready to use, thaw the frozen pesto jar in water and scoop out the desired amount.",
      "Boil spaghetti in salted water.",
      "Place cooked spaghetti in a pan and add basil pesto.",
      "Mix the spaghetti and pesto well.",
      "Serve on a plate and sprinkle with Parmesan cheese to finish."
    ]
  },
  {
    "name": "Capellini with Mixed Tomato Sauce",
    "url": "https://youtu.be/ZWJjReGjS_8",
    "uploader": "미뇨끼",
    "upload_date": "2024-08-11",
    "ingredients": [
      "Tomato",
      "Carrot",
      "Onion",
      "Celery",
      "Capellini",
      "Salt",
      "Basil",
      "Olive oil"
    ],
    "steps": [
      "Score the stem end of tomatoes and blanch in boiling water for 30 seconds.",
      "Peel the blanched tomatoes, remove the green core, and finely chop.",
      "Heat a generous amount of olive oil in a pan and sauté the chopped carrots, onions, and celery.",
      "Cover and cook until the vegetables are soft.",
      "Add the chopped tomatoes, sauté, season with salt, and cook until moisture evaporates.",
      "Bruise basil leaves with your palm, add to the sauce, and mix.",
      "Boil salted water and cook capellini for 2 minutes.",
      "Turn off the heat, add the cooked capellini to the tomato sauce, and mix well.",
      "Plate the pasta and pour any remaining sauce on top.",
      "Garnish with basil leaves and drizzle with olive oil."
    ]
  },
  {
    "name": "Eggplant Pickle",
    "url": "https://youtu.be/V43fhC95R9Q",
    "uploader": "미뇨끼",
    "upload_date": "2024-08-14",
    "ingredients": [
      "Eggplant",
      "Vinegar",
      "Salt",
      "Pepper",
      "Bay leaf",
      "Olive oil",
      "Sunflower oil"
    ],
    "steps": [
      "Cut the eggplant into bite-sized pieces.",
      "In a pot, mix water and vinegar (1:1 ratio), add bay leaf, salt, and whole black pepper, then bring to a boil.",
      "Add the eggplant to the boiling water and blanch for 3 minutes.",
      "Drain the blanched eggplant in a colander and let cool.",
      "Squeeze out excess water from the cooled eggplant by hand.",
      "Wrap the squeezed eggplant in paper towels and dry overnight to remove moisture.",
      "Pour a little olive oil into a glass jar.",
      "Arrange the eggplant neatly in the glass jar.",
      "Cover the eggplant completely with olive oil until submerged."
    ]
  },
  {
    "name": "Pasta alla Valdostana",
    "url": "https://youtu.be/3J9V9BQ9RK8",
    "uploader": "미뇨끼",
    "upload_date": "2024-08-18",
    "ingredients": [
      "Fontal cheese",
      "Ham",
      "Penne pasta",
      "Heavy cream",
      "Salt",
      "Butter"
    ],
    "steps": [
      "Dice Fontal cheese.",
      "Dice ham.",
      "Cook penne pasta in salted boiling water.",
      "Melt butter in a pan.",
      "Add diced ham to the pan and cook.",
      "Pour in heavy cream.",
      "Add diced Fontal cheese.",
      "Stir slowly over low heat until the cheese melts to create a cream sauce.",
      "Add the cooked penne pasta to the sauce.",
      "Toss the pasta and sauce thoroughly.",
      "Serve the finished pasta in a dish."
    ]
  },
  {
    "name": "Rice Salad",
    "url": "https://youtu.be/oMAc6SNi8vs",
    "uploader": "미뇨끼",
    "upload_date": "2024-08-25",
    "ingredients": [
      "Tuna",
      "Ham",
      "Corn",
      "Capers",
      "Red bell pepper",
      "Orange bell pepper",
      "Olives",
      "Eggplant pickle",
      "Pickled plum",
      "Eggs",
      "Rice",
      "Salt",
      "Pepper",
      "Olive oil"
    ],
    "steps": [
      "Wash rice, add water and salt, and cook for 16 minutes after it starts boiling.",
      "Drain the cooked rice through a sieve, rinse with cold water, and drain well.",
      "Finely chop the hard-boiled eggs.",
      "Finely chop the red bell pepper, orange bell pepper, olives, eggplant pickle, and pickled plum.",
      "Place rice in a bowl, drizzle with olive oil and sprinkle with pepper, then mix well.",
      "To the bowl with rice, add tuna, ham, corn, capers, chopped red bell pepper, orange bell pepper, olives, eggplant pickle, pickled plum, and chopped eggs.",
      "Mix all ingredients thoroughly.",
      "Wait until completely cooled, then serve on a plate."
    ]
  },
  {
    "name": "Tomato Sauce",
    "url": "https://youtu.be/AoivhHLWU-s",
    "uploader": "미뇨끼",
    "upload_date": "2024-08-28",
    "ingredients": [
      "Tomato",
      "Carrot",
      "Celery",
      "Onion",
      "Basil",
      "Salt",
      "Olive oil"
    ],
    "steps": [
      "Crush whole tomatoes by hand.",
      "Finely dice carrots, celery, and onions.",
      "Heat olive oil in a pot and sauté the diced vegetables.",
      "Add the crushed tomatoes and mix.",
      "Cover partially to allow steam to escape and simmer slowly over medium heat.",
      "Continue to simmer, stirring occasionally, for about 2-3 hours until the sauce thickens.",
      "Turn off the heat.",
      "Stir in basil and salt until well combined.",
      "Store the finished tomato sauce in glass jars."
    ]
  },
  {
    "name": "Tomato Sauce Spaghetti",
    "url": "https://youtu.be/Sq5XK2-Nb8U",
    "uploader": "미뇨끼",
    "upload_date": "2024-09-01",
    "ingredients": [
      "Shallots",
      "Spaghetti",
      "Tomato puree",
      "Pine nuts",
      "Sugar",
      "Olive oil"
    ],
    "steps": [
      "Finely chop the shallots.",
      "Heat olive oil in a pan and sauté shallots until soft.",
      "Pour in a can of tomato puree.",
      "Add pine nuts.",
      "Simmer the sauce until it thickens.",
      "Add sugar and mix.",
      "Add cooked spaghetti to the sauce and toss to coat.",
      "Serve spaghetti in a bowl, top with tomato sauce, drizzle with olive oil, and sprinkle with pine nuts."
    ]
  },
  {
    "name": "Arrabbiata",
    "url": "https://youtu.be/kEqKo45nPDw",
    "uploader": "미뇨끼",
    "upload_date": "2024-09-08",
    "ingredients": [
      "Penne",
      "Garlic",
      "Parsley",
      "Tomato sauce",
      "Peperoncino",
      "Olive oil"
    ],
    "steps": [
      "Heat olive oil in a pan.",
      "Add grated garlic to the olive oil.",
      "Slice the peperoncino and sauté it in the olive oil.",
      "Pour the tomato sauce into the pan and mix.",
      "Cook the penne in boiling water.",
      "Add the cooked penne to the tomato sauce.",
      "Mix the penne and sauce well.",
      "Chop the parsley and sprinkle it over the pasta.",
      "Serve the finished pasta in a bowl."
    ]
  },
  {
    "name": "Fried Squid",
    "url": "https://youtu.be/dagt4pPFXCk",
    "uploader": "미뇨끼",
    "upload_date": "2024-09-19",
    "ingredients": [
      "Squid",
      "Lemon",
      "Salt",
      "Flour",
      "Frying mix",
      "Oil"
    ],
    "steps": [
      "Clean fresh squid, removing innards.",
      "Cut the squid into bite-sized pieces.",
      "Lightly coat the squid with flour.",
      "Heat a generous amount of oil in a pan until hot.",
      "Fry the floured squid in the hot oil until crispy.",
      "Remove the fried squid and place on paper towels to drain excess oil.",
      "Lightly sprinkle with salt to season.",
      "Serve on a plate and drizzle with lemon juice."
    ]
  },
  {
    "name": "Pasta e Fagioli",
    "url": "https://youtu.be/EhMYVuK7vFo",
    "uploader": "미뇨끼",
    "upload_date": "2024-10-03",
    "ingredients": [
      "Bacon",
      "Onion",
      "Carrot",
      "Celery",
      "Cannellini beans",
      "Pasta mista",
      "Tomato sauce",
      "Salt",
      "Parsley",
      "Olive oil"
    ],
    "steps": [
      "Brown the bacon in olive oil.",
      "Add finely diced onion, carrot, and celery and sauté until softened.",
      "Add tomato sauce and sauté briefly.",
      "Add drained cannellini beans.",
      "Pour in water and season with salt.",
      "Bring to a boil over high heat.",
      "Add pasta mista and cook for 10-15 minutes, or until cooked through.",
      "Serve the finished pasta in bowls.",
      "Sprinkle with parsley.",
      "Drizzle with olive oil."
    ]
  },
  {
    "name": "Kabocha Squash Gnocchi",
    "url": "https://youtu.be/v4VRvmyrh-w",
    "uploader": "미뇨끼",
    "upload_date": "2024-10-16",
    "ingredients": [
      "Kabocha squash",
      "Potatoes",
      "Eggplant",
      "Cherry tomatoes",
      "Garlic",
      "Basil",
      "Egg",
      "Parmesan cheese",
      "Olive oil",
      "Flour"
    ],
    "steps": [
      "Cut the kabocha squash in half, remove seeds, and scoop out the flesh.",
      "Mash the potatoes.",
      "Add egg and flour to the mashed kabocha squash and potatoes, then knead to form a dough.",
      "Roll the dough into long ropes, cut into small pieces, and shape into gnocchi.",
      "Dice the eggplant and halve the cherry tomatoes.",
      "Sauté olive oil and garlic in a frying pan.",
      "Add the diced eggplant and halved cherry tomatoes to the pan and sauté together.",
      "Boil the gnocchi in boiling water.",
      "Add the boiled gnocchi to the sautéed vegetables and mix.",
      "Add basil and mix.",
      "Grate Parmesan cheese on top."
    ]
  },
  {
    "name": "Italian Mountain Dish Trio",
    "url": "https://youtu.be/SB2janmVgww",
    "uploader": "미뇨끼",
    "upload_date": "2024-10-20",
    "ingredients": [
      "Potato",
      "Gorgonzola cheese",
      "Grain flour",
      "Local cheese",
      "Buckwheat pasta",
      "Cabbage",
      "Salamella sausage",
      "Bread"
    ],
    "steps": [
      "Choose your desired meat.",
      "Grill the chosen meat in a wood-fired oven.",
      "Place the grilled meat between bread to make a sandwich."
    ]
  },
  {
    "name": "Ravioli",
    "url": "https://youtu.be/6WhjopRlitg",
    "uploader": "미뇨끼",
    "upload_date": "2024-10-24",
    "ingredients": [
      "Ravioli",
      "Meat",
      "Tomato sauce",
      "Butter",
      "Parmesan cheese",
      "Salt"
    ],
    "steps": [
      "Pour water into a pot and bring to a boil.",
      "Once the water boils, add salt.",
      "Add ravioli to the boiling water and cook.",
      "In a separate pan, add meat and a splash of the ravioli cooking water.",
      "Add butter and mix well with the meat.",
      "Add the cooked ravioli to the pan and toss with the meat butter sauce.",
      "Plate and sprinkle with Parmesan cheese.",
      "In another pan, heat the tomato sauce.",
      "Add the cooked ravioli to the heated tomato sauce and mix well.",
      "Serve and enjoy."
    ]
  },
  {
    "name": "Pappardelle with Porcini Mushrooms",
    "url": "https://youtu.be/P-kEgedOGbg",
    "uploader": "미뇨끼",
    "upload_date": "2024-11-17",
    "ingredients": [
      "Porcini mushrooms",
      "Pappardelle pasta",
      "Butter",
      "Parmesan cheese",
      "Parsley",
      "Olive oil",
      "Flour",
      "Eggs"
    ],
    "steps": [
      "Clean and slice the porcini mushrooms.",
      "Make pasta dough by combining flour and eggs.",
      "Wrap the pasta dough in plastic wrap and let it rest.",
      "Roll out the rested dough with a pasta machine to make pappardelle noodles.",
      "Cook the pappardelle noodles in boiling water.",
      "Heat olive oil in a pan and sauté the sliced porcini mushrooms.",
      "Add the cooked pasta noodles to the sautéed mushrooms.",
      "Add butter and pasta water, then mix.",
      "Add Parmesan cheese and parsley, and toss well.",
      "Serve the pasta on a plate."
    ]
  },
  {
    "name": "Perilla Seed Pasta",
    "url": "https://youtu.be/M2AUwm1Tuvo",
    "uploader": "미뇨끼",
    "upload_date": "2024-11-27",
    "ingredients": [
      "Pasta",
      "Perilla seed powder",
      "Garlic",
      "Parmesan cheese",
      "Cream",
      "Olive oil"
    ],
    "steps": [
      "Boil water and cook pasta.",
      "Pour a little olive oil into a pan.",
      "Grate garlic into the pan and sauté until fragrant.",
      "Pour cream into the pan.",
      "Add two heaping spoonfuls of perilla seed powder and mix well.",
      "Add the al dente pasta.",
      "Add two ladles of pasta water and mix well.",
      "Cook over low heat, stirring slowly, until the sauce thickens.",
      "Grate in a generous amount of Parmesan cheese and mix well.",
      "Serve the finished pasta in a bowl and sprinkle with a little perilla seed powder."
    ]
  },
  {
    "name": "Anchovy Aglio e Olio",
    "url": "https://youtu.be/0TDzIo57uXQ",
    "uploader": "미뇨끼",
    "upload_date": "2024-12-01",
    "ingredients": [
      "Garlic",
      "Anchovies",
      "Parsley",
      "Peperoncino",
      "Spaghetti",
      "Salt",
      "Olive oil"
    ],
    "steps": [
      "Thinly slice the garlic, finely chop the parsley, and crush the peperoncino.",
      "Boil spaghetti in salted water.",
      "Pour olive oil into a pan.",
      "Add anchovies, sliced garlic, and crushed peperoncino to the pan and sauté over heat.",
      "Sauté until the anchovies break down and the garlic turns golden brown.",
      "Add the cooked spaghetti directly to the pan and stir-fry in the oil to evaporate moisture.",
      "Add a portion of the chopped parsley and mix.",
      "Transfer the finished pasta to a plate.",
      "Sprinkle the remaining parsley on top."
    ]
  },
  {
    "name": "Carbonara",
    "url": "https://youtu.be/qjPLqtcG2ug",
    "uploader": "미뇨끼",
    "upload_date": "2024-12-15",
    "ingredients": [
      "Guanciale",
      "Pasta",
      "Eggs",
      "Parmesan cheese",
      "Black pepper"
    ],
    "steps": [
      "Cut guanciale into small cubes.",
      "Fry the cubed guanciale in a pan until golden and crispy.",
      "Remove the fried guanciale from the pan, reserving the rendered fat.",
      "Place egg yolks in a bowl.",
      "Add Parmesan cheese.",
      "Grind in black pepper.",
      "Pour the hot guanciale fat into the egg mixture and mix.",
      "Gradually add pasta water, mixing to create a creamy sauce.",
      "Cook the pasta.",
      "Add the cooked pasta to the sauce bowl and mix well.",
      "Serve the pasta on plates.",
      "Top with the fried guanciale.",
      "Finish with a sprinkle of Parmesan cheese and black pepper."
    ]
  },
  {
    "name": "Lemon Tuna Pasta",
    "url": "https://youtu.be/hKZHSaujp2Y",
    "uploader": "미뇨끼",
    "upload_date": "2024-12-18",
    "ingredients": [
      "Tuna",
      "Spaghetti",
      "Parsley",
      "Red chili pepper",
      "Garlic",
      "Lemon",
      "Salt",
      "Black pepper",
      "Olive oil"
    ],
    "steps": [
      "Drain the oil from the canned tuna.",
      "Finely chop the parsley and red chili pepper.",
      "Add salt to boiling water and cook the spaghetti.",
      "Heat a generous amount of olive oil in a pan, add finely minced garlic and parsley stems, then sauté.",
      "Add the chopped red chili pepper and gently sauté, being careful not to burn it.",
      "Add the tuna and mix well, sautéing until it absorbs the oil.",
      "Remove the sautéed parsley stems.",
      "Generously sprinkle with black pepper and lemon juice, then grate in lemon zest to finish.",
      "Transfer the cooked spaghetti to the pan.",
      "Add two to three ladles of pasta water and continue to cook in the pan.",
      "Turn off the heat and add olive oil, chopped parsley, and lemon zest.",
      "Mix all ingredients well.",
      "Serve the finished pasta on a nice plate and garnish with red chili pepper, parsley, and lemon zest."
    ]
  },
  {
    "name": "Lasagna al ragù",
    "url": "https://youtu.be/8Wtj74AtrSA",
    "uploader": "미뇨끼",
    "upload_date": "2024-12-22",
    "ingredients": [
      "Ground beef",
      "Lasagna sheets",
      "Onion",
      "Carrot",
      "Celery",
      "Tomato puree",
      "Milk",
      "Salt",
      "Pepper",
      "Nutmeg",
      "Parmesan cheese",
      "Olive oil",
      "Red wine",
      "Flour",
      "Butter"
    ],
    "steps": [
      "Heat olive oil and sauté onion, carrot, and celery.",
      "Add ground beef and cook, breaking it apart with a spatula.",
      "Season with salt, pepper, and nutmeg, then pour in red wine and cook until the alcohol evaporates.",
      "Add tomato puree and simmer over low heat for 1-2 hours until the liquid reduces.",
      "Melt butter, stir in flour, then gradually whisk in milk.",
      "Once it reaches a smooth, creamy soup consistency, turn off the heat and season with nutmeg and salt (Béchamel sauce).",
      "Boil lasagna sheets for 5 minutes, then cool in cold water.",
      "Drain excess water from lasagna sheets with a clean kitchen towel.",
      "In an oven-safe dish, layer béchamel sauce, lasagna sheets, ragù sauce, and Parmesan cheese.",
      "Repeat the layering for 5 layers, then generously sprinkle with Parmesan cheese.",
      "Bake in a preheated oven at 160°C for 20 minutes."
    ]
  },
  {
    "name": "Octopus Salad",
    "url": "https://youtu.be/TC-w0qUAFkE",
    "uploader": "미뇨끼",
    "upload_date": "2025-01-06",
    "ingredients": [
      "Octopus",
      "Potatoes",
      "Parsley",
      "Pine nuts",
      "Chili",
      "Olive oil",
      "Salt",
      "Pepper",
      "Garlic"
    ],
    "steps": [
      "Lightly rinse the octopus.",
      "Dip the octopus in and out of boiling water 3-4 times to curl the legs.",
      "Place the octopus in the boiling water.",
      "Add potatoes to the boiling water.",
      "Partially cover the pot with a lid, and simmer over low heat for 40 minutes.",
      "Turn off the heat, cover the pot, and let it cool for 1-2 hours until it can be handled.",
      "Gently peel off the skin of the octopus, leaving only the suckers on the top.",
      "Slice the cooked octopus into bite-sized pieces.",
      "Slice the cooked potatoes into bite-sized pieces.",
      "Place the sliced potatoes in a bowl, then add the sliced octopus.",
      "Add a dressing made with olive oil, parsley, pine nuts, chili, salt, pepper, and garlic, then mix well.",
      "Serve on a plate."
    ]
  },
  {
    "name": "Italian Red Wine Braised Beef",
    "url": "https://youtu.be/znsbWy0_SZM",
    "uploader": "미뇨끼",
    "upload_date": "2025-01-13",
    "ingredients": [
      "Beef shank",
      "Celery",
      "Carrot",
      "Onion",
      "Potatoes",
      "Red wine",
      "Nutmeg",
      "Cinnamon",
      "Pepper",
      "Salt",
      "Rosemary",
      "Bay leaf",
      "Olive oil",
      "Parsley",
      "Milk",
      "Butter"
    ],
    "steps": [
      "Cut beef shank into large pieces.",
      "Heat olive oil in a pot and sauté onion, carrot, and celery.",
      "Add beef shank and sauté together.",
      "Pour in red wine and boil to evaporate the alcohol.",
      "Add bay leaf, rosemary, paprika powder, salt, and pepper, then mix well.",
      "Cover partially and simmer over low heat for about 4 hours.",
      "Boil potatoes and mash finely.",
      "Add butter, milk, and salt to the mashed potatoes and mix until smooth to make mashed potatoes.",
      "Spread a generous layer of mashed potatoes on a plate.",
      "Top with the braised beef.",
      "Drizzle generously with the remaining sauce and finish with parsley and pepper."
    ]
  },
  {
    "name": "Pasta alla Monzese",
    "url": "https://youtu.be/GLsbzo1hIHw",
    "uploader": "미뇨끼",
    "upload_date": "2025-01-16",
    "ingredients": [
      "Salsiccia",
      "Onion",
      "Garlic",
      "Pasta",
      "Cream",
      "Saffron",
      "Parsley",
      "Parmesan cheese",
      "Salt",
      "Pepper",
      "Fennel",
      "Olive oil"
    ],
    "steps": [
      "Slit the salsiccia casing.",
      "Remove the salsiccia meat from the casing.",
      "Finely chop the onion and garlic.",
      "Heat olive oil in a pan and sauté the chopped onion and garlic.",
      "Add the salsiccia meat and cook until browned.",
      "Stir in the cream.",
      "Crush the saffron.",
      "Mix the crushed saffron with water.",
      "Pour the saffron water into the pan to color the sauce.",
      "Add the cooked pasta and mix well with the sauce.",
      "Garnish with parsley and Parmesan cheese."
    ]
  },
  {
    "name": "Salsiccia and Cheonggat Greens",
    "url": "https://youtu.be/rGtXAEWSVKU",
    "uploader": "미뇨끼",
    "upload_date": "2025-01-23",
    "ingredients": [
      "Salsiccia",
      "Cheonggat greens",
      "Garlic",
      "Peperoncino",
      "Salt",
      "Olive oil"
    ],
    "steps": [
      "Trim and prepare the root ends of the Cheonggat greens.",
      "Blanch the Cheonggat greens in salted boiling water.",
      "Squeeze out excess water from the blanched Cheonggat greens and set aside.",
      "Slice the garlic thinly and finely chop the peperoncino.",
      "Heat olive oil in a pan, then add garlic and peperoncino and sauté.",
      "Add the blanched Cheonggat greens to the pan and sauté with the garlic and peperoncino.",
      "Make space in the center of the sautéed Cheonggat greens and place the Salsiccia.",
      "Cover and cook over medium heat until the Salsiccia is golden brown and cooked through.",
      "Plate the completed Salsiccia Friarielli.",
      "Cut the Salsiccia into bite-sized pieces and enjoy with the Cheonggat greens."
    ]
  },
  {
    "name": "Orecchiette with Rapini",
    "url": "https://youtu.be/IFtbxZ1CNlI",
    "uploader": "미뇨끼",
    "upload_date": "2025-01-26",
    "ingredients": [
      "Orecchiette",
      "Korean Mustard Greens",
      "Garlic",
      "Anchovies",
      "Dried Red Chilies",
      "Cheongyang Chili Peppers",
      "Salt",
      "Parmesan Cheese",
      "Olive Oil"
    ],
    "steps": [
      "Cook orecchiette in salted boiling water.",
      "Thinly slice garlic.",
      "Heat olive oil in a pan and sauté the sliced garlic until fragrant.",
      "Add dried red chilies and anchovies, sautéing and mashing the anchovies.",
      "Add finely minced Cheongyang chili peppers and sauté.",
      "When the orecchiette is halfway cooked, add blanched and frozen Korean mustard greens and heat them through.",
      "Drain the cooked pasta and Korean mustard greens, transfer to the pan, and sauté well to absorb the oil.",
      "Grate and add a generous amount of Parmesan cheese.",
      "Add pasta water as desired to make it moist."
    ]
  },
  {
    "name": "Strawberry Tiramisu",
    "url": "https://youtu.be/xcXXXNN69WI",
    "uploader": "미뇨끼",
    "upload_date": "2025-02-10",
    "ingredients": [
      "Strawberries",
      "Egg yolks",
      "Mascarpone cheese",
      "Sugar",
      "Vanilla",
      "Lemon juice",
      "Cookies"
    ],
    "steps": [
      "Slice strawberries into small pieces and marinate with sugar and lemon juice.",
      "Blend remaining strawberries, sugar, and water to make strawberry juice.",
      "Place a bowl over boiling water and whisk egg yolks and sugar until dissolved.",
      "Add mascarpone cheese and vanilla, then whip.",
      "Spread a layer of cream evenly at the bottom of a glass container.",
      "Dip cookies in strawberry juice for 3 seconds on each side.",
      "Arrange the dipped cookies over the cream layer.",
      "Repeat by spreading another layer of cream and arranging strawberry juice-dipped cookies to build a total of 3 layers.",
      "Top with the pre-marinated strawberries.",
      "Refrigerate for at least one day to allow it to set."
    ]
  },
  {
    "name": "Pastina Soup",
    "url": "https://youtu.be/x-eyjGr5oEQ",
    "uploader": "미뇨끼",
    "upload_date": "2025-02-14",
    "ingredients": [
      "Onion",
      "Carrot",
      "Celery",
      "Tomato paste",
      "Chicken stock",
      "Parmesan cheese rind",
      "Parmesan cheese",
      "Small pasta",
      "Olive oil"
    ],
    "steps": [
      "Add a generous amount of olive oil to a pot.",
      "Add chopped onion, carrot, and celery and sauté.",
      "Cover and cook until the vegetables are tender.",
      "Add a spoonful of tomato paste and sauté until the oil turns red.",
      "Pour in a generous amount of water and add chicken stock.",
      "Add the Parmesan cheese rind and bring to a boil.",
      "Add the small pasta.",
      "Boil for about 10 minutes until the pasta is cooked.",
      "Serve a generous portion with the broth in a bowl.",
      "Sprinkle with Parmesan cheese.",
      "Drizzle with a final swirl of olive oil."
    ]
  },
  {
    "name": "Octopus Ragu Pasta",
    "url": "https://youtu.be/7Hmv1yEqPFg",
    "uploader": "미뇨끼",
    "upload_date": "2025-02-19",
    "ingredients": [
      "Octopus",
      "Carrot",
      "Onion",
      "Celery",
      "Tomato paste",
      "Red wine",
      "Tomato puree",
      "Salt",
      "Olive oil",
      "Pasta",
      "Parsley"
    ],
    "steps": [
      "Cut the cooked octopus into bite-sized pieces.",
      "Heat olive oil in a pan and sauté carrots, onions, and celery.",
      "Add tomato paste and sauté together.",
      "Add the chopped octopus and sauté thoroughly until all moisture evaporates.",
      "Pour in red wine and simmer until the alcohol evaporates.",
      "Add tomato puree, and once it boils, reduce the heat to low.",
      "Partially cover and simmer gently for at least 2 hours to complete the octopus ragu.",
      "Cook pasta in salted water.",
      "Add the cooked pasta to the pan and top with a generous amount of octopus ragu.",
      "Add a ladle of pasta water and a splash of olive oil, then mix the pasta and ragu sauce well.",
      "Serve the finished pasta on a plate and sprinkle with parsley."
    ]
  },
  {
    "name": "Pollack Roe Butter Pasta",
    "url": "https://youtu.be/pymsbO9M0Fw",
    "uploader": "미뇨끼",
    "upload_date": "2025-02-21",
    "ingredients": [
      "Pollack Roe",
      "Pasta",
      "Parsley",
      "Butter",
      "Lemon",
      "Salt"
    ],
    "steps": [
      "Separate the pollack roe from its membrane.",
      "Chop the parsley.",
      "Dice the butter.",
      "Boil pasta in a pot with water and salt.",
      "Transfer the cooked pasta to a thick glass bowl.",
      "Add the diced butter and pasta water to the pasta and mix quickly.",
      "Add the prepared pollack roe and mix well like a pesto.",
      "Serve the pasta, adding pollack roe and lemon zest on top."
    ]
  },
  {
    "name": "Italian Diet Meal",
    "url": "https://youtu.be/NS7YlajbFlQ",
    "uploader": "미뇨끼",
    "upload_date": "2025-02-23",
    "ingredients": [
      "zucchini",
      "eggplant",
      "ham",
      "chicken breast",
      "farro",
      "cherry tomatoes",
      "cucumber",
      "feta cheese",
      "olive oil",
      "salt"
    ],
    "steps": [
      "Cook farro in boiling water.",
      "Combine cooked farro with cherry tomatoes, cucumber, and feta cheese to make a grain salad.",
      "Slice chicken breast.",
      "Place lean ham on a plate.",
      "Grill zucchini and eggplant on a hot grill pan without oil.",
      "Arrange grilled zucchini and eggplant with the ham on a plate.",
      "Drizzle less olive oil than usual over the vegetables and ham on the plate.",
      "Sprinkle less salt than usual."
    ]
  },
  {
    "name": "Clam Vongole Pasta",
    "url": "https://youtu.be/Ia_DalcfcTY",
    "uploader": "미뇨끼",
    "upload_date": "2025-02-26",
    "ingredients": [
      "Clams",
      "Garlic",
      "Spaghetti",
      "Parsley",
      "Olive Oil",
      "White Wine",
      "Salt"
    ],
    "steps": [
      "Wash the clams thoroughly.",
      "Sauté garlic in olive oil in a pan.",
      "Add clams and white wine, cover, and steam until the clams open.",
      "Once clams begin to open, remove them and shuck the meat.",
      "Strain the remaining clam broth and set aside.",
      "Cook spaghetti in salted boiling water until halfway done.",
      "Pour the broth into the pan and add the half-cooked spaghetti to finish cooking.",
      "Add the shucked clam meat back into the pan and heat through.",
      "Sprinkle with parsley and mix well.",
      "Serve in a bowl."
    ]
  },
  {
    "name": "Strawberry Risotto",
    "url": "https://youtu.be/kXSrU6AMVtI",
    "uploader": "미뇨끼",
    "upload_date": "2025-03-03",
    "ingredients": [
      "Strawberries",
      "Carnaroli rice",
      "Carrot",
      "Onion",
      "Celery",
      "Salt",
      "Balsamic glaze",
      "Parmesan cheese",
      "Olive oil",
      "White wine",
      "Butter"
    ],
    "steps": [
      "Sauté carrot, onion, and green onion in a pot with olive oil.",
      "Pour in water and bring to a boil to make vegetable broth.",
      "Slice strawberries and set aside.",
      "In a separate pan, heat olive oil and sauté minced onion.",
      "Add rice and sauté until translucent.",
      "Pour in white wine and stir until absorbed by the rice.",
      "Season with salt.",
      "Gradually add the prepared vegetable broth, one ladleful at a time, stirring continuously until the rice is cooked.",
      "Stir in the sliced strawberries.",
      "Add butter and Parmesan cheese, and mix well.",
      "Serve the risotto on plates and garnish with remaining strawberries.",
      "Drizzle with balsamic glaze to finish."
    ]
  },
  {
    "name": "Amatriciana",
    "url": "https://youtu.be/0lNFu9siGFY",
    "uploader": "미뇨끼",
    "upload_date": "2025-03-12",
    "ingredients": [
      "Guanciale",
      "Whole peeled tomatoes",
      "Rigatoni",
      "Pecorino cheese",
      "Salt"
    ],
    "steps": [
      "Crush the whole peeled tomatoes by hand in a bowl.",
      "Cut the guanciale into small cubes.",
      "Cook the guanciale in a pan until crispy.",
      "Remove the crispy guanciale from the pan, then add the crushed tomatoes to the rendered fat.",
      "Season the tomato sauce with salt and bring it to a simmer.",
      "Add the cooked pasta to the tomato sauce.",
      "Stir in Pecorino cheese and half of the crispy guanciale into the pasta.",
      "Serve the pasta on plates.",
      "Top with the remaining guanciale and Pecorino cheese."
    ]
  },
  {
    "name": "Farro Salad",
    "url": "https://youtu.be/wU8vFvBy0wo",
    "uploader": "미뇨끼",
    "upload_date": "2025-03-16",
    "ingredients": [
      "Farro",
      "Yellow Bell Pepper",
      "Zucchini",
      "Cherry Tomatoes",
      "Canned Tuna",
      "Basil",
      "Salt",
      "Olive Oil"
    ],
    "steps": [
      "Cook farro, water, and salt in an electric rice cooker.",
      "Dice yellow bell pepper and zucchini into bite-sized pieces.",
      "Heat olive oil in a pan, add the chopped bell pepper and zucchini, season with salt, and sauté lightly.",
      "Halve cherry tomatoes.",
      "Marinate the cut tomatoes in salt and olive oil.",
      "Place the cooked farro in a large bowl.",
      "Add canned tuna on top of the farro.",
      "Add the sautéed bell pepper and zucchini to the bowl.",
      "Add the marinated tomatoes to the bowl.",
      "Sprinkle with basil.",
      "Mix all ingredients well."
    ]
  },
  {
    "name": "Uova in Purgatorio",
    "url": "https://youtu.be/1FfOXZ94UOk",
    "uploader": "미뇨끼",
    "upload_date": "2025-03-23",
    "ingredients": [
      "Onion",
      "Garlic",
      "Peperoncino",
      "Canned tomatoes",
      "Basil",
      "Eggs",
      "Parmesan cheese",
      "Olive oil",
      "Salt",
      "Bread"
    ],
    "steps": [
      "Chop the peperoncino.",
      "Crush canned tomatoes by hand.",
      "Heat olive oil in a pan and sauté onion and garlic.",
      "Add peperoncino and sauté together.",
      "Add crushed tomatoes and salt, mix well.",
      "Simmer until the sauce thickens.",
      "Make wells in the sauce and crack eggs into them, cook until set.",
      "Finish with fresh basil and Parmesan cheese."
    ]
  },
  {
    "name": "Mugwort Tiramisu",
    "url": "https://youtu.be/4sATZYRyGvQ",
    "uploader": "미뇨끼",
    "upload_date": "2025-03-26",
    "ingredients": [
      "Mascarpone",
      "Eggs",
      "Ladyfingers",
      "Sugar",
      "Vanilla",
      "Mugwort powder"
    ],
    "steps": [
      "Combine egg yolks and sugar in a double boiler and whisk until thick.",
      "Add mascarpone cheese and mix.",
      "Add mugwort powder, mix well until no lumps, then whip.",
      "Spread a thick layer of mugwort cream at the bottom of a glass dish.",
      "Dip ladyfingers briefly, once or twice on each side, in warm mugwort tea.",
      "Place dipped ladyfingers over the cream layer.",
      "Add another layer of mugwort cream.",
      "Repeat layering ladyfingers and cream.",
      "Dust the top layer with mugwort powder.",
      "Refrigerate for about a day to set.",
      "Serve scoop by scoop to enjoy the soft mugwort tiramisu."
    ]
  },
  {
    "name": "Sausage and Fries Pizza",
    "url": "https://youtu.be/xfllE7HolqU",
    "uploader": "미뇨끼",
    "upload_date": "2025-04-01",
    "ingredients": [
      "Hot dog sausages",
      "Potatoes",
      "Mozzarella",
      "Parmesan cheese",
      "Olive oil",
      "Pizza dough"
    ],
    "steps": [
      "Fry potatoes until golden brown.",
      "Spread out the pizza dough.",
      "Place mozzarella on the pizza dough.",
      "Sprinkle Parmesan cheese and olive oil.",
      "Add hot dog sausages.",
      "Bake the pizza in a wood-fired oven.",
      "Top the baked pizza with fried potatoes.",
      "Serve the finished pizza."
    ]
  },
  {
    "name": "Ruby Red Kiwi Mascarpone Biscuits",
    "url": "https://youtu.be/0iYKf_9IcTs",
    "uploader": "미뇨끼",
    "upload_date": "2025-04-03",
    "ingredients": [
      "Ruby Red Kiwi",
      "Mascarpone Cheese",
      "Misura Whole Wheat Biscuits"
    ],
    "steps": [
      "Thinly slice the Ruby Red kiwi.",
      "Place a spoonful of mascarpone cheese on each Misura whole wheat biscuit.",
      "Top the cheese with the sliced Ruby Red kiwi.",
      "Arrange the finished biscuits on a plate and serve."
    ]
  },
  {
    "name": "Cream Pasta",
    "url": "https://youtu.be/d1XgNZ0w-bk",
    "uploader": "미뇨끼",
    "upload_date": "2025-04-06",
    "ingredients": [
      "Jambon",
      "Onion",
      "Peas",
      "Fusilli",
      "Heavy Cream",
      "White Wine",
      "Salt",
      "Pepper"
    ],
    "steps": [
      "Cook the fusilli.",
      "Cut the jambon into bite-sized pieces.",
      "Finely chop the onion.",
      "Heat olive oil in a pan, then add the chopped onion and salt and sauté.",
      "Add the cut jambon and render the fat.",
      "Add frozen peas.",
      "Add a splash of white wine.",
      "Cover and steam lightly.",
      "Pour in the heavy cream and reduce slightly.",
      "Add the cooked fusilli and toss well.",
      "Plate and serve."
    ]
  },
  {
    "name": "Macedonia Fruit Salad",
    "url": "https://youtu.be/TNbP2lJaPew",
    "uploader": "미뇨끼",
    "upload_date": "2025-04-08",
    "ingredients": [
      "Pear",
      "Strawberry",
      "Banana",
      "Grape",
      "Blueberry",
      "Orange",
      "Ruby Red Kiwi",
      "Basil",
      "Sugar",
      "Lemon",
      "Grapefruit"
    ],
    "steps": [
      "Peel and dice the pear, then add to a bowl.",
      "Slice the strawberries and add to the bowl.",
      "Slice the bananas and add to the bowl.",
      "Add grapes, blueberries, and oranges to the bowl.",
      "Slice the ruby red kiwi and add to the bowl.",
      "Add basil.",
      "Add sugar.",
      "Squeeze lemon and grapefruit juice into the bowl.",
      "Mix all ingredients well.",
      "Transfer the prepared Macedonia to a serving dish."
    ]
  },
  {
    "name": "Shanghai Pasta",
    "url": "https://youtu.be/hCxc4XyS_zE",
    "uploader": "미뇨끼",
    "upload_date": "2025-04-11",
    "ingredients": [
      "Clams",
      "Shrimp",
      "Bok Choy",
      "Scallions",
      "Garlic",
      "Onion",
      "Salt",
      "Chili Oil",
      "White Wine",
      "Doubanjiang",
      "Sugar",
      "Clam Seasoning",
      "Pasta"
    ],
    "steps": [
      "Add salt to boiling water.",
      "Blanch the bok choy and set aside.",
      "Cook the pasta.",
      "Heat chili oil in a pan.",
      "Sauté scallions and garlic.",
      "Add clams.",
      "Add white wine, cover, and cook until clams open.",
      "Add shrimp and onion.",
      "Add Doubanjiang, sugar, and clam seasoning.",
      "Add the cooked pasta and stir-fry.",
      "Serve in a bowl and top with blanched bok choy, shrimp, and clams."
    ]
  },
  {
    "name": "Tomato Beef Dish",
    "url": "https://youtu.be/p-oNpVPVHh8",
    "uploader": "미뇨끼",
    "upload_date": "2025-04-13",
    "ingredients": [
      "Beef",
      "Canned tomatoes",
      "Garlic",
      "Olives",
      "Capers",
      "Salt",
      "Oregano",
      "Parsley",
      "Olive oil"
    ],
    "steps": [
      "Pound the thin beef to a 5mm thickness using a meat mallet (or coffee tamper).",
      "Heat olive oil in a frying pan and sauté the garlic.",
      "Crush canned tomatoes by hand, then pour into the pan with the sautéed garlic.",
      "Simmer over low heat until the tomato sauce thickens.",
      "Season with salt and add oregano.",
      "Add the beef to the sauce and sprinkle with salt.",
      "Cook the beef slowly over low heat, flipping and basting it with the sauce to cook evenly.",
      "Place the cooked beef on a plate and top with tomato sauce.",
      "Drizzle with olive oil and sprinkle with parsley to finish.",
      "Mix any remaining tomato sauce with spaghetti and serve."
    ]
  },
  {
    "name": "Cherry Blossom Tiramisu",
    "url": "https://youtu.be/-tQBGUOp6W0",
    "uploader": "미뇨끼",
    "upload_date": "2025-04-16",
    "ingredients": [
      "Mascarpone",
      "Eggs",
      "Cookies",
      "Sugar",
      "Cherry Blossom Cordial",
      "Beetroot Powder",
      "Cherry Blossoms"
    ],
    "steps": [
      "Whisk eggs and sugar in a double boiler until the sugar dissolves.",
      "Let the egg and sugar mixture cool slightly.",
      "Add mascarpone and cherry blossom cordial to the cooled mixture.",
      "Whisk until all ingredients are well combined.",
      "Sift in beetroot powder and whisk until the cream turns pink.",
      "Mix cherry blossom cordial and warm water in a 1:1 ratio to create a syrup.",
      "Quickly dip cookies into the syrup.",
      "In a serving dish, alternate layers of dipped cookies and cream, building a total of three layers.",
      "Decorate the top layer of cream with individual cherry blossoms.",
      "Refrigerate for at least one day to allow flavors to meld and the tiramisu to set.",
      "Slice with a spatula and serve."
    ]
  },
  {
    "name": "Baked Cheese Spaghetti",
    "url": "https://youtu.be/DAUtbX1O5kQ",
    "uploader": "미뇨끼",
    "upload_date": "2025-04-20",
    "ingredients": [
      "Spaghetti",
      "Garlic",
      "Onion",
      "Black olives",
      "Tomato sauce",
      "Mozzarella cheese",
      "Parsley",
      "Olive oil"
    ],
    "steps": [
      "Chop garlic and onion.",
      "Heat olive oil in a pan and sauté the chopped garlic and onion.",
      "Add black olives and sauté together.",
      "Add tomato sauce and bring to a boil.",
      "Add cooked spaghetti to the pan and mix well with the sauce.",
      "Transfer the spaghetti to an aluminum baking dish.",
      "Top generously with mozzarella cheese.",
      "Bake in the oven until the cheese is melted and golden brown.",
      "Sprinkle with parsley to finish."
    ]
  },
  {
    "name": "Creamy Italian Steak",
    "url": "https://youtu.be/x-KI0bopeRc",
    "uploader": "미뇨끼",
    "upload_date": "2025-04-25",
    "ingredients": [
      "Beef tenderloin",
      "Green peppercorns",
      "Dijon mustard",
      "Heavy cream",
      "Whiskey",
      "Flour",
      "Butter",
      "Butcher's twine"
    ],
    "steps": [
      "Tie the beef tenderloin with butcher's twine.",
      "Dredge the beef tenderloin evenly in flour.",
      "Melt butter in a pan.",
      "Sear the beef tenderloin in the pan for 2 minutes per side.",
      "Evenly brown the edges of the beef tenderloin.",
      "Pour whiskey into the pan.",
      "Add heavy cream and Dijon mustard.",
      "Temporarily remove the beef and mix the sauce well.",
      "Return the beef and add the green peppercorns to the sauce.",
      "Continue to baste the beef with the warm sauce as it cooks.",
      "Transfer the beef to a plate and generously pour the cream sauce over it.",
      "Slice the beef and serve."
    ]
  },
  {
    "name": "Pasta al Forno",
    "url": "https://youtu.be/sGtF8aPKWak",
    "uploader": "미뇨끼",
    "upload_date": "2025-04-29",
    "ingredients": [
      "Rigatoni",
      "Minced Meat",
      "Basil",
      "Celery",
      "Onion",
      "Carrot",
      "Mozzarella Cheese",
      "Parmesan Cheese",
      "Tomato Puree",
      "Red Wine",
      "Olive Oil"
    ],
    "steps": [
      "Heat olive oil in a pan and sauté minced celery, onion, and carrot.",
      "Add minced meat and brown until cooked through.",
      "Pour in red wine and reduce with the meat juices.",
      "Add tomato puree and mix.",
      "Cover and simmer on low heat for about two hours until the sauce thickens.",
      "Pre-cook the rigatoni.",
      "Mix the cooked rigatoni thoroughly with the ragu sauce.",
      "Transfer the pasta and sauce to an oven-safe pan.",
      "Generously add mozzarella cheese blocks, interspersed throughout.",
      "Sprinkle generously with Parmesan cheese.",
      "Top with basil and drizzle with olive oil.",
      "Bake in a 170°C oven for 20 minutes."
    ]
  },
  {
    "name": "Carrot Side Dish for Pasta",
    "url": "https://youtu.be/tG_rU3Ip7AU",
    "uploader": "미뇨끼",
    "upload_date": "2025-05-01",
    "ingredients": [
      "Carrots",
      "Rosemary",
      "Lemon juice",
      "Salt",
      "Olive oil",
      "Butter"
    ],
    "steps": [
      "Cut off the carrot greens.",
      "Peel the carrots.",
      "Slice the carrots thinly.",
      "Boil the sliced carrots in salted water.",
      "Drain the boiled carrots.",
      "[First Style]: Mix the boiled carrots with olive oil, lemon juice, and salt.",
      "[Second Style]: Melt butter in a pan, then add rosemary.",
      "[Second Style]: Add the boiled carrots and sauté briefly."
    ]
  },
  {
    "name": "Shrimp Zucchini Risotto",
    "url": "https://youtu.be/PxZXrUXGoRE",
    "uploader": "미뇨끼",
    "upload_date": "2025-05-06",
    "ingredients": [
      "Zucchini",
      "Onion",
      "Rice",
      "Shrimp",
      "White wine",
      "Vegetable broth",
      "Butter",
      "Lime zest",
      "Salt",
      "Pepper",
      "Olive oil"
    ],
    "steps": [
      "Grate the zucchini.",
      "Finely chop the onion.",
      "Heat olive oil in a pan and sauté the onion until translucent.",
      "Add the rice and sauté briefly.",
      "Pour in white wine and cook until absorbed.",
      "Add enough vegetable broth to just cover the rice and simmer.",
      "Stir in the grated zucchini.",
      "Season with salt, gradually add more vegetable broth, and cook until the rice is almost done.",
      "Add shrimp and cook until done.",
      "Turn off the heat, add butter, and stir vigorously for a creamy texture.",
      "Serve the risotto.",
      "Garnish with shrimp, lime zest, and pepper."
    ]
  },
  {
    "name": "Spinach Sesame Pizza",
    "url": "https://youtu.be/zGKW2YlLRwU",
    "uploader": "미뇨끼",
    "upload_date": "2025-05-14",
    "ingredients": [
      "Spinach",
      "Red onion",
      "Garlic confit",
      "Cream",
      "Balsamic glaze",
      "Peperoncino",
      "Pizza dough",
      "Fior di latte cheese",
      "Ricotta",
      "Sesame seeds"
    ],
    "steps": [
      "Prepare sourdough pizza dough.",
      "Spread cream sauce over the dough.",
      "Top with fior di latte cheese, ricotta cheese, red onion, garlic confit, and peperoncino.",
      "Add spinach on top.",
      "Sprinkle with sesame seeds.",
      "Place the pizza in a pizza oven.",
      "Bake until the pizza is cooked and the crust is golden brown.",
      "Drizzle with balsamic glaze."
    ]
  },
  {
    "name": "Cold Soy Milk Noodle Soup",
    "url": "https://youtu.be/41twM-Vnvl4",
    "uploader": "미뇨끼",
    "upload_date": "2025-05-18",
    "ingredients": [
      "Soybeans",
      "Noodles",
      "Sesame seeds",
      "Pine nuts",
      "Soy milk",
      "Salt",
      "Olive oil"
    ],
    "steps": [
      "Soak soybeans overnight.",
      "Boil soaked soybeans with a little water and salt for about 5 minutes.",
      "Cool boiled soybeans in cold water, then peel their skins.",
      "In a blender, combine peeled soybeans, sesame seeds, pine nuts, soy milk, cooled soybean cooking liquid, water, and salt.",
      "Blend until smooth.",
      "Cook noodles until chewy.",
      "Place cooked noodles in a bowl.",
      "Pour the blended soy milk mixture over the noodles.",
      "Drizzle with olive oil."
    ]
  },
  {
    "name": "Basil Pesto",
    "url": "https://youtu.be/k0DgDksp0CQ",
    "uploader": "미뇨끼",
    "upload_date": "2025-05-24",
    "ingredients": [
      "Basil",
      "Salt",
      "Garlic",
      "Pine nuts",
      "Pecorino cheese",
      "Parmesan cheese",
      "Olive oil",
      "Pasta"
    ],
    "steps": [
      "Add pine nuts, garlic, and salt to a blender and process lightly.",
      "Add basil, Pecorino cheese, Parmesan cheese, and olive oil to the blender.",
      "Blend all ingredients until well combined and smooth, like a fine puree.",
      "Transfer the finished pesto to a glass jar or container, pour olive oil on top, and refrigerate.",
      "Alternatively, divide the pesto into an ice cube tray and freeze for longer storage.",
      "When using frozen pesto, thaw slightly in water as needed.",
      "Mix the pesto into warm, cooked pasta to serve."
    ]
  },
  {
    "name": "Couscous Salad",
    "url": "https://youtu.be/geBh3W78PZw",
    "uploader": "미뇨끼",
    "upload_date": "2025-06-12",
    "ingredients": [
      "Tomato",
      "Cucumber",
      "Yellow bell pepper",
      "Carrot",
      "Zucchini",
      "Onion",
      "Peas",
      "Basil",
      "Salt",
      "Couscous",
      "Olive oil"
    ],
    "steps": [
      "Place couscous in a bowl.",
      "Add salt and olive oil to the couscous.",
      "Pour hot water over the couscous.",
      "Cover the bowl and let it soak for about 10 minutes.",
      "Dice tomatoes, cucumbers, yellow bell peppers, carrots, zucchini, and onions.",
      "Put yellow bell peppers, carrots, zucchini, and onions in a pan.",
      "Add peas to the pan and sprinkle with salt.",
      "Cover and sauté the vegetables until the peas are cooked.",
      "Fluff the rehydrated couscous with a fork to separate the grains.",
      "Add the cooked vegetables to the couscous.",
      "Add the diced tomatoes and cucumbers to the couscous.",
      "Tear basil leaves and add them to the couscous.",
      "Mix all ingredients well.",
      "Serve in a bowl."
    ]
  },
  {
    "name": "Panzanella",
    "url": "https://youtu.be/tdlmVvLlMKk",
    "uploader": "미뇨끼",
    "upload_date": "2025-06-19",
    "ingredients": [
      "Bread",
      "Cucumber",
      "Red onion",
      "Tomato",
      "Vinegar",
      "Salt",
      "Olive oil",
      "Basil"
    ],
    "steps": [
      "Cut bread into bite-sized pieces and place in a bowl.",
      "Drizzle a little vinegar over the bread and let it absorb.",
      "Peel the cucumber and slice into half-moon shapes.",
      "Thinly slice the red onion.",
      "Cut tomatoes into bite-sized pieces.",
      "Add the sliced cucumber, red onion, and tomatoes to the bowl with the bread.",
      "Sprinkle with salt and olive oil.",
      "Add basil.",
      "Mix all ingredients well.",
      "Serve in a bowl, drizzled with more olive oil."
    ]
  },
  {
    "name": "Coda alla Vaccinara with Rigatoni",
    "url": "https://youtu.be/E70qh68z-BI",
    "uploader": "미뇨끼",
    "upload_date": "2025-08-01",
    "ingredients": [
      "Oxtail",
      "Onion",
      "Carrot",
      "Celery",
      "Tomato puree",
      "Pine nuts",
      "Raisins",
      "Dark chocolate",
      "Rigatoni",
      "Parmesan cheese",
      "Olive oil",
      "White wine",
      "Broth"
    ],
    "steps": [
      "Heat olive oil in a pot.",
      "Sauté onion, carrot, and celery until softened.",
      "Add tomato puree and bring to a simmer.",
      "Add the oxtail meat to the sauce.",
      "Add a little oxtail broth.",
      "Add white wine and simmer uncovered for about 1 hour.",
      "Add pine nuts and raisins, and simmer for another 30 minutes to develop flavor.",
      "Grate in the dark chocolate and mix well.",
      "Cook the rigatoni.",
      "Add the cooked rigatoni to the sauce, toss, and plate.",
      "Sprinkle with Parmesan cheese to finish."
    ]
  },
  {
    "name": "Caponata",
    "url": "https://youtu.be/pLz7FW4jrow",
    "uploader": "미뇨끼",
    "upload_date": "2025-08-11",
    "ingredients": [
      "Eggplant",
      "Red Bell Pepper",
      "Red Onion",
      "Celery",
      "Cherry Tomatoes",
      "Green Olives",
      "Raisins",
      "Capers",
      "Pine Nuts",
      "Basil",
      "Sugar",
      "Vinegar",
      "Salt",
      "Olive Oil"
    ],
    "steps": [
      "Cut the eggplant into bite-sized pieces.",
      "Cut the red bell pepper into bite-sized pieces.",
      "Halve the cherry tomatoes, julienne the red onion, and finely chop the celery.",
      "Fry the eggplant in hot oil until golden brown, then remove.",
      "Lightly fry the bell pepper in the same oil, then remove.",
      "Sauté the red onion and celery in a pan until softened.",
      "Add the cherry tomatoes, green olives, rehydrated raisins, capers, and lightly toasted pine nuts. Cover and cook until softened.",
      "Add the fried eggplant and bell pepper back to the pan and mix well.",
      "Create an empty space in the center, add sugar, then pour in the vinegar.",
      "Stir until the sugar dissolves, then mix it with all the ingredients.",
      "Season with salt, then stir in the basil."
    ]
  },
  {
    "name": "Samphire Vongole Pasta",
    "url": "https://youtu.be/POc3uZCWtdI",
    "uploader": "미뇨끼",
    "upload_date": "2025-08-13",
    "ingredients": [
      "Samphire",
      "Clams",
      "Cherry tomatoes",
      "Pasta",
      "Garlic",
      "Peperoncino",
      "White wine",
      "Olive oil"
    ],
    "steps": [
      "Trim the samphire and cut off the leafy parts.",
      "Blanch the samphire in boiling water for about 2 minutes to soften.",
      "In a pan, add clams and white wine, cover, and cook until the clams open.",
      "Transfer the cooked clams to a separate bowl and strain the clam broth.",
      "In another pan, heat olive oil and lightly sauté garlic and peperoncino to release their fragrance.",
      "Add the halved cherry tomatoes and sauté.",
      "Add the blanched samphire and sauté.",
      "Add the al dente pasta to the pan.",
      "Add the clam broth and mix.",
      "Add the cooked clams and, if needed, add pasta water to emulsify and thicken the sauce."
    ]
  },
  {
    "name": "Parmigiana",
    "url": "https://youtu.be/6R8OgPd8ydw",
    "uploader": "미뇨끼",
    "upload_date": "2025-08-17",
    "ingredients": [
      "Eggplant",
      "Onion",
      "Tomato puree",
      "Basil",
      "Mozzarella",
      "Parmesan cheese",
      "Flour",
      "Egg",
      "Olive oil",
      "Oil"
    ],
    "steps": [
      "Sauté the onion.",
      "Add tomato puree and basil, then simmer over low heat for 2 hours to make the sauce.",
      "Slice the eggplant 1cm thick.",
      "Coat the sliced eggplant with flour.",
      "Dip the floured eggplant in egg wash.",
      "Fry the eggplant in 190°C oil until golden brown.",
      "Spread a layer of tomato sauce in an oven-safe dish.",
      "Layer fried eggplant, then spread with tomato sauce.",
      "Sprinkle with mozzarella and Parmesan cheese.",
      "Repeat layers of eggplant, sauce, and cheese for three layers.",
      "Finally, drizzle with olive oil.",
      "Bake in a 180°C oven for 15 minutes.",
      "Let the freshly baked Parmigiana cool slightly.",
      "Serve on a plate, garnished with olive oil and basil."
    ]
  },
  {
    "name": "Cream Carbonara",
    "url": "https://youtu.be/onlqyAlLW3s",
    "uploader": "미뇨끼",
    "upload_date": "2025-08-31",
    "ingredients": [
      "Pancetta",
      "Spaghetti",
      "Eggs",
      "Parmesan cheese",
      "Cream",
      "Olive oil",
      "Black pepper"
    ],
    "steps": [
      "Slice the pancetta.",
      "Heat olive oil in a pan and cook the pancetta until crispy.",
      "Grate the Parmesan cheese.",
      "In a bowl, combine egg yolks, grated Parmesan cheese, and black pepper to make the sauce.",
      "Cook the spaghetti.",
      "Add the cooked spaghetti to the pan with the pancetta.",
      "Add two ladles of pasta water and mix well, allowing the pancetta fat to coat the spaghetti.",
      "Add the egg-cheese sauce and cream to the pan.",
      "Stir until all ingredients are well combined and the sauce smoothly coats the spaghetti.",
      "Serve the finished carbonara in a bowl and sprinkle with Parmesan cheese."
    ]
  },
  {
    "name": "Pumpkin Risotto",
    "url": "https://youtu.be/qPTOHSo2gt4",
    "uploader": "미뇨끼",
    "upload_date": "2025-09-05",
    "ingredients": [
      "Pumpkin",
      "Onion",
      "Rice",
      "Celery",
      "Carrot",
      "Salt",
      "Parmesan cheese",
      "Vegetable broth",
      "Butter",
      "Olive oil"
    ],
    "steps": [
      "Cut the pumpkin in half.",
      "Scoop out the seeds and pulp from the pumpkin.",
      "Slice and peel the pumpkin.",
      "Finely dice the pumpkin.",
      "Sauté the onion with salt in olive oil.",
      "Add the diced pumpkin and a sprig of rosemary, then sauté together.",
      "Add warm vegetable broth and cook until the pumpkin is tender.",
      "Mash the cooked pumpkin with a fork.",
      "Add the rice and mix.",
      "Gradually add warm vegetable broth as needed, cooking until the rice is tender.",
      "Turn off the heat, add butter, and gently mix.",
      "Add Parmesan cheese and stir well.",
      "Serve the finished risotto on a plate and drizzle with olive oil."
    ]
  },
  {
    "name": "Garden Vegetable Pasta",
    "url": "https://youtu.be/gurRyz_CyBk",
    "uploader": "미뇨끼",
    "upload_date": "2025-09-07",
    "ingredients": [
      "Bell pepper",
      "Eggplant",
      "Zucchini",
      "Onion",
      "Garlic",
      "Cherry tomatoes",
      "Basil",
      "Casarecce",
      "Salt",
      "Tomato paste",
      "Parmesan cheese",
      "Olive oil"
    ],
    "steps": [
      "Cut bell peppers, eggplant, and zucchini into bite-sized pieces.",
      "Heat a generous amount of olive oil in a pan, add the cut vegetables, and season with salt.",
      "Cover and cook until the vegetables are tender, then transfer to a separate dish.",
      "Add more olive oil to the pan, sauté chopped onion and garlic with salt, then add cherry tomatoes and cook.",
      "Stir in tomato paste and sauté to enhance the flavor.",
      "Pour in a little water and simmer to create a sauce.",
      "Meanwhile, boil Casarecce pasta in a separate pot with salted water.",
      "Add the cooked vegetables back into the simmering sauce in the pan.",
      "Add the cooked pasta and fresh basil.",
      "Mix all ingredients well.",
      "Serve the finished pasta in a bowl and sprinkle with Parmesan cheese."
    ]
  },
  {
    "name": "Scallopine with Mushrooms",
    "url": "https://youtu.be/iPVokHoZe2Y",
    "uploader": "미뇨끼",
    "upload_date": "2025-09-12",
    "ingredients": [
      "Oyster Mushrooms",
      "Beef",
      "Garlic",
      "Parsley",
      "Salt",
      "Olive Oil",
      "Flour",
      "Butter",
      "White Wine"
    ],
    "steps": [
      "Cut the base off oyster mushrooms and tear them into strands.",
      "Heat olive oil in a pan and infuse with garlic.",
      "Add oyster mushrooms, season with salt, and sauté.",
      "Cover and cook mushrooms until tender.",
      "Lay out beef slices.",
      "Lightly coat beef slices with flour.",
      "In a separate pan, melt butter and lightly sear the floured beef on both sides.",
      "Remove beef. Add cooked mushrooms to the pan, pour in white wine, and stir to incorporate the flour residue for the sauce.",
      "Return beef to the pan. Add a little butter and water to adjust sauce consistency.",
      "Sprinkle with chopped parsley to finish."
    ]
  },
  {
    "name": "Pumpkin Flower Butter Pasta",
    "url": "https://youtu.be/wnpJZ1fuNJI",
    "uploader": "미뇨끼",
    "upload_date": "2025-09-17",
    "ingredients": [
      "Pumpkin flowers",
      "Pasta",
      "Garlic",
      "Pumpkin flower stems",
      "Anchovies",
      "Olive oil",
      "Butter"
    ],
    "steps": [
      "Cut the calyx of the pumpkin flower and remove the stamen.",
      "Spread the pumpkin flowers wide, stack them, then cut them into strips.",
      "Heat a generous amount of olive oil in a pan and infuse it with garlic.",
      "Cut and add the pumpkin flower stems, then sauté them.",
      "Add anchovies and fry them in the oil until they break down.",
      "Pour in pasta water to dissolve the anchovies."
    ]
  },
  {
    "name": "Italian Prosciutto and Cheese Toast",
    "url": "https://youtu.be/H4yqX3ELS1U",
    "uploader": "미뇨끼",
    "upload_date": "2025-09-29",
    "ingredients": [
      "Bread",
      "Sliced Cheese",
      "Prosciutto"
    ],
    "steps": [
      "Take a slice of bread.",
      "Place sliced cheese on the bread.",
      "Add prosciutto on top of the cheese.",
      "Cover with another slice of bread to form a sandwich.",
      "Toast the sandwich in an air fryer.",
      "Cut the toasted sandwich in half.",
      "Enjoy warm."
    ]
  },
  {
    "name": "Gnocchi",
    "url": "https://youtu.be/jRKDsgG4GZ0",
    "uploader": "미뇨끼",
    "upload_date": "2025-10-01",
    "ingredients": [
      "potatoes",
      "egg",
      "flour",
      "semolina"
    ],
    "steps": [
      "Wash potatoes and steam them with the skin on for 40 minutes.",
      "Peel the potatoes while still warm.",
      "Mash the potatoes with a masher and spread them out on a clean surface.",
      "Make a well in the center and add the beaten egg.",
      "Lightly mix everything with a fork.",
      "Gradually add flour in 2-3 batches and knead the dough.",
      "Knead until the dough is soft and smooth.",
      "Divide the dough into small portions and roll into long ropes.",
      "Cut the ropes into thumb-sized pieces using a scraper.",
      "Sprinkle semolina on a large tray and transfer the gnocchi.",
      "Generously sprinkle semolina over the gnocchi to coat.",
      "Place the tray with gnocchi in the freezer to freeze.",
      "Once frozen, transfer the gnocchi into a plastic bag, separating them individually."
    ]
  },
  {
    "name": "Gnocchi",
    "url": "https://youtu.be/qpBwO757mjc",
    "uploader": "미뇨끼",
    "upload_date": "2025-10-15",
    "ingredients": [
      "Gnocchi",
      "Butter",
      "Parmesan cheese",
      "Pesto",
      "Salt",
      "Tomato sauce"
    ],
    "steps": [
      "Add water and salt to a pot.",
      "Once the water boils, add frozen gnocchi and cook.",
      "When the gnocchi float to the surface, remove them.",
      "Add butter to the warm gnocchi and mix well.",
      "Sprinkle grated Parmesan cheese.",
      "Toss the cooked gnocchi with tomato sauce.",
      "In the warm, drained pot, add gnocchi and pesto.",
      "Mix the gnocchi and pesto well."
    ]
  },
  {
    "name": "Pesto Clam Gnocchi",
    "url": "https://youtu.be/V-uU9lodVz8",
    "uploader": "미뇨끼",
    "upload_date": "2025-10-25",
    "ingredients": [
      "Gnocchi",
      "Clams",
      "Garlic",
      "Pesto",
      "White wine",
      "Olive oil",
      "Salt",
      "Clam broth"
    ],
    "steps": [
      "Sauté garlic in olive oil.",
      "Add clams and white wine, cover, and steam.",
      "Remove clams from the pan.",
      "Strain clam broth and set aside.",
      "Boil gnocchi in salted water until they float, then remove.",
      "Add gnocchi to the pan, pour in pesto and clam broth.",
      "Stir well, then add the clams back.",
      "Toss until the sauce thickens.",
      "Transfer to a plate."
    ]
  },
  {
    "name": "Eggless Pumpkin Carbonara",
    "url": "https://youtu.be/3MjJWjoBoXI",
    "uploader": "미뇨끼",
    "upload_date": "2025-10-29",
    "ingredients": [
      "Pumpkin",
      "Onion",
      "Guanciale",
      "Pasta",
      "Pecorino cheese",
      "Salt",
      "Pepper",
      "Olive oil"
    ],
    "steps": [
      "Sauté onion with salt in a pan with olive oil.",
      "Add pumpkin and sauté until tender.",
      "Transfer the sautéed pumpkin and onion to a cup, add warm pasta water and Pecorino cheese, then blend until smooth.",
      "Cook pasta in boiling salted water.",
      "Crisp up guanciale in a pan and remove.",
      "Add the cooked pasta to the remaining guanciale fat and toss.",
      "Add the pumpkin sauce and pepper, then mantecare.",
      "Transfer the pasta to a plate and garnish with crispy guanciale, Pecorino cheese, and pepper."
    ]
  },
  {
    "name": "Vongole Pasta",
    "url": "https://youtu.be/0PSC2UdwqJ4",
    "uploader": "미뇨끼",
    "upload_date": "2025-11-02",
    "ingredients": [
      "clams",
      "pasta",
      "olive oil",
      "white wine",
      "parsley"
    ],
    "steps": [
      "Heat olive oil in a pan.",
      "Add frozen clams and white wine, cover, and cook.",
      "Once clams open, remove them from the pan.",
      "Strain the clam broth to remove sand, then wipe the pan clean.",
      "Pour the strained clam broth back into the clean pan.",
      "Add par-cooked pasta and cook until the broth thickens.",
      "Add the cooked clams and parsley.",
      "Mix all ingredients well.",
      "Plate and serve."
    ]
  },
  {
    "name": "Wine Poached Pears",
    "url": "https://youtu.be/926cV-hht1k",
    "uploader": "미뇨끼",
    "upload_date": "2025-11-09",
    "ingredients": [
      "pears",
      "red wine",
      "sugar",
      "cloves",
      "cinnamon",
      "orange peel",
      "vanilla ice cream",
      "cookies"
    ],
    "steps": [
      "Peel the pears.",
      "Remove the core from the bottom of each pear.",
      "Trim the bottom of each pear flat so they can stand upright.",
      "Place the pears upright in a deep pot.",
      "Add sugar, cloves, cinnamon, and orange peel to the pot.",
      "Pour in red wine and water until the pears are submerged.",
      "Bring to a boil, then occasionally spoon the wine mixture over the pears.",
      "Partially cover and cook until the pears are tender.",
      "Remove the cooked pears from the pot.",
      "Uncover the pot and reduce the remaining liquid over high heat until it forms a syrup.",
      "Arrange poached pears and vanilla ice cream on a plate.",
      "Drizzle the wine syrup evenly over them.",
      "Crumble cookies over the top."
    ]
  },
  {
    "name": "Hummus",
    "url": "https://youtu.be/nToaFWat8CU",
    "uploader": "미뇨끼",
    "upload_date": "2025-11-16",
    "ingredients": [
      "Chickpeas",
      "Garlic",
      "Lemon juice",
      "Salt",
      "Smoked paprika",
      "Cooking oil",
      "Olive oil",
      "Sesame seeds"
    ],
    "steps": [
      "Place canned chickpeas in a large bowl and add plenty of water.",
      "Gently rub the chickpeas to remove the skins.",
      "Pour in water and discard the skins that float to the surface.",
      "Add sesame seeds and cooking oil, then blend in a blender.",
      "Scrape down the sides and blend once more.",
      "Add chickpeas, olive oil, garlic, salt, lemon juice, and smoked paprika.",
      "Blend once, scrape down the sides, then blend again.",
      "Spread the hummus evenly on a plate with a spoon.",
      "Garnish the center with olive oil, chickpeas, and smoked paprika."
    ]
  },
  {
    "name": "Persimmon Pudding",
    "url": "https://youtu.be/yVvUgVOndyI",
    "uploader": "미뇨끼",
    "upload_date": "2025-11-26",
    "ingredients": [
      "Persimmon",
      "Cocoa powder"
    ],
    "steps": [
      "Peel the persimmon.",
      "Place the peeled persimmon in a measuring cup.",
      "Blend the persimmon until smooth.",
      "Add cocoa powder to the blended persimmon.",
      "Blend the cocoa powder and persimmon until smooth.",
      "Pour the mixture into a pudding mold.",
      "Chill in the refrigerator until set.",
      "Remove the set pudding from the mold."
    ]
  },
  {
    "name": "Soybean Paste Stew",
    "url": "https://youtu.be/-ubqsl2doO0",
    "uploader": "미뇨끼",
    "upload_date": "2025-12-04",
    "ingredients": [
      "Zucchini",
      "Green onion",
      "Spicy green chili",
      "Red chili",
      "Onion",
      "Potato",
      "Tofu",
      "Shiitake mushrooms",
      "Anchovies",
      "Kelp",
      "Blue crab",
      "Radish",
      "Soybean paste"
    ],
    "steps": [
      "Cut the zucchini, green onion, spicy green chili, red chili, onion, potato, and tofu into bite-sized pieces.",
      "Add shiitake mushrooms, anchovies, and kelp to water and soak overnight to make a broth.",
      "Pour the prepared broth into a pot, add radish and blue crab, and bring to a boil.",
      "Once the broth boils, skim off any impurities floating on top.",
      "Add a generous amount of soybean paste and mix well until dissolved.",
      "Add potatoes, zucchini, and onions, and boil over high heat.",
      "Add tofu, spicy green chili, red chili, and green onion, and bring to another boil.",
      "When the zucchini becomes translucent, the Soybean Paste Stew is complete."
    ]
  },
  {
    "name": "Savory Salmon Crepes",
    "url": "https://youtu.be/EZ13xAp4N_k",
    "uploader": "미뇨끼",
    "upload_date": "2025-12-19",
    "ingredients": [
      "Leek",
      "Smoked Salmon",
      "Nutmeg",
      "Salt",
      "Cream Cheese",
      "Parmesan Cheese",
      "White Wine",
      "Eggs",
      "Flour",
      "Butter",
      "Olive Oil",
      "Milk"
    ],
    "steps": [
      "Mix eggs, milk, melted butter, and flour to make the crepe batter.",
      "Pour thin layers of batter onto a hot crepe pan to make several crepes.",
      "Heat olive oil in a pan and sauté smoked salmon and leek.",
      "Add white wine and continue to sauté.",
      "Add cream cheese to the sautéed salmon and leek and mix to create the crepe filling.",
      "Spread the filling onto the cooked crepes, roll them up like cigars, and cut them in half.",
      "Melt butter in a saucepan, add flour and sauté, then gradually whisk in milk.",
      "Add salt and nutmeg, and cook until thickened to make the bechamel sauce.",
      "Spread a thin layer of bechamel sauce on the bottom of an oven-safe dish.",
      "Arrange the filled crepes in a single layer.",
      "Generously spoon bechamel sauce over the crepes.",
      "Sprinkle with Parmesan cheese and bake in the oven."
    ]
  },
  {
    "name": "Rolled Lasagna",
    "url": "https://youtu.be/WhMI2v0e-OY",
    "uploader": "미뇨끼",
    "upload_date": "2025-12-21",
    "ingredients": [
      "Shrimp",
      "Ragu",
      "Béchamel",
      "Tomato sauce",
      "Cream cheese",
      "Mascarpone",
      "Basil",
      "Peperoncino",
      "Egg",
      "Flour",
      "Olive oil"
    ],
    "steps": [
      "Prepare fresh lasagna dough with flour and eggs, rolling it out very thinly.",
      "Combine minced shrimp, basil, peperoncino, cream cheese, mascarpone, and egg to make the shrimp filling.",
      "Layer two sheets of fresh lasagna pasta.",
      "Spread a thin layer of ragu sauce on one side of the pasta sheets.",
      "Spread a thin layer of béchamel sauce on the other side of the pasta sheets.",
      "Generously spread the shrimp filling over the pasta sheets.",
      "Carefully roll the pasta sheets like gimbap to form a tight roll.",
      "Freeze the roll until firm.",
      "Slice the frozen roll into individual pieces.",
      "Arrange the sliced lasagna rolls neatly in a baking dish.",
      "Drizzle olive oil over the lasagna rolls.",
      "Bake in the oven until golden brown and crispy.",
      "Serve by spreading tomato sauce on a plate, then topping with the baked lasagna rolls."
    ]
  },
  {
    "name": "Mascarpone Cream",
    "url": "https://youtu.be/q1LSqACJtG0",
    "uploader": "미뇨끼",
    "upload_date": "2025-12-28",
    "ingredients": [
      "Eggs",
      "Mascarpone cheese",
      "Heavy cream",
      "Sugar",
      "Cornstarch",
      "Vanilla",
      "Milk"
    ],
    "steps": [
      "Combine egg yolks, sugar, cornstarch, and vanilla. Mix well.",
      "Gradually add milk, mixing until smooth.",
      "Pour the mixture into a pan and cook over heat, stirring constantly until thickened.",
      "Quickly cool the cooked mixture by placing the pan in an ice bath.",
      "Transfer the cooled mixture to a stand mixer bowl.",
      "Add mascarpone cheese and heavy cream to the stand mixer bowl.",
      "Whip until all ingredients are well combined and the cream is thick and smooth.",
      "Transfer the finished mascarpone cream to a container and refrigerate.",
      "Toast panettone in an air fryer.",
      "Serve toasted panettone with a generous amount of mascarpone cream."
    ]
  },
  {
    "name": "Cuttlefish Ink Risotto",
    "url": "https://youtu.be/p_aSAN4mvAc",
    "uploader": "미뇨끼",
    "upload_date": "2025-12-31",
    "ingredients": [
      "Cuttlefish",
      "Green onion",
      "Onion",
      "Risotto rice",
      "Mascarpone",
      "Parmesan cheese",
      "Butter",
      "White wine"
    ],
    "steps": [
      "Prepare the cuttlefish.",
      "Place cuttlefish and green onion in a pot.",
      "Pour water and simmer to make broth.",
      "Strain the broth.",
      "Sauté the onion in a pan.",
      "Add risotto rice and sauté together.",
      "Add white wine and cook until evaporated.",
      "Add the cuttlefish ink broth and slowly cook the rice.",
      "Finish the risotto with cold butter.",
      "Whip mascarpone and Parmesan cheese.",
      "Spread the whipped cheese on a plate.",
      "Place the ink risotto on top.",
      "Top with black Parmesan tuile.",
      "Top with fried cuttlefish."
    ]
  },
  {
    "name": "Crepe Suzette",
    "url": "https://youtu.be/RQqzNuUzfWo",
    "uploader": "미뇨끼",
    "upload_date": "2026-01-04",
    "ingredients": [
      "Tangerines",
      "Crepes",
      "Sugar",
      "Butter"
    ],
    "steps": [
      "Cut the tangerines in half.",
      "Squeeze juice from the tangerines.",
      "Add sugar and butter to a pan.",
      "Add tangerine juice to the pan and simmer until it forms a syrup.",
      "Place crepes in the syrup and fold them into quarters.",
      "Simmer the crepes in the sauce.",
      "Serve on a plate and garnish with tangerine slices."
    ]
  },
  {
    "name": "Italian Style Hot Chocolate",
    "url": "https://youtu.be/1piN6E3lCZ0",
    "uploader": "미뇨끼",
    "upload_date": "2026-01-08",
    "ingredients": [
      "Cocoa",
      "Milk",
      "Sugar",
      "Starch"
    ],
    "steps": [
      "Combine cocoa powder, sugar, and potato starch in a pot.",
      "Gradually pour in cold milk, mixing continuously.",
      "Place the pot over heat and slowly stir until it comes to a boil.",
      "Continue stirring until the starch thickens.",
      "Pour the finished hot chocolate into mugs."
    ]
  },
  {
    "name": "Italian Pasta Soup",
    "url": "https://youtu.be/csBbah9LTXY",
    "uploader": "미뇨끼",
    "upload_date": "2026-01-11",
    "ingredients": [
      "Onion",
      "Carrot",
      "Celery",
      "Chickpeas",
      "Spaghetti",
      "Mafaldine",
      "Orecchiette",
      "Tomato paste",
      "Chicken stock",
      "Black pepper",
      "Olive oil"
    ],
    "steps": [
      "Sauté onion, carrot, and celery in olive oil.",
      "Add tomato paste and sauté briefly.",
      "Pour in canned chickpeas along with their liquid.",
      "Add water to achieve a consistency between a thick stew and a thin soup, then bring to a boil.",
      "Break up various leftover pastas like spaghetti, mafaldine, and orecchiette, and add them.",
      "Add one chicken stock cube.",
      "Simmer uncovered for about 15 minutes, until the pasta is cooked and the broth has reduced to a desired consistency.",
      "Ladle into bowls and sprinkle with black pepper to finish."
    ]
  },
  {
    "name": "Pine Nut Noodles",
    "url": "https://youtu.be/kgRNDqkx958",
    "uploader": "미뇨끼",
    "upload_date": "2026-01-15",
    "ingredients": [
      "Pine nuts",
      "Zucchini",
      "Spinach",
      "Perilla leaves",
      "Cucumber",
      "Pear",
      "Salt",
      "Black sesame seeds",
      "Flour"
    ],
    "steps": [
      "Toast pine nuts in a pan.",
      "Finely chop toasted pine nuts, then blend with water until smooth to create a pine nut broth.",
      "Blanch zucchini and spinach.",
      "Blend perilla leaves and cucumber with water to make green juice.",
      "Strain the green juice through a fine sieve.",
      "Mix flour and the green juice to form a dough.",
      "Roll out the dough into flat noodles using a pasta machine.",
      "Cook the noodles in boiling water until done, then rinse and chill them in cold water.",
      "Pour the pine nut broth into a bowl and add the chilled noodles.",
      "Garnish with blanched zucchini, marinated cucumber, thinly sliced pear, and black sesame seeds."
    ]
  },
  {
    "name": "Cool Dallae Pasta",
    "url": "https://youtu.be/l5YUmOhkPOs",
    "uploader": "미뇨끼",
    "upload_date": "2026-01-18",
    "ingredients": [
      "Oyster",
      "Green onion",
      "Green laver",
      "Korean wild chive",
      "Garlic",
      "Spaghetti",
      "Radish",
      "Peperoncino",
      "Salt",
      "Kelp broth",
      "Olive oil",
      "Crumbled seaweed"
    ],
    "steps": [
      "Finely grate the radish, then lightly massage the oysters with it, and rinse them.",
      "Add salt to boiling water and blanch the oysters for 1 minute.",
      "Cut the green onion in half lengthwise, then cut into short pieces.",
      "Cut the wild chives to use only the root parts.",
      "Heat olive oil in a pan and sauté the garlic and green onion.",
      "Add the wild chive roots, and when they turn golden brown, remove only the roots."
    ]
  },
  {
    "name": "Alfredo Pasta",
    "url": "https://youtu.be/Z3SigT2rKas",
    "uploader": "미뇨끼",
    "upload_date": "2026-01-25",
    "ingredients": [
      "Flour",
      "Eggs",
      "Butter",
      "Parmesan cheese"
    ],
    "steps": [
      "Mix flour and eggs to make pasta dough.",
      "Roll out the dough with a pasta machine to make fresh pasta.",
      "Boil the fresh pasta in boiling water.",
      "Thinly slice butter and place it on a large plate.",
      "Place the cooked pasta on top of the butter on the plate.",
      "Grate a generous amount of Parmesan cheese and sprinkle it over the pasta.",
      "Mix well so that the butter and Parmesan cheese melt from the residual heat of the pasta."
    ]
  },
  {
    "name": "Pasta Rosettes",
    "url": "https://youtu.be/wWsPRpfommc",
    "uploader": "미뇨끼",
    "upload_date": "2026-01-28",
    "ingredients": [
      "Pasta dough",
      "Jambon ham",
      "Emmental cheese",
      "Béchamel sauce",
      "Salt",
      "Parmesan cheese"
    ],
    "steps": [
      "Roll out pasta dough thinly.",
      "Cut pasta sheets into A4-sized pieces and boil in salted water.",
      "Cool boiled pasta sheets in cold water and drain well.",
      "Spread a thin layer of Béchamel sauce over the pasta sheets.",
      "Place Jambon ham and Emmental cheese on top.",
      "Roll up the pasta sheets.",
      "Cut the rolled pasta into thick pieces.",
      "Spread Béchamel sauce on the bottom of an oven pan.",
      "Arrange the cut Rosette pieces tightly in the oven pan.",
      "Sprinkle Parmesan cheese over the Rosettes.",
      "Bake in the oven."
    ]
  },
  {
    "name": "Puttanesca",
    "url": "https://youtu.be/ylhSNAm7Yk0",
    "uploader": "미뇨끼",
    "upload_date": "2026-02-03",
    "ingredients": [
      "Spaghetti",
      "Whole peeled tomatoes",
      "Cherry tomatoes",
      "Parsley",
      "Garlic",
      "Taggiasca olives",
      "Capers",
      "Anchovies",
      "Peperoncino",
      "Salt",
      "Olive oil"
    ],
    "steps": [
      "Chop the parsley.",
      "Pit and crush the olives.",
      "Crush the whole peeled tomatoes by hand.",
      "Heat olive oil in a pan, add garlic and peperoncino, and sauté until fragrant.",
      "Add olives and capers and sauté.",
      "Add the crushed whole peeled tomatoes and simmer over low heat.",
      "Add anchovies and mix.",
      "Once the sauce has reduced, season with salt.",
      "Cook the spaghetti.",
      "Add the cooked spaghetti to the sauce and mix.",
      "Toss with olive oil and parsley to finish.",
      "Serve in a bowl."
    ]
  },
  {
    "name": "Monkfish Pasta",
    "url": "https://youtu.be/95UfijrvYe4",
    "uploader": "미뇨끼",
    "upload_date": "2026-02-05",
    "ingredients": [
      "Monkfish fillet",
      "Cherry tomatoes",
      "Garlic",
      "Peperoncino",
      "Taggiasca olives",
      "Paccheri",
      "Tomato paste",
      "Salt",
      "White wine",
      "Lemon zest",
      "Parsley",
      "Olive oil"
    ],
    "steps": [
      "Cut the monkfish into bite-sized pieces.",
      "Heat olive oil in a pan, then sauté garlic and peperoncino.",
      "Add cherry tomatoes and sauté.",
      "Add olives and sauté.",
      "Add tomato paste and mix.",
      "Season with salt.",
      "Add monkfish and sauté.",
      "Add white wine, cover, and cook over low heat.",
      "Cook pasta in boiling salted water.",
      "Add the cooked pasta to the sauce pan.",
      "Add pasta water and mix well.",
      "Add parsley and mantecare.",
      "Sprinkle with lemon zest to finish."
    ]
  },
  {
    "name": "Italian Winter Salad",
    "url": "https://youtu.be/kRwO4d-4IBs",
    "uploader": "미뇨끼",
    "upload_date": "2026-02-13",
    "ingredients": [
      "Radicchio",
      "Pomegranate",
      "Orange",
      "Pear",
      "Ricotta cheese",
      "Walnuts",
      "Salt",
      "Pepper",
      "Honey",
      "Olive oil"
    ],
    "steps": [
      "Separate radicchio leaves and trim the core.",
      "Cut the pomegranate and separate the seeds.",
      "Peel and segment the orange.",
      "Thinly slice the pear.",
      "Lightly toss radicchio leaves with olive oil and salt.",
      "Arrange the radicchio leaves on a plate.",
      "Top with orange segments and pear slices.",
      "Add pomegranate seeds and ricotta cheese.",
      "Sprinkle with walnuts.",
      "Season with pepper and drizzle with olive oil.",
      "Finish with a drizzle of honey."
    ]
  },
  {
    "name": "Butterfish Acqua Pazza",
    "url": "https://youtu.be/XfIQKHw3l0o",
    "uploader": "미뇨끼",
    "upload_date": "2026-02-15",
    "ingredients": [
      "Butterfish",
      "Cherry tomatoes",
      "Garlic",
      "Taggiasca olives",
      "Parsley",
      "Salt",
      "Black pepper",
      "Olive oil",
      "White wine"
    ],
    "steps": [
      "Trim butterfish fins and tail.",
      "Remove butterfish head and clean.",
      "Halve or crush Taggiasca olives.",
      "Heat olive oil in a pan and sauté sliced garlic.",
      "Add halved cherry tomatoes and parsley stalks to the pan.",
      "Once tomatoes release juice, add salt and Taggiasca olives, then sauté.",
      "Make a space in the center of the pan and place the prepared butterfish.",
      "Pour white wine over the butterfish and allow the alcohol to evaporate.",
      "Cover and cook until the butterfish is done.",
      "Season only the cooked butterfish with salt and pepper.",
      "Sprinkle with chopped parsley.",
      "Plate the butterfish and ingredients, then generously drizzle with the cooking liquid."
    ]
  },
  {
    "name": "Radicchio Risotto",
    "url": "https://youtu.be/2dR42h6GKGk",
    "uploader": "미뇨끼",
    "upload_date": "2026-02-18",
    "ingredients": [
      "Radicchio",
      "Onion",
      "Rice",
      "Red wine",
      "Taleggio cheese",
      "Parmesan cheese",
      "Butter"
    ],
    "steps": [
      "Remove outer leaves of radicchio and chop the rest.",
      "Mince the onion.",
      "Dice the Taleggio cheese.",
      "Grill the removed outer radicchio leaves in a pan until browned.",
      "Melt butter in a pan and sauté the minced onion.",
      "Add the chopped radicchio and sauté.",
      "Add risotto rice and sauté together.",
      "Pour in red wine and reduce.",
      "Gradually add hot water, stirring continuously for about 20 minutes until the rice is cooked.",
      "Add butter and Taleggio cheese and stir until melted.",
      "Add Parmesan cheese and 'mantecare' (stir vigorously to create creaminess) to finish.",
      "Serve on a plate and garnish with the grilled outer radicchio leaves."
    ]
  },
  {
    "name": "Scrambled Eggs & Salmon Confit",
    "url": "https://youtu.be/0N9-mpDBzxM",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-05-05",
    "ingredients": [
      "Salmon",
      "Eggs",
      "Mushrooms",
      "Asparagus",
      "Cherry Tomatoes",
      "Onion",
      "Pancetta",
      "Minced Garlic",
      "Salt",
      "Pepper",
      "Butter",
      "Parsley",
      "Dill",
      "Basil",
      "Duck Fat",
      "Olive Oil"
    ],
    "steps": [
      "Remove fat from salmon, sprinkle with salt, and drain.",
      "Cut salmon into pieces for confit.",
      "Maintain duck fat at about 45°C and cook salmon for about 15 minutes, intermittently immersing to maintain temperature.",
      "Brush off dirt from mushrooms, then cut in half.",
      "Finely chop onion and parsley.",
      "Heat duck fat in a pan, add mushrooms, season with salt and pepper, and sauté until golden brown.",
      "Add butter, half of the minced onion, and minced garlic to the sautéed mushrooms, cook, then finish with parsley.",
      "Remove tough ends from asparagus.",
      "Heat duck fat in a pan, add asparagus, season with salt and pepper, and sauté.",
      "Add butter and remaining minced onion to the sautéed asparagus and cook.",
      "Lightly pan-fry pancetta.",
      "Crack eggs, season with salt and pepper, and whisk well.",
      "Heat olive oil and butter in a pan, pour in eggs, and make scrambled eggs.",
      "Arrange scrambled eggs, salmon confit, sautéed mushrooms, sautéed asparagus, pan-fried pancetta, cherry tomatoes, basil, and dill attractively on a plate.",
      "Drizzle with extra virgin olive oil and sprinkle with a little more pepper to finish."
    ]
  },
  {
    "name": "Hairtail Fritter",
    "url": "https://youtu.be/3lNR6mk7naU",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-10-24",
    "ingredients": [
      "Silver Hairtail",
      "Pickled Wild Garlic Greens",
      "Red chili pepper",
      "Green chili pepper",
      "Egg",
      "Pine nuts",
      "Shredded red chili (for garnish)",
      "Salt",
      "Pepper",
      "Buckwheat flour",
      "Sesame seeds",
      "Olive oil"
    ],
    "steps": [
      "Prepare the hairtail and fillet the flesh along the bone by inserting a knife at a 45-degree angle.",
      "Remove any small bones attached to the belly side of the hairtail flesh.",
      "Season the part of the hairtail flesh where the scales used to be with salt and pepper.",
      "Evenly sprinkle salt and black sesame seeds on the inner part of the hairtail flesh.",
      "Lightly coat the hairtail flesh with buckwheat flour as thinly as possible and shake off any excess.",
      "Coat the buckwheat-floured hairtail with egg wash, making sure it doesn't drip."
    ]
  },
  {
    "name": "Mussel Pasta",
    "url": "https://youtu.be/Us3nULYOfcU",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-10-21",
    "ingredients": [
      "Mussels",
      "Spaghettini",
      "Pancetta",
      "Onion",
      "Parsley",
      "Dill",
      "Basil",
      "Thyme",
      "Saffron",
      "White Wine",
      "Salt",
      "Pepper",
      "Olive Oil"
    ],
    "steps": [
      "Heat olive oil in a pan.",
      "Cut pancetta into small pieces and add to the pan first.",
      "Remove leaves from parsley, dill, and thyme, using only the stems.",
      "Once pancetta renders fat, add onion and herb stems.",
      "Add cleaned mussels and sauté.",
      "Pour in white wine, cover, and steam over high heat.",
      "Once mussels are cooked, add saffron and mix.",
      "Remove cooked mussels and strain the broth.",
      "Separate mussels from their shells.",
      "In a new pan, heat olive oil, add finely diced pancetta and onion, season with salt and pepper, and sauté.",
      "Once onion is translucent, pour in the strained mussel broth and sprinkle with saffron.",
      "Add pre-cooked spaghettini, then stir in chopped parsley and thyme.",
      "Once pasta is cooked, transfer it to a plate and top with the mussels.",
      "Drizzle with extra virgin olive oil and garnish with basil to finish."
    ]
  },
  {
    "name": "Flounder Menbosha",
    "url": "https://youtu.be/KzUTBj0kK0Q",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-10-28",
    "ingredients": [
      "Flounder fillet",
      "Bread slices",
      "Boiled eggs",
      "Dijon mustard",
      "White wine vinegar",
      "Cornichons",
      "Capers",
      "Tarragon",
      "Chives",
      "Salt",
      "White pepper",
      "Olive oil"
    ],
    "steps": [
      "Pat dry the flounder fillet with a paper towel.",
      "Season the flounder fillet with salt and brush with egg white.",
      "Cut the bread slices to the size of the flounder fillet and score the top surface.",
      "Lightly season the bread with salt and attach it to the flounder fillet.",
      "Heat olive oil in a pan over very low heat and pan-fry the flounder fillet with the attached bread until golden brown on both sides.",
      "Place the boiled eggs in a bowl and mash them with a fork.",
      "Add Dijon mustard and white wine vinegar to the mashed eggs and whisk.",
      "Gradually add extra virgin olive oil and pure olive oil while whisking.",
      "Season with salt and white pepper.",
      "Finely chop cornichons and capers and add them, then finely chop and add tarragon and chives.",
      "Mix all ingredients well to complete the Gribiche sauce.",
      "Plate the pan-fried flounder toast and serve with Gribiche sauce."
    ]
  },
  {
    "name": "Duck Confit",
    "url": "https://youtu.be/dxKA90SsfTA",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-11-04",
    "ingredients": [
      "Duck legs",
      "Duck skin",
      "Potatoes",
      "Bread",
      "Garlic",
      "Rosemary",
      "Parsley",
      "Herbs",
      "Salt",
      "Pepper",
      "Butter",
      "Olive oil",
      "Duck fat",
      "Duck broth"
    ],
    "steps": [
      "Pat duck legs dry.",
      "Place duck legs, garlic, and rosemary in a pan and cover with olive oil.",
      "Cook in a 110°C oven for about 2 hours.",
      "Cut remaining duck skin and fat, then render the duck fat by simmering with water, garlic, and herbs.",
      "Add the rendered duck fat to the duck leg pan in the oven.",
      "Remove cooked duck legs and check for doneness by piercing with a sharp tool.",
      "Cook duck legs in a 180-190°C oven for 5-10 minutes until skin is crispy and golden.",
      "Halve potatoes lengthwise.",
      "Heat duck fat in a pan, place potatoes cut-side down, and season with salt and pepper.",
      "Flip and pan-fry potatoes until golden brown.",
      "Sauté potatoes with chopped parsley and butter.",
      "Simmer duck broth in a pan, add chopped rosemary, salt, and butter to make a sauce.",
      "Slice bread, brush with duck fat, and toast.",
      "Arrange duck confit, potatoes, and bread on a plate, drizzle with duck broth sauce, and serve."
    ]
  },
  {
    "name": "Grilled Barley Croaker with Freshly Cooked Rice",
    "url": "https://youtu.be/ftmh39mlKJc",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-11-07",
    "ingredients": [
      "Rice",
      "Barley Croaker",
      "Pine nuts",
      "Black sesame seeds",
      "Dried laver"
    ],
    "steps": [
      "Measure rice into a bowl and wash thoroughly until the starch is removed.",
      "Add water to the washed rice in a 1:1 ratio and boil over high heat without a lid.",
      "As the water reduces and holes appear on the rice surface, continue stirring and boiling.",
      "Once the water is almost gone and the rice is half-cooked, cover and steam over low heat for 10-15 minutes.",
      "Fluff the steamed rice with a spatula to release excess steam.",
      "Cut behind the fins and along the back of the barley croaker, then remove the intestines.",
      "Break the bone behind the head and pull to remove the large bones.",
      "Finely chop pine nuts and black sesame seeds.",
      "Stuff the cleaned croaker with the chopped pine nuts and sesame seeds.",
      "Grill over a straw fire until golden brown.",
      "Shred the grilled croaker, mix with rice, crush in dried laver, and mix by hand.",
      "Serve the mixed rice wrapped in dried laver or in a bowl."
    ]
  },
  {
    "name": "Steamed Beef Brisket and Napa Cabbage",
    "url": "https://youtu.be/HNHUoO7rvpA",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-11-11",
    "ingredients": [
      "Beef brisket",
      "Napa cabbage",
      "Green onion",
      "Green chili",
      "Red chili",
      "Soy sauce",
      "Sugar",
      "Oyster sauce",
      "White wine vinegar"
    ],
    "steps": [
      "Remove outer leaves from the napa cabbage, cut it in half, and fan it out to resemble a flower.",
      "Spread out the beef brisket slices.",
      "Boil water in a steamer until steam begins to rise, then add the napa cabbage and beef brisket and steam for 3 minutes and 30 seconds.",
      "Finely chop the red chili, green chili, and green onion.",
      "To the chopped vegetables, add oyster sauce, soy sauce, white wine vinegar, sugar, and water, then mix well to make the sauce.",
      "Place the steamed napa cabbage and beef brisket on a plate.",
      "Drizzle plenty of the prepared sauce over the cabbage.",
      "Enjoy the finished Steamed Beef Brisket and Napa Cabbage."
    ]
  },
  {
    "name": "Market Deli Meat Creations",
    "url": "https://youtu.be/2kf6p4ZpERE",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-11-14",
    "ingredients": [
      "Hamburg Steak",
      "Goindol Tteokgalbi",
      "Button Mushrooms",
      "Onion",
      "Fresh Mozzarella Cheese",
      "Basil",
      "Chervil",
      "Salt",
      "Pepper",
      "Minced Garlic",
      "Heavy Cream",
      "Tomato Sauce",
      "Paprika Powder",
      "White Truffle Oil",
      "Parsley",
      "Olive Oil"
    ],
    "steps": [
      "Slice button mushrooms and finely chop the onion.",
      "In a pan, sauté the chopped onion over low heat until translucent, then season with salt and pepper.",
      "Add button mushrooms and minced garlic, and continue to sauté.",
      "Pour in heavy cream and bring to a simmer to create a cream sauce.",
      "Stir white truffle oil and chopped parsley into the cream sauce.",
      "Pour the cream sauce over the cooked hamburg steak, then sprinkle with paprika powder and drizzle with truffle oil to finish.",
      "Remove any sauce coating from the tteokgalbi.",
      "Make a slit in the tteokgalbi and insert fresh mozzarella cheese.",
      "Spread tomato sauce evenly in an oven-safe dish, then place the cheese-stuffed tteokgalbi on top.",
      "Top the tteokgalbi with another layer of tomato sauce, fresh mozzarella cheese, and basil.",
      "Drizzle with extra virgin olive oil and air fry at 180 degrees Celsius for 7 minutes.",
      "Finish the completed tteokgalbi gratin by drizzling with extra virgin olive oil and sprinkling with chervil."
    ]
  },
  {
    "name": "Spanish Omelet",
    "url": "https://youtu.be/xssPQ7fS7PI",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-11-25",
    "ingredients": [
      "Potato",
      "Onion",
      "Egg",
      "Pancetta",
      "Basil",
      "Parsley",
      "Pine Nuts",
      "Parmesan Cheese",
      "Salt",
      "Pepper",
      "Olive Oil",
      "White Wine Vinegar",
      "Thyme"
    ],
    "steps": [
      "Thinly slice potatoes to 2.5-3mm thickness.",
      "In a pan with olive oil, add sliced potatoes, season with salt and pepper, and stir-fry.",
      "Slice onions to 2-3mm thickness, add to the pan with potatoes, season with salt and pepper, and cook until softened and lightly browned.",
      "Add sliced pancetta to the cooked potatoes and onions and mix.",
      "Whisk 5-6 eggs well, season with salt and pepper, and mix.",
      "Add the whisked eggs and roughly torn basil to the cooked potatoes, onions, and pancetta, and mix evenly.",
      "Pour the mixture into the pan and stir with a spatula when it begins to set.",
      "Transfer to a preheated oven at 150°C and bake for 7-10 minutes.",
      "While the omelet bakes, blend parsley, olive oil, pine nuts, white wine vinegar, salt, and pepper in a blender to make a parsley vinaigrette.",
      "Grate Parmesan cheese into the finished parsley vinaigrette and mix.",
      "Invert the omelet from the oven onto a plate, drizzle with olive oil, and sprinkle with thyme to finish.",
      "Slice the Spanish omelet and enjoy with the parsley vinaigrette."
    ]
  },
  {
    "name": "Chef Kang Leo's Beef Mushroom Hot Pot",
    "url": "https://youtu.be/iL2FlN2sVGQ",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-11-28",
    "ingredients": [
      "Thinly sliced beef brisket",
      "Shiitake mushrooms",
      "Button mushrooms",
      "Oyster mushrooms",
      "Enoki mushrooms",
      "Bok choy",
      "Wild chives",
      "Coastal angelica",
      "Korean angelica",
      "Mung bean sprouts",
      "Broth",
      "Cotton candy"
    ],
    "steps": [
      "Lay mung bean sprouts on the bottom of the pot.",
      "Place oyster mushrooms and bok choy on top of the mung bean sprouts.",
      "Layer coastal angelica, wild chives, shiitake mushrooms, button mushrooms, and Korean angelica.",
      "Place the thinly sliced beef brisket on top of the vegetables.",
      "Add a generous amount of enoki mushrooms.",
      "Pour in the broth.",
      "Top with cotton candy and bring to a boil."
    ]
  },
  {
    "name": "Kabocha Squash Soup",
    "url": "https://youtu.be/1OCVnkVnSds",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-12-02",
    "ingredients": [
      "Kabocha squash",
      "Onion",
      "Butter",
      "Heavy cream",
      "Parmesan cheese",
      "Salt",
      "White pepper",
      "Olive oil",
      "White truffle oil",
      "Mint"
    ],
    "steps": [
      "Cut the kabocha squash in half and scoop out the seeds.",
      "Peel the squash and cut it into small pieces.",
      "Heat olive oil in a pan, add the squash, season with salt, and slowly sauté over low heat.",
      "When the squash is partially cooked, add butter and continue to sauté.",
      "Once the squash is tender, add minced onion and sauté together.",
      "Transfer the sautéed squash and onion to a blender, add Parmesan cheese, and blend until smooth.",
      "Pour the blended mixture into a pot, add water to adjust consistency, and bring to a simmer.",
      "Stir in heavy cream over low heat, being careful not to alter the soup's color.",
      "Finish by adding truffle oil and white pepper.",
      "Serve in a bowl, garnish with a drizzle of olive oil and mint leaves."
    ]
  },
  {
    "name": "Braised Mackerel in Tomato Sauce",
    "url": "https://youtu.be/RqRYUBNg7BA",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-12-05",
    "ingredients": [
      "Mackerel",
      "Pancetta",
      "Onion",
      "Zucchini",
      "Minced garlic",
      "Thyme",
      "Basil",
      "Dill",
      "Parsley",
      "Tomato sauce",
      "Paprika powder",
      "Salt",
      "White pepper",
      "White wine",
      "Bread",
      "Olive oil"
    ],
    "steps": [
      "Cut off the head and tail of the mackerel.",
      "Clean the mackerel's guts thoroughly and score the body.",
      "Season the mackerel with salt and white pepper.",
      "Heat olive oil in a pan and sear the mackerel over high heat until golden brown.",
      "Remove the seared mackerel and set aside.",
      "In the same pan with the leftover mackerel oil, add sliced pancetta and onion, and sauté.",
      "Season with salt, white pepper, and minced garlic, then add thyme and continue to sauté.",
      "Add white wine and cook until the alcohol evaporates.",
      "Once the alcohol has evaporated, add tomato sauce and paprika powder, stirring well.",
      "Return the mackerel to the sauce and simmer over medium-low heat until the sauce is well absorbed.",
      "Cut zucchini into small pieces and place them on top.",
      "Tear basil and dill and sprinkle on top, then drizzle generously with extra virgin olive oil.",
      "Toast the bread until golden brown.",
      "Drizzle the toasted bread with olive oil, sprinkle with salt and chopped parsley.",
      "Cut the bread into quarters, then drizzle with extra virgin olive oil to finish."
    ]
  },
  {
    "name": "Cassoulet",
    "url": "https://youtu.be/gmqnZ9m8TCU",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-12-16",
    "ingredients": [
      "Canned butter beans",
      "Canned whole tomatoes",
      "Merguez sausage",
      "Lamb sausage",
      "Chorizo",
      "Bierwurst",
      "Pancetta",
      "Coppa cruda",
      "Duck legs",
      "Onion",
      "Carrot",
      "Garlic",
      "Leek",
      "Chicken stock",
      "White wine",
      "Cognac",
      "Paprika powder",
      "Salt",
      "Pepper",
      "Rosemary",
      "Thyme",
      "Basil",
      "Parsley",
      "Breadcrumbs",
      "Olive oil",
      "Kitchen twine"
    ],
    "steps": [
      "Debone the duck legs.",
      "Season the duck legs with salt and white pepper.",
      "Heat olive oil in a pan, sear the chorizo sausage first, then remove.",
      "In the same pan, sear the seasoned duck legs, lamb sausage, and merguez sausage.",
      "Skewer the long lamb sausages with rosemary sprigs to hold their shape.",
      "Dice the onion and carrot into pea-sized pieces.",
      "Remove the seared meats from the pan briefly, then sauté the diced onion and carrot.",
      "Return the duck legs to the sautéed vegetables, pour in cognac, and flambé.",
      "Add white wine and paprika powder, mix well.",
      "Tie leek greens, parsley stems, thyme, and rosemary together with twine to make a bouquet garni, add it, and pour in chicken stock.",
      "Slice and add the whole tomatoes, then add the seared chorizo, lamb, merguez sausages, along with pancetta, bierwurst, and coppa cruda.",
      "Rinse the canned butter beans with water and add them at the end.",
      "Season dry breadcrumbs, garlic, rosemary, and parsley with salt and white pepper, then grind to make breadcrumbs.",
      "Sprinkle the breadcrumbs over the finished cassoulet and serve."
    ]
  },
  {
    "name": "Coffee Soufflé",
    "url": "https://youtu.be/WasoF8Zrf-4",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-12-19",
    "ingredients": [
      "Milk",
      "Eggs",
      "Butter",
      "Vanilla Ice Cream",
      "Vanilla Bean",
      "Dark Chocolate",
      "Flour",
      "Cornstarch",
      "Grand Marnier",
      "Espresso",
      "Sugar"
    ],
    "steps": [
      "In a pan, combine milk and sugar, scrape in the vanilla bean seeds, then add the vanilla bean pod and Grand Marnier and mix.",
      "In a separate bowl, mix flour and cornstarch, then add to the milk mixture in the pan, whisking until smooth and lump-free.",
      "Cook over low heat, stirring constantly, until slightly thickened. Then add the egg yolks and continue stirring to make a pastry cream (crème pâtissière).",
      "Remove the vanilla bean pod from the finished pastry cream, cover with plastic wrap, and refrigerate.",
      "Grate the dark chocolate, cover with plastic wrap, and refrigerate.",
      "Thoroughly butter the inside of a cold mold, brushing from bottom to top. Chill in the refrigerator until set, then butter again.",
      "Pour espresso into a pan and reduce until sticky.",
      "Mix the reduced espresso well with the chilled pastry cream, then cover with plastic wrap and refrigerate.",
      "Whip egg whites, gradually adding sugar, to form stiff meringue.",
      "Gently fold the coffee pastry cream and meringue together with a spatula.",
      "Fill the mold completely with the batter, smooth the top, and sprinkle with the grated dark chocolate.",
      "Bake in a preheated 200°C oven for 5 minutes. Finish by sprinkling fine sugar over the baked soufflé.",
      "Serve immediately with vanilla ice cream."
    ]
  },
  {
    "name": "Chou Farci",
    "url": "https://youtu.be/P_Ejnyuf4H0",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-12-23",
    "ingredients": [
      "Cabbage",
      "Ground pork",
      "Chicken liver",
      "Onion",
      "Button mushrooms",
      "Asparagus",
      "Pancetta",
      "Bread slices",
      "Salt",
      "White pepper",
      "Pink peppercorns",
      "Minced garlic",
      "Tomato sauce",
      "Parmesan cheese",
      "Basil",
      "Parsley",
      "Thyme",
      "Rosemary",
      "Olive oil",
      "Cognac",
      "Milk",
      "Eggs",
      "Butter"
    ],
    "steps": [
      "Cut off the thick stem parts of the cabbage leaves.",
      "Place the cabbage leaves in a steamer and steam for about 3 minutes.",
      "Trim and remove the sinews and fat from the chicken liver.",
      "Heat olive oil in a pan, add chicken liver and minced onion, season with salt and white pepper, and sauté until medium-rare.",
      "Add cognac to the sautéed chicken liver and onion, flambé, then turn off the heat.",
      "Blend the thoroughly cooked onion and chicken liver in a mixer and mix it into a bowl containing the ground pork."
    ]
  },
  {
    "name": "Squid Ceviche",
    "url": "https://youtu.be/Y8bgth2anAc",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-12-26",
    "ingredients": [
      "Squid",
      "Cherry tomatoes",
      "Cucumber",
      "Onion",
      "Radishes",
      "Lime",
      "Grapefruit",
      "Avocado",
      "Cheongyang chili pepper",
      "Parsley",
      "Basil",
      "Salt",
      "Black pepper",
      "Tabasco sauce",
      "Pink peppercorns",
      "Olive oil"
    ],
    "steps": [
      "Thinly slice radishes and soak in water to remove pungency.",
      "Dice cherry tomatoes and cucumber into similar sizes.",
      "Julienne onion.",
      "Remove the peel and white pith from the grapefruit, then dice the flesh.",
      "Remove the white pith from the lime, then either thinly slice it or squeeze its juice.",
      "Cut the squid down the middle, remove the internal organs and bone, then peel off the skin.",
      "Score the squid, then slice into thin strips or flat pieces as desired.",
      "Slice and add Cheongyang chili pepper.",
      "Combine all vegetables and squid with olive oil, salt, black pepper, pink peppercorns, parsley, and basil, then mix well.",
      "Dice and add avocado, then mix gently.",
      "Finish by drizzling with Tabasco sauce."
    ]
  },
  {
    "name": "Ginseng-Stuffed Chicken Roulade with Lentil Garnish and Pan Sauce",
    "url": "https://youtu.be/eWhlXgN53aQ",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2021-12-30",
    "ingredients": [
      "Chicken thighs",
      "Ginseng",
      "Green lentils",
      "Pancetta",
      "Spinach",
      "Celery",
      "Carrots",
      "Red onion",
      "Garlic",
      "Basil",
      "Parsley",
      "Thyme",
      "Dill",
      "Heavy cream",
      "Salt",
      "Black pepper",
      "White wine",
      "Butter",
      "Flour",
      "Olive oil",
      "Kitchen twine",
      "Butcher's needle"
    ],
    "steps": [
      "Debone and skin chicken thighs. Score the meat to flatten and remove sinews.",
      "Season the deboned chicken meat with salt and pepper. Season the inside of the chicken skin with salt.",
      "In a pan, melt butter, add salt, pepper, and olive oil, then sauté spinach until wilted. Drain thoroughly.",
      "Cut ginseng in half, remove the head, and steam for about 5 minutes.",
      "Layer the chicken skin with meat, sautéed spinach, steamed ginseng, more sautéed spinach, and more meat. Roll it up and secure by sewing with kitchen twine and a needle.",
      "In a pan with olive oil, place chicken bones. Add the sewed chicken roulade, seam-side down, and sear over low heat to seal.",
      "Transfer the seared chicken roulade and bones to a preheated 220°C oven and bake for 15-20 minutes.",
      "Trim the ends of the baked chicken roulade, remove the twine, then slice thickly.",
      "In the same pan with remaining pan juices, sauté red onion, carrots, celery, and chicken bones until golden. Add flour and white wine, then simmer to create the sauce.",
      "Strain the sauce to remove bones and vegetables. Season with thyme, salt, and pepper.",
      "Cook lentils in salted water, drain, and cool. Render pancetta until crisp. Sauté red onion, carrots, celery, and minced garlic in the rendered fat.",
      "Add the cooked lentils, heavy cream, minced parsley, and basil to the sautéed vegetables. Simmer until thickened like a risotto to complete the lentil garnish.",
      "Plate the lentil garnish, top with the sliced chicken roulade, generously drizzle with sauce, and finish with basil, dill, and olive oil."
    ]
  },
  {
    "name": "Butter-Braised Gwamegi",
    "url": "https://youtu.be/SBIozMt-t6o",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-01-02",
    "ingredients": [
      "Gwamegi",
      "Potato",
      "Onion",
      "Garlic",
      "Cilantro",
      "Scallions",
      "Thyme",
      "Salt",
      "Black pepper",
      "Mirin",
      "White wine",
      "Lime juice",
      "Paprika powder",
      "Cayenne pepper",
      "Butter",
      "Olive oil",
      "Chicken broth",
      "Baguette"
    ],
    "steps": [
      "Cut the Gwamegi into bite-sized pieces.",
      "Slice potatoes somewhat thickly.",
      "In an oiled pan, pan-fry potatoes until golden brown, seasoning with salt and pepper.",
      "Add garlic and continue frying with the potatoes, then remove all from the pan and set aside.",
      "Thinly slice the onion.",
      "In the same pan, sauté the onion until translucent, seasoning with salt and pepper.",
      "Add thyme and Gwamegi, and stir-fry together.",
      "Return the cooked potatoes and garlic to the pan, pour in white wine, and cook to evaporate the alcohol.",
      "Add mirin and chicken broth, then simmer until reduced.",
      "Add lime juice and paprika powder, and bring to a boil.",
      "Add butter and swirl the pan to melt it into the sauce.",
      "Finish by adding cilantro and scallions to taste.",
      "(Optional) Sprinkle cayenne pepper for extra heat.",
      "Serve the Gwamegi stew on baguette slices drizzled with olive oil and sprinkled with cayenne pepper."
    ]
  },
  {
    "name": "Beef Stock",
    "url": "https://youtu.be/VBuugKB_3Cc",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-01-06",
    "ingredients": [
      "Carrot",
      "Leek",
      "Garlic",
      "Celery",
      "Onion",
      "Bay Leaf",
      "Thyme",
      "Tomato",
      "Parsley",
      "Pancetta",
      "Beef Bone Broth",
      "Bouquet Garni",
      "Cognac",
      "Tomato Paste",
      "White Wine",
      "Black Pepper",
      "Olive Oil"
    ],
    "steps": [
      "Chop carrots, celery, onion, leek, garlic, and tomatoes. Trim the hard rind from the pancetta.",
      "In a pan, heat olive oil, add whole black peppercorns and chopped pancetta, and sauté.",
      "Add carrots and sauté until browned, then add celery and onion and continue to sauté.",
      "Add leek and garlic and sauté briefly.",
      "Stir in tomato paste and cook until a crust forms at the bottom of the pan.",
      "Add Cognac and flambé, then add white wine to deglaze.",
      "Add tomatoes and sauté.",
      "Wrap parsley stems, bay leaves, and thyme in leek greens and tie with string to make a bouquet garni.",
      "Pour beef bone broth over the sautéed vegetables, add the bouquet garni, and simmer on medium heat for about 1 hour.",
      "Scrape any browned bits from the sides of the pot and mix into the stock.",
      "Strain the cooked stock, reserving only the liquid. Gently press the solids to extract any remaining liquid.",
      "Cool quickly, then portion and freeze, or refrigerate if using immediately."
    ]
  },
  {
    "name": "Gwamegi Oil Pasta",
    "url": "https://youtu.be/tcqF4gfgm08",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-01-16",
    "ingredients": [
      "Gwamegi",
      "Fettuccine pasta",
      "Pancetta",
      "Clams",
      "Onion",
      "Salt",
      "Sichuan peppercorn powder",
      "Butter",
      "Olive oil",
      "Olive oil",
      "White wine",
      "Thyme",
      "Parsley",
      "Garlic",
      "Basil",
      "Dill"
    ],
    "steps": [
      "Boil water for pasta, adding salt, thyme, parsley stems, garlic, butter, and pancetta rind.",
      "Add fettuccine to the boiling water and cook, then set aside some of the pasta water.",
      "Drain the cooked pasta, then mix with butter and let it cool.",
      "Heat olive oil in a pan, then stir-fry pancetta to render its fat.",
      "Add butter, onion, thyme, parsley, clams, and white wine, then cover and cook until the clams open.",
      "Once the clams are cooked, remove them. Separate half of the clam meat from their shells and set aside, also reserving the clam broth."
    ]
  },
  {
    "name": "Steak Tartare",
    "url": "https://youtu.be/XpBoEXTS2KQ",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-01-23",
    "ingredients": [
      "beef round",
      "shallots",
      "jalapeño",
      "capers",
      "cornichons",
      "chives",
      "parsley",
      "lemon zest",
      "salt",
      "pepper",
      "Dijon mustard",
      "ketchup",
      "Worcestershire sauce",
      "Tabasco sauce",
      "egg",
      "French fries",
      "baguette",
      "olive oil"
    ],
    "steps": [
      "Pat beef dry and remove any silver skin.",
      "Season beef with salt and pepper, sear all sides over high heat briefly, then let cool.",
      "Finely mince the beef.",
      "Finely mince shallots, cornichons, jalapeño, parsley, chives, and capers.",
      "Combine minced beef and vegetables in a bowl with Dijon mustard, ketchup, Worcestershire sauce, and Tabasco sauce. Mix thoroughly.",
      "Form the meat mixture into a patty shape and place on a serving plate.",
      "Separate an egg yolk and place it on top of the meat. Arrange the chopped vegetables around it.",
      "Drizzle with olive oil, sprinkle with fresh pepper, and finish with a sprinkle of lemon zest.",
      "Fry French fries in 150-160°C oil until golden brown, then sprinkle with salt.",
      "Break the yolk, mix it into the tartare, and serve with French fries and baguette."
    ]
  },
  {
    "name": "Bolognese Pasta",
    "url": "https://youtu.be/NAeoN80QCUE",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-01-27",
    "ingredients": [
      "Ground beef",
      "Ground pork",
      "Bacon",
      "Onion",
      "Carrot",
      "Celery",
      "Minced garlic",
      "Leek",
      "Pappardelle",
      "Canned tomatoes",
      "Tomato paste",
      "Red wine",
      "Brown stock",
      "Olive oil",
      "Butter",
      "Parmesan cheese",
      "Salt",
      "Pepper",
      "Thyme",
      "Parsley",
      "Dill",
      "Basil"
    ],
    "steps": [
      "Dice the bacon and fry it in a pan with olive oil.",
      "Brown ground beef and pork in a 1:1 ratio, seasoning with pepper, then drain excess fat.",
      "Finely chop onion, carrot, celery, and leek, then sauté them in the remaining meat fat, seasoning with salt and pepper.",
      "Once vegetables are tender, add the browned meat and minced garlic, mixing well.",
      "Stir in tomato paste and cook, then add plenty of red wine and cook until the alcohol evaporates.",
      "Add canned tomatoes and break them up in the pot.",
      "Add brown stock and simmer thoroughly.",
      "Add picked thyme leaves and adjust seasoning with salt and pepper.",
      "Stir in butter to finish the sauce.",
      "Cook pappardelle in boiling water with olive oil and salt.",
      "Finely chop parsley and basil leaves.",
      "Melt butter in a pan, add cooked pasta, and sauté, seasoning with salt and pepper.",
      "Arrange the pasta on a plate and top with chopped parsley and basil.",
      "Heat the desired amount of sauce, spoon it over the pasta, and finish with Parmesan cheese and dill."
    ]
  },
  {
    "name": "Chicken Francese",
    "url": "https://youtu.be/B7j0STRptEw",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-02-06",
    "ingredients": [
      "Chicken breast",
      "Eggs",
      "Dark cherries",
      "Lemon",
      "Chives",
      "Shallot",
      "Parsley",
      "Butter",
      "Parmesan cheese",
      "Chicken broth",
      "Port wine",
      "White wine",
      "Salt",
      "Black pepper",
      "Flour",
      "Olive oil"
    ],
    "steps": [
      "Pat dry chicken breasts, place in a plastic bag, and pound with a meat mallet to an even thickness.",
      "Season both sides of the flattened chicken breasts with salt and pepper.",
      "Whisk eggs with chopped parsley, salt, pepper, and Parmesan cheese to make an egg wash.",
      "Melt olive oil and butter in a pan.",
      "Dredge chicken breasts in flour, then dip in the egg wash to coat.",
      "Place the coated chicken breasts in the pan and cook until golden brown on both sides.",
      "Remove cooked chicken breasts and let them rest.",
      "Finely chop shallots for the sauce, add more butter to the same pan, and sauté the shallots.",
      "Add port wine, white wine, lemon juice, pitted cherries, and chicken broth to the sautéed shallots, and bring to a simmer to make the sauce.",
      "Return the chicken breasts to the finished sauce and simmer, turning occasionally, until the sauce infuses well.",
      "Chop chives and grate lemon zest, then sprinkle over the braised chicken breasts.",
      "Add chopped chives, Parmesan cheese, and salt to the remaining sauce, bring to a quick boil to adjust consistency.",
      "Arrange chicken breasts on a plate, elegantly spoon cherry sauce around them, and finish with a sprinkle of Parmesan cheese."
    ]
  },
  {
    "name": "Squid Ink Scallops",
    "url": "https://youtu.be/LrJiCkisLkA",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-02-10",
    "ingredients": [
      "fresh scallops",
      "red pepper",
      "parsley",
      "shallot",
      "squid ink",
      "salt",
      "pepper",
      "paprika powder",
      "saffron",
      "white wine",
      "heavy cream",
      "olive oil",
      "clam broth",
      "butter"
    ],
    "steps": [
      "Torch the skin of the red pepper, then soak in cold water and rub to remove the skin. Slice thinly and set aside.",
      "In a pan, add olive oil and sauté thinly sliced shallots over low heat until transparent. Season with salt and pepper.",
      "Add thinly sliced red pepper to the sautéed shallots and continue to sauté. Then add white wine and heavy cream and simmer gently.",
      "Once the sauce is smooth, blend it in a mixer, then strain through a fine sieve. Add paprika powder and saffron to complete the red pepper sauce.",
      "In another pan, add olive oil and sauté thinly sliced shallots until transparent. Season with salt and pepper.",
      "Add chopped parsley and white wine to the sautéed shallots and sauté until wilted. Then add heavy cream and season with salt and pepper.",
      "Once the sauce is smooth, blend it in a mixer, then strain through a fine sieve to complete the parsley cream sauce.",
      "In another pan, add olive oil and sauté thinly sliced shallots until transparent.",
      "Add clam broth and heavy cream to the sautéed shallots and bring to a boil. Strain through a fine sieve to remove the shallots.",
      "To the strained broth, add heavy cream and squid ink and simmer over low heat until very dark and reduced to complete the squid ink sauce.",
      "In a pan, add olive oil and butter. Sear scallops over high heat until golden brown on both sides and caramelized.",
      "Spread the squid ink sauce widely on a plate and top with the seared scallops.",
      "Dot the red pepper sauce and parsley cream sauce around the scallops and drizzle with olive oil to finish."
    ]
  },
  {
    "name": "Gochujang Stew",
    "url": "https://youtu.be/joLhhFXFGzo",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-02-17",
    "ingredients": [
      "Pork belly",
      "Tofu",
      "Potato",
      "Onion",
      "Enoki mushrooms",
      "Shiitake mushrooms",
      "Zucchini",
      "Green onions",
      "Red chili pepper",
      "Green chili pepper",
      "Gochujang",
      "Minced garlic",
      "Fish sauce",
      "Gochugaru",
      "Salt",
      "Black pepper",
      "Sesame oil",
      "Olive oil",
      "Broth"
    ],
    "steps": [
      "Cut pork belly into bite-sized pieces, season with salt and pepper, stir-fry until golden brown, then remove.",
      "Cut potatoes into bite-sized pieces, season with salt and pepper, stir-fry until golden brown, then remove.",
      "Quarter shiitake mushrooms and stir-fry, then add onion, season with salt and pepper, stir-fry briefly, then remove.",
      "Cut zucchini into bite-sized pieces and slice green onions, stir-fry briefly over high heat, then remove.",
      "Add broth to a pot, dissolve gochujang, then season with fish sauce.",
      "Add the stir-fried pork belly and potatoes to the boiling stew first and continue to boil.",
      "Drain water from tofu and grill with a torch.",
      "Add minced garlic, stir-fried shiitake mushrooms, onion, grilled tofu, stir-fried zucchini, green onions, sprinkle with gochugaru, and boil further.",
      "If the sour taste is strong, add sesame oil to balance the flavor.",
      "Slice green onions, red chili, and green chili, place on top, add enoki mushrooms, and finish."
    ]
  },
  {
    "name": "Beef Bourguignon",
    "url": "https://youtu.be/SQv5Rg8WB40",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-02-24",
    "ingredients": [
      "Brisket",
      "Parsnips",
      "Cremini Mushrooms",
      "Carrots",
      "Bacon",
      "Pancetta",
      "Shallots",
      "Onions",
      "Leeks",
      "Beef Brown Stock",
      "Salt",
      "Pepper",
      "Garlic",
      "Cognac",
      "Red Wine",
      "Bay Leaves",
      "Parsley",
      "Basil",
      "Thyme",
      "Dill",
      "Butter"
    ],
    "steps": [
      "Remove fat from brisket, cut into large pieces, season with salt and pepper, brown in an oiled pan, and set aside.",
      "In the same pan, sauté chopped onions seasoned with salt and pepper until softened, then add and mix in tomato paste.",
      "Return the seared beef to the pan, pour in cognac and flambé, then add red wine and bring to a boil.",
      "Add beef brown stock, bay leaves, thyme, and whole peppercorns. Bring to a boil, then cover and cook in a 175-180°C oven for 30 minutes.",
      "Slice bacon or pancetta, render its fat, and add to the pot in the oven.",
      "Sauté carrots, parsnips, shallots, and cremini mushrooms in a pan until browned, then season with salt and pepper.",
      "Add leeks and pancetta, sauté, then deglaze the pan with red wine, scraping up any browned bits from the bottom and cooking off the alcohol.",
      "Remove the pot from the oven, wipe the sides, add the sautéed vegetables, and simmer slowly over low heat.",
      "Finish with crispy thyme, chopped basil, parsley, and a drizzle of olive oil."
    ]
  },
  {
    "name": "Ham Omelet",
    "url": "https://youtu.be/4KU5R4HG1h8",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-03-03",
    "ingredients": [
      "Eggs",
      "Onion",
      "Bell pepper",
      "Pancetta",
      "Black truffle",
      "Parmesan cheese",
      "Salt",
      "Pepper",
      "Butter",
      "Olive oil",
      "Truffle oil"
    ],
    "steps": [
      "Melt olive oil and butter in a pan, then add chopped onion, bell pepper, and pancetta. Season with salt and pepper and sauté until softened.",
      "Crack eggs into a bowl, season with salt and pepper, and whisk until the whites and yolks are well combined.",
      "Melt butter in another pan (until it foams and turns creamy, but does not burn).",
      "Pour the whisked eggs into the melted butter and stir continuously to create a scramble-like consistency.",
      "When the eggs are about 80% cooked, turn off the heat and place the sautéed vegetables and pancetta on one side of the eggs.",
      "Using a spatula, fold one end of the omelet over to form an oval shape.",
      "If the omelet doesn't move easily, melt a little butter underneath it to help it glide, then gently tap the pan to perfect its shape.",
      "Transfer the finished omelet to a plate.",
      "Rub a little butter over the surface of the omelet for a glossy finish.",
      "Drizzle with truffle oil and top with sliced black truffle and grated Parmesan cheese."
    ]
  },
  {
    "name": "Clafoutis",
    "url": "https://youtu.be/7-NXoPYmO3c",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-03-10",
    "ingredients": [
      "Dark cherries",
      "Milk",
      "Heavy cream",
      "Butter",
      "Chocolate ice cream",
      "Brown sugar",
      "Granulated sugar",
      "Powdered sugar",
      "Eggs",
      "Vanilla bean",
      "Flour",
      "Mint leaves"
    ],
    "steps": [
      "Combine milk and heavy cream.",
      "Crack eggs (separate yolks and whites if desired, or use whole), then add butter and brown sugar, mixing well until the sugar dissolves.",
      "Split the vanilla bean lengthwise, scrape out the seeds, and add them to the egg mixture, then mix.",
      "Pour the milk and cream mixture into the egg mixture and stir well.",
      "Sift in the flour and mix until smooth to form the batter.",
      "Remove stems and pits from the cherries.",
      "Grease a baking dish for the clafoutis with butter, then sprinkle evenly with granulated sugar.",
      "Pour the batter into the dish until about 3/4 full, then densely arrange the pitted dark cherries on top of the batter.",
      "Preheat the air fryer to 170°C.",
      "Place the dish with batter and cherries into the air fryer and bake for about 40 minutes.",
      "Remove the baked clafoutis, sprinkle with powdered sugar, and use a kitchen torch to melt the sugar to create a crust.",
      "Place the clafoutis on a plate, sprinkle again with powdered sugar, then garnish with chocolate ice cream and mint leaves to finish."
    ]
  },
  {
    "name": "Onion Soup",
    "url": "https://youtu.be/WkMLHqRp0ek",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-03-24",
    "ingredients": [
      "Onion",
      "Merguez Sausage",
      "Leek",
      "Baguette",
      "Gruyère Cheese",
      "Parmesan Cheese",
      "Thyme",
      "Parsley",
      "Bay Leaf",
      "Salt",
      "Pepper",
      "Soy Sauce",
      "Cognac",
      "White Wine",
      "Chicken Broth",
      "Butter"
    ],
    "steps": [
      "Thinly slice the onions.",
      "Melt butter in a hot pan, add onions, season with salt and pepper, and cook until golden brown and moisture has evaporated.",
      "Once onions begin to brown, add thinly sliced white parts of leek and continue to sauté.",
      "Scrape up any browned bits from the bottom of the pan and continue cooking until onions are deeply caramelized.",
      "Deglaze with cognac, then add white wine, chicken broth, and a bouquet garni (bay leaf and thyme) and bring to a simmer.",
      "Slice baguette thinly and air fry until crispy to make croutons.",
      "Grill Merguez sausage and cut into bite-sized pieces.",
      "Ladle hot soup into bowls, top with sausage, croutons, and a generous amount of Gruyère and Parmesan cheese.",
      "Melt the cheese using an air fryer or kitchen torch, then garnish with parsley and thyme."
    ]
  },
  {
    "name": "Egg Benedict",
    "url": "https://youtu.be/3UKlryG_riE",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-03-31",
    "ingredients": [
      "Egg",
      "Rapeseed leaves",
      "Mortadella ham",
      "English muffin",
      "Parsley",
      "Cayenne pepper",
      "Lemon",
      "Salt",
      "Pepper",
      "Butter",
      "Vinegar",
      "Milk",
      "Extra virgin olive oil"
    ],
    "steps": [
      "Melt butter over low heat, skim milk solids, and strain to separate clarified butter.",
      "Separate egg yolks into a bowl, season with salt, pepper, and lemon juice.",
      "Gradually add warm clarified butter, mixing well to make hollandaise sauce (add milk or cream if desired).",
      "Halve English muffins and toast them until crispy in an ungreased pan.",
      "Spread butter on toasted muffins and sprinkle with salt and pepper.",
      "Thinly slice mortadella ham and pan-fry lightly.",
      "Melt butter in a pan, sauté destemmed rapeseed leaves with salt and pepper until wilted.",
      "Boil water in a pot, add vinegar, and stir to create a whirlpool.",
      "Gently drop egg into the center of the whirlpool, reduce to medium heat, and cook until yolk is warm and white is set, then remove and drain.",
      "Cover a plate with plastic wrap, brush with extra virgin olive oil, and arrange parsley leaves face down.",
      "Sprinkle parsley with salt and microwave for 1 minute to make crispy parsley garnish.",
      "Gently warm and loosen thickened hollandaise sauce in a double boiler.",
      "Layer ham, sautéed rapeseed leaves, and poached egg on toasted English muffins.",
      "Drizzle generously with hollandaise sauce, then sprinkle with crispy parsley and cayenne pepper."
    ]
  },
  {
    "name": "Bread and Butter Pudding",
    "url": "https://youtu.be/R2ysLQYxqtM",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-04-07",
    "ingredients": [
      "Baguette",
      "Sliced bread",
      "Eggs",
      "Milk",
      "Heavy cream",
      "Butter",
      "Brown sugar",
      "Crystal sugar",
      "Vanilla bean",
      "Cranberries",
      "Pistachios",
      "Chocolate",
      "Jam",
      "Raisins",
      "Macadamia nuts",
      "Ice cream",
      "Icing sugar",
      "Lemon",
      "Mint"
    ],
    "steps": [
      "Slice leftover baguette or sliced bread into bite-sized pieces.",
      "Grease the inside of a baking dish with butter.",
      "Butter the baguette pieces, or butter one side of the jammed and overlapped sliced bread pieces.",
      "Arrange the buttered bread pieces neatly in the baking dish.",
      "Sprinkle nuts (pistachios, macadamia nuts), dried fruits (cranberries, raisins), and chopped chocolate over the bread as desired.",
      "In a separate bowl, combine brown sugar and eggs, and whisk well until the sugar dissolves.",
      "Add vanilla bean seeds and mix, then add heavy cream and milk and whisk again.",
      "Pour the mixture over the bread in the dish and let it sit briefly to absorb.",
      "Sprinkle crystal sugar over the top before baking.",
      "Bake in a preheated oven at 185°C for 25 minutes.",
      "Cut the baked pudding into bite-sized pieces.",
      "Top with a scoop of ice cream, garnish with mint leaves and lemon zest, then sprinkle with icing sugar."
    ]
  },
  {
    "name": "Spicy Mixed Buckwheat Noodles with Sea Squirt",
    "url": "https://youtu.be/Y_KFKr9xXKw",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-04-21",
    "ingredients": [
      "Warty sea squirt",
      "Buckwheat noodles",
      "Apple",
      "Pear",
      "Onion",
      "Green onion",
      "Cucumber",
      "Egg",
      "Crumbled seaweed",
      "Minced ginger",
      "Omija syrup",
      "White wine vinegar",
      "Sugar",
      "Minced garlic",
      "Naengmyeon dongchimi broth",
      "Chili powder",
      "Soy sauce",
      "Sesame oil",
      "Sesame seeds"
    ],
    "steps": [
      "Score the sea squirt, remove water and internal organs, then rinse in saltwater.",
      "Trim the sea squirt by removing hard parts.",
      "Peel and core the apple and pear. Peel the onion and green onion. Cut them all into small pieces.",
      "In a blender, combine the cut fruits and vegetables, minced garlic, minced ginger, soy sauce, and sugar. Blend until smooth.",
      "Add omija syrup, sesame oil, sesame seeds, chili powder, and white wine vinegar to the blended sauce. Mix well.",
      "Let the sauce age for one to two days.",
      "Boil buckwheat noodles in salted water for 3 minutes and 30 seconds.",
      "Rinse the cooked buckwheat noodles in cold water and drain thoroughly.",
      "Julienne the cucumber.",
      "Place the buckwheat noodles in a bowl and pour an appropriate amount of the aged sauce over them.",
      "Garnish with julienned cucumber, trimmed sea squirt, a soft-boiled egg (halved), crumbled seaweed, and sesame seeds.",
      "Drizzle with sesame oil to finish."
    ]
  },
  {
    "name": "Lasagna",
    "url": "https://youtu.be/cyaOBkWKsF8",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-04-28",
    "ingredients": [
      "Lasagna noodles",
      "Spinach",
      "Cherry tomatoes",
      "Pancetta",
      "Ricotta cheese",
      "Mozzarella cheese",
      "Parmesan cheese",
      "Basil",
      "Parsley",
      "Nutmeg",
      "Salt",
      "Black pepper",
      "Onion",
      "Minced garlic",
      "Heavy cream",
      "Olive oil"
    ],
    "steps": [
      "Boil the lasagna noodles until tender, then drain.",
      "Quarter the spinach, blanch it in the pasta cooking water, then squeeze out the moisture.",
      "Remove the stems from the cherry tomatoes.",
      "In a pot, heat olive oil and sauté minced onion, salt, black pepper, minced garlic, and pancetta until transparent. Add heavy cream and nutmeg, bring to a boil until thickened, then let it cool like a dumpling filling.",
      "To the cooled filling, add minced basil, parsley, and squeezed spinach, then mix.",
      "In another pan, heat olive oil and sauté thinly sliced onion. Add heavy cream, nutmeg, minced basil, and parsley to make a less viscous sauce."
    ]
  },
  {
    "name": "Marry Me Chicken",
    "url": "https://youtu.be/BrgJiS7ExLc",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-05-19",
    "ingredients": [
      "Chicken breast",
      "Onion",
      "Sun-dried tomatoes",
      "Chili flakes",
      "Minced garlic",
      "Basil",
      "Oregano",
      "Thyme",
      "Salt",
      "Black pepper",
      "White wine",
      "Chicken broth",
      "Heavy cream",
      "Olive oil",
      "Butter",
      "Flour",
      "Sun-dried tomato oil"
    ],
    "steps": [
      "Pat chicken breasts dry with paper towels and trim any excess fat.",
      "Season the trimmed chicken breasts with salt and black pepper.",
      "Heat olive oil in a pan, then sear chicken breasts until lightly browned.",
      "Add butter to the pan with the seared chicken, continue cooking until medium-well, then remove and set aside.",
      "In the pan where the chicken was cooked, add flour and cook until golden brown to create a roux.",
      "In a new pan, heat olive oil and sauté sliced onion, salt, black pepper, chili flakes, butter, and minced garlic until the onion is translucent.",
      "Return the cooked chicken breasts to the onion pan, pour in white wine, and simmer to reduce the alcohol.",
      "Add the pan juices from searing the chicken to the pan. Temporarily remove the chicken breasts to prevent burning.",
      "Add chicken broth, heavy cream, minced thyme, oregano, and basil to the pan, and simmer until the sauce thickens.",
      "Return the cooked chicken breasts and sun-dried tomatoes (drained of oil) to the finished sauce and simmer briefly.",
      "Add remaining thyme, oregano, and basil, then finish with sun-dried tomato oil and black pepper."
    ]
  },
  {
    "name": "Butterfish Ceviche",
    "url": "https://youtu.be/uyGI3hLpzMc",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-05-26",
    "ingredients": [
      "Butterfish",
      "Radish",
      "Shallot",
      "Red chili pepper",
      "Green chili pepper",
      "Cherry tomatoes",
      "Chives",
      "Basil",
      "Chili powder",
      "Omija syrup",
      "White wine vinegar",
      "Salt",
      "Pepper",
      "Capers",
      "Lime zest",
      "Olive oil",
      "Lime"
    ],
    "steps": [
      "Scale the cleaned butterfish and pat dry with paper towels.",
      "Remove the fins and head from the butterfish. Gently separate the flesh from the bones and thinly slice.",
      "Prepare a classic vinaigrette (mixture of white wine vinegar and extra virgin olive oil) and pour it over the sliced butterfish, then marinate in the refrigerator.",
      "Thinly slice the radish and shallots, then soak them in water to reduce their pungency. Slice the red chili, green chili, cherry tomatoes, chives, and basil.",
      "Combine the sliced vegetables and capers in a bowl. Add chili powder, omija syrup, extra virgin olive oil, salt, pepper, and lime zest to make the garnish.",
      "Season the chilled marinated butterfish with salt and pepper.",
      "Gently mix the seasoned butterfish with the garnish and arrange flat on a plate.",
      "Top with the soaked shallots and radishes, lime slices, and chives to finish."
    ]
  },
  {
    "name": "Cheongsong Spicy Chicken Bulgogi",
    "url": "https://youtu.be/aSePCLvywR0",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-06-02",
    "ingredients": [
      "Chicken",
      "Minced garlic",
      "Minced ginger",
      "Chives",
      "Basil",
      "Gochujang",
      "Gochugaru",
      "Omija extract",
      "Soy sauce",
      "Sugar",
      "Salt",
      "Black pepper",
      "Chicken broth",
      "Sesame oil",
      "Olive oil",
      "Sesame seeds"
    ],
    "steps": [
      "First, grind the chicken cartilage, then add and coarsely mince the chicken meat for texture.",
      "Reduce the chicken broth in a pot.",
      "Mix gochujang, gochugaru, minced garlic, minced ginger, sesame oil, soy sauce, omija extract, sugar, and sesame seeds to make a sauce.",
      "Finely chop the basil and chives.",
      "Add the chopped herbs to the minced chicken and mix.",
      "Season with salt and black pepper.",
      "Pour the reduced chicken broth over the minced chicken and mix well.",
      "Add the prepared sauce to the chicken and knead thoroughly until the flavors are well incorporated.",
      "Heat olive oil in a preheated pan, then spread the chicken mixture thinly and widely, cooking on both sides.",
      "Transfer the cooked chicken bulgogi to a plate, then sear with a torch to add a smoky flavor.",
      "Sprinkle with chopped chives to finish."
    ]
  },
  {
    "name": "Cold Brisket Pasta with Tomato Salsa",
    "url": "https://youtu.be/GviAYqcNubU",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-06-09",
    "ingredients": [
      "Brisket",
      "Capellini pasta",
      "Cherry tomatoes",
      "Red onion",
      "Cucumber",
      "Jalapeño",
      "Garlic",
      "Anchovies",
      "Basil",
      "Parsley",
      "Lemon",
      "Tomato paste",
      "Paprika powder",
      "Smoked paprika powder",
      "Tabasco",
      "Salt",
      "Pepper",
      "Olive oil",
      "Cheese"
    ],
    "steps": [
      "Boil water and cook capellini pasta, then rinse with cold water and drain.",
      "Drain excess liquid from jalapeños, then finely mince garlic and anchovies.",
      "Separate basil and parsley leaves from stems. Finely chop the stems and set aside with the leaves.",
      "Combine cherry tomatoes, jalapeños, garlic, anchovies, basil, parsley, tomato paste, paprika powder, smoked paprika powder, Tabasco, salt, pepper, lemon zest, lemon pulp, pure olive oil, and extra virgin olive oil in a food processor and blend well to make the tomato salsa.",
      "Julienne the cucumber and red onion.",
      "Heat olive oil in a pan, season the brisket with salt and pepper, and cook until golden brown.",
      "Combine the cooked pasta, seared brisket, julienned red onion, and julienned cucumber in a large bowl.",
      "Add the prepared tomato salsa to the bowl and toss until all ingredients are well combined.",
      "Plate the pasta, garnish with julienned cucumber, and drizzle with a little olive oil.",
      "Finally, grate and generously sprinkle cheese to finish."
    ]
  },
  {
    "name": "Skirt Steak and Grilled Vegetables with Tomato Salsa",
    "url": "https://youtu.be/DMAZI1hm9RM",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-06-30",
    "ingredients": [
      "Skirt steak",
      "Tomato",
      "Eggplant",
      "Zucchini",
      "Bell pepper",
      "Onion",
      "Jalapeño",
      "Salt",
      "Black pepper",
      "Chili powder",
      "Minced garlic",
      "Lemon juice",
      "Tabasco sauce",
      "Fish sauce",
      "Parsley"
    ],
    "steps": [
      "Chop the tomato (after removing the stem).",
      "Finely chop the onion.",
      "Slice the jalapeño.",
      "Coarsely chop parsley leaves and finely mince stems.",
      "Finely chop the bell pepper.",
      "Add chili powder and minced garlic to taste.",
      "Add lemon juice, salt, pepper, Tabasco sauce, and fish sauce; mix well to complete the tomato salsa.",
      "Slice eggplant, zucchini, and bell pepper into even thicknesses.",
      "Season the skirt steak with black pepper.",
      "Grill zucchini, eggplant, and bell pepper in a preheated pan without oil.",
      "Transfer grilled vegetables to a plate, then grill the skirt steak in the preheated pan.",
      "Place the grilled skirt steak on top of the vegetables and garnish with parsley."
    ]
  },
  {
    "name": "Crumpets",
    "url": "https://youtu.be/-_rekHEs3TU",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-07-21",
    "ingredients": [
      "Egg",
      "Loquat",
      "Blueberry",
      "Raspberry",
      "Salt",
      "Vegemite",
      "Honey",
      "Vinegar",
      "Flour",
      "Cooking oil",
      "Whipping cream",
      "Yeast",
      "Baking powder",
      "Butter",
      "Milk"
    ],
    "steps": [
      "In a bowl, combine flour, milk, water, salt, baking powder, and yeast, mixing to form a thin batter.",
      "Cover the batter with plastic wrap and let it rise for about 30 minutes.",
      "Heat cooking oil in a pan, place a round mold, and lightly grease the mold with oil.",
      "Pour batter about halfway into the mold and cook over low heat for 5-7 minutes.",
      "Once bubbles appear, remove from the mold, and flip a few times to brown.",
      "Spread butter and Vegemite on the crumpets.",
      "Beat eggs and mix with salt.",
      "Heat cooking oil in a pan, pour in the beaten eggs, and stir to make scrambled eggs.",
      "Add butter just before finishing and mix well to make them creamy.",
      "Top the crumpets generously with scrambled eggs.",
      "In a bowl, whip the whipping cream using a whisk.",
      "Place the whipped cream on top of the crumpets, then add raspberries, blueberries, and thinly sliced loquat.",
      "Drizzle sweet honey on top."
    ]
  },
  {
    "name": "Spicy and Tangy Razor Clams",
    "url": "https://youtu.be/6hAsdQb0ebE",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-07-28",
    "ingredients": [
      "Razor clams",
      "Perilla leaves",
      "Spinach",
      "Cheongyang chili pepper",
      "Onion",
      "Garlic",
      "Ginger",
      "Yuzu",
      "Dried kelp",
      "Salt"
    ],
    "steps": [
      "Soak razor clams in saltwater to purge sand.",
      "Place yuzu, ginger, garlic, cheongyang chili pepper, perilla leaves, spinach, and onion into a blender.",
      "Prepare kelp broth by soaking dried kelp in water.",
      "Blend the ingredients until well combined.",
      "Add the kelp broth to the blender and blend again.",
      "Cook the purged razor clams on charcoal for about 2 minutes.",
      "When the clam shells slightly open, remove from heat and extract the meat.",
      "Use kelp as a serving plate.",
      "Arrange the cooked razor clam meat on the kelp.",
      "Lightly drizzle Joseph sauce over the razor clams to finish."
    ]
  },
  {
    "name": "Meat Pie",
    "url": "https://youtu.be/KsSK-2_X98Y",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-08-04",
    "ingredients": [
      "Ground meat",
      "Steak",
      "Onion",
      "Garlic",
      "Bay leaf",
      "Salt",
      "Red wine",
      "Soy sauce",
      "Chinese vinegar",
      "Tomato sauce",
      "Sriracha sauce",
      "Flour",
      "Butter",
      "Egg wash",
      "Cooking oil"
    ],
    "steps": [
      "Mix flour, butter, and water to make the dough.",
      "Wrap the dough in parchment paper and refrigerate for 30 minutes to 1 hour.",
      "Finely chop the onion, and mince the garlic with salt.",
      "Cut the steak into cubes.",
      "Coat the steak and ground meat with flour.",
      "Melt butter in a pan and sauté the floured steak.",
      "Add onion, minced garlic, bay leaf, and red wine to the sautéed steak and mix.",
      "Add ground meat and cook over low heat for about 1 hour and 30 minutes.",
      "Add soy sauce and Chinese vinegar, then season to taste.",
      "Grease a pie dish with cooking oil and dust with flour.",
      "Roll out the dough slightly larger than the pie dish, place it in the dish, and fill with the cooled filling.",
      "Cover with the top crust and carefully seal to prevent the meat from spilling out.",
      "Brush the top of the dough with egg wash and bake in a 180°C oven for about 15-18 minutes.",
      "Serve the finished meat pie with tomato sauce (mixed with Sriracha)."
    ]
  },
  {
    "name": "Seaweed Cake",
    "url": "https://youtu.be/QALolnjcLXs",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-08-11",
    "ingredients": [
      "Seaweed powder",
      "Whipping cream",
      "White chocolate",
      "Gelatin",
      "Food coloring",
      "Biscuits"
    ],
    "steps": [
      "Soak gelatin in cold water for 5 minutes.",
      "Whip together whipping cream and seaweed powder.",
      "Melt white chocolate in a double boiler, then mix with the soaked gelatin.",
      "Fold the gelatin and white chocolate mixture into the seaweed cream.",
      "Pour the mixture into a mold and freeze.",
      "Mix white chocolate and food coloring to make a green glaze.",
      "Apply the green glaze over the frozen cake and refrigerate for 1 hour.",
      "Apply another layer of glaze to the cake after refrigerating.",
      "Lightly torch the cake surface for a glossy finish.",
      "Sprinkle biscuits on a serving plate and place the cake on top.",
      "Decorate the cake with a candle."
    ]
  },
  {
    "name": "Scotch Eggs",
    "url": "https://youtu.be/G0UCYnJA_gU",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-09-01",
    "ingredients": [
      "Pork",
      "Venison",
      "Eggs",
      "Salt",
      "Breadcrumbs",
      "Tomato Radish",
      "Cooking oil",
      "Ice"
    ],
    "steps": [
      "Boil eggs in boiling water for 5 minutes and 30 seconds.",
      "Cool the boiled eggs in ice water, then peel them.",
      "Mix minced pork and venison on parchment paper, spread thinly, and season with salt.",
      "Wrap the peeled eggs with the prepared meat, forming a round shape.",
      "Dip in egg wash, then coat with breadcrumbs.",
      "Dip in egg wash again and coat with breadcrumbs for a double coating.",
      "Fry in oil for 5 minutes.",
      "Cut the well-fried Scotch Eggs in half.",
      "Arrange tomato radish on a plate and beautifully place the Scotch Eggs to finish."
    ]
  },
  {
    "name": "Coq au Vin",
    "url": "https://youtu.be/8wftXj85d7U",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-09-08",
    "ingredients": [
      "Whole Chicken",
      "Pancetta",
      "Mushrooms",
      "Carrots",
      "Shallots",
      "Garlic",
      "Potatoes",
      "Red Wine",
      "Chicken Stock",
      "Thyme",
      "Salt",
      "Pepper",
      "Milk",
      "Butter"
    ],
    "steps": [
      "Stuff the whole chicken with garlic, shallots, thyme, mushrooms, and pancetta.",
      "Pour an entire bottle of red wine over it, then marinate in the refrigerator for 24 hours.",
      "Heat a pan with butter, then sear the chicken until the skin is golden brown.",
      "After searing the chicken and vegetables, strain the remaining wine and bring it to a boil.",
      "Skim off any impurities that rise to the surface while the wine boils.",
      "While skimming, dissolve 1 chicken stock cube in water and bring to a boil.",
      "Return the boiled wine and chicken stock to the chicken and vegetables, then simmer for 90 minutes.",
      "Place potatoes on a bed of salt and bake in the oven at 180°C for 25 minutes.",
      "Place the baked potatoes in a sieve and mash them.",
      "Put the mashed potatoes into a pot and cook for 3-4 minutes.",
      "Add butter to the mashed potatoes and mix well.",
      "Add salt, pepper, and milk to the mixed potatoes and stir again."
    ]
  },
  {
    "name": "Fish and Chips",
    "url": "https://youtu.be/w5QXxjh36Yw",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-09-15",
    "ingredients": [
      "Cod",
      "Potatoes",
      "Lemon",
      "Salt",
      "Flour",
      "Cornstarch",
      "Baking powder",
      "Soju",
      "Beer",
      "Oil"
    ],
    "steps": [
      "Remove moisture and bones from the fish.",
      "For the fish batter, thoroughly mix flour, cornstarch, baking powder, Soju, and beer.",
      "Lightly coat the cod with cornstarch, then dip in the batter, and deep-fry in oil for 5-6 minutes.",
      "Peel the potatoes and cut them into bite-sized pieces.",
      "Place potatoes in a pot, cover with water, and boil over medium heat for about 20 minutes.",
      "Drain the cooked potatoes, pat dry with paper towels, and freeze for 2 hours.",
      "Fill a pot with enough oil to cover the potatoes, and fry them once at 130°C for 5 minutes.",
      "Drain the fried potatoes, let them cool, and freeze again for 10 minutes.",
      "Take the potatoes out of the freezer and fry them again at 180°C for 7 minutes."
    ]
  },
  {
    "name": "Carbonara",
    "url": "https://youtu.be/qY7C-X0G7_s",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-09-22",
    "ingredients": [
      "Pancetta",
      "Shallots",
      "Lemon",
      "Flour",
      "Eggs",
      "Dijon mustard",
      "Heavy cream",
      "Salt",
      "Parsley",
      "Butter",
      "Oil"
    ],
    "steps": [
      "Combine flour, egg yolks, and whole eggs.",
      "Let the well-mixed dough rest for 30 minutes.",
      "Roll out the dough thinly using a rolling pin or pasta machine.",
      "Cut the pasta to your desired thickness.",
      "Dust the pasta with flour, then let it dry for 20-30 minutes.",
      "Chop the pancetta and shallots.",
      "Heat oil in a pan. Add shallots and cook until softened, then add pancetta and butter.",
      "Stir in Dijon mustard and heavy cream.",
      "Cook the fresh pasta in salted boiling water for about 2 minutes.",
      "Gradually add pasta cooking water to the sauce to adjust consistency and taste.",
      "Add shredded lemon peel to the sauce.",
      "Add the pasta to the sauce, toss well, and sprinkle with parsley."
    ]
  },
  {
    "name": "Salmon Steak",
    "url": "https://youtu.be/PFyXnR3-_Dw",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-09-29",
    "ingredients": [
      "Salmon",
      "Scallions",
      "Soy Milk",
      "Salt",
      "Lemon Juice",
      "Cooking Oil",
      "Olive Oil",
      "Butter"
    ],
    "steps": [
      "Blend scallions and cooking oil.",
      "First, add soy milk, then gradually pour in olive oil.",
      "Season the prepared salmon with salt.",
      "Cook the salmon, adjusting heat, until the skin is golden and crispy.",
      "When searing the salmon belly, add butter to caramelize it.",
      "Plate on a white dish."
    ]
  },
  {
    "name": "Lamb Roast with Potato Garnish",
    "url": "https://youtu.be/HIDWIqBblgE",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-10-06",
    "ingredients": [
      "Lamb",
      "Potato",
      "Turmeric",
      "Caraway",
      "Dried Coriander",
      "Cumin",
      "Black Pepper",
      "Salt",
      "Butter",
      "Flour",
      "Cooking Oil",
      "Red Wine",
      "Chicken Broth",
      "Lamb Broth"
    ],
    "steps": [
      "Sprinkle 3kg of lamb with black pepper, cumin, caraway, turmeric, and dried coriander, then add salt.",
      "Rub the spices and salt evenly onto the lamb.",
      "Place the lamb in a pan with cooking oil and sear until the surface is golden brown.",
      "Place the seared lamb into an oven-safe dish.",
      "After reducing the remaining drippings in the searing pan, pour in enough chicken broth to submerge the lamb.",
      "Roast in the oven at 120°C for about 3-4 hours."
    ]
  },
  {
    "name": "Pavlova",
    "url": "https://youtu.be/xZTtrKs2cYc",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-10-13",
    "ingredients": [
      "Egg whites",
      "Heavy cream",
      "Peaches",
      "Kiwi",
      "Grapes",
      "Raspberries",
      "Sugar",
      "Icing sugar",
      "Makgeolli",
      "Blueberry jam",
      "Perilla leaf powder"
    ],
    "steps": [
      "Whip egg whites until foamy.",
      "Gradually add sugar while whipping until stiff meringue forms.",
      "Gently fold in icing sugar.",
      "Draw desired size circles on parchment paper and flip it over.",
      "Transfer meringue to a piping bag and pipe circles onto the parchment paper to form the pavlova base.",
      "Pipe small teardrop-shaped meringues around the pavlova base for decoration.",
      "Bake meringue in an 80°C oven for at least 3 hours.",
      "Whip heavy cream, gradually adding makgeolli and adjusting to taste, to make makgeolli cream.",
      "Spread makgeolli cream and jam over the baked meringue sheet.",
      "Place a second meringue sheet on top and gently press to allow cream to seep out.",
      "Decorate the sides and top of the pavlova with remaining makgeolli cream and decorative meringues.",
      "Slice seasonal fruits like peaches, kiwi, grapes, and raspberries thinly, arrange them on top, and sprinkle with perilla leaf powder to finish."
    ]
  },
  {
    "name": "Norwegian Salmon Soup",
    "url": "https://youtu.be/zXnTKWrPdGc",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-10-20",
    "ingredients": [
      "Snapper frame",
      "Salmon",
      "Shrimp",
      "Scallions",
      "Onion",
      "Leek",
      "Parsley",
      "Heavy cream",
      "Caraway",
      "Black pepper",
      "Cornstarch"
    ],
    "steps": [
      "Place snapper frame in a pot.",
      "Add whole fresh parsley to the pot.",
      "Add whole black peppercorns and caraway to the pot.",
      "Roughly chop onion and leek, then add to the pot.",
      "Pour 3 liters of water into the pot and simmer over low heat for about an hour to make stock.",
      "Strain the cooked stock to remove fish bones and vegetables.",
      "Add 1000ml of heavy cream to the stock and mix well.",
      "Mix 100g of cornstarch with 200ml of water to create a slurry, then add to the soup and stir well to thicken.",
      "Place bite-sized salmon, shrimp, and scallions in a serving bowl.",
      "Pour the hot soup into the bowl, covering the garnishes.",
      "Sprinkle finely chopped scallions over the soup."
    ]
  },
  {
    "name": "Beef Tripe Kimchi Stew",
    "url": "https://youtu.be/VZS-RjAG1So",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-10-27",
    "ingredients": [
      "Beef Tripe",
      "Kimchi",
      "Garlic",
      "Tofu",
      "Chives",
      "Cheongyang Chili Pepper",
      "Onion",
      "Soy Sauce",
      "Chili Powder",
      "Sugar"
    ],
    "steps": [
      "Slice tripe into bite-sized pieces and render fat in a pan.",
      "Slice kimchi into bite-sized pieces.",
      "Once tripe fat has rendered, add kimchi, sugar, and chili powder, then stir-fry.",
      "Continue stir-frying until kimchi softens.",
      "Pour in water and bring to a boil.",
      "Finely chop half an onion.",
      "Add chopped onion to the stew.",
      "Cut tofu into bite-sized pieces.",
      "Mince garlic.",
      "Slice Cheongyang chili pepper.",
      "Add sliced tofu, minced garlic, and sliced Cheongyang chili pepper to the stew and boil.",
      "Simmer until the broth is rich, then transfer to an earthenware pot.",
      "Garnish with chives."
    ]
  },
  {
    "name": "Baked Oysters Gratin",
    "url": "https://youtu.be/WQnHaLX4p2c",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-11-03",
    "ingredients": [
      "Oysters",
      "Spinach",
      "Shallots",
      "Mozzarella Cheese",
      "Dijon Mustard",
      "Lemon",
      "Salt",
      "Pepper",
      "Butter",
      "Flour",
      "Milk",
      "Parsley"
    ],
    "steps": [
      "Shuck oysters, separate the meat, clean them, and reserve the shells and oyster liquor.",
      "Melt butter in a pan, add flour, and cook to make a roux.",
      "Gradually add milk to the roux, stirring constantly to avoid lumps, to make béchamel sauce.",
      "Grate lemon zest into the béchamel sauce and season with salt and pepper.",
      "Add Dijon mustard and oyster liquor, adjusting the consistency of the sauce.",
      "Place spinach leaves in the cleaned oyster shells and top with oysters.",
      "Spoon a generous amount of béchamel sauce over the oysters.",
      "Top with thinly sliced shallots, sprinkle with mozzarella cheese and parsley, then add more grated lemon zest.",
      "Grill or use a torch until the cheese is melted and golden brown."
    ]
  },
  {
    "name": "Steak with Doenjang Sauce",
    "url": "https://youtu.be/9zj4xkmRfIQ",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-11-10",
    "ingredients": [
      "Beef sirloin",
      "Beef stock",
      "Doenjang",
      "Heavy cream",
      "Marinated wild garlic leaves",
      "Olive oil",
      "Salt",
      "Pepper",
      "Butter",
      "Garlic"
    ],
    "steps": [
      "Season beef sirloin with salt.",
      "Heat olive oil in a hot pan and lightly sear the steak.",
      "Brush butter on the lightly cooked steak, let it rest, then repeat this process two more times.",
      "After resting, let the steak cool for about 5 minutes.",
      "Add beef stock to the pan where the steak was cooked and bring to a boil.",
      "Add doenjang and heavy cream, stir, and simmer.",
      "Grate garlic into the sauce.",
      "Add butter and pepper to the sauce and mix well.",
      "Slice the rested steak into bite-sized pieces and arrange on a plate.",
      "Garnish the plate with marinated wild garlic leaves and serve with doenjang sauce."
    ]
  },
  {
    "name": "Kimchi Pancake",
    "url": "https://youtu.be/2-alDWeQyak",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-11-17",
    "ingredients": [
      "Kimchi",
      "Persimmon",
      "Cheongyang chili pepper",
      "Green onion",
      "Perilla leaves",
      "Red chili powder",
      "Kimchi juice",
      "Flour",
      "Cooking oil"
    ],
    "steps": [
      "Cut kimchi into bite-sized pieces and place in a bowl, then add kimchi juice.",
      "Combine flour and water in a 1:1 ratio and mix well to make the pancake batter.",
      "Peel the persimmon, julienne it, and add to the batter.",
      "Finely julienne perilla leaves, finely chop Cheongyang chili pepper and green onion, and add them to the batter.",
      "Add red chili powder to taste and stir the batter until all ingredients are well combined.",
      "Heat cooking oil in a pan over medium heat, pour in the batter, and spread thinly.",
      "If concerned about burning, occasionally shake the pan. When the pancake is golden brown, flip it and cook both sides thoroughly."
    ]
  },
  {
    "name": "Sausage Rolls",
    "url": "https://youtu.be/74az4szLgBM",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-11-24",
    "ingredients": [
      "Ground meat",
      "Red onion",
      "Onion",
      "Tomato",
      "Celery",
      "Garlic",
      "Horseradish",
      "Sage",
      "Salt",
      "Chili powder",
      "Apple cider vinegar",
      "Red wine",
      "Flour",
      "Butter",
      "Egg",
      "Cooking oil"
    ],
    "steps": [
      "Combine ground meat, sage, garlic, and celery. Add a raw egg and mix again.",
      "Make a dough by combining flour and butter, then slowly add water.",
      "Roll out the dough and refrigerate for 20 minutes to chill.",
      "Finely chop red onion and sauté with salt in a pan with cooking oil.",
      "Once the onion softens, add garlic and chili powder and continue to sauté.",
      "Add tomato and red wine, simmer until it becomes a sauce, then turn off the heat.",
      "Stir in apple cider vinegar into the sauce to enhance flavor.",
      "Place the meat mixture in a long strip on the dough, roll it up, and seal the ends.",
      "Chill in the refrigerator for about 20 minutes, then cut into desired portions.",
      "Make incisions and brush with egg yolk.",
      "Bake in a 180°C oven for 20 minutes.",
      "Slice and serve with the sauce."
    ]
  },
  {
    "name": "Classic Whole Fried Chicken and Spicy Glazed Chicken",
    "url": "https://youtu.be/NNsercZv7dA",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-12-01",
    "ingredients": [
      "Chicken",
      "Beer",
      "Frying powder",
      "Soy milk",
      "Soy sauce",
      "Gochujang",
      "Gochugaru",
      "Minced garlic",
      "Salt",
      "Black pepper",
      "Dried pepperberry",
      "Gardenia fruit",
      "Honey",
      "Orange",
      "Corn starch",
      "Oil"
    ],
    "steps": [
      "Submerge the young chicken in beer and marinate in the refrigerator for 24 hours.",
      "Halve the marinated chicken, remove the internal organs, and pat dry thoroughly with paper towels.",
      "Mix frying powder and soy milk in a 1:1 ratio to make a thick batter.",
      "Coat the chicken with the batter, then thoroughly coat with frying powder.",
      "Fry the chicken in oil preheated to 160°C for about 12 minutes until golden brown, then remove and let cool.",
      "Cut the fried chicken into serving-sized pieces.",
      "Mix salt, black pepper, and dried pepperberry to make chicken seasoning salt.",
      "In a pot, combine soy sauce, gochujang, gochugaru, minced garlic, honey, orange peel, and gardenia fruit. Simmer over medium heat for 30 minutes until sticky.",
      "Strain the sauce to remove solids, then add more honey to adjust sweetness to taste.",
      "Add fresh orange juice for a refreshing tang, then add a 1:1 corn starch slurry (corn starch mixed with water) to thicken the sauce.",
      "Brush the finished seasoned sauce over the fried chicken and sprinkle with thinly sliced raw garlic."
    ]
  },
  {
    "name": "Marinated Egg Bibimbap",
    "url": "https://youtu.be/plGN0no09Qw",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-12-08",
    "ingredients": [
      "Egg",
      "Bracken Fiddleheads",
      "Kimchi",
      "Black Rice",
      "Oyster Mushrooms",
      "Watercress",
      "King Oyster Mushrooms",
      "Mung Bean Sprouts",
      "Bok Choy",
      "Soy Sauce",
      "Gyeran-jang Seasoning Soy Sauce",
      "Gochujang",
      "Sesame Seeds",
      "Ginger",
      "Salt",
      "Crushed Seaweed",
      "Kelp",
      "Cooking Oil",
      "Sesame Oil"
    ],
    "steps": [
      "Boil eggs for 5 minutes and 30 seconds.",
      "Combine water, gyeran-jang seasoning soy sauce, ginger, and kelp, then bring to a boil.",
      "Once the sauce boils, immediately remove from heat and transfer to a container.",
      "Add the boiled eggs to the sauce and marinate in the refrigerator for 3 days.",
      "Cook rice with water.",
      "Cover the rice and cook for 10-20 minutes.",
      "Let the rice rest for 10 minutes.",
      "Blanch bok choy, starting from the stems, for about 30 seconds. Then toss with sesame oil, sesame seeds, and salt.",
      "Heat cooking oil in a pan, sprinkle king oyster mushrooms and oyster mushrooms with salt, then cover and cook.",
      "Cook bracken fiddleheads with equal parts soy sauce and water.",
      "Briefly warm mung bean sprouts in the pan using residual heat to absorb mushroom flavor.",
      "Plate the rice, marinated eggs, and vegetables, then mix and serve.",
      "Add kimchi, crushed seaweed, and watercress to taste."
    ]
  },
  {
    "name": "K-BBQ Pork Belly",
    "url": "https://youtu.be/sGB9CkjDj5s",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-12-15",
    "ingredients": [
      "Pork belly",
      "Kimchi",
      "Lettuce",
      "Eggs",
      "Sansho pepper",
      "Malt syrup",
      "Gochugaru",
      "Doenjang",
      "Grapeseed oil",
      "Cooking oil"
    ],
    "steps": [
      "Combine sansho pepper, rice water, doenjang, malt syrup, and gochugaru to create a marinade.",
      "Marinate the pork belly in the mixture for 24 hours.",
      "Place the marinated pork belly on a charcoal grill and begin grilling.",
      "Cut the grilled pork belly into bite-sized pieces with kitchen shears.",
      "Drizzle remaining marinade over the pork belly while grilling to add a smoky flavor.",
      "Put 150g of kimchi into a blender and blend.",
      "Add 3 eggs to the blended kimchi and blend again.",
      "Slowly pour grapeseed oil or cooking oil into the kimchi-egg mixture while blending until it emulsifies into a mayonnaise-like sauce.",
      "Adjust the spiciness of the kimchi mayonnaise by adding kimchi juice to taste.",
      "Arrange the grilled pork belly on a serving plate.",
      "Drizzle any remaining marinade over the grilled pork belly for extra sansho pepper aroma.",
      "Enjoy the pork belly wrapped in lettuce, dipped in kimchi mayonnaise, as ssam."
    ]
  },
  {
    "name": "LA Galbi",
    "url": "https://youtu.be/1xMxM1Y-NiQ",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-12-12",
    "ingredients": [
      "LA Style Beef Short Ribs",
      "Green onion",
      "Onion",
      "Asian pear",
      "Minced garlic",
      "Minced ginger",
      "Soy sauce",
      "Corn syrup",
      "Sugar",
      "Sake",
      "Mirin",
      "Black pepper",
      "Sesame oil",
      "Sesame seeds"
    ],
    "steps": [
      "Warm the corn syrup in the microwave for about 15 seconds.",
      "First, mix the corn syrup and sugar together.",
      "Put ginger and garlic into a blender in a 1:1 ratio.",
      "Add one tablespoon of sesame seeds.",
      "Add pepper, mirin, sake, green onion, onion, Asian pear, soy sauce, and sesame oil, then blend until smooth.",
      "Add the blended marinade to the corn syrup and sugar mixture and mix well.",
      "Add water.",
      "Prepare the short ribs for marinating.",
      "Lay the short ribs in a single layer, pour the marinade over them, and let them marinate.",
      "Grill over medium-low heat, letting the sauce reduce and cook.",
      "Once the pan is hot, increase the heat to medium-high and continue grilling to caramelize.",
      "Once the sauce has reduced, flip the short ribs and drizzle about one tablespoon of the remaining marinade over them.",
      "Serve on a plate and sprinkle with sesame seeds."
    ]
  },
  {
    "name": "Bang-a Pesto Pasta",
    "url": "https://youtu.be/8eh-bbQw1Eg",
    "uploader": "미뇨끼",
    "upload_date": "2025-06-29",
    "ingredients": [
      "Bang-a leaves",
      "Pasta",
      "Peach",
      "Peanuts",
      "Parmesan cheese",
      "Ricotta cheese",
      "Olive oil"
    ],
    "steps": [
      "Prepare bang-a leaves.",
      "Blend peanuts in a blender.",
      "Add olive oil, bang-a leaves, and Parmesan cheese to the blender to make pesto.",
      "Cook pasta.",
      "Place cooked pasta in a bowl and add bang-a pesto.",
      "Add a little pasta water and mix the pasta and pesto.",
      "Add ricotta cheese and gently mix with the pasta.",
      "Cut peach into bite-sized pieces.",
      "Serve pasta on a plate and top with sliced peach."
    ]
  },
  {
    "name": "Fish and Chips",
    "url": "https://youtu.be/In_kon7CPlA",
    "uploader": "한신희",
    "upload_date": "2025-10-14",
    "ingredients": [
      "Pollock fillet",
      "Potato",
      "Mayonnaise",
      "Shallot",
      "Cornichon pickles",
      "Capers",
      "Parsley",
      "Pickle juice",
      "Salt",
      "Pepper",
      "Paprika powder",
      "Whiskey",
      "Lager beer",
      "All-purpose flour",
      "Baking powder",
      "Flour for dredging",
      "Cooking oil"
    ],
    "steps": [
      "Slice potatoes thinly using a mandoline slicer.",
      "Rinse the sliced potatoes twice in cold water to remove starch, then pat dry with a kitchen towel.",
      "Skin the pollock fillet, cut it diagonally in half, and season with salt.",
      "Combine cold lager beer, all-purpose flour, baking powder, paprika powder, salt, and whiskey to make the batter.",
      "Mix mayonnaise, finely chopped shallots, cornichon pickles, capers, chopped parsley, pickle juice, and salt to make tartar sauce.",
      "Fry the potatoes in oil preheated to 180°C until golden brown, then remove from oil."
    ]
  },
  {
    "name": "Potato Frittata",
    "url": "https://youtu.be/8fsEEslp1f0",
    "uploader": "미뇨끼",
    "upload_date": "2025-07-03",
    "ingredients": [
      "Potatoes",
      "Zucchini",
      "Onion",
      "Eggs",
      "Tomatoes",
      "Basil",
      "Olive oil"
    ],
    "steps": [
      "Prepare the potatoes.",
      "Peel the potatoes.",
      "Boil the potatoes.",
      "Slice the zucchini.",
      "Slice the onion.",
      "Whisk the eggs.",
      "Slice the boiled potatoes.",
      "Heat olive oil in a pan.",
      "Sauté the sliced zucchini and onion in the pan.",
      "Arrange the sliced potatoes over the sautéed zucchini and onion.",
      "Pour in the whisked eggs.",
      "Cover and cook.",
      "Flip the frittata to cook the other side.",
      "Serve the frittata, garnished with tomatoes and basil."
    ]
  },
  {
    "name": "Pasta alla Norma",
    "url": "https://youtu.be/Dg_3bEX9sBw",
    "uploader": "미뇨끼",
    "upload_date": "2025-07-15",
    "ingredients": [
      "Eggplant",
      "Garlic",
      "Mezze Maniche pasta",
      "Basil",
      "Tomato puree",
      "Pecorino cheese",
      "Salt",
      "Olive oil"
    ],
    "steps": [
      "Dice the eggplant into small, bite-sized pieces.",
      "Pour a generous amount of olive oil into a pan and add the diced eggplant, seasoned with salt.",
      "Sauté slowly over medium-low heat until golden brown.",
      "Set aside the cooked eggplant.",
      "In the same pan, add the tomato puree and garlic.",
      "Cover partially and simmer over low heat for about 30 minutes, then season with salt.",
      "Add the sautéed eggplant back into the tomato sauce.",
      "Cook the tubular pasta in salted water.",
      "Add the cooked pasta to the sauce, add a splash of pasta water, and gently toss to emulsify.",
      "Finish with Pecorino cheese and basil."
    ]
  },
  {
    "name": "Beef Brisket Pot Rice",
    "url": "https://youtu.be/lgAAB9KJ7Qg",
    "uploader": "한신희",
    "upload_date": "2025-10-16",
    "ingredients": [
      "Beef Brisket",
      "Garlic Chives",
      "Shiitake Mushrooms",
      "Shallots",
      "Garlic",
      "Dried Kelp",
      "Dried Shrimp",
      "Oyster Sauce",
      "Soy Sauce",
      "Tuna Sauce",
      "Green Plum Extract",
      "Sugar",
      "Sesame Oil",
      "Sesame Seeds",
      "Rice",
      "Broth",
      "Broth Tablet",
      "Cooking Oil",
      "Shiitake Mushroom Stems"
    ],
    "steps": [
      "Slice beef, garlic, and shallots, then marinate in soy sauce.",
      "Slice shiitake mushrooms.",
      "Add dried kelp, dried shrimp, and sliced shiitake mushrooms to water, boil to make broth, then strain.",
      "Heat olive oil in a pan, stir-fry the marinated beef until cooked, then set aside.",
      "In the same pan, add rice and sliced shiitake mushrooms and stir-fry.",
      "Pour the broth over the stir-fried rice and mushrooms, cover, and simmer for 8 minutes.",
      "Slice scallions.",
      "Top the pot rice with the stir-fried beef and sliced scallions, cover, and let steam for 5 minutes.",
      "Grind sesame seeds.",
      "Mix the ingredients in the pot rice well, serve in a bowl, and sprinkle with ground sesame seeds."
    ]
  },
  {
    "name": "Spicy Seafood Noodle Porridge",
    "url": "https://youtu.be/ifIdehR1-f0",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-12-16",
    "ingredients": [
      "Green onions",
      "Chili pepper",
      "Garlic",
      "Egg",
      "Nori",
      "Brown rice",
      "Jin Jjambbong instant noodles",
      "Chili oil",
      "Chili powder",
      "Soy sauce",
      "Sesame oil"
    ],
    "steps": [
      "Slice the green onions.",
      "Add chili oil to a pot.",
      "Add the green onions.",
      "Crack an egg into a mixing bowl.",
      "Deseed and slice the chili pepper.",
      "Add garlic and chili powder to the pot.",
      "Add soy sauce.",
      "Add a little water to the pot.",
      "Mix well, then add the remaining water.",
      "Add the sliced chili pepper to the egg and mix well.",
      "Tear nori into small pieces and mix into the egg mixture.",
      "Break the instant noodles into pieces.",
      "Add the liquid soup base to the pot.",
      "Once the water boils, add the noodles.",
      "Remove from heat when the noodles are almost cooked.",
      "Pour in the egg mixture.",
      "Bring to a gentle boil over medium-high heat.",
      "Transfer to a bowl and top with the finishing oil and shredded nori.",
      "Drizzle with sesame oil."
    ]
  },
  {
    "name": "Gnocchi-Style Meatballs Polpette",
    "url": "https://youtu.be/3rIiG2K0GiA",
    "uploader": "미뇨끼",
    "upload_date": "2025-07-17",
    "ingredients": [
      "Minced Beef",
      "White Bread",
      "Pasta",
      "Parsley",
      "Carrot",
      "Onion",
      "Celery",
      "Basil",
      "Pine Nuts",
      "Raisins",
      "Milk",
      "Parmesan Cheese",
      "Salt",
      "Tomato Sauce",
      "Olive Oil"
    ],
    "steps": [
      "Trim the crusts from the white bread, cut into square cubes, and place them in a bowl.",
      "Pour a generous amount of milk over the bread cubes and mash them until they form a thick, porridge-like paste.",
      "To the mashed bread, add minced beef, chopped parsley, salt, Parmesan cheese, pine nuts, and raisins.",
      "Knead and mix the ingredients thoroughly for a long time until the mixture becomes smooth like clay and loses any grainy texture.",
      "Roll the dough into ping-pong ball-sized spheres and arrange them on a disposable tray.",
      "Freeze the meatballs on the tray in the freezer."
    ]
  },
  {
    "name": "Soup Curry",
    "url": "https://youtu.be/DmNIDMUz8W0",
    "uploader": "한신희",
    "upload_date": "2025-10-21",
    "ingredients": [
      "Chicken",
      "Shiitake mushrooms",
      "Green onions",
      "Oyster mushrooms",
      "Broccoli",
      "Kabocha squash",
      "Eggs",
      "Rice",
      "Cheddar cheese",
      "Salt",
      "Pepper",
      "Paprika powder",
      "Garlic",
      "Ginger",
      "Coriander seeds",
      "Cumin seeds",
      "Basil",
      "Curry roux",
      "Olive oil",
      "Butter"
    ],
    "steps": [
      "Separate the chicken leg quarters.",
      "Place the remaining chicken, shiitake mushrooms, and green onions in a pot and sear the surfaces with a kitchen torch.",
      "Pour in enough water to cover the ingredients, simmer for 1 hour, then strain to make a rich chicken broth.",
      "Prepare the oyster mushrooms, broccoli, and kabocha squash, then toss with olive oil, salt, and pepper. Season the separated chicken leg quarters with paprika powder, salt, and pepper.",
      "Roast the seasoned vegetables and chicken leg quarters in a preheated 180°C oven for 25 minutes.",
      "Melt butter in a pot and sauté the garlic and ginger.",
      "Add paprika powder, coriander seeds, cumin seeds, and basil, and sauté together.",
      "Add the roasted chicken leg quarters, chicken broth, and curry roux, and simmer to let the flavors meld.",
      "Season with salt and pepper to taste.",
      "Arrange the chicken leg quarters, roasted vegetables, and hard-boiled eggs in a bowl, then pour in the curry soup to finish.",
      "Serve with cheddar cheese on top of rice."
    ]
  },
  {
    "name": "Oyster Pasta",
    "url": "https://youtu.be/U8fbYw9KFoQ",
    "uploader": "한신희",
    "upload_date": "2025-10-24",
    "ingredients": [
      "Oysters",
      "Red chili pepper",
      "Spaghetti",
      "Garlic",
      "Anchovies",
      "White wine",
      "Lemon",
      "Parsley",
      "Salt",
      "Olive oil"
    ],
    "steps": [
      "Rinse the oysters in cold salted water.",
      "Roughly chop the red chili pepper, including the seeds.",
      "Cook the spaghetti in 1% salted water for about 8 minutes.",
      "Add minced garlic, anchovies, and olive oil to a pan and turn on the heat.",
      "Mash the anchovies and sauté over low heat; when the garlic turns golden brown, add the oysters and chopped red chili pepper.",
      "Add a splash of white wine and cook until the oysters are about halfway done.",
      "Add the cooked spaghetti and pasta water to the pan and continue cooking the pasta.",
      "Once the pasta is cooked to your desired al dente and the pasta water has reduced, turn off the heat.",
      "Add lemon zest and parsley, then 'mantecare' (emulsify) by adding a little olive oil.",
      "Serve the finished pasta on a plate."
    ]
  },
  {
    "name": "Elaeagnus Panna Cotta",
    "url": "https://youtu.be/MtJq62sAcYA",
    "uploader": "미뇨끼",
    "upload_date": "2025-07-20",
    "ingredients": [
      "Elaeagnus fruit",
      "Heavy cream",
      "Sugar",
      "Leaf gelatin",
      "Basil"
    ],
    "steps": [
      "Mix heavy cream and sugar, then heat until sugar dissolves.",
      "Soak leaf gelatin in lukewarm water for 5 minutes to soften.",
      "Turn off heat, add softened gelatin, and stir until completely dissolved.",
      "Transfer to glass cups, cool, then refrigerate to set.",
      "Remove seeds from each Elaeagnus fruit.",
      "Add sugar to the deseeded Elaeagnus fruit and simmer until thickened.",
      "Blend the simmered Elaeagnus fruit into a jam.",
      "Spoon Elaeagnus jam generously over the chilled panna cotta.",
      "Place a towel under the cup and gently tap to level the jam surface.",
      "Garnish with a green basil leaf."
    ]
  },
  {
    "name": "Korean Beef Tartare",
    "url": "https://youtu.be/l3iWfUIAEmM",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-12-19",
    "ingredients": [
      "Topside Beef",
      "Rump Steak",
      "Asian Pear",
      "Cheongyang Pepper",
      "Button Mushrooms",
      "Egg",
      "Gochujang",
      "Garlic",
      "MSG",
      "Salt",
      "Sugar",
      "Sesame Oil",
      "Sesame Seeds",
      "Black Pepper"
    ],
    "steps": [
      "Combine gochujang and sugar.",
      "Slice some Asian pear for garnish, then grate the remaining pear and add to the gochujang mixture.",
      "Add minced garlic and sesame oil to the gochujang mixture.",
      "Season the gochujang mixture with salt, sesame seeds, and black pepper, then mix well.",
      "Add MSG to the gochujang mixture.",
      "Slice Cheongyang peppers and garlic for serving.",
      "Peel and thinly slice button mushrooms.",
      "Slice the topside beef into long strips and place into a mixing bowl.",
      "Season the beef with salt, a pinch of sugar, a dash of sesame oil, and black pepper, then mix well.",
      "In a separate container, combine sugar and salt (6:4 ratio), then embed an egg yolk and let it cure.",
      "Grate the cured egg yolk over the beef tartare before serving."
    ]
  },
  {
    "name": "Tagliata",
    "url": "https://youtu.be/DexThQYJmz4",
    "uploader": "미뇨끼",
    "upload_date": "2025-07-22",
    "ingredients": [
      "Sirloin steak",
      "Cherry tomatoes",
      "Arugula",
      "Parmesan cheese",
      "Salt",
      "Balsamic vinegar",
      "Olive oil"
    ],
    "steps": [
      "Soak the sirloin steak (in its packaging) in warm water for 20 minutes.",
      "Halve the cherry tomatoes and toss with olive oil and salt.",
      "Shave the Parmesan cheese thinly.",
      "Pat the sirloin steak dry and brush with olive oil.",
      "Grill the sirloin steak on a preheated grill pan for 2 minutes per side (total 4 minutes).",
      "Thinly slice the grilled sirloin steak on a cutting board.",
      "Arrange a generous bed of arugula on a large plate and drizzle with olive oil.",
      "Place the sliced sirloin steak on top of the arugula.",
      "Top with cherry tomatoes and Parmesan cheese.",
      "Generously drizzle with balsamic vinegar to finish."
    ]
  },
  {
    "name": "Steak",
    "url": "https://youtu.be/UPnO_QGl4DA",
    "uploader": "한신희",
    "upload_date": "2025-10-26",
    "ingredients": [
      "Olive oil"
    ],
    "steps": [
      "Bring the sirloin steak to room temperature for 3 hours until its core temperature reaches 14°C.",
      "Season the sirloin steak with salt.",
      "Preheat the oven to 110°C.",
      "Place the seasoned sirloin steak in the oven and cook slowly until its core temperature reaches 40°C.",
      "Add olive oil to a cast iron pan and heat until very hot.",
      "Sear the steak (removed from the oven) in the hot pan until its core temperature reaches 55°C.",
      "Slice and serve."
    ]
  },
  {
    "name": "Cherry Tomato Pasta",
    "url": "https://youtu.be/m6NENirheCQ",
    "uploader": "미뇨끼",
    "upload_date": "2025-07-24",
    "ingredients": [
      "Cherry tomatoes",
      "Garlic",
      "Pasta",
      "Fresh basil",
      "Olive oil",
      "Salt",
      "Parmesan cheese"
    ],
    "steps": [
      "Slice cherry tomatoes in half.",
      "Heat a generous amount of olive oil in a pan and sauté garlic until fragrant.",
      "Add the sliced cherry tomatoes and salt, and mix well.",
      "Cover the pan and cook for 15 minutes.",
      "In a separate pot, boil salted water and cook the pasta according to package directions.",
      "Uncover the cooked tomatoes, stir to evaporate moisture, and allow an orange-colored oil to form.",
      "Add the cooked pasta and a splash of pasta water, and mix well.",
      "Grate in Parmesan cheese and mix.",
      "Tear in basil leaves and mix. Serve immediately."
    ]
  },
  {
    "name": "Salmon Confit",
    "url": "https://youtu.be/bva2Q2rIF_4",
    "uploader": "한신희",
    "upload_date": "2025-10-28",
    "ingredients": [
      "Salmon",
      "Garlic",
      "Shallots",
      "Garlic scapes",
      "Shio kombu",
      "Salt",
      "Lemon peel",
      "Lemon juice",
      "Lemon zest",
      "White wine",
      "White wine vinegar",
      "Butter",
      "Olive oil"
    ],
    "steps": [
      "Pat salmon dry with paper towels.",
      "Cut salmon into desired portions and trim edges.",
      "Season salmon with salt.",
      "Place salmon, olive oil, crushed garlic, and lemon peel in a vacuum-sealable bag and vacuum seal.",
      "Set sous vide machine to 48°C and confit the vacuum-sealed salmon for 25 minutes.",
      "Thinly slice shallots, place in a pot, add white wine and vinegar, and reduce by two-thirds.",
      "Remove from heat and emulsify by gradually whisking in cold butter, one piece at a time.",
      "Add lemon juice and strain through a sieve to complete the Lemon Beurre Blanc sauce.",
      "Cut garlic scapes into oblique slices.",
      "Blanch garlic scapes in salted water for 3 seconds, then mix with leftover confit oil and minced shio kombu to create a garnish.",
      "Arrange the salmon confit, beurre blanc sauce, and garlic scape garnish nicely on a plate."
    ]
  },
  {
    "name": "Ricotta Stuffed Squash Blossom Fritters",
    "url": "https://youtu.be/WA7YEsIPNeU",
    "uploader": "미뇨끼",
    "upload_date": "2025-07-28",
    "ingredients": [
      "Squash blossoms",
      "Ricotta cheese",
      "Basil",
      "Lemon zest",
      "Anchovy",
      "Flour",
      "Beer",
      "Oil"
    ],
    "steps": [
      "Pick the squash blossoms.",
      "Gently remove the pistil/stamen from inside each blossom.",
      "In a bowl, mix ricotta cheese, basil, lemon zest, and anchovy to create the filling.",
      "Carefully open each blossom, fill with the ricotta mixture, and twist the petals to seal.",
      "Whisk together flour and beer to make a light batter.",
      "Dip the stuffed blossoms into the batter, ensuring they are fully coated.",
      "Fry until golden brown and crispy."
    ]
  },
  {
    "name": "Chicken Breast",
    "url": "https://youtu.be/bjGfcXqN3Cs",
    "uploader": "한신희",
    "upload_date": "2025-10-30",
    "ingredients": [
      "Chicken Breast",
      "Salt",
      "Pepper",
      "Sugar",
      "Pickling Spice",
      "Garlic",
      "Olive Oil"
    ],
    "steps": [
      "Pan Frying: Pat dry the chicken breast.",
      "Pan Frying: Rub chicken breast with salt, pepper, olive oil, and minced garlic, then marinate.",
      "Pan Frying: Grill chicken breast in a medium-hot pan for 3 minutes per side.",
      "Pan Frying: Cover and let rest for 5 minutes.",
      "Pan Frying: Cut the cooked chicken breast in half and check the cross-section.",
      "Boiling (30 min): Add a generous amount of salt to boiling water.",
      "Boiling (30 min): Add chicken breast, cover, and wait for 30 minutes.",
      "Boiling (30 min): Remove the boiled chicken breast, cut in half, and check the cross-section.",
      "Confit: Place chicken breast, olive oil, salt, and pepper into a vacuum bag and seal.",
      "Confit: Cook using a sous vide machine at 62.5°C for 1 hour and 30 minutes.",
      "Confit: Remove the cooked chicken breast, cut in half, and check the cross-section.",
      "Sous Vide: Mix water, salt, sugar, and pickling spice to make a brine solution.",
      "Sous Vide: Place chicken breast and brine solution into a vacuum bag and seal.",
      "Sous Vide: Cook using a sous vide machine at 62.5°C for 1 hour and 30 minutes.",
      "Sous Vide: Remove the cooked chicken breast, cut in half, and check the cross-section."
    ]
  },
  {
    "name": "Spring Greens and Shrimp Porridge",
    "url": "https://youtu.be/ROOSaLvT7CU",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2025-12-23",
    "ingredients": [
      "Whiteleg Shrimp",
      "Manila Clams",
      "Rice",
      "Rapeseed Greens",
      "Chamnamul",
      "Sebalnamul",
      "Dried Shrimp",
      "Paprika Powder",
      "Garlic",
      "Sesame Seeds",
      "Sesame Oil",
      "Olive Oil"
    ],
    "steps": [
      "Briefly blanch the rapeseed greens, then rinse them in cold water and set aside.",
      "Wash the rice and let it soak.",
      "Wash the chamnamul and finely chop it.",
      "Finely chop the rapeseed greens as well.",
      "Heat oil in a pan and cook the shrimp.",
      "Before the shrimp overcooks, add the Manila clams."
    ]
  },
  {
    "name": "Samgyetang Risotto",
    "url": "https://youtu.be/ZAy5cI0y_AI",
    "uploader": "미뇨끼",
    "upload_date": "2025-07-30",
    "ingredients": [
      "Samgyetang",
      "Onion",
      "Risotto rice",
      "Scallions",
      "Salt",
      "Parmesan cheese",
      "Olive oil",
      "White wine",
      "Butter"
    ],
    "steps": [
      "Heat the chicken and broth from the packaged Samgyetang in a pan.",
      "Remove the chicken and debone, shredding the meat.",
      "Sauté the onion in olive oil with a pinch of salt until softened.",
      "Add the risotto rice and sauté briefly.",
      "Pour in white wine and bring to a boil to evaporate.",
      "Gradually add Samgyetang broth, stirring for at least 17 minutes until the rice is cooked.",
      "Stir the shredded chicken into the risotto.",
      "Turn off the heat, then stir in cold butter, Parmesan cheese, and scallions.",
      "Serve the Samgyetang risotto in a bowl.",
      "Drizzle with olive oil to finish."
    ]
  },
  {
    "name": "Tomato Sauce",
    "url": "https://youtu.be/y8McjoZOBtE",
    "uploader": "미뇨끼",
    "upload_date": "2025-08-06",
    "ingredients": [
      "Tomatoes"
    ],
    "steps": [
      "Sterilize glass jars in hot water.",
      "Cut tomatoes in half.",
      "Place cut tomatoes in a pot and add water.",
      "Boil the tomatoes.",
      "Strain the boiled tomatoes to remove excess water.",
      "Pass the strained tomatoes through a food mill to make the sauce.",
      "Pour the prepared tomato sauce into the sterilized jars.",
      "Close the jar lids.",
      "Place the jars containing the sauce in a pot and boil to seal them."
    ]
  },
  {
    "name": "Gat Kimchi Agnolotti",
    "url": "https://youtu.be/L8F1dVt4Q_E",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2026-01-01",
    "ingredients": [
      "Gat Kimchi",
      "Ricotta cheese",
      "Jamon",
      "Kimchi juice",
      "Kimchi stems"
    ],
    "steps": [
      "Separate Gat Kimchi leaves and stems.",
      "Squeeze liquid from Gat Kimchi leaves to use in pasta dough.",
      "Make the filling with squeezed Gat Kimchi leaves, ricotta cheese, and jamon.",
      "Prepare pasta dough using kimchi juice.",
      "Form agnolotti with the dough and filling.",
      "Grill Gat Kimchi stems for a smoky flavor and use as garnish."
    ]
  },
  {
    "name": "Braised Pork Rib Kimchi Stew",
    "url": "https://youtu.be/kKu833DX70Y",
    "uploader": "한신희",
    "upload_date": "2025-11-07",
    "ingredients": [
      "Pork ribs",
      "Pork shoulder",
      "Kimchi",
      "Green onions",
      "Red chili pepper",
      "Ginger",
      "Dried pollack",
      "Kelp",
      "Dried small fish",
      "Gochugaru",
      "Saeujeot",
      "Brown sugar",
      "Bay leaves"
    ],
    "steps": [
      "Blanch pork ribs with ginger, bay leaves, and water for 10 minutes, then remove impurities.",
      "Cut pork shoulder into large pieces.",
      "In a pot, add dried pollack, dried small fish, kelp, and water, then simmer on low heat for 40 minutes to prepare the broth.",
      "Add kimchi, blanched pork ribs, and sliced pork shoulder to the pot.",
      "Add the prepared broth, gochugaru, and saeujeot, then mix.",
      "Cover and simmer on medium heat for 1 hour.",
      "Slice green onions and red chili pepper diagonally.",
      "Add the sliced green onions and red chili pepper to the simmering kimchi jjim and mix.",
      "Serve in a bowl."
    ]
  },
  {
    "name": "Pork Neck Bossam Wraps",
    "url": "https://youtu.be/5JNsrzLzvfI",
    "uploader": "한신희",
    "upload_date": "2025-11-10",
    "ingredients": [
      "Pork Neck Fillet",
      "Oysters",
      "Radish",
      "Green Onion",
      "Perilla Leaves",
      "Doenjang (Korean Soybean Paste)",
      "Corn Syrup",
      "Salt",
      "Red Chili Powder",
      "Garlic",
      "Seasoning Sauce",
      "Barley Ssamjang",
      "Sesame Seeds",
      "Sesame Oil",
      "MSG"
    ],
    "steps": [
      "Bring water to a boil with doenjang, green onion, and MSG.",
      "Once boiling, add the pork neck fillet, close the lid, and simmer over low heat for 1 hour.",
      "After turning off the heat, let the meat rest in the pot for 20-30 minutes before removing.",
      "Slice the cooked pork neck fillet into bite-sized pieces.",
      "Julienne the radish into 0.5cm thick strips.",
      "Marinate the julienned radish with corn syrup and salt for 20 minutes.",
      "Squeeze out excess water from the marinated radish.",
      "To the squeezed radish, add red chili powder, corn syrup, garlic, seasoning sauce, and ground sesame seeds, then mix to make spicy radish salad (Musaengchae).",
      "Mix ground sesame seeds and sesame oil into the barley ssamjang to make ssamjang.",
      "Arrange oysters, perilla leaves, sliced pork neck fillet, spicy radish salad, and ssamjang on a serving plate."
    ]
  },
  {
    "name": "Bracken Fern Pasta",
    "url": "https://youtu.be/V64TDgH2pdY",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2026-01-06",
    "ingredients": [
      "Bracken Fern",
      "Linguine",
      "Green Onion",
      "Garlic",
      "Peperoncino",
      "Parmesan Cheese",
      "Soy Sauce",
      "Black Pepper",
      "Tuna Sauce",
      "Olive Oil",
      "Perilla Oil",
      "Butter",
      "Perilla Seed Powder",
      "Salt"
    ],
    "steps": [
      "Wash bracken fern and squeeze out excess water.",
      "Tear thicker bracken fern strands.",
      "Cut bracken fern in half.",
      "Thinly slice green onion and soak in cold water to remove pungency.",
      "Roughly chop garlic.",
      "Heat olive oil in a pan and sauté half of the garlic.",
      "Before garlic browns, add bracken fern and sauté.",
      "Add a pinch of black pepper.",
      "Sauté bracken fern until slightly charred. Meanwhile, boil pasta for 4 minutes.",
      "Add 1/2 tablespoon soy sauce to the bracken fern.",
      "Once bracken fern is cooked, remove from pan. Add 2 tablespoons olive oil to the pan.",
      "Add remaining garlic to the pan.",
      "Crush and add 1.5 peperoncinos.",
      "Add 240ml pasta water to the pan.",
      "Add 1/2 tablespoon butter.",
      "Add 1/2 tablespoon tuna sauce.",
      "Add pasta.",
      "Once pasta is partially cooked, add bracken fern back into the pan.",
      "Reduce heat to medium and add 20g Parmigiano-Reggiano cheese.",
      "Turn off heat and emulsify.",
      "Add 0.5 tablespoon perilla seed powder.",
      "Drizzle with a tiny bit of perilla oil.",
      "Plate the pasta and drain the green onion.",
      "Sprinkle with Parmigiano-Reggiano cheese and black pepper."
    ]
  },
  {
    "name": "Beef and Octopus Porridge",
    "url": "https://youtu.be/3d4t2S-yrqg",
    "uploader": "한신희",
    "upload_date": "2025-11-12",
    "ingredients": [
      "Beef",
      "Octopus",
      "Onion",
      "Scallions",
      "Carrot",
      "Anchovies",
      "Kelp",
      "Soy sauce",
      "Pear juice",
      "Onion juice",
      "Green plum extract",
      "Brown sugar",
      "Minced garlic",
      "Black pepper",
      "Rice",
      "Cooking oil",
      "Sesame oil"
    ],
    "steps": [
      "Grate radish and squeeze out the juice.",
      "Marinate beef with pear juice, minced garlic, black pepper, and sesame oil.",
      "Cut octopus into bite-sized pieces, and mince scallions and carrots.",
      "In a pot, add water, anchovies, kelp, and minced garlic, then boil to make a broth.",
      "Heat olive oil in a pan and stir-fry the marinated beef.",
      "Add grated radish, minced scallions, and minced carrots to the cooked beef and stir-fry together.",
      "Strain the prepared broth and pour it into the pan, then bring to a boil.",
      "Add cooked rice and the sliced octopus, then mix well.",
      "Cook until the porridge thickens.",
      "Serve the porridge in a bowl, garnished with stir-fried beef, octopus, scallions, sesame seeds, and seaweed."
    ]
  },
  {
    "name": "Monkfish Liver Salt Gimbap",
    "url": "https://youtu.be/i2CZxlkvpRA",
    "uploader": "한신희",
    "upload_date": "2025-11-15",
    "ingredients": [
      "Monkfish liver",
      "Large green onion",
      "Scallions",
      "Mirin",
      "Tequila",
      "Soy sauce",
      "Cheongju",
      "Sesame oil",
      "Butter",
      "Cooked rice",
      "Shio konbu",
      "Seaweed",
      "Sesame seeds"
    ],
    "steps": [
      "Remove blood vessels and membranes from the monkfish liver.",
      "Briefly soak the monkfish liver in mirin and tequila to remove any fishy smell.",
      "Blanch the monkfish liver and large green onions in water (around 90°C) for 10 minutes.",
      "Drain the blanched monkfish liver and simmer it with regular soy sauce, mirin, light soy sauce (usukuchi), and cheongju over low heat.",
      "Strain the simmered monkfish liver through a fine sieve and mash it.",
      "Add butter to the mashed monkfish liver for added flavor.",
      "Mix shio konbu and sesame oil into the rice.",
      "Combine sesame salt, sesame oil, and finely chopped scallions to make the filling.",
      "Spread the sesame salt filling in a single line on the rice.",
      "Tightly roll the gimbap using plastic wrap, then slice it into uniform pieces and arrange on a plate.",
      "Generously top the sliced gimbap with the monkfish liver.",
      "Finish by sprinkling a generous amount of chopped scallions."
    ]
  },
  {
    "name": "Herb-Crusted Salmon",
    "url": "https://youtu.be/4Sd5GP03DaM",
    "uploader": "미뇨끼",
    "upload_date": "2025-08-21",
    "ingredients": [
      "Salmon fillet",
      "Potatoes",
      "Asparagus",
      "Parsley",
      "Dill",
      "Rosemary",
      "Lemon salt",
      "Salt",
      "Breadcrumbs",
      "Olive oil",
      "Butter",
      "Milk"
    ],
    "steps": [
      "Add breadcrumbs, parsley, dill, rosemary, olive oil, and lemon salt to a blender.",
      "Blend until well combined.",
      "Lightly grease a parchment-lined baking tray with olive oil.",
      "Place the salmon fillet on the tray.",
      "Generously top the salmon fillet with the breadcrumb mixture.",
      "Bake in a preheated 180°C oven for 15 minutes.",
      "Make potato puree by mashing boiled potatoes with butter and milk until smooth.",
      "Spread the potato puree evenly on a plate.",
      "Sauté asparagus in butter until tender.",
      "Arrange the sautéed asparagus over the potato puree.",
      "Season the asparagus with salt.",
      "Serve the baked salmon and enjoy."
    ]
  },
  {
    "name": "Uni Butter Pasta",
    "url": "https://youtu.be/ILAYlxgdXYM",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2026-01-07",
    "ingredients": [
      "uni",
      "spaghettini",
      "anchovies",
      "peperoncino",
      "parsley",
      "minced garlic",
      "tuna sauce",
      "salt",
      "pepper",
      "white wine",
      "butter",
      "olive oil"
    ],
    "steps": [
      "Finely chop the anchovies.",
      "Add 6g of salt to 1L of water and boil the pasta for 6 minutes.",
      "Heat 2T olive oil in a pan.",
      "Add anchovies and sauté.",
      "Add 1 tsp minced garlic.",
      "Add 1.5 peperoncino.",
      "Add 2T white wine.",
      "Add 300ml pasta water.",
      "Add 1T tuna sauce.",
      "Season generously with pepper.",
      "Add the pasta.",
      "Add butter.",
      "Drizzle with olive oil.",
      "Reduce until the sauce thickens.",
      "Transfer to a plate and top with uni.",
      "Garnish with parsley and a drizzle of olive oil."
    ]
  },
  {
    "name": "Korean Style Rice Salad",
    "url": "https://youtu.be/16fVB1GsKdA",
    "uploader": "미뇨끼",
    "upload_date": "2025-08-24",
    "ingredients": [
      "Arborio rice",
      "Cherry tomatoes",
      "Red onion",
      "Eggplant",
      "Zucchini",
      "Corn",
      "Black olives",
      "Peperoncino",
      "Tuna",
      "Parsley",
      "Salt",
      "Olive oil"
    ],
    "steps": [
      "Boil water in a pot.",
      "Add salt to the boiling water.",
      "Add Arborio rice and cook until the grains are plump and tender.",
      "Drain the cooked rice thoroughly in a colander and let it cool.",
      "Halve the cherry tomatoes.",
      "Finely chop the red onion.",
      "In a large bowl, combine the halved cherry tomatoes, chopped red onion, and corn.",
      "Season with salt and drizzle with olive oil.",
      "Dice the eggplant.",
      "Dice the zucchini.",
      "Heat a generous amount of olive oil in a pan and sauté the diced eggplant until golden brown.",
      "Add the diced zucchini to the sautéed eggplant and cook for a little longer.",
      "Transfer the sautéed eggplant and zucchini to a bowl.",
      "Add the cooled rice and tuna packed in olive oil.",
      "Add black olives, peperoncino, and chopped parsley, then mix well until all ingredients are evenly combined.",
      "Wait until the dish is completely cooled."
    ]
  },
  {
    "name": "Green Laver Clam Chowder",
    "url": "https://youtu.be/WbpuqgQbvXM",
    "uploader": "한신희",
    "upload_date": "2025-11-19",
    "ingredients": [
      "Manila clams",
      "Surf clams",
      "Shallots",
      "Celery",
      "Carrots",
      "Potatoes",
      "Bacon",
      "Green laver",
      "Chives",
      "White wine",
      "Salt",
      "Pepper",
      "Cream",
      "Garlic",
      "Butter",
      "Flour"
    ],
    "steps": [
      "Purge the clams in saltwater.",
      "Place the purged clams in a pot with white wine, water, and crushed garlic, then boil for 7 minutes.",
      "Strain the clam broth through a fine-mesh sieve lined with cheesecloth.",
      "Remove the clam meat from their shells and roughly chop.",
      "Strain the clam broth again through the finest-mesh sieve.",
      "Dice the shallots, celery, carrots, potatoes, and bacon into small cubes.",
      "In a pot, melt the butter and render the fat from the bacon.",
      "Add the shallots, season with salt and pepper, then add the carrots and potatoes and sauté.",
      "Sift in the flour, then add the chopped clam meat and celery.",
      "Pour in the clam broth and cream, and simmer gently until thickened.",
      "Once the carrots are tender, turn off the heat, add the green laver, and mix well.",
      "Serve the finished soup in bowls and garnish with a sprinkle of chopped chives in the center.",
      "Serve alongside hand-torn baguette."
    ]
  },
  {
    "name": "Seasoned Oyster Mushrooms",
    "url": "https://youtu.be/aYWlzG-ldQA",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2026-01-09",
    "ingredients": [
      "Oyster Mushrooms",
      "Soy Sauce",
      "Oyster Sauce",
      "Perilla Powder",
      "Mayonnaise",
      "Salt",
      "Black Pepper",
      "Perilla Oil",
      "Olive Oil",
      "Sesame Seeds"
    ],
    "steps": [
      "Tear the mushrooms into small pieces.",
      "In a pot, combine mayonnaise, soy sauce, oyster sauce, perilla powder, perilla oil, and black pepper, then mix.",
      "Once the water boils, season with salt.",
      "Add the mushrooms and blanch.",
      "Once the mushrooms soften, squeeze out the water and remove.",
      "Let the mushrooms cool slightly.",
      "Heat olive oil in a pan and stir-fry the mushrooms.",
      "Stir-fry until the moisture from the mushrooms has evaporated.",
      "Sprinkle with salt.",
      "Spread them in a wide pan to cool.",
      "Put the mushrooms in a mixing bowl, add the sauce, and mix well.",
      "Transfer to a serving dish and sprinkle with sesame seeds."
    ]
  },
  {
    "name": "Carbonara",
    "url": "https://youtu.be/xgoM4cMQG9w",
    "uploader": "미뇨끼",
    "upload_date": "2025-08-27",
    "ingredients": [
      "Iberico guanciale",
      "pasta",
      "eggs",
      "Pecorino Romano cheese",
      "Grana Padano cheese",
      "black pepper",
      "salt"
    ],
    "steps": [
      "Remove the rind from the Iberico guanciale and cut into thick strips.",
      "Slowly render the guanciale over low heat until crispy.",
      "Grate Pecorino Romano and Grana Padano cheeses.",
      "Separate egg yolks into a bowl, then add the grated cheese and black pepper and mix well.",
      "Cook pasta in salted boiling water until al dente.",
      "Set aside the crispy guanciale. Add the rendered guanciale fat to the egg and cheese mixture in the bowl.",
      "Transfer the cooked pasta directly into the sauce bowl.",
      "Add one ladle of pasta cooking water to the sauce and mix vigorously.",
      "Place the sauce bowl over the still-boiling water (double boiler style) and stir continuously to emulsify into a creamy sauce without scrambling the eggs.",
      "Serve immediately, topped with crispy guanciale and extra grated cheese."
    ]
  },
  {
    "name": "Carabinero, Yellowtail, and Scallop Pot Rice",
    "url": "https://youtu.be/B52wqRTH7Aw",
    "uploader": "한신희",
    "upload_date": "2025-11-23",
    "ingredients": [
      "Carabinero shrimp",
      "Yellowtail",
      "Scallops",
      "Wild garlic",
      "Green olives",
      "Rice",
      "Soy sauce",
      "Pickle brine",
      "Olive oil",
      "Kelp broth"
    ],
    "steps": [
      "Prepare the yellowtail fillet.",
      "Clean and dice the scallop adductor muscles.",
      "Separate heads and shells from carabinero shrimp.",
      "Combine carabinero shrimp head innards, chopped wild garlic, pickle brine, and soy sauce to make a seasoning sauce.",
      "Heat olive oil in a pan, lightly sauté carabinero shells, then add kelp broth and simmer to make a stock. Strain the stock.",
      "Place rice (soaked for 2 hours) and an equal amount of stock in a pot. Cover and cook over medium-low heat for 10 minutes.",
      "Top the rice with chopped wild garlic and halved green olives.",
      "Grill the yellowtail until golden brown and place it on top of the pot rice.",
      "Cover and let steam for 10 minutes.",
      "Place the prepared scallop adductor muscles and carabinero shrimp on the steamed pot rice.",
      "Drizzle with the seasoning sauce to finish."
    ]
  },
  {
    "name": "Bruschetta",
    "url": "https://youtu.be/2qR0sjkcK0Y",
    "uploader": "미뇨끼",
    "upload_date": "2025-08-29",
    "ingredients": [
      "Cherry tomatoes",
      "Bread",
      "Salt",
      "Oregano",
      "Basil",
      "Garlic",
      "Olive oil"
    ],
    "steps": [
      "Cut cherry tomatoes into quarters.",
      "Place cut tomatoes in a bowl.",
      "Season tomatoes generously with salt.",
      "Add oregano.",
      "Add basil leaves.",
      "Add olive oil, mix well, and set aside.",
      "Toast two slices of bread in a pan with generous olive oil until golden brown.",
      "Transfer the toasted bread to a plate.",
      "Rub garlic on the toasted bread.",
      "Spoon the tomato mixture onto the bread.",
      "Drizzle with the accumulated tomato juices.",
      "Garnish with basil leaves."
    ]
  },
  {
    "name": "Amberjack Tartare",
    "url": "https://youtu.be/2VT0fRI3IJI",
    "uploader": "한신희",
    "upload_date": "2025-11-25",
    "ingredients": [
      "Amberjack",
      "Gold kiwi",
      "Kombu",
      "Pickled shallots",
      "Pickled chilies",
      "Chives",
      "Egg",
      "Miso paste",
      "Dijon mustard",
      "Sake",
      "Lime",
      "Black pepper",
      "Chili oil"
    ],
    "steps": [
      "Separate the amberjack loin.",
      "Soak kombu in sake, then wrap it around the amberjack loin for kombu-jime curing.",
      "Peel and dice the gold kiwi.",
      "In a mixing bowl, combine miso paste, soft-boiled egg yolk, minced pickled shallots, minced pickled chilies, and Dijon mustard.",
      "Add grated lime zest, lime juice, and freshly ground black pepper, then mix well.",
      "Add chopped chives.",
      "Dice the kombu-jime amberjack and add it to the mixing bowl.",
      "Add gold kiwi and chili oil, then mix everything together.",
      "Place a mold on a plate and arrange the tartare neatly inside.",
      "Grate lime zest over the tartare.",
      "Pipe the remaining soft-boiled egg yolk on top for decoration."
    ]
  },
  {
    "name": "Sea Urchin Seaweed Soup",
    "url": "https://youtu.be/vXXMgeqVp3U",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2026-01-10",
    "ingredients": [
      "Sea urchin roe",
      "Seaweed",
      "Soy sauce",
      "Clam seasoning",
      "Sesame oil"
    ],
    "steps": [
      "Rinse the sea urchin with sea water or salt water.",
      "Wash the seaweed thoroughly.",
      "Place the seaweed in a pot and stir-fry.",
      "Gradually add rice washing water while stir-frying the seaweed.",
      "Add 500ml of rice washing water.",
      "Add 1 tablespoon of soy sauce.",
      "Add the sea urchin roe.",
      "Add 1/3 teaspoon of clam seasoning."
    ]
  },
  {
    "name": "Monkfish Tacos",
    "url": "https://youtu.be/wsZkKsLfCHk",
    "uploader": "한신희",
    "upload_date": "2025-11-27",
    "ingredients": [
      "Monkfish fillet",
      "Red cabbage",
      "Red onion",
      "Jalapeño",
      "Avocado",
      "Salt",
      "Pepper",
      "Dijon mustard",
      "Lime zest",
      "Lime juice",
      "Honey",
      "Mayonnaise",
      "Sriracha sauce",
      "Smoked paprika",
      "Garlic",
      "Cilantro",
      "Olive oil",
      "Corn flour",
      "All-purpose flour",
      "Baking powder",
      "Frying mix",
      "Oil"
    ],
    "steps": [
      "Pat dry the monkfish fillet, cut into thick pieces, and season with salt and pepper.",
      "Thinly shred the red cabbage, then mix with Dijon mustard, lime zest, lime juice, honey, and salt to make a lime slaw.",
      "Thinly slice the red onion and soak in cold water.",
      "Finely mince the jalapeño and mix with mayonnaise, Sriracha, smoked paprika, and pepper to make Sriracha mayo sauce.",
      "Cut the avocado, then blend with minced jalapeño, onion, lime zest, lime juice, olive oil, garlic, and a pinch of salt to make avocado salsa.",
      "Combine corn flour, all-purpose flour, a little oil, baking powder, and warm water, then knead well to make a dough."
    ]
  },
  {
    "name": "White Chicken Ragu Inari Sushi",
    "url": "https://youtu.be/bycgSKmr578",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2026-01-13",
    "ingredients": [
      "Chicken tenderloin",
      "Onion",
      "Button mushrooms",
      "Minced garlic",
      "Fried tofu pockets",
      "Cooked rice",
      "Milk",
      "Parmesan cheese",
      "Mozzarella cheese",
      "Cheddar cheese",
      "Salt",
      "Pepper",
      "Sugar",
      "Vinegar",
      "Oyster sauce",
      "Olive oil",
      "White wine",
      "Truffle oil",
      "Truffle paste",
      "Dried parsley",
      "Furikake",
      "Parmesan crisps"
    ],
    "steps": [
      "Make sushi vinegar by mixing sugar, vinegar, and salt.",
      "Mix cooked rice with sushi vinegar and furikake, then let cool.",
      "Heat olive oil in a pan and add minced garlic.",
      "Dice the onion.",
      "Add diced onion and sauté over low heat.",
      "Slice button mushrooms.",
      "Once onion is transparent, season with salt and pepper.",
      "Add mushrooms and sauté.",
      "Season with salt and pepper.",
      "Cut the chicken tenderloin.",
      "Add more olive oil, then add chicken and cook.",
      "Drizzle with white wine.",
      "Increase heat to high.",
      "Pour in milk until chicken is partially submerged.",
      "Season with salt.",
      "Sprinkle with Parmesan cheese.",
      "Add oyster sauce.",
      "Sprinkle with parsley.",
      "Plate the ragu, drizzle with truffle oil, and let cool.",
      "Fill fried tofu pockets 80% with rice, then top generously with the ragu."
    ]
  },
  {
    "name": "Black Pepper Beef",
    "url": "https://youtu.be/T-nXL1yLF4o",
    "uploader": "한신희",
    "upload_date": "2025-11-29",
    "ingredients": [
      "Beef tenderloin",
      "Bell pepper",
      "Jalapeño",
      "Button mushrooms",
      "Garlic",
      "Red chili pepper",
      "Green onion",
      "Ginger",
      "Soy sauce",
      "Ketchup",
      "Pepper",
      "MSG",
      "Salt",
      "Sugar",
      "Cooking wine",
      "Oil",
      "Butter",
      "Flour",
      "Starch"
    ],
    "steps": [
      "Slice the beef tenderloin into bite-sized pieces and sprinkle with salt.",
      "Remove the seeds from the bell pepper and jalapeño and dice them.",
      "Brush off the dirt from the button mushrooms and cut them into quarters.",
      "Mix soy sauce, ketchup, pepper, MSG, sugar, and water to make a sauce.",
      "Thinly slice the garlic and fry in oil until crispy.",
      "In a pot, melt butter, add flour, and sauté for 1 minute."
    ]
  },
  {
    "name": "Gochujang Butter Roasted Chicken",
    "url": "https://youtu.be/f--TPhg1nFY",
    "uploader": "한신희",
    "upload_date": "2025-12-02",
    "ingredients": [
      "Chicken",
      "Bacon",
      "Spinach",
      "Cremini Mushrooms",
      "Asparagus",
      "Garlic",
      "Lime Zest",
      "Orzo",
      "Gochujang",
      "Grana Padano Cheese",
      "Laoganma",
      "Heavy Cream",
      "Salt",
      "Sugar",
      "Smoked Paprika Powder",
      "Black Pepper",
      "Butter",
      "Oil"
    ],
    "steps": [
      "Trim excess fat from the chicken and pat dry with paper towels.",
      "Combine butter, gochujang, lime zest, garlic, Grana Padano cheese, Laoganma, and sugar to make gochujang butter.",
      "Cut cremini mushrooms, spinach, and asparagus into bite-sized pieces.",
      "Cook orzo pasta al dente in salted water.",
      "Heat oil in a pan and cook bacon until crispy to render its fat.",
      "Add the prepared vegetables to the bacon pan and sauté.",
      "Add heavy cream, gochujang, paprika powder, salt, and pepper, then reduce by half.",
      "Add the cooked orzo pasta and continue to reduce until thick to complete the stuffing.",
      "Once the stuffing has cooled slightly, fill it into the chicken.",
      "Thoroughly spread the gochujang butter over and under the chicken skin.",
      "Truss the chicken.",
      "Roast the chicken in a 160°C oven for 1 hour until done."
    ]
  },
  {
    "name": "Creamy Shin Ramyun with Uni",
    "url": "https://youtu.be/SGLA9PuXze0",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2026-01-14",
    "ingredients": [
      "Red onion",
      "Minced garlic",
      "Cheongyang chili pepper",
      "Instant noodles",
      "Uni (sea urchin roe)",
      "Red pepper powder",
      "Instant noodle seasoning packet",
      "Black pepper",
      "Olive oil",
      "Milk",
      "Parsley"
    ],
    "steps": [
      "Slice the red onion into medium pieces.",
      "Heat olive oil in a pan and sauté the red onion.",
      "Add minced garlic and continue to sauté.",
      "Stir in red pepper powder.",
      "Pour in water and the instant noodle seasoning packet.",
      "While it boils, slice the Cheongyang chili.",
      "Add the instant noodles and sliced Cheongyang chili.",
      "Gradually add milk and bring to a simmer.",
      "Stir in olive oil until creamy.",
      "Serve in a bowl and top with uni.",
      "Garnish with parsley, black pepper, and a drizzle of olive oil."
    ]
  },
  {
    "name": "Witch's Soup",
    "url": "https://youtu.be/psDwsxCcdpI",
    "uploader": "한신희",
    "upload_date": "2025-12-04",
    "ingredients": [
      "Cabbage",
      "Red onion",
      "Tomatoes",
      "Celery",
      "Potatoes",
      "Carrots",
      "Garlic",
      "Chuck eye roll",
      "Tomato paste",
      "Smoked paprika",
      "Salt",
      "Pepper",
      "Olive oil",
      "Chicken broth",
      "Orzo pasta"
    ],
    "steps": [
      "Gather and prepare all vegetables.",
      "Cut the vegetables into bite-sized pieces.",
      "Pat the chuck eye roll dry with a paper towel, cut into cubes, and season with salt and pepper.",
      "Heat olive oil in a pot and brown the chuck eye roll.",
      "Add carrots and potatoes, then sauté with tomato paste in the meat drippings.",
      "Add all remaining vegetables (cabbage, celery, tomatoes, red onion, garlic) and mix.",
      "Add reduced chicken broth and bring to a boil.",
      "Stir in a generous amount of smoked paprika.",
      "Cover and simmer for 40 minutes.",
      "Season with salt and pepper to taste.",
      "Serve the finished Witch's Soup, optionally with orzo pasta."
    ]
  },
  {
    "name": "Tomato Polpette",
    "url": "https://youtu.be/dGr2z_nOUsM",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2026-01-16",
    "ingredients": [
      "Ground beef",
      "Ground pork",
      "Onion",
      "Shallot",
      "Kabocha squash",
      "Celery",
      "Whole peeled tomatoes",
      "Bread slices",
      "Garlic",
      "Bacon crumbles",
      "Salt",
      "Pepper",
      "Oregano",
      "Reggiano cheese",
      "Mozzarella cheese",
      "Shredded cheese",
      "Minced garlic",
      "Parsley",
      "Butter",
      "Milk",
      "Olive oil"
    ],
    "steps": [
      "Trim the crusts off the bread slices.",
      "Cut the bread into quarters and soak in milk.",
      "In a mixing bowl, combine ground beef, ground pork, minced garlic, oregano, salt, pepper, and Reggiano cheese.",
      "Squeeze excess milk from the soaked bread and add it to the mixing bowl, then mix well.",
      "Knead the meat mixture and form into balls.",
      "Finely chop the onion, heat olive oil in a pan, and sauté the onion until translucent.",
      "Add shallots, butter, and celery to the pan and sauté over low heat until softened.",
      "Dice the kabocha squash.",
      "Place the diced squash in a baking pan, drizzle with olive oil, season with salt and pepper, and roast in the oven until tender.",
      "Heat oil in a pan and cook the meatballs until browned on all sides.",
      "Add minced garlic to the tomato sauce.",
      "Pour whole peeled tomatoes into a mixing bowl and crush them.",
      "Add a little water, then pour the crushed tomatoes into a pan to create the sauce.",
      "Add oregano to the tomato sauce.",
      "Sprinkle with parsley.",
      "Season the tomato sauce with salt and pepper.",
      "Place the roasted kabocha squash on top of the tomato sauce.",
      "Arrange the meatballs on top of the sauce, cover with mozzarella cheese and shredded cheese, then bake in the oven until bubbly and golden.",
      "Finish by sprinkling with parsley."
    ]
  },
  {
    "name": "1952 Carbonara",
    "url": "https://youtu.be/rCQBF50BsAc",
    "uploader": "미뇨끼",
    "upload_date": "2025-09-10",
    "ingredients": [
      "Pasta",
      "Lardo",
      "Eggs",
      "Parmesan Cheese",
      "Salt",
      "Olive Oil",
      "Butter",
      "Black Pepper"
    ],
    "steps": [
      "Boil water, add salt, and cook pasta.",
      "Slice the lardo thinly.",
      "Render thinly sliced lardo in a pan with olive oil and butter.",
      "Whisk eggs in a bowl and set aside.",
      "Finely grate the Parmesan cheese.",
      "Immediately transfer the hot pasta to the bowl with the whisked eggs.",
      "Pour the hot rendered lardo fat over the pasta and mix quickly.",
      "Once the eggs are slightly cooked by the residual heat, add the grated Parmesan cheese and mix well.",
      "Add black pepper and mix again.",
      "Serve on plates and sprinkle with additional Parmesan cheese to finish."
    ]
  },
  {
    "name": "Bone-in Pork Loin Steak with Black Garlic Puree",
    "url": "https://youtu.be/z9O5kUCdAIM",
    "uploader": "한신희",
    "upload_date": "2025-12-06",
    "ingredients": [
      "Bone-in pork loin",
      "Black garlic",
      "Garlic",
      "Shallot",
      "Apple",
      "Thai basil",
      "Balsamic vinegar",
      "Whole grain mustard",
      "Salt",
      "Pepper",
      "Chicken stock",
      "Butter",
      "Oil"
    ],
    "steps": [
      "Score the fat on the pork loin, season with salt and pepper, and rub with olive oil.",
      "Peel the black garlic and halve the regular garlic.",
      "In a pan, sauté garlic in olive oil, then add butter, black garlic, and chicken stock, and reduce.",
      "Blend the reduced garlic mixture until smooth, then strain through a fine-mesh sieve.",
      "Dice the apple and shallot, then sauté in butter in a pan.",
      "Season the apple and shallot with salt and pepper, then add balsamic vinegar and whole grain mustard and reduce.",
      "Julienne the Thai basil and add it to the reduced apple and shallot mixture.",
      "In a preheated pan with olive oil, sear the pork loin standing on its fat side first.",
      "Once the fat has rendered sufficiently, sear both sides of the meat.",
      "Add a few garlic cloves to the pan and baste the pork while searing.",
      "Cook until the internal temperature reaches 65°C. Let it rest.",
      "Slice the pork loin and arrange on a plate with the black garlic puree.",
      "Garnish with the sautéed apple mixture and Thai basil to finish."
    ]
  },
  {
    "name": "Grapefruit Salad",
    "url": "https://youtu.be/bWhPZLAL8-s",
    "uploader": "한신희",
    "upload_date": "2025-12-10",
    "ingredients": [
      "Oro Blanco grapefruit",
      "Grapefruit",
      "Feta cheese",
      "Lime",
      "Apple mint",
      "Olive oil"
    ],
    "steps": [
      "Cut off the top and bottom of the grapefruit.",
      "Score the grapefruit peel vertically in 4 places and remove the peel.",
      "Separate the grapefruit segments.",
      "Remove the membrane from the grapefruit segments.",
      "Grate feta cheese onto a plate.",
      "Place the grapefruit segments on top of the feta cheese.",
      "Drizzle a little olive oil over the grapefruit.",
      "Grate more feta cheese over the grapefruit.",
      "Grate and sprinkle lime zest.",
      "Garnish with apple mint."
    ]
  },
  {
    "name": "Sweet Pumpkin Porridge",
    "url": "https://youtu.be/eLiM_aId75w",
    "uploader": "미뇨끼",
    "upload_date": "2025-09-14",
    "ingredients": [
      "Sweet Pumpkin",
      "Sweet Rice",
      "Kidney Beans",
      "Ginger",
      "Sweet Rice Balls",
      "Salt",
      "Allulose",
      "Pumpkin Broth"
    ],
    "steps": [
      "Place diced sweet pumpkin and soaked sweet rice in a pot.",
      "Pour pumpkin broth into the pot.",
      "Cover and simmer for about 10 minutes.",
      "Blend the pumpkin porridge until slightly coarse using an immersion blender.",
      "Season with salt and allulose to taste.",
      "Add kidney beans and ginger, then mix.",
      "Simmer over low heat for at least 20 minutes to adjust consistency.",
      "Boil the sweet rice balls in boiling water.",
      "Transfer the cooked sweet rice balls to the pumpkin porridge and mix.",
      "Continue to simmer briefly with the pumpkin porridge until the sweet rice balls are fully cooked.",
      "Serve the finished pumpkin porridge in bowls."
    ]
  },
  {
    "name": "Melon Gazpacho with Sweet Shrimp Tartare",
    "url": "https://youtu.be/duBcopu0T2s",
    "uploader": "한신희",
    "upload_date": "2025-12-12",
    "ingredients": [
      "Sweet shrimp",
      "Melon",
      "Tomato",
      "Avocado",
      "Dijon mustard",
      "Mayonnaise",
      "Lemon juice",
      "Salt",
      "Olive oil",
      "Chives",
      "Lemon zest",
      "Dill"
    ],
    "steps": [
      "Remove tails from sweet shrimp and cut into 3 pieces.",
      "Peel and deseed the melon, then cut into cubes.",
      "Score an 'X' on the tomatoes and blanch the surface with a torch to peel the skin.",
      "Cut a portion of the peeled tomatoes for blending with the melon.",
      "Blend melon, tomatoes, lemon juice, olive oil, and salt in a blender to make gazpacho.",
      "Strain the blended gazpacho through a sieve and chill in the refrigerator.",
      "Dice the remaining melon and tomatoes into small, neat cubes.",
      "In a bowl, combine diced melon, tomatoes, sweet shrimp, chopped chives, Dijon mustard, mayonnaise, lemon zest, and lemon juice, then mix well.",
      "Slice ripe avocado, add to the mixture, and season with salt to finish the tartare.",
      "Fill a circular mold with the tartare.",
      "Garnish with dill, then pour the chilled gazpacho over."
    ]
  },
  {
    "name": "Braised Pork Belly Kimchi Stew",
    "url": "https://youtu.be/aw6brbzDYqc",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2026-01-17",
    "ingredients": [
      "Aged Kimchi",
      "Pork Belly",
      "Dried Anchovies",
      "Onion",
      "Korean Radish",
      "Green Onion",
      "Cheongyang Chili Pepper",
      "Soy Sauce",
      "Salted Shrimp Paste",
      "Mirin",
      "Sugar",
      "Minced Garlic",
      "Minced Ginger",
      "Gochugaru",
      "Tuna Extract",
      "Black Pepper",
      "Cooking Oil",
      "Sesame Oil",
      "Sesame Seeds",
      "Kimchi Juice"
    ],
    "steps": [
      "Scrape off some chili flakes from the kimchi.",
      "Strain the kimchi juice.",
      "Cut Korean radish to line the bottom of the pot.",
      "Cut the onion into large pieces.",
      "Slice green onion and Cheongyang chili pepper diagonally.",
      "Heat cooking oil in a pot and sear the pork belly, starting with the skin side down.",
      "Once the pork is browned, remove it and sauté the radish in the rendered pork fat.",
      "Remove the radish, then add gochugaru and sesame oil to the pot.",
      "Stir to prevent burning, then add a little rice water.",
      "Arrange the radish and onion on the bottom of the pot.",
      "Add the seared pork belly and kimchi, then pour in rice water.",
      "Add soy sauce and salted shrimp paste.",
      "Add mirin and sugar.",
      "Add minced garlic and ginger.",
      "Add dried anchovies, then top with Cheongyang chili pepper and green onion.",
      "Pour in kimchi juice.",
      "Cover and simmer for 1 hour and 30 minutes.",
      "Add the green parts of the green onion and sprinkle with sesame seeds.",
      "Finish with a drizzle of sesame oil."
    ]
  },
  {
    "name": "Pumpkin Soup Pasta",
    "url": "https://youtu.be/-pPLJTCKwHU",
    "uploader": "미뇨끼",
    "upload_date": "2025-09-21",
    "ingredients": [
      "Pumpkin",
      "Pasta",
      "Salt",
      "Pepper",
      "Olive oil",
      "Peperoncino",
      "Garlic",
      "Parsley",
      "Parmesan cheese"
    ],
    "steps": [
      "Remove seeds from the pumpkin, peel, and chop into small pieces.",
      "Heat olive oil in a pot, then add peperoncino and garlic to infuse the oil.",
      "Add the chopped pumpkin, sprinkle with salt, and gently sauté until it softens and absorbs the oil.",
      "Remove the peperoncino and garlic.",
      "Pour in water and simmer until the pumpkin is soft enough to be mashed with a ladle.",
      "Mash the cooked pumpkin with a ladle.",
      "Break pasta into small pieces.",
      "Add the broken pasta and water to the mashed pumpkin, and cook until the pasta is tender.",
      "Add chopped parsley and pepper, and mix well.",
      "Add Parmesan cheese and mix well.",
      "Serve the finished soup pasta in a bowl and drizzle with olive oil."
    ]
  },
  {
    "name": "Gat Kimchi Agnolotti",
    "url": "https://youtu.be/_LtwW_RW1wU",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2026-01-20",
    "ingredients": [
      "Gat Kimchi",
      "Clams",
      "Salsiccia",
      "Prosciutto",
      "Bacon bits",
      "Onion",
      "Shallot",
      "Garlic",
      "Parsley",
      "Beetroot powder",
      "Manchego cheese",
      "Ricotta cheese",
      "Blue cheese",
      "White wine",
      "Pepper",
      "Salt",
      "Kimchi brine",
      "Butter",
      "Olive oil",
      "Perilla oil",
      "Bread flour",
      "Semolina",
      "Whole egg"
    ],
    "steps": [
      "Squeeze the brine from the Gat Kimchi.",
      "Heat oil in a pan, pan-fry the Gat Kimchi to extract its oil.",
      "Combine bread flour and semolina.",
      "Add the whole egg.",
      "Mix beetroot powder into the kimchi brine.",
      "Add the mixed kimchi brine to the dough ingredients.",
      "Mix all dough ingredients together.",
      "While the dough is being prepared, cool the extracted Gat Kimchi oil.",
      "Let the dough rest.",
      "Heat olive oil in a pan and add the clams.",
      "Add white wine, cover, and steam the clams to extract broth.",
      "Add water.",
      "Slice the onion, heat oil in a pan, and sauté until softened.",
      "Rinse the kimchi once with water.",
      "Once the onion is softened, add the garlic.",
      "Divide the Gat Kimchi into three parts, and finely chop the leafy parts.",
      "Combine chopped Gat Kimchi, ricotta cheese, prosciutto, salsiccia, blue cheese, parsley, and sautéed onion in a blender and process to make the filling.",
      "Set aside the Gat Kimchi oil.",
      "Strain the clam broth.",
      "Add shallots and pepper to the strained broth and reduce it.",
      "Roll out the pasta dough and cut it into squares.",
      "Pipe the prepared filling in a straight line onto the pasta squares using a pastry bag.",
      "Cover with another pasta sheet, press down with your thumb, then cut with a pasta cutter.",
      "Heat oil in a pan and crisp up the thicker parts of the Gat Kimchi until golden.",
      "Add salt to boiling water and cook the pasta.",
      "Add the prepared broth and butter to a pan.",
      "Once the pasta floats, transfer it to the sauce and reduce.",
      "Arrange the pan-fried Gat Kimchi on a plate, then top with the agnolotti.",
      "Mix kimchi oil, kimchi brine, and perilla oil.",
      "Drizzle a little sauce over the agnolotti, then sprinkle with bacon bits.",
      "Thinly slice and place Manchego cheese on top."
    ]
  },
  {
    "name": "Korean Beef Tartare",
    "url": "https://youtu.be/5miWe8fx8GU",
    "uploader": "한신희",
    "upload_date": "2025-12-15",
    "ingredients": [
      "Beef tenderloin",
      "Pickled gungchae stems",
      "Sweet persimmon",
      "Egg",
      "Sesame oil",
      "Salt",
      "Sesame seeds",
      "Garlic",
      "Yeondu (savory seasoning sauce)",
      "Chives",
      "Barley shrimp seaweed crisps"
    ],
    "steps": [
      "Slice the beef into small pieces.",
      "Finely chop the pickled gungchae stems and mix with the beef.",
      "Finely chop the chives.",
      "Prepare a seasoning sauce by mixing sesame oil, salt, sesame seeds, garlic, and Yeondu.",
      "Add the seasoning sauce to the beef mixture and toss to combine and season.",
      "Peel and slice the sweet persimmon to the same size as the beef, then mix into the beef mixture.",
      "Shape the yukhoe mixture using a round mold and place it on a serving plate.",
      "Salt-cure the egg yolk (for 2 days after sous vide).",
      "Grate the cured egg yolk over the yukhoe like cheese.",
      "Sprinkle chives over the yukhoe to finish.",
      "Serve with barley shrimp seaweed crisps on the side."
    ]
  },
  {
    "name": "Gnocchi alla Sorrentina",
    "url": "https://youtu.be/0r4B9AH7uf4",
    "uploader": "미뇨끼",
    "upload_date": "2025-09-24",
    "ingredients": [
      "potatoes",
      "fresh mozzarella",
      "basil",
      "tomato sauce",
      "flour"
    ],
    "steps": [
      "Steam potatoes.",
      "Mash the steamed potatoes.",
      "Mix flour into the mashed potatoes to form a dough.",
      "Cut the dough and shape into gnocchi.",
      "Toss gnocchi with tomato sauce.",
      "Add fresh mozzarella and basil.",
      "Transfer to an oven-safe dish.",
      "Air fry at 170°C for 15 minutes."
    ]
  },
  {
    "name": "Eight Treasure Duck",
    "url": "https://youtu.be/X6SJjQafKmo",
    "uploader": "한신희",
    "upload_date": "2025-12-18",
    "ingredients": [
      "Whole duck",
      "Glutinous rice",
      "Fresh shrimp",
      "Dried shrimp",
      "Lotus seeds",
      "Duck breast",
      "Chicken breast",
      "Shiitake mushrooms",
      "Bamboo shoots",
      "Oyster sauce",
      "Sesame oil",
      "Vinegar",
      "Corn syrup",
      "Cooking oil"
    ],
    "steps": [
      "Debone the whole duck, starting from the neck skin and following the bones.",
      "Brush the deboned duck with vinegar and corn syrup, then refrigerate for 12 hours to dry.",
      "Cut duck breast, chicken breast, shiitake mushrooms, bamboo shoots, lotus seeds, and fresh shrimp into 1cm cubes.",
      "Heat oil in a wok, add dried shrimp, and stir-fry.",
      "Add glutinous rice, prepared duck breast, chicken breast, shiitake mushrooms, bamboo shoots, lotus seeds, and fresh shrimp, then stir-fry together.",
      "Season the stir-fried filling with oyster sauce and sesame oil.",
      "Open the duck's neck and generously stuff it with the stir-fried filling.",
      "Sew the duck's neck opening closed.",
      "Tie the duck's waist tightly with string to create a gourd shape.",
      "Place in a steamer and steam for 2 hours.",
      "Transfer the steamed duck to a wok and continuously baste with preheated oil (around 220°C/430°F) until golden brown.",
      "Remove the string and thread, then plate and serve."
    ]
  },
  {
    "name": "Beef Bulgogi",
    "url": "https://youtu.be/sgvZOitT8LE",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2026-01-21",
    "ingredients": [
      "Beef chuck",
      "Onion",
      "Green onion",
      "Shiitake mushrooms",
      "Oyster mushrooms",
      "Perilla leaves",
      "Leafy greens",
      "Sugar",
      "Plum extract",
      "Soy sauce",
      "Sesame oil",
      "Minced garlic",
      "Black pepper",
      "Sesame seeds",
      "Cooking oil"
    ],
    "steps": [
      "Add sugar and plum extract and mix.",
      "Add soy sauce.",
      "Add sesame oil and minced garlic.",
      "Add black pepper, sesame seeds, and water.",
      "Set aside the prepared marinade.",
      "Marinate the meat in the prepared sauce.",
      "Slice the onion and green onion.",
      "Slice the shiitake mushrooms and tear the oyster mushrooms.",
      "Heat cooking oil in a pan.",
      "Sauté the oyster mushrooms and shiitake mushrooms.",
      "Sauté the onion.",
      "Sauté the marinated beef until the liquid evaporates.",
      "Add the sautéed mushrooms, onion, and green onion."
    ]
  },
  {
    "name": "Pan-Seared Duck Breast",
    "url": "https://youtu.be/SmV15W_S4BY",
    "uploader": "한신희",
    "upload_date": "2025-12-22",
    "ingredients": [
      "Duck",
      "Garlic",
      "Onion",
      "Coriander Seeds",
      "Tomato Paste",
      "Butter",
      "Salt",
      "Pepper",
      "Thyme",
      "Caraway",
      "Cumin Seeds",
      "Honey"
    ],
    "steps": [
      "Remove silver skin from duck, score the skin, and dry in the refrigerator for two days.",
      "Roast duck bones in the oven until crispy.",
      "In a pot, combine roasted duck bones, garlic, onion, coriander seeds, tomato paste, and water. Simmer for 6 hours, regularly skimming off foam.",
      "Strain the duck broth and reduce until sticky to create a duck jus.",
      "Once the duck jus begins to boil, slowly whisk in cold butter to emulsify the sauce.",
      "Season the dried duck breast generously with salt and pepper.",
      "Place duck breast skin-side down in a cold pan. Cook over low heat, pressing down to render fat evenly and achieve crispy skin.",
      "Sear the sides of the duck breast.",
      "Add thyme and butter, then baste the duck breast with the pan drippings.",
      "Remove duck from the pan, cover with foil, and rest for 20 minutes.",
      "In the same pan, add crushed caraway, cumin seeds, and coriander seeds. Stir in honey to create a glaze.",
      "Dip the rested duck breast in the prepared glaze to coat.",
      "Slice the duck breast in half, arrange on a plate, and drizzle with the remaining glaze to serve."
    ]
  },
  {
    "name": "Miso Cream Pasta",
    "url": "https://youtu.be/FZ6J_mmHhGY",
    "uploader": "한신희",
    "upload_date": "2025-12-24",
    "ingredients": [
      "Fusilli Lunghi Bucati",
      "Onion",
      "Garlic",
      "Bacon",
      "Pine nuts",
      "Jambon",
      "Dill",
      "Chicken broth",
      "Cream",
      "Miso",
      "Salt",
      "White wine",
      "Pepper",
      "Butter",
      "Olive oil"
    ],
    "steps": [
      "Finely chop the onion.",
      "Finely chop the garlic.",
      "Thinly slice the bacon.",
      "Add salt to boiling water and cook Fusilli Lunghi Bucati for 10 minutes, then drain.",
      "Heat olive oil in a pan and sauté the bacon.",
      "Add the chopped garlic and onion and sauté, then deglaze the pan with white wine.",
      "Toast the pine nuts in a pan until golden brown, then roughly chop them.",
      "Add the chopped pine nuts, chicken broth, cream, and miso to the pan and mix.",
      "Add the cooked pasta, pepper, butter, and dill, and mix until the butter melts.",
      "Plate the pasta.",
      "Top with jambon, and sprinkle with dill and toasted pine nuts to finish."
    ]
  },
  {
    "name": "Spicy Pork Stir-fry",
    "url": "https://youtu.be/elYpAx7a1Ek",
    "uploader": "한신희",
    "upload_date": "2025-12-27",
    "ingredients": [
      "Thinly Sliced Pork Belly",
      "Green Onions",
      "Dried Zucchini Strips",
      "Oyster Mushrooms",
      "Perilla Leaves",
      "Gochujang",
      "Gochugaru",
      "Lao Gan Ma",
      "Soy Sauce",
      "Garlic",
      "Ginger",
      "Yondu",
      "Brown Sugar",
      "Sansho Pepper Powder",
      "Mara Powder",
      "Sesame Oil",
      "Cooking Oil",
      "Sesame Seeds"
    ],
    "steps": [
      "Cut pork into bite-sized pieces.",
      "Finely mince garlic and ginger.",
      "Combine gochugaru, gochujang, Lao Gan Ma, sesame oil, soy sauce, Yondu, brown sugar, mara powder, minced garlic, and minced ginger to make the seasoning sauce.",
      "Slice green onions diagonally.",
      "Tear oyster mushrooms into large pieces.",
      "Soak dried zucchini strips in water, then cut larger pieces in half.",
      "Remove stems from perilla leaves and julienne them as thinly as possible.",
      "Heat a generous amount of cooking oil in a pan, add pork and oyster mushrooms, and stir-fry until the pork is about 50% cooked.",
      "Add dried zucchini strips, green onions, and the prepared seasoning sauce, then stir-fry, mixing well.",
      "Arrange the finished spicy pork stir-fry attractively on a plate.",
      "Garnish with thinly sliced perilla leaves, arranged like a nest, and sprinkle with sesame seeds.",
      "Wrap in lettuce and enjoy."
    ]
  },
  {
    "name": "BBQ Pork Ribs",
    "url": "https://youtu.be/VAAhb8vP2FE",
    "uploader": "한신희",
    "upload_date": "2025-12-28",
    "ingredients": [
      "Pork Ribs",
      "Button Mushrooms",
      "King Oyster Mushrooms",
      "Garlic",
      "Salt",
      "Black Pepper",
      "Sugar",
      "Thyme",
      "BBQ Sauce",
      "Wholegrain Mustard",
      "Honey",
      "Olive Oil"
    ],
    "steps": [
      "Remove the membrane from the pork ribs.",
      "Mix brown sugar, salt, black pepper, and thyme to make a rub.",
      "Apply the rub evenly over the pork ribs.",
      "Cut garlic cloves in half and wrap them with the pork ribs in foil.",
      "Bake in a 150°C oven for 2 hours and 30 minutes.",
      "Slice king oyster mushrooms and button mushrooms into bite-sized pieces and place them in a bowl.",
      "Add olive oil, salt, and black pepper, then toss to coat.",
      "Mix wholegrain mustard, honey, and black pepper into the BBQ sauce.",
      "Remove the baked ribs from the oven, discard the foil, and separate the roasted garlic.",
      "Add the separated roasted garlic to the sauce and blend until smooth with an immersion blender.",
      "Liberally coat the ribs with the garlic sauce.",
      "Bake the ribs and mushrooms together in a 180°C oven until browned.",
      "Serve the finished pork ribs on a plate and enjoy."
    ]
  },
  {
    "name": "Pomodoro",
    "url": "https://youtu.be/tAx7u7uvYUw",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2026-01-28",
    "ingredients": [
      "Cherry tomatoes",
      "Chopped tomatoes",
      "Chopped onion",
      "Garlic",
      "Spaghettini",
      "Parsley",
      "Tomato sauce",
      "Salt",
      "Pepper",
      "Olive oil"
    ],
    "steps": [
      "Wash and destem cherry tomatoes.",
      "Halve the cherry tomatoes.",
      "Bring 1L of water with 6g of salt to a boil.",
      "While the water boils, chop the parsley.",
      "Crush 3 cloves of garlic. In a pan, add 3T of olive oil and the crushed garlic to make garlic oil.",
      "Cook spaghettini for 4 minutes and 30 seconds.",
      "Once the garlic aroma is released, remove the garlic. Add 1T of chopped onion and 1g of salt.",
      "Add the cherry tomatoes and season with about 1g of salt.",
      "Add half a cup of tomato sauce.",
      "Add olive oil to thicken the sauce.",
      "Sprinkle with parsley."
    ]
  },
  {
    "name": "Braised Spanish Mackerel with Stir-fried Napa Cabbage",
    "url": "https://youtu.be/dYdlvZnMCbY",
    "uploader": "한신희",
    "upload_date": "2025-12-30",
    "ingredients": [
      "Spanish Mackerel",
      "Napa Cabbage",
      "Red Chili Pepper",
      "Garlic",
      "Soy Sauce",
      "Korean Cooking Wine",
      "Sugar",
      "Sesame Seeds",
      "Sesame Oil",
      "Korean Vegetable Seasoning",
      "Corn Syrup",
      "Fish Sauce",
      "Salt",
      "Black Pepper",
      "Mirin",
      "Flour",
      "Cooking Oil"
    ],
    "steps": [
      "Clean and debone the Spanish mackerel.",
      "Season the prepared mackerel with salt, black pepper, and mirin.",
      "Combine soy sauce, sugar, garlic, Korean cooking wine, corn syrup, crushed sesame seeds, Korean vegetable seasoning, and sesame oil to make the braising sauce.",
      "Slice the napa cabbage into strips.",
      "Heat cooking oil in a pan, add garlic, and sauté until fragrant.",
      "Add the sliced cabbage, fish sauce, and water, then stir-fry until the cabbage softens.",
      "Sprinkle sesame seeds over the stir-fried cabbage.",
      "Lightly coat both sides of the seasoned mackerel with flour.",
      "Heat cooking oil in a pan, place the mackerel skin-side down, and cook while pressing gently to prevent it from curling.",
      "Once the mackerel starts turning opaque, flip it over.",
      "Pour the prepared braising sauce over the mackerel and simmer until the sauce reduces.",
      "Arrange the stir-fried cabbage on a plate and top with the braised mackerel.",
      "Garnish with red chili pepper."
    ]
  },
  {
    "name": "Jumbo Shrimp Dish",
    "url": "https://youtu.be/I6HrKtJ-Ljs",
    "uploader": "한신희",
    "upload_date": "2026-01-01",
    "ingredients": [
      "Jumbo shrimp",
      "Garlic",
      "Onion",
      "Pechino (likely peperoncino)",
      "Date cherry tomatoes",
      "Green olives",
      "Basil",
      "Parsley",
      "Paprika powder",
      "Salt",
      "Pepper",
      "Olive oil",
      "Baguette"
    ],
    "steps": [
      "Trim the antennae and long legs of the shrimp, then peel the shells, leaving the tail segment intact.",
      "Make an incision along the back of the shrimp and remove the vein.",
      "Marinate the prepared shrimp with olive oil, pepper, salt, and paprika powder, mixing well.",
      "Dice the onion coarsely, remove the stem from the garlic and lightly crush it.",
      "Roughly chop the parsley leaves, and halve the date cherry tomatoes.",
      "Pour a generous amount of olive oil into a pan, then add the shrimp shells, diced onion, and crushed garlic."
    ]
  },
  {
    "name": "American Chef's Molly Pasta",
    "url": "https://youtu.be/bQETOCWcFhg",
    "uploader": "한신희",
    "upload_date": "2026-01-03",
    "ingredients": [
      "Garlic",
      "Peperoncino",
      "Shio Konbu",
      "Parsley",
      "Lemon Juice",
      "Salt",
      "Pepper",
      "Spaghetti",
      "Butter",
      "Olive Oil"
    ],
    "steps": [
      "Slice garlic thinly.",
      "Finely chop parsley.",
      "Add a generous amount of olive oil to a pan.",
      "Add sliced garlic to the pan and sauté until sizzling.",
      "Add chopped peperoncino and a pinch of pepper to create the sauce base.",
      "Add salt to boiling water and cook spaghetti for 3 minutes.",
      "Transfer cooked pasta to the sauce pan and add one ladle of pasta water.",
      "Add chopped parsley and butter, turn off the heat, and mantecare (emulsify).",
      "Drizzle with lemon juice, plate, and serve."
    ]
  },
  {
    "name": "Thinly Sliced Pork Belly Doenjang-jjigae",
    "url": "https://youtu.be/AbH55e-QrSM",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2026-01-31",
    "ingredients": [
      "Thinly Sliced Pork Belly",
      "Green Onion",
      "Cheongyang Chili Pepper",
      "Red Chili Pepper",
      "Korean Zucchini",
      "Potato",
      "Onion",
      "Tofu",
      "Chili Powder",
      "Tuna Sauce",
      "Mirin",
      "Doenjang",
      "Gochujang",
      "Salt",
      "Ssamjang",
      "Minced Garlic",
      "Oil"
    ],
    "steps": [
      "Cut the chili peppers, onion, potato, green onion, and zucchini into bite-sized pieces.",
      "Cut the tofu into pieces larger than the potatoes.",
      "Add a moderate amount of oil to a pot and grill the thinly sliced pork belly over low heat.",
      "Once the meat is cooked, remove it and lower the heat.",
      "In the pot, add doenjang, gochujang, and chili powder, and stir-fry over medium heat.",
      "Gradually add water, stirring to dissolve the doenjang well, and bring it to a boil."
    ]
  },
  {
    "name": "Short Rib Rice Cake Soup (Galbi Tteokguk)",
    "url": "https://youtu.be/gTy5jG2QEMA",
    "uploader": "한신희",
    "upload_date": "2026-01-05",
    "ingredients": [
      "brisket",
      "short rib soup broth",
      "large dumplings",
      "green onions",
      "joraengi tteok (coin-shaped rice cakes)",
      "minced garlic",
      "soy sauce",
      "salt",
      "sesame oil",
      "cooking oil"
    ],
    "steps": [
      "Cut the brisket into bite-sized pieces.",
      "Slice green onions diagonally.",
      "Add equal amounts of sesame oil and cooking oil to a pot.",
      "Add the sliced brisket and salt, then stir-fry.",
      "Strain the short rib soup broth to remove any enoki mushrooms, then pour into the pot.",
      "Add the short rib meat from the short rib soup to the pot.",
      "Skim off any impurities that rise to the surface while boiling.",
      "Add more water.",
      "Add the sliced green onions and minced garlic, then bring to a boil.",
      "Add joraengi tteok and dumplings, and boil until cooked through.",
      "Season with soup soy sauce to taste and finish."
    ]
  },
  {
    "name": "Chestnut, Mushroom, and Bacon Pasta",
    "url": "https://youtu.be/ktNXGPMZNjs",
    "uploader": "미뇨끼",
    "upload_date": "2025-11-19",
    "ingredients": [
      "Chestnut",
      "Shiitake mushroom",
      "Bacon",
      "Garlic",
      "Tagliatelle",
      "Milk",
      "White wine",
      "Parmesan cheese"
    ],
    "steps": [
      "Score chestnuts and roast them in an air fryer.",
      "Peel the roasted chestnuts.",
      "Blend roasted chestnuts and milk until smooth to make chestnut puree.",
      "Fry bacon until crispy, then finely chop.",
      "Sauté minced garlic and shiitake mushrooms in the bacon fat.",
      "Pour in white wine and simmer.",
      "Add the cooked tagliatelle to the pan.",
      "Pour in the chestnut puree and mix.",
      "Grate in Parmesan cheese and mix.",
      "Serve the pasta, garnishing with chestnut pieces and chopped bacon."
    ]
  },
  {
    "name": "Meljeot Potato Pancakes",
    "url": "https://youtu.be/-0h21_6jfEs",
    "uploader": "한신희",
    "upload_date": "2026-01-09",
    "ingredients": [
      "Potatoes",
      "Pork Jowl",
      "Onion",
      "Carrot",
      "Celery",
      "Anchovies",
      "Garlic",
      "Shrimp",
      "Lemon",
      "Parsley",
      "Dill",
      "Salt",
      "Mirin",
      "Red Pepper Powder",
      "Corn Syrup",
      "Heavy Cream",
      "Black Pepper",
      "Crushed Red Pepper",
      "Cooking Oil",
      "Olive Oil"
    ],
    "steps": [
      "Strain the anchovy extract.",
      "Cut pork jowl, add to an oiled pan, and render the fat.",
      "Finely chop onion, carrot, and celery, add to the pork jowl pan, and sauté until moisture evaporates.",
      "Add anchovies, mirin, red pepper powder, water, and corn syrup to the sautéed vegetables, boil, then strain to make the meljeot sauce.",
      "Finely julienne potatoes, season with 1% salt, marinate for 7 minutes, then squeeze out excess water.",
      "Fry two potato pancakes until golden brown in a generously oiled pan.",
      "Sauté minced garlic in olive oil, then add heavy cream and meljeot sauce, and blend to make meljeot bagna cauda.",
      "Season peeled shrimp with salt and pepper, then sauté.",
      "Place one potato pancake on a plate, spread with meljeot sauce, then top with another potato pancake.",
      "Drizzle generously with meljeot bagna cauda and top with six sautéed shrimp.",
      "Garnish with parsley, dill, lemon zest, lemon juice, and crushed red pepper to finish."
    ]
  },
  {
    "name": "Pumpkin Carbonara Bigoli",
    "url": "https://youtu.be/WQmzLH5W-Jo",
    "uploader": "미뇨끼",
    "upload_date": "2025-11-23",
    "ingredients": [
      "Pasta",
      "Pumpkin",
      "Bacon",
      "Hazelnuts",
      "Basil leaves"
    ],
    "steps": [
      "Cook fresh bigoli pasta in boiling water.",
      "Add the cooked pasta to a pan with pumpkin sauce.",
      "Mix the pasta and sauce together.",
      "Plate the pasta in a round shape.",
      "Top the pasta with more pumpkin sauce.",
      "Garnish with bacon, hazelnuts, and basil leaves."
    ]
  },
  {
    "name": "Pork Ribs and Radish Salad",
    "url": "https://youtu.be/CBKq2abC2XM",
    "uploader": "한신희",
    "upload_date": "2026-01-10",
    "ingredients": [
      "Pork Ribs",
      "Radish",
      "Soy Sauce",
      "Chili Powder",
      "Garlic",
      "Mirin",
      "Corn Syrup",
      "Pear Juice",
      "Salted Shrimp",
      "Ginger Syrup",
      "Sugar",
      "Salt",
      "Vinegar",
      "Onion Juice",
      "Pine Nut Powder",
      "Sesame Oil",
      "Black Pepper"
    ],
    "steps": [
      "Score the bone-in pork belly at 7mm intervals.",
      "Mix soy sauce, sugar, grated pear, minced garlic, grated onion, ginger syrup, sesame oil, and black pepper to make the galbi marinade.",
      "Pour the galbi marinade over the bone-in pork belly and marinate in the refrigerator.",
      "Thinly slice and julienne the radish, then put it in a mixing bowl.",
      "Add corn syrup and chili powder to the julienned radish and mix to coat with color.",
      "Mix additional chili powder, salted shrimp, sugar, ginger syrup, vinegar, salt, and minced garlic to make the radish salad dressing."
    ]
  },
  {
    "name": "Chiferri with Brazilian Bean Puree",
    "url": "https://youtu.be/Xa1VT1y4VHw",
    "uploader": "미뇨끼",
    "upload_date": "2025-12-01",
    "ingredients": [
      "Kidney beans",
      "Carrot",
      "Celery",
      "Chiferri pasta",
      "Salt",
      "Pepper",
      "Olive oil"
    ],
    "steps": [
      "Blend canned kidney beans and their liquid until smooth.",
      "Bring salted water to a boil in a pot.",
      "Add whole carrots and celery and boil until tender.",
      "Remove and thinly julienne the boiled carrots and celery.",
      "Add Chiferri pasta to the same pot and boil.",
      "Drain the cooked pasta.",
      "Add the strained bean puree to the cooked pasta.",
      "Add olive oil and pepper, then mix.",
      "Add the julienned carrots and celery and toss.",
      "Serve and drizzle with olive oil."
    ]
  },
  {
    "name": "Oatmeal Soup",
    "url": "https://youtu.be/5uk6gjoHgwM",
    "uploader": "한신희",
    "upload_date": "2026-01-12",
    "ingredients": [
      "Shrimp",
      "Asparagus",
      "Garlic",
      "Amazing Oatmeal",
      "Amazing Oat Barista Oat Milk",
      "Shio Kombu",
      "Grana Padano Cheese",
      "Pine nuts",
      "Almonds",
      "Chervil",
      "Salt",
      "Butter",
      "Perilla oil",
      "Olive oil"
    ],
    "steps": [
      "Boil oatmeal with water.",
      "Add oat milk and boil.",
      "Add toasted pine nuts, salt, cheese, and butter, then blend.",
      "Heat oil in a pan.",
      "Slice garlic and add to the pan.",
      "Add shrimp, asparagus, and shio kombu, then sauté.",
      "Arrange the sautéed ingredients beautifully on top of the oatmeal soup.",
      "Drizzle with perilla oil.",
      "Sprinkle with toasted nuts.",
      "Garnish with chervil to finish."
    ]
  },
  {
    "name": "Soybean Pulp Stew",
    "url": "https://youtu.be/BOzd3-VuWYE",
    "uploader": "한신희",
    "upload_date": "2026-01-13",
    "ingredients": [
      "Pork Shoulder",
      "Soybean Pulp",
      "Napa Cabbage",
      "Green Onion",
      "Red Chili Pepper",
      "Cheongyang Chili Pepper",
      "Salted Shrimp",
      "Salt",
      "Ginger Juice",
      "Minced Garlic",
      "Black Pepper",
      "Broth",
      "Cooking Oil",
      "Sesame Oil",
      "Perilla Oil"
    ],
    "steps": [
      "Slice cabbage, chili peppers, and green onions, and cut pork into large pieces.",
      "Grate ginger, squeeze out the juice, let it sit briefly for the starch to settle, then prepare only the clear ginger juice.",
      "Marinate the pork with the clear ginger juice, salt, and pepper.",
      "Heat cooking oil in a pot and brown the pork.",
      "Pour enough water to cover the meat and add broth.",
      "Add the thicker parts of the cabbage first and bring to a boil.",
      "Add the leafy parts of the cabbage, green onions, and chili peppers, and continue to boil.",
      "Generously add salted shrimp and soybean pulp.",
      "Add minced garlic and mix well.",
      "Season with salt to taste.",
      "Serve the finished Biji Jjigae in a bowl."
    ]
  },
  {
    "name": "Warm Chicken Soba Noodles",
    "url": "https://youtu.be/BbU7gnLgh1U",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2026-02-04",
    "ingredients": [
      "chicken",
      "chicken bones",
      "chicken feet",
      "soba noodles",
      "kelp",
      "Chamnamul",
      "Korean rice wine",
      "Kaeshi",
      "katsuobushi"
    ],
    "steps": [
      "Simmer chicken bones, chicken feet, kelp, katsuobushi, Korean rice wine, and water to make a broth.",
      "Mix Kaeshi into the prepared broth to create tsuyu.",
      "Sear the chicken in a hot pan until crispy.",
      "Cut the crispy chicken into bite-sized pieces.",
      "Place cooked soba noodles in a bowl.",
      "Arrange the cooked chicken and Chamnamul on top of the soba.",
      "Pour the prepared tsuyu broth over the ingredients."
    ]
  },
  {
    "name": "Mulled Wine",
    "url": "https://youtu.be/TeSbXd_KRuM",
    "uploader": "미뇨끼",
    "upload_date": "2025-12-07",
    "ingredients": [
      "Lemon",
      "Orange",
      "Anise",
      "Cloves",
      "Cinnamon sticks",
      "Red wine",
      "Sugar"
    ],
    "steps": [
      "Pour red wine into a pot.",
      "Peel long strips of lemon and orange zest and add them to the pot.",
      "Add cinnamon sticks to the pot.",
      "Add sugar to the pot.",
      "Add anise and cloves to the pot.",
      "Stir all ingredients.",
      "Simmer on low heat for about 30 minutes.",
      "Strain the mulled wine and pour into mugs."
    ]
  },
  {
    "name": "Lamb Gratin",
    "url": "https://youtu.be/SC6AvWCdtAM",
    "uploader": "한신희",
    "upload_date": "2026-01-15",
    "ingredients": [
      "Ground lamb",
      "Onion",
      "Carrot",
      "Garlic",
      "Potato",
      "Tomato paste",
      "Worcestershire sauce",
      "Rosemary",
      "Chicken stock",
      "Red wine",
      "Balsamic vinegar",
      "Heavy cream",
      "Parmesan cheese",
      "Salt",
      "Black pepper",
      "Butter",
      "Egg",
      "Olive oil"
    ],
    "steps": [
      "Roughly chop potatoes and boil until tender.",
      "Mince the onion.",
      "Grate the carrot.",
      "Heat olive oil in a pan, add ground lamb, and cook until browned.",
      "Season with salt and pepper while cooking.",
      "Add minced onion and grated carrot, and sauté together.",
      "Add tomato paste, Worcestershire sauce, rosemary, chicken stock, and red wine, then simmer until thickened.",
      "Stir in balsamic vinegar and continue to simmer until the liquid has reduced.",
      "Mash the boiled potatoes, removing any skins.",
      "Combine mashed potatoes with heavy cream, butter, egg yolk, and Parmesan cheese, mixing well.",
      "Spread the simmered meat mixture evenly in an oven-safe dish, then top generously with mashed potatoes.",
      "Create a decorative pattern on the mashed potatoes with a fork and sprinkle with additional cheese.",
      "Bake in a preheated oven at 180°C for about 20 minutes."
    ]
  },
  {
    "name": "Russian Salad",
    "url": "https://youtu.be/8LgO-1JjrLo",
    "uploader": "미뇨끼",
    "upload_date": "2025-12-09",
    "ingredients": [
      "Carrots",
      "Potatoes",
      "Frozen peas",
      "Pickles",
      "Mayonnaise",
      "Salt"
    ],
    "steps": [
      "Cut carrots into bite-sized pieces.",
      "Cut potatoes into bite-sized pieces.",
      "Combine the cut carrots, potatoes, and frozen peas.",
      "Boil the ingredients in salted water until slightly firm.",
      "Drain the boiled ingredients and pat dry with a kitchen towel.",
      "Place the thoroughly cooled ingredients into a bowl.",
      "Drizzle mayonnaise generously.",
      "Mix all ingredients together.",
      "Garnish with pickles cut into branch shapes."
    ]
  },
  {
    "name": "Seasoned Grilled Perilla Leaves",
    "url": "https://youtu.be/KDBcjPnoEtw",
    "uploader": "한신희",
    "upload_date": "2026-01-16",
    "ingredients": [
      "Perilla leaves",
      "Chestnuts",
      "Jujubes",
      "Sugar",
      "Soy sauce",
      "Perilla oil",
      "Chili powder",
      "Grain syrup",
      "Sesame seeds"
    ],
    "steps": [
      "Remove perilla leaf stems.",
      "Thinly julienne chestnuts.",
      "Remove seeds from jujubes and flatten them.",
      "Sprinkle sugar on the sticky side of flattened jujubes, then thinly julienne.",
      "Mix soy sauce, perilla oil, chili powder, grain syrup, and water to make a sauce.",
      "Add julienned chestnuts and jujubes to the sauce and mix.",
      "Overlap 3 perilla leaves, then evenly spread the sauce.",
      "Heat perilla oil in a pan, place the seasoned perilla leaves, and grill.",
      "When perilla leaves turn golden brown, flip and grill the other side.",
      "Transfer grilled perilla leaves to a plate and sprinkle with sesame seeds."
    ]
  },
  {
    "name": "Bucatini with Garlic Tomato Sauce",
    "url": "https://youtu.be/xHWH0bfC1oU",
    "uploader": "미뇨끼",
    "upload_date": "2025-12-11",
    "ingredients": [
      "Bucatini",
      "Garlic",
      "Basil",
      "Tomatoes",
      "Salt",
      "Pepper",
      "Olive oil",
      "White wine"
    ],
    "steps": [
      "Heat a generous amount of olive oil in a pan.",
      "Add garlic and sauté until browned.",
      "Pour in white wine.",
      "Immediately add tomatoes.",
      "Season with salt and pepper.",
      "Simmer the sauce for 15 minutes.",
      "Add a generous amount of salt to boiling water.",
      "Cook the pasta.",
      "Stir in basil 5 minutes before serving the sauce.",
      "Place cooked pasta on a plate.",
      "Top with tomato sauce."
    ]
  },
  {
    "name": "Beef Tartare, French Onion Soup, Roast Beef, Crème Brûlée",
    "url": "https://youtu.be/F369M8Uz7Bk",
    "uploader": "한신희",
    "upload_date": "2026-01-20",
    "ingredients": [
      "Beef",
      "Raw Beef",
      "Onion",
      "Butter",
      "Cheese",
      "Sugar",
      "Kitchen Twine",
      "Bread",
      "Broth"
    ],
    "steps": [
      "Slice onions.",
      "Caramelize onions in butter.",
      "Tie beef roast with kitchen twine.",
      "Sear and flambé the tied beef.",
      "Assemble ingredients in oven-safe dishes and bake French Onion Soup.",
      "Garnish the prepared beef tartare.",
      "Sprinkle sugar over custard and caramelize with a torch to finish Crème Brûlée.",
      "Slice the roast beef evenly.",
      "Plate and serve the finished dishes."
    ]
  },
  {
    "name": "Spicy Radish Bibimbap",
    "url": "https://youtu.be/TJJQSqSVwQ0",
    "uploader": "미뇨끼",
    "upload_date": "2025-12-14",
    "ingredients": [
      "Radish",
      "Cooked rice",
      "Tofu",
      "Zucchini",
      "Bell pepper",
      "Mushroom",
      "Egg",
      "Salt",
      "Sugar",
      "Korean chili powder",
      "Vinegar",
      "Perilla oil",
      "Sesame seeds"
    ],
    "steps": [
      "Thinly julienne the radish.",
      "In a bowl, add salt, sugar, and vinegar to the julienned radish and massage by hand to pickle.",
      "Squeeze out and discard the water from the radish.",
      "Grind sesame seeds.",
      "Add Korean chili powder and ground sesame seeds to the pickled radish and mix well by hand.",
      "Place cooked rice in a large bowl.",
      "Top the rice with the mixed radish salad (musaengchae).",
      "Drizzle generously with perilla oil.",
      "Mix the rice and radish salad well by hand.",
      "Place cooked tofu, zucchini, bell pepper, and mushrooms on top of the bibimbap.",
      "Fry an egg and place it on top of the bibimbap.",
      "Drizzle with more perilla oil and mix all ingredients well again to finish."
    ]
  },
  {
    "name": "White Sausage Ragu Pasta",
    "url": "https://youtu.be/Kl7Ll3eAw2c",
    "uploader": "한신희",
    "upload_date": "2026-01-22",
    "ingredients": [
      "Salsiccia sausage",
      "ground beef",
      "onion",
      "celery",
      "button mushrooms",
      "pasta",
      "tomato paste",
      "Parmesan cheese",
      "white wine",
      "heavy cream",
      "salt",
      "pepper",
      "herbs",
      "beef broth",
      "olive oil"
    ],
    "steps": [
      "Remove casing from salsiccia sausage and chop into small pieces.",
      "Finely chop mushrooms and celery.",
      "Heat olive oil in a pot and brown the ground beef.",
      "Add chopped salsiccia and cook together.",
      "Stir in a small amount of tomato paste.",
      "Add chopped mushrooms and celery, cooking for at least 10 minutes to evaporate their moisture.",
      "Season with salt and pepper.",
      "Pour in white wine and scrape up any browned bits from the bottom of the pot.",
      "Add beef broth (or water).",
      "Grate Parmesan cheese and add the rind.",
      "Reduce heat to low and simmer for 30-40 minutes.",
      "In a separate pan, combine a ladleful of ragu sauce and heavy cream.",
      "Add cooked pasta and toss, allowing it to finish cooking in the sauce.",
      "Plate the pasta nicely and generously top with sauce.",
      "Garnish with parsley."
    ]
  },
  {
    "name": "Italian Chickpea Pasta and Risotto",
    "url": "https://youtu.be/gU9oePZ4iUM",
    "uploader": "미뇨끼",
    "upload_date": "2025-12-15",
    "ingredients": [
      "Chickpeas",
      "Pasta",
      "Rice",
      "Carrot",
      "Celery",
      "Onion",
      "Tomato paste",
      "Saffron",
      "Butter",
      "Parmesan cheese",
      "Knorr chicken stock powder",
      "Olive oil",
      "White wine",
      "Pepper"
    ],
    "steps": [
      "Heat olive oil in a pot and sauté chopped carrot, celery, and onion.",
      "Add tomato paste and sauté together.",
      "Add chickpeas.",
      "Add plenty of water and finely broken pasta.",
      "Boil for about 15 minutes, then add Knorr chicken stock powder and mix.",
      "Serve in a bowl and sprinkle with pepper.",
      "Heat olive oil in a pan and sauté rice and onion.",
      "Add Knorr chicken stock powder and mix.",
      "Pour in white wine and sauté until absorbed by the rice.",
      "Gradually add broth made with Knorr chicken stock and cook the rice.",
      "Add saffron and stir.",
      "Add butter and Parmesan cheese, and mix well until thickened.",
      "Serve in a bowl."
    ]
  },
  {
    "name": "Surf Clam Pasta",
    "url": "https://youtu.be/Qa61cZSmt50",
    "uploader": "한신희",
    "upload_date": "2026-01-24",
    "ingredients": [
      "Surf clams",
      "Pasta",
      "Garlic",
      "Wild chives",
      "Peperoncino",
      "Salt",
      "Olive oil",
      "White wine",
      "Butter",
      "Parmesan cheese"
    ],
    "steps": [
      "Crush the garlic.",
      "Rinse the surf clams in salted water.",
      "Cook the pasta in salted water until about 70% done.",
      "Heat olive oil in a pan, then sauté the crushed garlic and peperoncino until fragrant.",
      "Add the surf clams and white wine, cover, and cook for 1 minute.",
      "Remove the cooked surf clams.",
      "Add the cooked pasta to the pan and remove the chili and garlic.",
      "Once the pasta is cooked, add the removed surf clams and butter.",
      "Crush the root part of the wild chives and add.",
      "Toss to combine the ingredients in the pan.",
      "Sprinkle with Parmesan cheese to finish."
    ]
  },
  {
    "name": "Homemade Cheesy Fried Chicken",
    "url": "https://youtu.be/yuntEM4O3J4",
    "uploader": "한신희",
    "upload_date": "2026-01-27",
    "ingredients": [
      "Chicken",
      "Salt",
      "Sugar",
      "Korean chili powder",
      "Cheddar cheese",
      "Parmesan cheese",
      "Cheese blend powder",
      "Onion powder",
      "Bay leaf",
      "Frying mix",
      "Cooking oil"
    ],
    "steps": [
      "Cut the chicken into large pieces.",
      "Mix water, salt, sugar, Korean chili powder, and bay leaf to make a brine.",
      "Add the chicken to the brine, cover with plastic wrap, and marinate for 6 hours.",
      "Lightly pat dry the marinated chicken.",
      "Prepare a wet batter by mixing frying mix and water.",
      "Dip the chicken in the wet batter once.",
      "Coat the chicken with dry frying mix, shaking well to create a wavy texture.",
      "Fry the chicken in cooking oil preheated to 170°C for 14 minutes.",
      "Remove the fried chicken and drain excess oil.",
      "Combine Cheddar cheese, Parmesan cheese, cheese blend powder, onion powder, and sugar, then shake well to make the seasoning.",
      "Place the fried chicken in a mixing bowl.",
      "Add the cheese seasoning and toss well to coat.",
      "Arrange nicely on a plate and serve."
    ]
  },
  {
    "name": "Warm Noodle Soup",
    "url": "https://youtu.be/jaa4ZQrHfrs",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2026-02-07",
    "ingredients": [
      "Beltfish",
      "Mussels",
      "Burdock root",
      "Jerusalem artichoke",
      "Mushrooms",
      "Noodles",
      "Salt",
      "Kelp"
    ],
    "steps": [
      "Add mussels, kelp, burdock root, and Jerusalem artichoke to water and boil to make broth.",
      "Score the beltfish and season with salt.",
      "Grill the beltfish in a pan until about 80% cooked.",
      "Add grilled mushrooms to the broth.",
      "Blanch noodles in hot water and place in a bowl.",
      "Arrange grilled beltfish and broth ingredients attractively in the bowl.",
      "Pour in the hot broth."
    ]
  },
  {
    "name": "Spicy Garlic Parsley Spaghetti",
    "url": "https://youtu.be/HBeNBruoCqY",
    "uploader": "미뇨끼",
    "upload_date": "2025-12-17",
    "ingredients": [
      "Spaghetti",
      "Garlic",
      "Red Chili",
      "Parsley",
      "Dried Chili Oil",
      "Salt",
      "Olive Oil",
      "Parmesan Cheese"
    ],
    "steps": [
      "Peel and mince the garlic.",
      "Thinly slice the red chili.",
      "Finely chop the parsley.",
      "Add salt to boiling water and cook the spaghetti.",
      "Heat a generous amount of olive oil in a pan, then add garlic and red chili and sauté.",
      "Add dried chili oil and sauté together.",
      "Drain the cooked spaghetti and add it to the pan, mixing with some pasta water.",
      "Add the chopped parsley and mix well.",
      "Serve the finished spaghetti on a plate.",
      "Grate Parmesan cheese over the top."
    ]
  },
  {
    "name": "Minari Chicken Noodle Soup",
    "url": "https://youtu.be/a8342d5-dBc",
    "uploader": "한신희",
    "upload_date": "2026-01-29",
    "ingredients": [
      "Chicken",
      "Kalguksu noodles",
      "Minari",
      "Shiitake mushrooms",
      "Green onions",
      "Ginger",
      "Kelp",
      "Salted shrimp",
      "Salt",
      "Soy sauce",
      "Mirin",
      "Yeondu",
      "Rice syrup",
      "Sesame oil"
    ],
    "steps": [
      "Debone the chicken, reserving the meat for garnish.",
      "Marinate the deboned chicken meat in soy sauce, sesame oil, water, and mirin.",
      "Lightly oil a pot and brown the chicken bones.",
      "Add ginger, rehydrated shiitake mushrooms, green onions, kelp, and water to the browned chicken bones and simmer for one hour.",
      "Skim off any white foam that rises to the surface during the initial boiling.",
      "Once the broth is rich, strain it through a sieve.",
      "Season the strained broth with salt, pepper, and salted shrimp.",
      "Add kalguksu noodles to the broth and cook until the noodles are done.",
      "Bake the marinated chicken meat in a 180°C oven until golden brown.",
      "Serve the cooked noodles and broth in a bowl, top with the baked chicken garnish, and sprinkle with fragrant sliced minari."
    ]
  },
  {
    "name": "White Mapo Tofu",
    "url": "https://youtu.be/zNO0N1kTBlk",
    "uploader": "한신희",
    "upload_date": "2026-01-31",
    "ingredients": [
      "Soft Tofu",
      "Ground Pork",
      "Cod Milt",
      "Scallions",
      "Garlic",
      "Ginger",
      "Cheongyang Chili Pepper",
      "Rice",
      "Soy Sauce",
      "Sansho Oil",
      "Chicken Broth",
      "Starch",
      "Cooking Oil"
    ],
    "steps": [
      "Finely chop garlic, ginger, and scallions, and chop Cheongyang chili pepper.",
      "Slightly open a corner of the soft tofu package to create an air layer, then carefully remove the tofu.",
      "Cube the soft tofu, then blanch it in boiling water for 2 minutes.",
      "Heat cooking oil in a pan and stir-fry the ground pork until the moisture evaporates.",
      "Add the finely chopped garlic, ginger, and scallions to the stir-fried pork and continue to stir-fry.",
      "Add soy sauce and stir-fry until it develops a smoky flavor."
    ]
  },
  {
    "name": "Mushroom Sandwich",
    "url": "https://youtu.be/4dw5eECay20",
    "uploader": "한신희",
    "upload_date": "2026-02-03",
    "ingredients": [
      "Shimeji mushrooms",
      "Button mushrooms",
      "Onion",
      "Emmental cheese",
      "Hearth bread",
      "Salt",
      "Pepper",
      "Thyme",
      "Olive oil",
      "White wine"
    ],
    "steps": [
      "Brush button mushrooms clean and quarter them.",
      "Trim the base of shimeji mushrooms and separate into strands.",
      "Slice the onion.",
      "Heat olive oil in a pan and lightly sauté the onion.",
      "Add all mushrooms, season with salt and pepper, and sauté.",
      "Add a little white wine (or water) and sauté until the mushrooms soften.",
      "Stir in the thyme.",
      "Slice the hearth bread in half horizontally.",
      "Fill the hearth bread with the sautéed mushrooms.",
      "Slice Emmental cheese and generously layer it over the mushrooms.",
      "Close the bread and bake in a preheated oven at 180°C for 10 minutes.",
      "Cut the finished sandwich and serve."
    ]
  },
  {
    "name": "Panettone",
    "url": "https://youtu.be/NF-WG3T-xZY",
    "uploader": "미뇨끼",
    "upload_date": "2025-12-24",
    "ingredients": [
      "Sourdough starter",
      "Candied fruit",
      "Chocolate chips",
      "Almond cream",
      "Crushed sugar cookies",
      "Egg yolks",
      "Butter",
      "Sugar",
      "Honey",
      "Powdered sugar",
      "Flour",
      "Vanilla bean"
    ],
    "steps": [
      "Mix sourdough starter with sugar water and flour, then let it ferment until doubled.",
      "Add flour and knead the dough. Flatten it thin with a large rolling machine, roll it up, and ferment again. Repeat this process four times.",
      "Add egg yolks and butter, then knead until sticky.",
      "Let the dough rise again.",
      "Add more egg yolks, vanilla bean, honey, and butter, then knead vigorously until firm and passes the windowpane test.",
      "Fold in candied fruit and chocolate chips.",
      "Let the dough rise again.",
      "Divide the dough into bread molds and let it rise again.",
      "Spread almond cream, crushed sugar cookies, and powdered sugar on top of the bread.",
      "Bake for 1 hour.",
      "Immediately after removing from the oven, skewer the hot panettone and hang it upside down to cool for a day.",
      "Slice and enjoy the finished panettone."
    ]
  },
  {
    "name": "Hotel-Style Egg Dishes",
    "url": "https://youtu.be/SgjImgnR2N0",
    "uploader": "한신희",
    "upload_date": "2026-02-05",
    "ingredients": [
      "Eggs",
      "Ham",
      "Chopped vegetables",
      "Cheese",
      "Heavy cream",
      "Butter"
    ],
    "steps": [
      "Place eggs in boiling water, stirring with chopsticks to center the yolk. Boil for 6-10 minutes for desired doneness, then cool in ice water.",
      "Melt butter in a pan, crack in eggs. Cook without flipping for sunny-side up, or flip once for over-easy or over-medium.",
      "Whisk eggs, add heavy cream, mix well, then strain through a sieve.",
      "Melt butter in a pan, pour in the prepared egg mixture. Stir, scraping the edges as it cooks, and remove from heat when still soft.",
      "Melt butter in a hot pan, pour in the prepared egg mixture. Stir like scrambled eggs, then as the edges begin to set, fold from the center to form an oval-shaped omelet.",
      "Melt butter in a pan, sauté chopped vegetables and ham. Pour in the prepared egg mixture, stir like scrambled eggs, then add cheese and roll into an omelet shape to complete a combination omelet."
    ]
  },
  {
    "name": "Seafood Gratin",
    "url": "https://youtu.be/QjCO8i5jCC0",
    "uploader": "한신희",
    "upload_date": "2026-02-06",
    "ingredients": [
      "Scallops",
      "Shrimp",
      "Squid",
      "Fish milt",
      "Baguette",
      "Dijon mustard",
      "Chives",
      "Salt",
      "Pepper",
      "Butter",
      "Flour",
      "Broth",
      "Cream",
      "Emmental cheese",
      "Breadcrumbs",
      "Olive oil"
    ],
    "steps": [
      "Steam scallops, shrimp, squid, and fish milt in an oven with a super steam function.",
      "Remove scallop meat from shells, and cut shrimp and fish milt into bite-sized pieces.",
      "Sauté equal parts butter and flour in a pan.",
      "Add the broth from the steamed seafood and cream to the sautéed mixture and reduce by half.",
      "Add the prepared seafood and Dijon mustard, then mix.",
      "Stir in chopped chives and season with salt and pepper.",
      "Toss the seafood with the finished sauce and transfer to a gratin dish.",
      "Sprinkle generously with Emmental cheese and breadcrumbs.",
      "Bake in a convection oven until the top is crispy.",
      "Drizzle baguette slices with olive oil and sprinkle with salt.",
      "Toast the baguette slices in the oven until crispy."
    ]
  },
  {
    "name": "Pork Galbi Jjim",
    "url": "https://youtu.be/pYbvptbIhjw",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2026-02-14",
    "ingredients": [
      "Pork ribs",
      "Pork shoulder",
      "Soy sauce",
      "Garlic",
      "Mirin",
      "Corn syrup",
      "Ginger",
      "Sugar",
      "Vinegar",
      "Tuna sauce",
      "Rice wine",
      "Star anise",
      "Bay leaf"
    ],
    "steps": [
      "Sear pork ribs in a pan until browned on both sides.",
      "Place seared pork ribs and vegetables into a pot and bring to a boil.",
      "Simmer until the meat is tender.",
      "Serve the finished Pork Galbi Jjim in a bowl."
    ]
  },
  {
    "name": "Hotel-Style Fruit Platter",
    "url": "https://youtu.be/TFaiEnHxt10",
    "uploader": "한신희",
    "upload_date": "2026-02-09",
    "ingredients": [
      "Melon",
      "Pineapple",
      "Kiwi"
    ],
    "steps": [
      "Lightly trim the stem end of the melon.",
      "Cut the melon exactly in half.",
      "Scoop out the melon seeds with a pointed spoon.",
      "Cut each melon half again to make quarters.",
      "Trim both hard ends flat on each melon quarter.",
      "Slice each melon quarter diagonally (instead of lengthwise) to form several triangular pieces.",
      "From the pointed end of each melon slice, make a cut without severing the flesh completely.",
      "Arrange the melon slices neatly in a circular pattern on a plate.",
      "Cut off the top and bottom ends of the pineapple.",
      "Carefully peel the pineapple, following its natural curve to preserve its shape.",
      "Cut the pineapple into quarters, using the core as a guide.",
      "Lay each quarter flat and cut out the core.",
      "Slice the pineapple diagonally into bite-sized pieces, twisting each slice slightly with the knife without fully separating it, then arrange on a plate.",
      "Lightly trim the top and bottom ends of the kiwi.",
      "Peel the kiwi vertically, similar to how the pineapple was peeled.",
      "Slice the kiwi into round pieces, or cut it vertically and then diagonally again, and arrange on a plate."
    ]
  },
  {
    "name": "Olive Marinade",
    "url": "https://youtu.be/VjJW5t8o3SE",
    "uploader": "한신희",
    "upload_date": "2026-02-10",
    "ingredients": [
      "green olives",
      "black olives",
      "garlic",
      "button mushrooms",
      "lemon zest",
      "thyme",
      "peperoncino",
      "salt",
      "pepper",
      "olive oil"
    ],
    "steps": [
      "Place garlic, olives, button mushrooms, salt, pepper, thyme, peperoncino, and lemon zest in a pot.",
      "Pour olive oil over the ingredients until submerged and mix.",
      "Slowly cook the pot at 115 degrees Celsius for about 30 minutes.",
      "Transfer the olive marinade and oil to a pan.",
      "Mash the marinated garlic.",
      "Add cooked pasta and emulsify to finish the Aglio e Olio."
    ]
  },
  {
    "name": "Collection of Pollack Roe Dishes",
    "url": "https://youtu.be/DdflHGLVbCU",
    "uploader": "한신희",
    "upload_date": "2026-02-14",
    "ingredients": [
      "Pollack roe",
      "Mascarpone cheese",
      "Egg(s)",
      "Soaked rice",
      "Button mushroom(s)",
      "Salmon",
      "Cucumber",
      "Scallion(s)",
      "Honey",
      "Salt",
      "Yeondu (Fermented soybean seasoning)",
      "Mirin",
      "Powdered broth",
      "Sesame seeds",
      "Sesame oil"
    ],
    "steps": [
      "Add mascarpone cheese to a mixing bowl.",
      "Split the pollack roe in half, scrape out only the roe, and add it to the bowl along with mascarpone cheese, honey, salt, and thinly sliced white parts of scallions.",
      "Mix the ingredients well until combined.",
      "Beat two eggs, then add 150ml water, Yeondu (fermented soybean seasoning), pollack roe, and mirin, and mix well.",
      "Pour the mixture into a dish, briefly heat with a torch to remove air bubbles, then cover with plastic wrap and steam for 15 minutes in a steamer.",
      "Place pollack roe in the center and drizzle with sesame oil."
    ]
  },
  {
    "name": "Oyster and Green Onion Pancake",
    "url": "https://youtu.be/vJ2kFOftSDA",
    "uploader": "한신희",
    "upload_date": "2026-02-17",
    "ingredients": [
      "Large green onions",
      "Small green onions",
      "Dried shrimp",
      "Oysters",
      "Green chili",
      "Red chili",
      "Yondu seasoning sauce",
      "Soy sauce",
      "Pickled brine",
      "Red pepper powder",
      "Sesame oil",
      "Salt",
      "Potato starch",
      "Frying mix",
      "Sesame seeds",
      "Cooking oil"
    ],
    "steps": [
      "Wash and halve the large green onions, then slice diagonally into 0.5cm thick pieces.",
      "Cut the small green onions to a similar length.",
      "Wash oysters in salted water, then rinse once or twice in clean water.",
      "Mix potato starch, frying mix, water, soy sauce, Yondu seasoning sauce, and sesame oil to make the batter.",
      "In a large bowl, combine the sliced large green onions, small green onions, and dried shrimp, then pour in the batter and mix.",
      "Heat oil in a pan, pour in the pancake batter, and press lightly to fill any gaps.",
      "Add oysters to the remaining batter, mix, and place on top of the pancake in the pan.",
      "Drizzle oil occasionally and cook until the surface is crispy.",
      "Flip the pancake and continue cooking until golden brown, then transfer to a serving plate.",
      "Mix soy sauce, minced green and red chilies, red pepper powder, sesame seeds, and pickled brine to make the dipping sauce."
    ]
  },
  {
    "name": "Grilled Pork Collar Butt with Salt Sauce",
    "url": "https://youtu.be/iRYA_oh3li8",
    "uploader": "한신희",
    "upload_date": "2026-02-21",
    "ingredients": [
      "Pork collar",
      "Salt sauce"
    ],
    "steps": [
      "Score the pork collar.",
      "Add salt sauce and mix well.",
      "Pan-fry until golden brown."
    ]
  },
  {
    "name": "Homemade Snack Trio",
    "url": "https://youtu.be/mPfhPgo-h2w",
    "uploader": "한신희",
    "upload_date": "2026-02-22",
    "ingredients": [
      "Chicken wings",
      "Sweet corn",
      "Tofu",
      "Soy sauce",
      "Rice syrup",
      "Mayonnaise",
      "Sriracha sauce",
      "Yondu",
      "Honey",
      "Salt",
      "Black pepper",
      "Smoked paprika",
      "MSG",
      "Oil",
      "Starch",
      "Perilla oil"
    ],
    "steps": [
      "Place chicken wings in a mixing bowl.",
      "Add salt, black pepper, smoked paprika, and oil, then toss well.",
      "Place the seasoned chicken wings on a rack and bake at 190°C for 15 minutes.",
      "Drain the sweet corn and place it in a mixing bowl.",
      "Add starch and MSG, then mix well until sticky.",
      "Pour a generous amount of oil into a pan.",
      "Pour all the sweet corn batter into the pan and spread thinly.",
      "When one side is crispy, flip and cook the other side until done.",
      "Cut the tofu into uniform pieces.",
      "Place tofu in an ungreased pan and turn on low heat.",
      "Flip the tofu frequently to remove all moisture.",
      "Mix mayonnaise, sriracha, and honey to make a sauce.",
      "Drizzle perilla oil over the dried tofu and pan-fry at a moderate temperature.",
      "Mix soy sauce, rice syrup, Yondu, and water to make a seasoning sauce.",
      "Toss the baked chicken wings in the sauce, then plate them and sprinkle with a little black pepper.",
      "Plate the cooked tofu and drizzle with the seasoning sauce."
    ]
  },
  {
    "name": "Mini Kimbap",
    "url": "https://youtu.be/iHRAbpd6v00",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2026-02-21",
    "ingredients": [
      "Egg",
      "Seaweed sheets",
      "Cooked rice",
      "Pickled daikon radish",
      "Dried gourd strips",
      "White pollack roe",
      "Bulgogi",
      "Fish cake",
      "Pickled ginger",
      "Cream cheese",
      "Mirin",
      "Salt",
      "Sesame oil"
    ],
    "steps": [
      "Make egg strips (jidan) by adding mirin.",
      "Sauté a generous amount of meat with bulgogi seasoning.",
      "Mix white pollack roe and cream cheese.",
      "Season the rice with salt and sesame oil.",
      "Prepare the pickled daikon radish, dried gourd strips, fish cake, and pickled ginger.",
      "Place seaweed on a bamboo mat, add the ingredients, and roll."
    ]
  },
  {
    "name": "Rich Mussel Broth",
    "url": "https://youtu.be/zlBhDIk9Ahc",
    "uploader": "한신희",
    "upload_date": "2026-02-25",
    "ingredients": [
      "Mussels"
    ],
    "steps": [
      "Rinse mussels several times until the water runs clear.",
      "Discard any broken mussels.",
      "Place cleaned mussels and water in a large pot.",
      "Simmer for about 2 hours until the mussel flavor is fully extracted.",
      "Remove all cooked mussels.",
      "Slowly reduce the rich mussel broth."
    ]
  },
  {
    "name": "Grilled Spanish Mackerel",
    "url": "https://youtu.be/41TPEUFfKM8",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2026-02-25",
    "ingredients": [
      "Spanish mackerel",
      "Salt",
      "Black pepper",
      "Soy sauce",
      "Wasabi",
      "Green onions",
      "Lemon zest",
      "Olive oil"
    ],
    "steps": [
      "Score the skin of the Spanish mackerel.",
      "Season the Spanish mackerel with salt.",
      "Drizzle a generous amount of olive oil in a pan.",
      "Place the Spanish mackerel skin-side down in the pan over low heat, pressing gently as it cooks.",
      "Baste the fish with the oil from the pan, cooking it slowly until done.",
      "Sprinkle black pepper on the grilling fish.",
      "Place the perfectly cooked Spanish mackerel on a bed of rice.",
      "Serve with wasabi, chopped green onions, and lemon zest."
    ]
  },
  {
    "name": "Abalone Ge-u Pasta",
    "url": "https://youtu.be/4i7vzGI0Mt4",
    "uploader": "한신희",
    "upload_date": "2026-02-27",
    "ingredients": [
      "Abalone",
      "Pasta",
      "Abalone innards",
      "Gamtae",
      "Soy sauce",
      "Mirin",
      "Heavy cream",
      "Lemon zest",
      "Butter",
      "Garlic butter",
      "Chicken stock"
    ],
    "steps": [
      "Thoroughly clean the abalone with a toothbrush.",
      "Insert a spoon into the pointed end of the abalone to separate it from its shell, then remove the innards and teeth.",
      "Heat water in a pot to about 90°C, then turn off the heat. Briefly blanch the abalone for about 1 minute, then remove it. This will make it easier to remove the innards and teeth.",
      "Cook the pasta to about 80% of your desired al dente texture.",
      "In a pan, add butter. Once it starts to melt, lower the heat as much as possible and add a small amount of minced garlic.",
      "Add the prepared abalone to the pan and cook it slowly, basting with the garlic butter."
    ]
  },
  {
    "name": "Winter Cabbage Bibimbap & Pollack Roe Soft Tofu Stew",
    "url": "https://youtu.be/3o232YG7xBw",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2026-02-27",
    "ingredients": [
      "Winter Cabbage",
      "Clams",
      "Pollack Roe",
      "Soft Tofu",
      "Zucchini",
      "Onion",
      "Enoki Mushrooms",
      "Scallions",
      "Cheongyang Chili Pepper",
      "Chili Powder",
      "Soy Sauce",
      "Tuna Sauce",
      "Salted Shrimp",
      "Mirin",
      "Salt",
      "Sesame Oil",
      "Plum Extract",
      "Egg",
      "Cooked Rice",
      "Sesame Seeds"
    ],
    "steps": [
      "Separate winter cabbage leaves, wash under running water, then sprinkle with a pinch of salt and marinate.",
      "In an earthen pot, add 2 spoons each of sesame oil and chili oil, then add sliced scallions and stir-fry.",
      "Add 2 leveled spoons of chili powder, 200g purged clams, and 1 tablespoon mirin; stir to combine.",
      "Pour in 500ml water (just enough to cover) and bring to a boil.",
      "Slice mushrooms, onion, zucchini, and Cheongyang chili pepper, add to the earthen pot, and bring to a boil.",
      "Slice soft tofu into bite-sized pieces, add, then season with 1 teaspoon salted shrimp, 1 tablespoon minced garlic, and two drops of soup soy sauce.",
      "Combine 1 tablespoon soy sauce, 1 tablespoon chili powder, 0.5 tablespoon tuna sauce, 0.5 teaspoon minced garlic, 0.5 tablespoon plum extract, 1 tablespoon water, 2 tablespoons sesame oil, and sesame seeds to make the bibimbap sauce.",
      "Add the marinated winter cabbage and cooked rice to the bibimbap sauce and gently mix.",
      "Crack an egg yolk into the soft tofu stew and sprinkle with sliced scallions to finish."
    ]
  },
  {
    "name": "Spring Cabbage Bibimbap",
    "url": "https://youtu.be/kb7c7qTyNlc",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2026-02-28",
    "ingredients": [
      "Spring Cabbage",
      "Soy Sauce",
      "Gochugaru",
      "Garlic",
      "Plum Extract",
      "Tuna Sauce",
      "Sesame Oil",
      "Sesame Seeds"
    ],
    "steps": [
      "Combine soy sauce, gochugaru, garlic, plum extract, tuna sauce, water, sesame oil, and sesame seeds to make the seasoning sauce.",
      "Add the seasoning sauce to the spring cabbage and mix well.",
      "Serve in a bowl."
    ]
  },
  {
    "name": "Cheese Platter",
    "url": "https://youtu.be/TaE1-idqdZY",
    "uploader": "한신희",
    "upload_date": "2026-03-04",
    "ingredients": [
      "Isigny Camembert",
      "Brie au Bleu Cheese",
      "Comté Cheese",
      "Tête de Moine Cheese",
      "Smoked Cheese",
      "Saint-André Cheese",
      "Baguette",
      "Soft Bread",
      "Sliced Ham",
      "Honey",
      "White Wine",
      "Red Wine"
    ],
    "steps": [
      "Slice the Camembert cheese.",
      "Place the sliced Camembert cheese on baguette.",
      "Lightly melt the cheese using an oven or torch.",
      "Drizzle honey over the melted cheese and top with roasted almonds.",
      "Slice the Brie au Bleu cheese.",
      "Cut the Comté cheese into stick shapes.",
      "Place the Tête de Moine cheese on soft bread.",
      "Place sliced ham on the Tête de Moine cheese to make a sandwich.",
      "Slice the smoked cheese.",
      "Slice the Saint-André cheese.",
      "Arrange all prepared cheeses, bread, honey, almonds, and wine on a platter."
    ]
  },
  {
    "name": "Buldak Seaweed Noodle Soup",
    "url": "https://youtu.be/EXr6DPRYXeQ",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2026-03-03",
    "ingredients": [
      "Beef Seaweed Soup",
      "Buldak liquid sauce",
      "Buldak powdered soup base",
      "Buldak vegetable flakes",
      "Buldak noodles",
      "Sesame seeds",
      "Sesame oil"
    ],
    "steps": [
      "Pour beef seaweed soup into a pot.",
      "Add 150ml of water to the pot.",
      "Add the Buldak liquid sauce to the pot.",
      "Add the Buldak powdered soup base to the pot.",
      "Add the Buldak vegetable flakes.",
      "Once the contents of the pot boil, add Buldak noodles and cook.",
      "Transfer the finished Buldak Seaweed Noodle Soup to a bowl.",
      "Sprinkle sesame seeds according to taste.",
      "Drizzle one or two drops of sesame oil according to taste."
    ]
  },
  {
    "name": "European Vegetable Bouquet Recipe Collection",
    "url": "https://youtu.be/vBUJjsUHA4E",
    "uploader": "한신희",
    "upload_date": "2026-03-06",
    "ingredients": [
      "Canned tuna",
      "Onion",
      "Garlic",
      "Cheongyang chili pepper",
      "Cooked rice",
      "European salad greens",
      "Olives",
      "Shrimp",
      "Burrata cheese",
      "Boneless chicken thigh",
      "Egg",
      "Ham",
      "Bread",
      "Tomato",
      "Gochujang",
      "Doenjang",
      "Gochugaru",
      "Sesame oil",
      "Perilla oil",
      "Toasted sesame seeds",
      "Salt",
      "Basil pesto",
      "Balsamic vinegar",
      "Black pepper",
      "Mayonnaise",
      "Olive oil"
    ],
    "steps": [
      "Drain oil from canned tuna and place in a bowl.",
      "Finely chop half an onion and add to the bowl.",
      "Finely mince garlic and add to the bowl.",
      "Remove seeds from Cheongyang chili pepper, roughly chop for texture, and add to the bowl.",
      "Add gochujang, doenjang, gochugaru, sesame oil, perilla oil, and toasted sesame seeds, mix well to make tuna ssamjang.",
      "Add salt and sesame oil to cooked rice and form rice balls.",
      "Pick and wash the wrapping greens from the European salad greens.",
      "Place rice balls and tuna ssamjang on the wrapping greens to make tuna ssamjang ssam-bap (rice wraps).",
      "Arrange European salad greens beautifully on a plate, as if decorating a garden.",
      "Arrange olives by color.",
      "Place blanched shrimp on top.",
      "Add burrata cheese.",
      "Chop roasted almonds and sprinkle over.",
      "Drizzle with basil pesto.",
      "Add olive oil and balsamic vinegar to complete the Basil Burrata Salad.",
      "Season boneless chicken thigh with salt and black pepper.",
      "In a pan with generous oil, slowly grill garlic and chicken thigh, starting with the skin side down.",
      "Flip the fried egg and ham to cook them well-done.",
      "Toast three slices of bread.",
      "Spread mayonnaise on the toasted bread.",
      "Generously layer vegetables, egg, and ham on one slice of bread.",
      "Cover with another slice of bread, then layer mayonnaise, tomato, and chicken on top.",
      "Cover with the final slice of bread, then cut in half to complete the Chicken Club Sandwich."
    ]
  },
  {
    "name": "Cotechino and Lentils",
    "url": "https://youtu.be/LINrhptVCcc",
    "uploader": "미뇨끼",
    "upload_date": "2026-02-22",
    "ingredients": [
      "Cotechino sausage",
      "Lentils",
      "Celery",
      "Carrot",
      "Onion",
      "Salt",
      "Olive oil",
      "Tomato paste"
    ],
    "steps": [
      "Slice the cotechino sausage.",
      "Dice celery, carrot, and onion.",
      "Heat olive oil in a pot.",
      "Add diced celery, carrot, and onion and sauté.",
      "Add tomato paste and mix.",
      "Add lentils and sauté briefly.",
      "Pour in water and bring to a boil.",
      "Cover the pot and simmer until tender.",
      "Boil the cotechino sausage in water.",
      "Season the cooked lentils with salt.",
      "Spoon lentils onto a plate.",
      "Top the lentils with the boiled cotechino sausage."
    ]
  },
  {
    "name": "Bomdong Lasagna",
    "url": "https://youtu.be/4tDFyW3U9nw",
    "uploader": "미뇨끼",
    "upload_date": "2026-02-27",
    "ingredients": [
      "Bomdong",
      "Jambon",
      "Butter",
      "Milk",
      "Parmesan Cheese",
      "Egg",
      "Salt",
      "Flour"
    ],
    "steps": [
      "Cut off the base of the bomdong and separate the leaves.",
      "Blanch the bomdong in boiling salted water.",
      "Cool the blanched bomdong in cold water, then squeeze out excess water thoroughly.",
      "Mix flour and egg to make a dough, then roll out into lasagna sheets.",
      "Boil the lasagna sheets once, cool in cold water, and drain well.",
      "Melt butter and flour in a pot, cook briefly, then gradually add milk while stirring to make a Béchamel sauce.",
      "Spread a layer of Béchamel sauce in a baking dish, then layer with lasagna sheets, bomdong, Parmesan cheese, and jambon.",
      "Top generously with Béchamel sauce and Parmesan cheese.",
      "Bake in a preheated 180°C oven for 20 minutes."
    ]
  },
  {
    "name": "Buldak Seaweed Noodle Soup",
    "url": "https://youtu.be/Yl63hcsYWK0",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2026-03-04",
    "ingredients": [
      "Beef seaweed soup",
      "Ramyeon noodles",
      "Buldak liquid sauce",
      "Buldak powdered seasoning"
    ],
    "steps": [
      "Add water to a pot.",
      "Add beef seaweed soup to the pot.",
      "Add Buldak liquid sauce to the pot.",
      "Add Buldak powdered seasoning to the pot.",
      "Add ramyeon noodles to the pot.",
      "Boil until noodles are cooked.",
      "Transfer the finished Buldak Seaweed Noodle Soup to a bowl."
    ]
  },
  {
    "name": "Chiacchiere",
    "url": "https://youtu.be/jZRtH0CAkZo",
    "uploader": "미뇨끼",
    "upload_date": "2026-03-01",
    "ingredients": [
      "Flour",
      "Eggs",
      "Butter",
      "Orange Zest",
      "Sugar",
      "Liqueur",
      "Cooking Oil",
      "Powdered Sugar"
    ],
    "steps": [
      "Put flour, sugar, liqueur, butter, orange zest, and eggs into a mixer and knead the dough.",
      "Form the dough into a ball and knead until smooth.",
      "Roll out the dough thinly using a pasta machine.",
      "Cut the rolled-out dough into rectangular shapes using a fluted pastry wheel.",
      "Make a small slit in the center of each rectangular piece of dough.",
      "Place the dough in hot cooking oil and fry until golden brown.",
      "Remove the fried Chiacchiere from the oil.",
      "Arrange the Chiacchiere on a plate.",
      "Dust the Chiacchiere with powdered sugar to finish."
    ]
  },
  {
    "name": "Homemade Aromatic Oil",
    "url": "https://youtu.be/oWDLGDwRAYY",
    "uploader": "한신희",
    "upload_date": "2026-03-10",
    "ingredients": [
      "Shallots",
      "Green onions",
      "Ginger",
      "Cooking oil"
    ],
    "steps": [
      "Finely mince the shallots.",
      "Remove the core and film from the green onions, then thinly slice and finely mince.",
      "Thinly slice and finely mince the ginger.",
      "Add cooking oil to a pot, then add the minced shallots, green onions, and ginger.",
      "Simmer slowly over low heat to infuse the aroma.",
      "Once the moisture has evaporated and the bubbles become smaller, slightly increase the heat and fry until the vegetables are crispy.",
      "When the vegetable flakes turn golden brown, turn off the heat and immediately remove the vegetables.",
      "Strain the finished aromatic oil through a fine-mesh sieve lined with a paper towel.",
      "Let the aromatic oil cool, then transfer to containers for storage.",
      "Remove as much oil as possible from the vegetable flakes with a paper towel and store them crispy."
    ]
  },
  {
    "name": "Korean Black & White Liquor",
    "url": "https://youtu.be/q97M3MmSg1g",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2026-03-10",
    "ingredients": [
      "rice",
      "wheat"
    ],
    "steps": [
      "Cook rice, then spread it thinly and widely on a clean cloth to cool quickly.",
      "Sprinkle water over polished wheat and mix evenly.",
      "Shape the wheat by hand into a dumpling form, then place it in a mold and press with your feet to create the nuruk (fermentation starter) shape.",
      "Grind the well-dried nuruk into a powder.",
      "Add the nuruk powder to the cooled rice.",
      "Mix the rice and nuruk powder thoroughly by hand until well combined.",
      "Place the mixed ingredients into an earthenware pot and ferment for 7 months.",
      "Scoop out and taste the top liquid from the fermented Heukbaekju.",
      "Place the fermented mash from the pot into a cotton cloth, set it on a strainer rack, and press to filter.",
      "Pour the filtered Heukbaekju into bottles."
    ]
  },
  {
    "name": "Spring Cabbage Salsiccia Pasta",
    "url": "https://youtu.be/giJ3qSqIyKU",
    "uploader": "미뇨끼",
    "upload_date": "2026-03-05",
    "ingredients": [
      "Spring Cabbage",
      "Garlic",
      "Salsiccia",
      "Penne",
      "Salt",
      "White Wine",
      "Olive Oil",
      "Parmesan Cheese"
    ],
    "steps": [
      "Separate outer spring cabbage leaves, halve them, then cut into bite-sized pieces (about three segments).",
      "Halve fresh salsiccia and scoop out the filling with a spoon.",
      "Heat olive oil in a pan and sauté garlic.",
      "Add salsiccia and cook, breaking it into small pieces.",
      "Add spring cabbage and stir-fry.",
      "Season with salt and cook until spring cabbage is tender.",
      "Add white wine.",
      "Add cooked penne pasta to the pan.",
      "Turn off heat and add one ladle of pasta water.",
      "Add olive oil and Parmesan cheese.",
      "Toss to combine all ingredients well."
    ]
  },
  {
    "name": "Anchovy Tomato Oil Pasta",
    "url": "https://youtu.be/vu8PHkyMT4k",
    "uploader": "미뇨끼",
    "upload_date": "2026-03-08",
    "ingredients": [
      "Garlic",
      "Anchovies",
      "Dried chili peppers",
      "Cherry tomatoes",
      "Spaghetti",
      "Parmesan cheese",
      "Parsley",
      "Olive oil"
    ],
    "steps": [
      "Heat olive oil in a pan and sauté the garlic.",
      "Add anchovies and dried chili peppers and sauté together.",
      "Add halved cherry tomatoes and sauté until softened.",
      "Add al dente spaghetti to the pan.",
      "Add a ladleful of pasta water and simmer until the sauce thickens slightly.",
      "Sprinkle generously with Parmesan cheese and add chopped parsley."
    ]
  },
  {
    "name": "Webfoot Octopus and Shepherd's Purse Risotto",
    "url": "https://youtu.be/4nQTpi_D0v4",
    "uploader": "한신희",
    "upload_date": "2026-03-12",
    "ingredients": [
      "Webfoot octopus",
      "Shepherd's purse",
      "Rice",
      "Salt",
      "Butter",
      "Flavored oil",
      "Flour",
      "Chicken broth",
      "White wine",
      "Fried vegetables"
    ],
    "steps": [
      "Clean webfoot octopus by removing internal organs, mouth, and eyes; rub with flour to clean suckers.",
      "Blanch cleaned webfoot octopus in boiling water for 30 seconds, then cut into bite-sized pieces.",
      "Blanch shepherd's purse in salted water, reserving some for garnish.",
      "Combine blanched shepherd's purse and chicken broth, then blend finely to create shepherd's purse chicken broth.",
      "Melt butter in a pan, then sauté blanched webfoot octopus and reserved shepherd's purse for 1-2 minutes until lightly browned. Set aside.",
      "In the same pan, sauté rice, then add white wine and chicken broth and simmer until reduced.",
      "Once the chicken broth has reduced, add the shepherd's purse chicken broth and simmer, stirring continuously, until the rice is cooked and the risotto is creamy.",
      "When the risotto reaches the desired consistency, turn off the heat, add butter, and mix well by shaking the pan.",
      "Serve the risotto evenly on a plate.",
      "Top with the sautéed webfoot octopus and shepherd's purse, garnish with fried vegetables, and drizzle with flavored oil."
    ]
  },
  {
    "name": "Beef Sandwich",
    "url": "https://youtu.be/HStopKYbTgY",
    "uploader": "한신희",
    "upload_date": "2026-03-14",
    "ingredients": [
      "Beef tenderloin",
      "Onion",
      "Bread",
      "Emmental cheese",
      "Salt",
      "Pepper",
      "Balsamic vinegar",
      "Mayonnaise",
      "Oil",
      "Butter"
    ],
    "steps": [
      "Finely mince the beef tenderloin.",
      "Add salt and pepper to the minced beef and knead it well.",
      "Form the beef into patties the size of the bread, pressing down in the center.",
      "Thinly slice the onion.",
      "Slice the bread thickly and toast until golden brown.",
      "Heat oil in a pan and cook the beef patties to medium.",
      "Flip the patties and baste them with butter while cooking.",
      "Place sliced Emmental cheese on top of the patties, cover, and melt.",
      "In the same pan, add the onion, season with salt, and sauté, scraping up any browned bits from the bottom of the pan.",
      "Add balsamic vinegar to the sautéed onions.",
      "Spread a thin layer of mayonnaise on the toasted bread.",
      "Place the patty and onions on one slice of bread, then cover with another slice to make a sandwich.",
      "Slice the sandwich and serve."
    ]
  },
  {
    "name": "Lao Gan Ma Garlic Chives Shrimp Pasta",
    "url": "https://youtu.be/qO3Ges3E5ME",
    "uploader": "미뇨끼",
    "upload_date": "2026-03-11",
    "ingredients": [
      "Garlic chives",
      "Shrimp",
      "Garlic",
      "Pasta",
      "Lao Gan Ma",
      "Olive oil",
      "Butter"
    ],
    "steps": [
      "Slice the garlic chives.",
      "Prepare the shrimp.",
      "Heat olive oil in a pan and sauté the garlic.",
      "Add the garlic chives and stir-fry.",
      "Add the shrimp and cook until done.",
      "Add Lao Gan Ma and stir-fry with all ingredients.",
      "Add cooked casarecce pasta.",
      "Add butter.",
      "Mix all ingredients well.",
      "Serve the finished pasta on a plate."
    ]
  },
  {
    "name": "Spring Greens Beef Tartare Bibimbap",
    "url": "https://youtu.be/MOfzwbDjk1E",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2026-03-17",
    "ingredients": [
      "Beef",
      "Watercress",
      "Glasswort",
      "Daylily Shoots",
      "Pear",
      "Oligosaccharide Syrup",
      "Chili Powder",
      "Gochujang",
      "Plum Extract",
      "Soy Sauce",
      "Mirin",
      "Sugar",
      "Garlic",
      "Sesame Seeds",
      "Black Pepper",
      "Lemon",
      "Salt",
      "Sesame Oil",
      "Cooked Rice",
      "Egg"
    ],
    "steps": [
      "Combine oligosaccharide syrup, chili powder, gochujang, plum extract, soy sauce, mirin, water, lemon juice, sugar, minced garlic, grated pear, sesame seeds, and black pepper to create the all-purpose yukhoe bibimbap sauce.",
      "Blanch daylily shoots in boiling salted water for 10-15 seconds, then rinse in cold water, squeeze out excess water, cut into bite-sized pieces, and lightly season with salt and sesame oil.",
      "Wash and prepare watercress and glasswort; cut longer pieces of glasswort.",
      "Mix the beef tartare with the all-purpose yukhoe bibimbap sauce and a little sesame oil.",
      "Place cooked rice in a bowl, then arrange watercress, blanched daylily shoots, and glasswort around it.",
      "Place the seasoned yukhoe in the center, leaving a space in the middle for an egg yolk.",
      "Sprinkle with sesame seeds and black pepper, then drizzle a little sesame oil over the vegetables.",
      "Mix all ingredients well and enjoy."
    ]
  },
  {
    "name": "Caesar Salad with Crispy Chicken",
    "url": "https://youtu.be/6sBe-zxwgyI",
    "uploader": "한신희",
    "upload_date": "2026-03-17",
    "ingredients": [
      "Chicken thigh",
      "Salad greens",
      "Dill",
      "Salt",
      "Pepper",
      "Dijon mustard",
      "Lemon juice",
      "Garlic",
      "Grated cheese",
      "Apple cider vinegar",
      "Anchovies",
      "Grana Padano cheese",
      "Oil",
      "Egg yolk",
      "Olive oil"
    ],
    "steps": [
      "Season chicken thighs with salt and pepper.",
      "Heat oil in a pan and cook chicken skin-side down until crispy.",
      "Remove cooked chicken thighs and set aside.",
      "Add water to the pan where chicken was cooked, scrape up the browned bits to create a deglazing liquid.",
      "Combine egg yolk, Dijon mustard, lemon juice, garlic, grated cheese, apple cider vinegar, anchovies, and the deglazing liquid in a measuring cup.",
      "Blend all ingredients until smooth using an immersion blender.",
      "Slowly add olive oil while blending until the dressing thickens.",
      "Add pepper to finish the dressing.",
      "Gently toss salad greens with Caesar dressing in a bowl.",
      "Plate the dressed salad and top with shredded cooked chicken thighs.",
      "Sprinkle dill and grated cheese over the salad.",
      "Grate Grana Padano cheese into a hot pan and cook until golden brown to form a cheese crisp.",
      "Crumble the finished cheese crisp over the salad."
    ]
  },
  {
    "name": "Mushroom Pappardelle Pasta",
    "url": "https://youtu.be/AmszctU4YiA",
    "uploader": "미뇨끼",
    "upload_date": "2026-03-15",
    "ingredients": [
      "Oyster Mushrooms",
      "Shimeji Mushrooms",
      "Button Mushrooms",
      "Shiitake Mushrooms",
      "Dried Shiitake Mushrooms",
      "Pappardelle",
      "Minced Garlic",
      "White Wine",
      "Salt",
      "Parmesan Cheese",
      "Parsley",
      "Olive Oil",
      "Butter"
    ],
    "steps": [
      "Slice the oyster mushrooms, shimeji mushrooms, button mushrooms, and shiitake mushrooms into various shapes and sizes.",
      "Rehydrate the dried shiitake mushrooms in hot water to make a broth.",
      "Heat a generous amount of olive oil in a pan and lightly sauté the minced garlic.",
      "Add all the sliced mushrooms, mix well, then add a splash of white wine.",
      "Season with salt, then cover and steam-cook the mushrooms until easily tender.",
      "Boil the pappardelle for about 5 minutes, leaving it significantly undercooked."
    ]
  },
  {
    "name": "Grilled Mackerel with Romesco Sauce",
    "url": "https://youtu.be/zmk-dNjcCdM",
    "uploader": "강레오 걍레오",
    "upload_date": "2025-10-09",
    "ingredients": [
      "Mackerel",
      "Bell Pepper",
      "Tomato Sauce",
      "Garlic",
      "Almonds",
      "Paprika Powder",
      "Salt",
      "Pepper",
      "Olive Oil",
      "Parsley"
    ],
    "steps": [
      "Remove the head and guts from the mackerel and wash it clean.",
      "Pat dry the inside of the mackerel with a paper towel.",
      "Fillet the mackerel and remove any small bones.",
      "Season the mackerel fillets with salt and pepper, and score the skin side.",
      "Heat olive oil in a pan, grill the mackerel skin-side down until crispy, then flip and grill for about 10 more seconds.",
      "Roast the bell peppers over direct flame until the skin is completely charred black."
    ]
  },
  {
    "name": "European-Style Peking Duck",
    "url": "https://youtu.be/J4n7YOuIUDE",
    "uploader": "강레오 걍레오",
    "upload_date": "2025-10-16",
    "ingredients": [
      "Duck",
      "Green onions",
      "Cucumber",
      "Dumpling wrappers",
      "Parsley",
      "Salt",
      "Black pepper",
      "Hoisin sauce",
      "Olive oil",
      "Duck fat"
    ],
    "steps": [
      "Pat duck dry with paper towels.",
      "Score the duck skin only.",
      "Season both sides of the duck with salt and pepper.",
      "Lightly drizzle olive oil in a cold pan and place the duck skin-side down.",
      "Start on medium-low heat and render the duck skin until crispy.",
      "Remove rendered duck fat and cook the duck on one side without flipping.",
      "Rest the cooked duck briefly.",
      "Julienne green onions and cucumber.",
      "Brush duck fat between 3-4 dumpling wrappers, stack them, and roll out thinly with a rolling pin.",
      "Steam the rolled-out dumpling wrappers until puffed, then separate them into individual sheets.",
      "Combine hoisin sauce with the duck drippings from resting to make a dipping sauce.",
      "Thinly slice the rested duck.",
      "Serve duck, julienned green onions and cucumber, and sauce wrapped in the steamed pancakes."
    ]
  },
  {
    "name": "Assorted Grilled Fish Set Meal",
    "url": "https://youtu.be/jdwesAD-WtU",
    "uploader": "강레오 걍레오",
    "upload_date": "2025-10-23",
    "ingredients": [
      "Mackerel",
      "Atka Mackerel",
      "Spanish Mackerel",
      "Flounder",
      "Freshwater Shrimp",
      "Korean Radish",
      "Scallions",
      "Acorn Jelly",
      "Glass Noodles",
      "Various Vegetables",
      "Rice Cakes",
      "Tofu",
      "Rice",
      "Mushrooms",
      "Minced Meat",
      "Seaweed",
      "Kimchi Seasoning",
      "Soy Sauce",
      "Chili Powder",
      "Minced Garlic",
      "Sesame Seeds",
      "Gochujang"
    ],
    "steps": [
      "Prepare various fish such as mackerel, Atka mackerel, Spanish mackerel, and flounder, then grill them until golden brown in a stone oven.",
      "Simmer freshwater shrimp, Korean radish, and various vegetables to make Terleagi (freshwater fish stew).",
      "Soak rice, then cook Mushroom Pot Rice with mushrooms and minced meat, or Seaweed Pot Rice with seaweed.",
      "Serve or prepare various side dishes such as Scallion Kimchi, Acorn Jelly, Japchae, Tteokbokki, and Braised Tofu from the prepared dish area.",
      "Arrange the warm pot rice, Terleagi stew, stone oven-grilled fish, and all prepared side dishes in the traditional 12-cheop bansang style."
    ]
  },
  {
    "name": "Honey Butter Banana Croissant",
    "url": "https://youtu.be/gwU4OirTiY8",
    "uploader": "강레오 걍레오",
    "upload_date": "2025-10-30",
    "ingredients": [
      "Croissant",
      "Banana",
      "Blueberries",
      "Ice cream",
      "Honey",
      "Cane sugar",
      "Butter",
      "Pistachio powder"
    ],
    "steps": [
      "Melt the butter.",
      "Add honey to the melted butter and mix well.",
      "Slice the croissant in half.",
      "Spread the butter-honey mixture on the croissant and sprinkle with cane sugar.",
      "Bake the croissant in the oven.",
      "Peel and slice the banana.",
      "Caramelize honey in a pan over low heat until it turns brown.",
      "Add banana to the caramelized honey, toss, and cook.",
      "Add blueberries and gently toss with the honey mixture.",
      "Place the baked croissant on a plate.",
      "Top the croissant with the cooked banana and blueberries.",
      "Add a scoop of ice cream.",
      "Sprinkle with pistachio powder.",
      "Slice the croissant into serving pieces."
    ]
  },
  {
    "name": "Grilled Mackerel",
    "url": "https://youtu.be/pu9llQWYb4k",
    "uploader": "강레오 걍레오",
    "upload_date": "2025-11-12",
    "ingredients": [
      "Mackerel",
      "Salt",
      "Pepper",
      "Cooking oil"
    ],
    "steps": [
      "Remove the fins from the mackerel.",
      "Pat dry the mackerel with a paper towel.",
      "Fillet the mackerel.",
      "Season the mackerel with fine salt.",
      "Score the mackerel skin, being careful not to cut into the flesh.",
      "Lightly sprinkle white pepper on the mackerel.",
      "Heat cooking oil in a pan.",
      "Place the mackerel, skin-side down, in the pan and press the center for 10 seconds.",
      "Flip the mackerel and cook the flesh side for another 10 seconds."
    ]
  },
  {
    "name": "Grilled Eel Rice Bowl",
    "url": "https://youtu.be/WFsM8Pzl5RQ",
    "uploader": "강레오 걍레오",
    "upload_date": "2025-11-13",
    "ingredients": [
      "Eel",
      "Rice",
      "Egg",
      "Soy sauce",
      "Mirin",
      "Sake",
      "Green onion",
      "Garlic",
      "Ginger",
      "Sugar",
      "Salt",
      "Pepper",
      "Chives"
    ],
    "steps": [
      "Wash rice and soak for about 20 minutes.",
      "Combine soy sauce, mirin, sake, green onion, garlic, ginger, and sugar in a pot and simmer over medium heat until reduced to make the sauce.",
      "Season prepared eel with salt and pepper.",
      "Grill the eel initially, then smoke it with burning rice straw for flavor.",
      "After the initial grilling, scrape off any burnt parts from the eel surface.",
      "Cook the soaked rice with water in a pot, ensuring it doesn't stick to the bottom.",
      "Cover the pot with foil between the lid to seal and let the rice steam.",
      "Dip the grilled eel in the sauce and grill again, repeating the process to coat it thoroughly.",
      "Slice the finished eel into bite-sized pieces.",
      "Drizzle the sauce over the rice in a bowl.",
      "Place a generous amount of julienned egg omelet on top of the rice.",
      "Arrange the sliced eel on top of the egg omelet, then garnish with chopped chives to finish."
    ]
  },
  {
    "name": "Crispy-Skinned, Tender Duck Breast",
    "url": "https://youtu.be/KBfIEs7qXBU",
    "uploader": "강레오 걍레오",
    "upload_date": "2025-11-14",
    "ingredients": [
      "duck breast",
      "salt",
      "pepper",
      "cooking oil"
    ],
    "steps": [
      "Pat dry the duck skin and flesh with paper towels.",
      "Remove any excess fascia from the duck.",
      "Score the duck skin.",
      "Season the duck generously with salt and pepper.",
      "Add a small amount of oil to a cold pan.",
      "Place the duck breast, skin-side down, in the pan.",
      "Once the fat starts rendering and sizzling from the skin, reduce heat to low.",
      "Press down on the duck skin with tongs to crisp it.",
      "Slice the crispy duck steak and serve."
    ]
  },
  {
    "name": "Ceviche and Clam Soup",
    "url": "https://youtu.be/NJTe9SZf6lA",
    "uploader": "강레오 걍레오",
    "upload_date": "2025-11-20",
    "ingredients": [
      "Mullet",
      "Shrimp",
      "Clams",
      "Shallots",
      "Cherry tomatoes",
      "Red radish",
      "Scallions",
      "Basil",
      "Dill",
      "Red bell pepper",
      "Pink peppercorns",
      "Baby capers",
      "Salt",
      "Pepper",
      "Garlic",
      "Lime",
      "White wine vinegar",
      "Extra virgin olive oil",
      "Cheongju",
      "Bread"
    ],
    "steps": [
      "Thinly slice shallots into rings.",
      "Slice cherry tomatoes and thinly slice red radish.",
      "Finely chop scallions, basil, and dill.",
      "Mince baby capers.",
      "Thinly slice red bell pepper.",
      "Peel the lime, separate the flesh, and dice it.",
      "Scrape off the white pith from the lime peel, then finely mince the peel to make lime zest.",
      "Cut mullet into bite-sized pieces and place in a bowl.",
      "Place minced garlic over the mullet.",
      "Remove shrimp heads, peel, and season with salt and pepper.",
      "Lightly sauté the seasoned shrimp in a pan with extra virgin olive oil.",
      "Add all the sliced vegetables, lime, capers, pink peppercorns, mullet, minced garlic, and sautéed shrimp to the bowl.",
      "Season with salt and pepper, and generously add white wine vinegar and extra virgin olive oil.",
      "Mix all ingredients well to combine.",
      "Serve the ceviche on a plate with bread.",
      "Place clams in a pot.",
      "Pour in a little Cheongju.",
      "Cover and boil over high heat until the clams open.",
      "Remove the open clams and discard one shell from each.",
      "Add a little more water to the remaining broth and bring to a boil.",
      "Add shrimp to the boiling water.",
      "Return the shelled clam meat to the broth.",
      "Add chopped scallions.",
      "Serve the clam soup in a bowl."
    ]
  },
  {
    "name": "Jeollado-style Grilled Chicken",
    "url": "https://youtu.be/E4Svvlwb528",
    "uploader": "강레오 걍레오",
    "upload_date": "2025-11-25",
    "ingredients": [
      "chicken",
      "cheongyang chili pepper",
      "green onion",
      "basil",
      "yuzu syrup",
      "yuzu juice",
      "salt",
      "black pepper",
      "perilla oil",
      "olive oil"
    ],
    "steps": [
      "Pat the whole chicken dry with paper towels.",
      "Separate the chicken into wings, drumsticks, and thighs (including oyster meat), then debone them.",
      "Slice chicken breasts into three pieces along the grain.",
      "Debone the prepared drumsticks and wings, then flatten them.",
      "Finely chop cheongyang chili pepper and the white part of the green onion.",
      "Finely chop basil.",
      "Combine chopped cheongyang chili, green onion, and basil with yuzu syrup, yuzu juice, salt, black pepper, and perilla oil to make the yuzu sauce.",
      "Light charcoal in a charcoal grill.",
      "Lightly brush olive oil on each prepared chicken piece and season with salt and pepper.",
      "Grill chicken until golden brown on one side, then flip and continue grilling until fully cooked.",
      "Serve the grilled chicken on a plate with the yuzu sauce."
    ]
  },
  {
    "name": "Galchi Ratatouille",
    "url": "https://youtu.be/fGMYJkNv0tc",
    "uploader": "강레오 걍레오",
    "upload_date": "2025-11-27",
    "ingredients": [
      "Beltfish",
      "Zucchini",
      "Eggplant",
      "Bell pepper",
      "Cherry tomatoes",
      "Onion",
      "Garlic",
      "Pancetta",
      "Tomato paste",
      "Whole peeled tomatoes",
      "Parsley",
      "Butter",
      "Parmesan cheese",
      "Salt",
      "Black pepper",
      "Olive oil"
    ],
    "steps": [
      "Pat dry the prepared beltfish with a kitchen towel.",
      "Remove the belly fat and blood from the beltfish.",
      "Make an incision on both sides of the beltfish's fin bones and remove the bones.",
      "Season the beltfish with salt and pepper.",
      "Cut zucchini, eggplant, bell pepper, cherry tomatoes, and onion into bite-sized pieces, and slice the garlic.",
      "Heat olive oil in a pan, sauté the onion and bell pepper, then season with salt and pepper."
    ]
  },
  {
    "name": "Butchering Chicken",
    "url": "https://youtu.be/5H86ainpyQQ",
    "uploader": "강레오 걍레오",
    "upload_date": "2025-11-29",
    "ingredients": [
      "Chicken"
    ],
    "steps": [
      "Separate the chicken wings by cutting through the elbow joint.",
      "Make an incision along the breast, keeping as much skin attached as possible towards the breast.",
      "Cut the ligaments between the joints, then pull the bone straight out to separate.",
      "Remove the oyster meat with your fingers.",
      "Since the upper part of the breastbone is thick and tapers towards the bottom, angle the knife slightly and follow the bone to separate, rather than holding it straight.",
      "Flip the chicken, hold the tenderloin, cut the ligaments from the back, and pull the bone straight out to separate."
    ]
  },
  {
    "name": "Pine and Button Mushroom Toast",
    "url": "https://youtu.be/rfFCVk7doUg",
    "uploader": "강레오 걍레오",
    "upload_date": "2025-12-04",
    "ingredients": [
      "button mushrooms",
      "pine mushrooms",
      "onion",
      "garlic",
      "parsley",
      "salt",
      "pepper",
      "olive oil",
      "butter",
      "bread",
      "Parmesan cheese"
    ],
    "steps": [
      "Clean button mushrooms and cut into quarters.",
      "Tear or slice pine mushrooms into bite-sized pieces, thinly slice the onion, and mince the garlic.",
      "Season the torn pine mushrooms with salt, pepper, and olive oil, then toss to coat.",
      "Heat olive oil in a pan, add button mushrooms, and season with salt and pepper.",
      "Sauté over high heat until the mushrooms are golden brown and their moisture has evaporated.",
      "Add the thinly sliced onion, a drizzle of olive oil, and butter to the sautéed button mushrooms, and continue to cook until tender.",
      "Stir in the minced garlic and parsley, then remove from heat.",
      "Place the sautéed button mushrooms and seasoned pine mushrooms on toasted bread.",
      "Generously sprinkle with Parmesan cheese and garnish with additional chopped parsley."
    ]
  },
  {
    "name": "Clam Soup",
    "url": "https://youtu.be/qIrKeMirRt8",
    "uploader": "강레오 걍레오",
    "upload_date": "2025-12-05",
    "ingredients": [
      "Clams",
      "Ganghwa Island Shrimp",
      "Scallions",
      "Cheongju"
    ],
    "steps": [
      "Place clams in a pan.",
      "Add a little Cheongju.",
      "Cover and boil.",
      "Remove opened clams.",
      "Shuck the clam meat.",
      "Add a little more water to the pan and boil.",
      "Add Ganghwa Island shrimp and boil.",
      "Return the clam meat.",
      "Add green parts of scallions.",
      "Serve the clam soup in a bowl."
    ]
  },
  {
    "name": "Kang Leo's Tteokbokki Medley",
    "url": "https://youtu.be/Vz8YjVOm4ic",
    "uploader": "강레오 걍레오",
    "upload_date": "2025-12-11",
    "ingredients": [
      "Rice cakes",
      "Tiger shrimp",
      "Clams",
      "Oysters",
      "Carrots",
      "Green onions",
      "Onions",
      "Tomatoes",
      "Salt",
      "Tomato gochujang",
      "Saffron",
      "Butter",
      "Chili oil",
      "Starch",
      "Eggs"
    ],
    "steps": [
      "Slice onions, carrots, and green onions.",
      "Sauté shrimp heads, shells, tomatoes, and vegetables, then strain to make shrimp bisque.",
      "Shell clams; parboil oysters and separate them from their broth.",
      "Season rice cakes with salt.",
      "Prepare oyster broth and thicken with starch.",
      "Add saffron and butter to the clam tteokbokki base, bring to a boil, then add rice cakes and clams and cook.",
      "Add tomato gochujang, rice cakes, and shrimp meat to the shrimp bisque and cook to make gochujang tteokbokki.",
      "Add rice cakes and oysters to the oyster tteokguk broth and cook.",
      "Make meringue from egg whites, place it on top of the oyster tteokguk, and garnish with green onions and chili oil.",
      "Serve Clam Saffron Tteokbokki, Shrimp Gochujang Tteokbokki, and Oyster Tteokguk in bowls."
    ]
  },
  {
    "name": "Ceviche",
    "url": "https://youtu.be/sahOLkBxxGE",
    "uploader": "강레오 걍레오",
    "upload_date": "2025-12-12",
    "ingredients": [
      "Sliced mullet",
      "Medium shrimp",
      "Shallots",
      "Cherry tomatoes",
      "Scallions",
      "Lime",
      "Baby capers",
      "Pink peppercorns",
      "Salt",
      "Pepper",
      "Olive oil"
    ],
    "steps": [
      "Finely chop the shallots, cherry tomatoes, and scallions.",
      "Place the chopped scallions, cherry tomatoes, and shallots in a bowl.",
      "Add the pink peppercorns.",
      "Add finely chopped baby capers.",
      "Peel the lime, segment it, and finely chop the pulp.",
      "Add half of the chopped lime pulp to the bowl.",
      "Add the sliced mullet to the bowl.",
      "Season the medium shrimp with salt and pepper.",
      "Lightly sauté the seasoned shrimp in a hot pan.",
      "Add the sautéed shrimp to the bowl.",
      "Season with salt and pepper.",
      "Drizzle generously with extra virgin olive oil.",
      "Mix all ingredients well."
    ]
  },
  {
    "name": "Leo Kang's Clam Tteokbokki",
    "url": "https://youtu.be/IyYVs9Phmn4",
    "uploader": "강레오 걍레오",
    "upload_date": "2025-12-15",
    "ingredients": [
      "Clam",
      "Rice cakes",
      "Salt",
      "Saffron",
      "Butter"
    ],
    "steps": [
      "Cut the rice cakes into bite-sized pieces.",
      "Place the cut rice cakes in a bowl and season with salt.",
      "Put the rice cakes in a pot.",
      "Add saffron.",
      "Add butter.",
      "Add clams."
    ]
  },
  {
    "name": "Shrimp Tteokbokki",
    "url": "https://youtu.be/lXN1l_rd4f8",
    "uploader": "강레오 걍레오",
    "upload_date": "2025-12-17",
    "ingredients": [
      "shrimp",
      "rice cakes",
      "tomato gochujang",
      "garnish seeds"
    ],
    "steps": [
      "Extract bisque from shrimp heads and bring to a boil.",
      "Stir tomato gochujang into the bisque.",
      "Add rice cakes and simmer.",
      "Season and stir-fry shrimp separately.",
      "Add the stir-fried shrimp to the tteokbokki at the very end.",
      "Mix well to cook the shrimp with residual heat.",
      "Serve in a bowl, topped with garnish seeds."
    ]
  },
  {
    "name": "Oyster Stew",
    "url": "https://youtu.be/7PVm9x2g2Ak",
    "uploader": "강레오 걍레오",
    "upload_date": "2025-12-18",
    "ingredients": [
      "Oysters",
      "Onion",
      "Cherry Tomatoes",
      "Tabasco",
      "Parsley",
      "Olive Oil",
      "White Wine",
      "Baguette Bread"
    ],
    "steps": [
      "Heat olive oil in a pan.",
      "Add onion and sauté until tender.",
      "Add cherry tomatoes and cook.",
      "Pour in white wine.",
      "Add oysters.",
      "Stir in a dash of Tabasco.",
      "Simmer to reduce the liquid and thicken the stew.",
      "Sprinkle with parsley.",
      "Serve with baguette bread."
    ]
  },
  {
    "name": "Oyster Rice Cake Soup",
    "url": "https://youtu.be/3dDSzM_RXU4",
    "uploader": "강레오 걍레오",
    "upload_date": "2025-12-24",
    "ingredients": [
      "Oyster",
      "Rice cakes",
      "Egg",
      "Green onion",
      "Chili oil"
    ],
    "steps": [
      "Cook oysters and green onions in a pot.",
      "Remove the cooked oysters from the pot.",
      "Strain the broth used to cook the oysters and return it to the pot.",
      "After boiling the broth, add rice cakes and cook.",
      "When the rice cakes are cooked, return the oysters to the pot.",
      "Whisk the egg white until foamy.",
      "Add the foamy egg white to the rice cake soup.",
      "Transfer the finished rice cake soup to a bowl.",
      "Garnish with green onions and chili oil as desired."
    ]
  },
  {
    "name": "Korean Beef Rice Bowl",
    "url": "https://youtu.be/6N0d4R6o2AA",
    "uploader": "강레오 걍레오",
    "upload_date": "2025-12-29",
    "ingredients": [
      "Beef",
      "Green onion",
      "Ginger",
      "Garlic",
      "Onion",
      "Scallions",
      "Soy sauce",
      "Mirin",
      "Sake",
      "Yuzu marmalade",
      "Salt",
      "Black pepper",
      "Sesame seeds",
      "Cooking oil",
      "Cooked rice"
    ],
    "steps": [
      "In a pan, combine soy sauce, mirin, sake, yuzu marmalade, green onion, ginger, crushed garlic, and onion. Bring to a boil to make the rice bowl sauce.",
      "Season the beef with salt and black pepper.",
      "Heat cooking oil in a hot pan and sear the seasoned beef until golden brown.",
      "Slice the seared beef into bite-sized pieces.",
      "Arrange the sliced beef neatly over cooked rice.",
      "Pour the prepared rice bowl sauce over the beef.",
      "Garnish with scallions and sesame seeds."
    ]
  },
  {
    "name": "John Dory Platter",
    "url": "https://youtu.be/jDhUL0QsOdA",
    "uploader": "강레오 걍레오",
    "upload_date": "2026-01-01",
    "ingredients": [
      "John Dory",
      "Perilla leaves",
      "Salt",
      "Pepper",
      "Chili powder",
      "Soy sauce",
      "Wasabi",
      "Olive oil",
      "Butter"
    ],
    "steps": [
      "Clean the John Dory, removing the head and guts.",
      "Fillet the cleaned John Dory.",
      "Season the John Dory liver with salt and olive oil, then wrap in foil and steam.",
      "Divide the John Dory fillets for sashimi and grilling.",
      "For sashimi, skin and thinly slice a portion of the fillet. Thinly slice some of the steamed liver and arrange both on a plate with perilla leaves.",
      "Season the grilling fillets with salt and chili powder.",
      "Heat olive oil and butter in a pan, then pan-fry the seasoned fillets until golden brown.",
      "Thinly slice the remaining steamed liver and serve on a plate with wasabi and soy sauce.",
      "Serve the grilled fillets on a plate."
    ]
  },
  {
    "name": "Grilled Marinated Sirloin Tip Steak",
    "url": "https://youtu.be/z8gj8BP8b1c",
    "uploader": "강레오 걍레오",
    "upload_date": "2026-01-02",
    "ingredients": [
      "Sirloin tip",
      "Green onion",
      "Garlic",
      "Savory Seasoning Sauce",
      "White pepper",
      "Honey",
      "Sesame seeds"
    ],
    "steps": [
      "Finely chop green onions.",
      "Chop garlic.",
      "Place sirloin tip in a bowl.",
      "Pour savory seasoning sauce over the sirloin tip.",
      "Sprinkle white pepper.",
      "Add honey.",
      "Mix all ingredients well by hand.",
      "Place marinated sirloin tip on a plate and sprinkle with sesame seeds.",
      "Grill over charcoal."
    ]
  },
  {
    "name": "Jondori Sashimi",
    "url": "https://youtu.be/UHPWhCAFT18",
    "uploader": "강레오 걍레오",
    "upload_date": "2026-01-07",
    "ingredients": [
      "Jondori",
      "Jondori liver"
    ],
    "steps": [
      "Remove the head and internal organs from the Jondori.",
      "Carefully separate the Jondori liver.",
      "Scrape scales from bottom to top, being careful not to get cut by sharp bones, then rinse with water.",
      "Using a flexible knife, fillet the Jondori along the bones.",
      "Divide the filleted flesh into belly, middle, and back sections.",
      "Slice the Jondori fillets for sashimi.",
      "Slice the Jondori liver.",
      "Arrange the sliced Jondori sashimi and liver attractively on a plate."
    ]
  },
  {
    "name": "Aglio e Olio Pasta",
    "url": "https://youtu.be/eUkwkkRKdfY",
    "uploader": "강레오 걍레오",
    "upload_date": "2026-01-08",
    "ingredients": [
      "Spaghetti",
      "Garlic",
      "Pepperoncino Peppers",
      "Parsley",
      "Butter",
      "Olive Oil",
      "Salt",
      "Pepper"
    ],
    "steps": [
      "Mince some garlic, slice the pepperoncino peppers, and finely chop the parsley leaves.",
      "Boil water in a pot, add salt, then add parsley stems and a few garlic cloves to infuse flavor.",
      "Add spaghetti to the boiling water and cook for 1 minute and 45 seconds.",
      "In another pan, generously coat with olive oil, sauté minced garlic and pepperoncino peppers over low heat, then add butter for flavor.",
      "Remove the core from the garlic and blanch until translucent, then blend with olive oil, salt, pepper, and a little pasta water to create a pureed sauce.",
      "Drain the cooked spaghetti and transfer it to the pan with your chosen sauce (butter emulsified sauce or garlic puree), adding a little pasta water.",
      "Add the finely chopped parsley leaves and toss warm until the pasta and sauce are well combined.",
      "Optionally, add more minced raw garlic and toss before serving."
    ]
  },
  {
    "name": "Salmon Steak and Cantonese Poached Chicken",
    "url": "https://youtu.be/i3NDBmm9L0w",
    "uploader": "강레오 걍레오",
    "upload_date": "2026-01-15",
    "ingredients": [
      "Salmon",
      "Chicken",
      "Carrot",
      "Parsley",
      "Garlic",
      "Ginger",
      "Scallions",
      "Pine mushrooms",
      "Salt",
      "Black pepper",
      "Thyme",
      "Turmeric",
      "Olive oil",
      "Orange juice",
      "Butter",
      "Chili oil",
      "Soy sauce"
    ],
    "steps": [
      "Scale salmon skin and cut into portions.",
      "Score salmon skin, then season with salt and pepper.",
      "Cook salmon in an olive oil-coated pan, skin-side down first.",
      "Press down to crisp the salmon skin, then lightly cook the sides.",
      "Sprinkle with thyme, then remove from pan and let rest.",
      "Thinly slice carrots, place in an olive oil-coated pan, and season with salt and pepper.",
      "Add orange juice, thyme, parsley, minced garlic, and butter, then simmer to create carrot sauce.",
      "Spread carrot sauce on a plate, top with salmon steak, and drizzle lightly with salmon pan drippings.",
      "Cut the chicken down the back to halve, bone it out, flatten, then season with salt and pepper.",
      "Boil water in a pot, then add thyme sprigs, parsley stems, scallion (white part), garlic, ginger, and turmeric to make broth.",
      "Once the broth boils, reduce heat to low and poach the chicken for 20 minutes.",
      "Cool the poached chicken in ice water, then cut into bite-sized pieces.",
      "Mince scallions, pine mushrooms, garlic, and ginger, then mix with soy sauce, chili oil, and concentrated chicken drippings to make a sauce.",
      "Drizzle sauce over the chicken."
    ]
  },
  {
    "name": "Aglio e Olio",
    "url": "https://youtu.be/Q_o23H9YVAU",
    "uploader": "강레오 걍레오",
    "upload_date": "2026-01-19",
    "ingredients": [
      "Spaghetti",
      "Garlic",
      "Parsley",
      "Salt",
      "Black pepper",
      "Peperoncino",
      "Olive oil"
    ],
    "steps": [
      "Cut garlic cloves in half and remove the bitter germ.",
      "Blanch the prepared garlic in boiling water until translucent to remove pungency.",
      "Blend blanched garlic with olive oil, salt, and black pepper to make a garlic sauce.",
      "Mix a little pasta water into the prepared garlic sauce.",
      "Add olive oil and peperoncino to a non-heated pan.",
      "Add the cooked spaghetti to the pan.",
      "Pour in pasta water and the prepared garlic sauce, then mix thoroughly.",
      "Add chopped parsley and toss until the pasta and sauce are well combined.",
      "Serve on a plate."
    ]
  },
  {
    "name": "Pan-Seared John Dory with Liver",
    "url": "https://youtu.be/oC7gqxXTamM",
    "uploader": "강레오 걍레오",
    "upload_date": "2026-01-20",
    "ingredients": [
      "John Dory fish",
      "John Dory liver",
      "Salt",
      "Pepper",
      "Butter",
      "Potatoes",
      "Chorizo sausage",
      "Chives",
      "Parsley",
      "White wine vinegar",
      "Olive oil",
      "Caviar"
    ],
    "steps": [
      "Season the cleaned John Dory fish with salt and pepper.",
      "Cut the John Dory liver into bite-sized pieces and season with salt and pepper.",
      "In a pan with olive oil, pan-sear the seasoned John Dory starting with the skin side until crispy, then add butter and cook through.",
      "Pan-sear the seasoned John Dory liver until golden brown.",
      "Boil the potatoes with their skin on, then mash them and generously add olive oil.",
      "Slice and add chorizo sausage to the mashed potatoes, then season with salt and pepper.",
      "Finely chop chives and parsley, add them to the potato mixture, and mix well.",
      "Combine white wine vinegar, olive oil, and caviar to make a caviar vinaigrette.",
      "Plate the mashed potatoes, top with the pan-seared John Dory fillet, and serve with the pan-seared liver and caviar vinaigrette."
    ]
  },
  {
    "name": "Grilled Oxtail and Seaweed Soup",
    "url": "https://youtu.be/UgY48owSXVU",
    "uploader": "강레오 걍레오",
    "upload_date": "2026-01-22",
    "ingredients": [
      "Oxtail",
      "Seaweed",
      "Green onion",
      "Salmon roe",
      "Garlic",
      "Ginger",
      "Magnolia leaves",
      "Chili powder",
      "Soy sauce",
      "Salt",
      "Black pepper",
      "Yeondoo (vegetable umami sauce)",
      "Yeondoo broth coin",
      "Honey",
      "White vinegar",
      "Sesame seeds",
      "Perilla oil"
    ],
    "steps": [
      "Mince or chop garlic and green onions.",
      "Mix Yeondoo, chili powder, soy sauce, minced ginger, honey, white vinegar, sesame seeds, and perilla oil to make the sauce.",
      "Season the oxtail with Yeondoo, salt, and pepper, then brush with honey and perilla oil.",
      "Lay magnolia leaves on charcoal and grill the oxtail on top.",
      "Lightly toast roasted seaweed over a flame and crumble it.",
      "Boil water in an earthenware pot, then add Yeondoo broth coin (Korean beef flavor) and green onions to make the broth.",
      "In a prepared bowl, add crumbled seaweed, minced green onions, sesame seeds, and salmon roe.",
      "Add roasted seaweed to the broth and boil to complete the seaweed soup.",
      "Plate the warm grilled oxtail by topping with minced green onions.",
      "Pour the finished seaweed soup into a bowl and drizzle with a little perilla oil."
    ]
  },
  {
    "name": "Salmon Steak",
    "url": "https://youtu.be/ppQC__0zkHM",
    "uploader": "강레오 걍레오",
    "upload_date": "2026-01-26",
    "ingredients": [
      "Salmon",
      "Salt",
      "Pepper",
      "Thyme",
      "Oil"
    ],
    "steps": [
      "Pat salmon dry with a paper towel.",
      "Cut the salmon into portions.",
      "Score the salmon skin.",
      "Season both sides of the salmon generously with salt and pepper.",
      "Heat oil in a pan and cook the salmon skin-side down until crispy.",
      "Once about one-third of the salmon is cooked through, flip and cook the flesh side.",
      "Lay the salmon on its side in the pan and cook for about 10 seconds.",
      "Sprinkle with thyme and cook until moist and medium-rare."
    ]
  },
  {
    "name": "John Dory Confit with Foie Gras",
    "url": "https://youtu.be/w_gVMR57gUU",
    "uploader": "강레오 걍레오",
    "upload_date": "2026-01-29",
    "ingredients": [
      "John Dory fish",
      "Duck liver",
      "Olive oil",
      "Salt",
      "Garlic",
      "White wine vinegar",
      "White pepper",
      "Chives",
      "Salmon roe",
      "Salted kelp"
    ],
    "steps": [
      "Fillet the John Dory and remove the skin.",
      "Season the John Dory fillets with salt.",
      "Pour olive oil into a metal tray.",
      "Crush garlic and add it to the olive oil.",
      "Heat the olive oil over low heat.",
      "Place the seasoned John Dory fillets into the warm olive oil.",
      "Gently cook the John Dory fillets over low heat for 15 minutes, turning occasionally.",
      "Remove the cooked John Dory fillets from the oil and drain them on a rack.",
      "Cook the foie gras (duck liver) in the same oil.",
      "Make a vinaigrette sauce: Combine olive oil, white wine vinegar, salt, white pepper, chopped chives, and salmon roe.",
      "Arrange the cooked John Dory fillets on a plate.",
      "Drizzle the prepared vinaigrette sauce over the John Dory.",
      "Garnish with chopped salted kelp.",
      "Slice the cooked foie gras and arrange it alongside on the plate.",
      "Serve with additional sauce if desired."
    ]
  },
  {
    "name": "Grilled Oxtail",
    "url": "https://youtu.be/xdqtjX5ti88",
    "uploader": "강레오 걍레오",
    "upload_date": "2026-02-03",
    "ingredients": [
      "oxtail",
      "fermented soybean seasoning",
      "salt",
      "perilla oil",
      "sesame oil",
      "magnolia leaves"
    ],
    "steps": [
      "Thinly slice frozen oxtail.",
      "Marinate oxtail with fermented soybean seasoning.",
      "Drizzle oxtail with perilla oil or sesame oil.",
      "Sprinkle salt on the oxtail.",
      "Place magnolia leaves on the charcoal grill.",
      "Grill the seasoned oxtail on the charcoal.",
      "Flip the oxtail and grill both sides until golden brown.",
      "Brush the grilled oxtail with a mixture of fermented soybean seasoning and perilla oil before eating."
    ]
  },
  {
    "name": "Steak Tartare",
    "url": "https://youtu.be/Vqz5-6knAVM",
    "uploader": "강레오 걍레오",
    "upload_date": "2026-02-05",
    "ingredients": [
      "beef tenderloin",
      "pickles",
      "shallots",
      "capers",
      "jalapeño",
      "parsley",
      "egg",
      "salt",
      "pepper",
      "Dijon mustard",
      "ketchup",
      "Tabasco sauce",
      "olive oil",
      "caviar",
      "baguette"
    ],
    "steps": [
      "Season the beef tenderloin all over with salt, pepper, and olive oil.",
      "Place the seasoned tenderloin in a hot pan and sear all sides until browned, pressing down as you go.",
      "Remove the seared tenderloin from the pan, then pour water into the pan and scrape up any browned bits.",
      "Place the seared tenderloin in the freezer to chill thoroughly.",
      "Finely chop the pickles, shallots, capers, jalapeño, and parsley.",
      "Place the chopped vegetables in a bowl and add salt.",
      "Thinly slice and finely chop the chilled tenderloin, then add it to the bowl.",
      "Add Dijon mustard, ketchup, Tabasco sauce, and an egg yolk to the meat and vegetables in the bowl, then mix well.",
      "Press the mixed tartare into a small mold or cup, then invert it onto a plate to form a shape.",
      "Top the tartare with an egg yolk and caviar, arrange chopped vegetables around it, and drizzle with olive oil for garnish.",
      "Prepare sliced baguette by drizzling with olive oil and sprinkling with salt.",
      "Serve the tartare on baguette slices, topped with caviar."
    ]
  },
  {
    "name": "French-Style Beef Tartare",
    "url": "https://youtu.be/gCfxpA2R7Ho",
    "uploader": "강레오 걍레오",
    "upload_date": "2026-02-09",
    "ingredients": [
      "Beef",
      "Cornichons",
      "Shallots",
      "Capers",
      "Jalapeño",
      "Parsley",
      "Salt",
      "Black pepper",
      "Dijon mustard",
      "Ketchup",
      "Tabasco sauce",
      "Olive oil",
      "Egg",
      "Caviar"
    ],
    "steps": [
      "Finely chop cornichons, shallots, capers, jalapeño, and parsley.",
      "Pat dry the beef with a kitchen towel to remove excess blood.",
      "Season the beef generously on both sides with salt and pepper.",
      "Brush olive oil on the surface of the beef.",
      "Quickly sear all sides of the beef in a hot pan until just browned on the outside.",
      "Slice the seared beef thinly, then finely chop it again.",
      "Combine the chopped beef and chopped ingredients in a bowl.",
      "Add salt, Dijon mustard, ketchup, and Tabasco sauce.",
      "Add 1 egg yolk and mix well until all ingredients are thoroughly combined.",
      "Shape the tartare into a round mound on a plate.",
      "Place an egg yolk on top of the tartare and garnish with caviar.",
      "Drizzle olive oil around the tartare to finish."
    ]
  },
  {
    "name": "Pressed Hairtail Sushi",
    "url": "https://youtu.be/05vANGiMWFw",
    "uploader": "강레오 걍레오",
    "upload_date": "2026-02-13",
    "ingredients": [
      "Hairtail",
      "Shiso leaves",
      "Pickled ginger",
      "Green onions",
      "Wasabi",
      "Rice",
      "Sushi vinegar"
    ],
    "steps": [
      "Prepare boneless hairtail fillet.",
      "Soak the hairtail fillet in sushi vinegar for 5 minutes.",
      "Remove fillet, pat dry, and score the skin side.",
      "Place hairtail on a bamboo mat, skin side up, and spread wasabi.",
      "Arrange shiso leaves, pickled ginger, and green onions on top.",
      "Form rice into portions and place them on the ingredients.",
      "Roll tightly with the bamboo mat to shape.",
      "Lightly torch the skin side of the formed sushi.",
      "Tightly wrap the sushi with plastic wrap.",
      "Slice the wrapped sushi into uniform pieces to finish."
    ]
  },
  {
    "name": "Oval Squid Ceviche",
    "url": "https://youtu.be/IYiY6osO5Kc",
    "uploader": "강레오 걍레오",
    "upload_date": "2026-02-16",
    "ingredients": [
      "Oval squid",
      "Shallot",
      "Chili pepper",
      "Radish",
      "Cherry tomatoes",
      "Scallions",
      "Capers",
      "Parsley",
      "Dill",
      "Salmon roe",
      "Salt",
      "Pepper",
      "Yuzu ponzu",
      "Lemon juice",
      "Olive oil"
    ],
    "steps": [
      "Season the oval squid with salt and pepper.",
      "Lightly torch the skin side of the oval squid, keeping the skin on.",
      "Thinly slice the seared oval squid.",
      "Finely dice half a shallot, finely dice the chili pepper, thickly slice the red radish, slice the cherry tomatoes, and finely chop the scallions, capers, and parsley.",
      "Combine all chopped ingredients and sliced squid in a bowl.",
      "Add yuzu ponzu, olive oil, and lemon juice.",
      "Mix all ingredients thoroughly.",
      "Arrange on a serving plate.",
      "Garnish attractively with dill and salmon roe.",
      "Finish by drizzling with olive oil."
    ]
  },
  {
    "name": "Buse Gulbi Rice",
    "url": "https://youtu.be/paJ4C1NhdWQ",
    "uploader": "강레오 걍레오",
    "upload_date": "2026-02-19",
    "ingredients": [
      "Buse Gulbi",
      "Pre-cooked rice",
      "Braised burdock root",
      "Dried celtuce stems",
      "Red bell pepper",
      "Scallions",
      "Raw perilla oil",
      "Rayu sauce",
      "Black sesame seeds",
      "Perilla oil",
      "Barley tea",
      "Seaweed"
    ],
    "steps": [
      "Heat the packaged Buse Gulbi in an oven for 1 minute and 30 seconds.",
      "Remove the fins and head from the Buse Gulbi.",
      "Make an incision along the back, debone, and remove the entrails to clean the fish.",
      "Finely chop the braised burdock root, dried celtuce stems, red bell pepper, and scallions.",
      "Combine the heated pre-cooked rice with the chopped vegetables, raw perilla oil, and Rayu sauce, then mix well.",
      "Stuff the mixed rice into the debone Buse Gulbi.",
      "Sprinkle black sesame seeds and chopped scallions over the rice-filled Buse Gulbi.",
      "Torch the surface of the Buse Gulbi until golden brown to add a smoky flavor.",
      "Drizzle perilla oil lightly over the torched Buse Gulbi.",
      "Serve on a plate with barley tea and seaweed."
    ]
  },
  {
    "name": "Carbonara",
    "url": "https://youtu.be/M_Muqh2cWv4",
    "uploader": "강레오 걍레오",
    "upload_date": "2026-02-26",
    "ingredients": [
      "Linguine",
      "Guanciale",
      "Eggs",
      "Pecorino cheese",
      "Parsley",
      "Peperoncino",
      "Black pepper",
      "Olive oil",
      "Salt"
    ],
    "steps": [
      "Boil linguine in salted boiling water.",
      "Cut guanciale into bite-sized pieces and crisp them up in a pan with olive oil until golden.",
      "Remove the cooked guanciale and set aside, separating it from the rendered fat.",
      "Combine egg yolks and pasta water, then gently heat in a double boiler to create a smooth sabayon-like sauce.",
      "Gradually whisk in olive oil into the sabayon sauce to emulsify it.",
      "Add the guanciale fat and peperoncino to the pan, then add the cooked linguine and toss to warm through.",
      "Combine the warm linguine with the sabayon sauce and finely grated Pecorino cheese, mixing well.",
      "Plate the Carbonara and lightly char the surface with a kitchen torch.",
      "Top the torched Carbonara with remaining Pecorino cheese, parsley, crispy guanciale, black pepper, and a drizzle of olive oil."
    ]
  },
  {
    "name": "Bloody Mary Oysters",
    "url": "https://youtu.be/qkDEVCASeTM",
    "uploader": "강레오 걍레오",
    "upload_date": "2026-03-12",
    "ingredients": [
      "Oysters",
      "Shallots",
      "Celery",
      "Basil",
      "Cherry tomatoes",
      "Tomato juice",
      "Tabasco sauce",
      "Olive oil",
      "Black pepper",
      "Paprika powder"
    ],
    "steps": [
      "Prepare fresh oysters.",
      "Separate oysters from their shells and wash them clean.",
      "Finely chop the shallots, celery, and basil.",
      "Put the cherry tomatoes and tomato juice into a blender and blend.",
      "To the blended tomato mixture, add the chopped shallots, celery, basil, black pepper, Tabasco sauce, paprika powder, and olive oil, then mix well to make the Bloody Mary sauce.",
      "Fill a serving dish with ice and arrange the oysters on top.",
      "Spoon the Bloody Mary sauce over each oyster and garnish with basil."
    ]
  },
  {
    "name": "Tenderloin Steak",
    "url": "https://youtu.be/klAYPHOxjno",
    "uploader": "셰프호윤 Chef Hoyoon",
    "upload_date": "2026-01-27",
    "ingredients": [
      "Tenderloin",
      "Onion",
      "Mushrooms",
      "Butter",
      "Cognac",
      "Cream",
      "Fond de Veau",
      "Black Pepper"
    ],
    "steps": [
      "Sear the tenderloin in a pan with butter.",
      "Finish cooking the interior in a 75°C oven.",
      "Slice the cooked tenderloin.",
      "Prepare the mushroom cognac sauce (using butter, cognac, cream, Fond de Veau).",
      "Season with black pepper.",
      "Plate the tenderloin with potatoes.",
      "Drizzle with the mushroom cognac sauce."
    ]
  },
  {
    "name": "Carbonara",
    "url": "https://youtu.be/QiwCo2rO08U",
    "uploader": "MBN Entertainment",
    "upload_date": "2026-02-22",
    "ingredients": [
      "Egg yolks",
      "Pasta",
      "Guanciale",
      "Pecorino Cheese",
      "Salt",
      "Pepper",
      "Chili flakes",
      "Olive oil"
    ],
    "steps": [
      "Add salt and olive oil to the pasta cooking water.",
      "Fry the guanciale until crispy, then set aside, reserving the rendered fat.",
      "Combine egg yolks, Pecorino cheese, salt, and pepper to make the sauce.",
      "Add pasta cooking water to the sauce and mix until slightly thickened.",
      "Add the cooked pasta to the sauce and toss to coat.",
      "Drizzle with extra virgin olive oil if desired."
    ]
  },
  {
    "name": "Marinara and Margherita Pizza",
    "url": "https://youtu.be/Brwwqcw7K98",
    "uploader": "미뇨끼",
    "upload_date": "2024-11-08",
    "ingredients": [
      "Dough",
      "Toppings"
    ],
    "steps": [
      "When trying Neapolitan pizza for the first time, try Marinara and Margherita pizza.",
      "Savor the authentic flavor of the dough.",
      "Try Margherita and Marinara pizza first."
    ]
  },
  {
    "name": "Iced Americano",
    "url": "https://youtu.be/Nk8R0cDTvpA",
    "uploader": "미뇨끼",
    "upload_date": "2024-10-31",
    "ingredients": [
      "Espresso"
    ],
    "steps": [
      "Prepare ice water.",
      "Prepare espresso.",
      "Pour espresso into the ice water and enjoy."
    ]
  },
  {
    "name": "Pizzoccheri",
    "url": "https://youtu.be/-GVglRZ5Jqg",
    "uploader": "미뇨끼",
    "upload_date": "2025-11-12",
    "ingredients": [
      "Buckwheat flour",
      "Wheat flour",
      "Potatoes",
      "Cabbage",
      "Cheese",
      "Parmesan cheese",
      "Butter",
      "Garlic",
      "Salt"
    ],
    "steps": [
      "Knead buckwheat flour, wheat flour, and water to form a dough.",
      "Dust with flour and roll thinly with a rolling pin.",
      "Cut into pieces about the length of a finger.",
      "Cut potatoes and cabbage into bite-sized pieces.",
      "Slice the cheese thinly.",
      "Salt boiling water and cook potatoes until tender.",
      "Once potatoes are cooked, add buckwheat pasta and cook thoroughly.",
      "Add cabbage and cook briefly until slightly crisp-tender.",
      "Melt butter with garlic until golden.",
      "Layer the cooked ingredients, cheese, and Parmesan in a large bowl, forming three layers.",
      "Pour the hot butter over the top.",
      "Cover tightly and wait for about 5 minutes.",
      "Mix well with a spatula and serve."
    ]
  },
  {
    "name": "Fresh Kimchi Stew",
    "url": "https://youtu.be/_rYksZ2KBPY",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-01-13",
    "ingredients": [
      "Kimchi",
      "Pork Shoulder",
      "Chicken Stock",
      "Natto",
      "Tofu",
      "Green Onions",
      "Cherry Tomatoes",
      "Tabasco",
      "Garlic",
      "Gochugaru",
      "Sand Lance Fish Sauce"
    ],
    "steps": [
      "Please see the video for the full recipe."
    ]
  },
  {
    "name": "Steak",
    "url": "https://youtu.be/htnHxuYfVO4",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-06-16",
    "ingredients": [
      "Hanging tender",
      "Chicken breast",
      "Sirloin",
      "Salmon"
    ],
    "steps": [
      "Cook the hanging tender steak.",
      "Cook the chicken breast steak.",
      "Cook the sirloin steak.",
      "Cook the salmon steak."
    ]
  },
  {
    "name": "Steamed Clams in Wine, Whelk Capellini, Tomato Hangover Ramyeon, Fish and Chips, Gochujang Stew",
    "url": "https://youtu.be/jLk8rl4Sk5Y",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-06-23",
    "ingredients": [
      "Clams",
      "Whelk",
      "Capellini",
      "Tomato",
      "Instant Noodles",
      "Fish",
      "Chips",
      "Gochujang"
    ],
    "steps": [
      "Refer to the video timeline for recipes."
    ]
  },
  {
    "name": "Green Tea Strawberry Gochujang Fusion",
    "url": "https://youtu.be/2ITPIKLCGSE",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-08-18",
    "ingredients": [
      "Green Tea",
      "Strawberry Gochujang"
    ],
    "steps": [
      "Source green tea from Hadong Green Tea Fields.",
      "Obtain gochujang from Master Ki Soon-do in Damyang.",
      "Create a unique dish using the green tea and gochujang."
    ]
  },
  {
    "name": "Amppong Sundae",
    "url": "https://youtu.be/4qKtMM-xCP4",
    "uploader": "STUDIO JJ [스튜디오 제이제이]",
    "upload_date": "2022-08-25",
    "ingredients": [
      "Pig uterus",
      "Pig large intestine"
    ],
    "steps": [
      "Use pig uterus to make sundae, suyuk, and gukbap.",
      "Use pig large intestine casing for a chewy texture."
    ]
  }
];
export default menuData_en;
